/* tslint:disable */
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import { type Action, ActionFromJSON, ActionToJSON } from "../models/Action";
import {
  type AggregationSettings,
  AggregationSettingsFromJSON,
  AggregationSettingsToJSON,
} from "../models/AggregationSettings";
import {
  type ArrivalTimePostProcessing,
  ArrivalTimePostProcessingFromJSON,
  ArrivalTimePostProcessingToJSON,
} from "../models/ArrivalTimePostProcessing";
import { type AuthProfile, AuthProfileFromJSON, AuthProfileToJSON } from "../models/AuthProfile";
import {
  type Authenticate,
  AuthenticateFromJSON,
  AuthenticateToJSON,
} from "../models/Authenticate";
import {
  type BaseEventState,
  BaseEventStateFromJSON,
  BaseEventStateToJSON,
} from "../models/BaseEventState";
import {
  type BasicPostProcessing,
  BasicPostProcessingFromJSON,
  BasicPostProcessingToJSON,
} from "../models/BasicPostProcessing";
import {
  type BoundaryCondition,
  BoundaryConditionFromJSON,
  BoundaryConditionToJSON,
} from "../models/BoundaryCondition";
import { type Breach, BreachFromJSON, BreachToJSON } from "../models/Breach";
import { type BreachGraph, BreachGraphFromJSON, BreachGraphToJSON } from "../models/BreachGraph";
import {
  type BreachGraphRequest,
  BreachGraphRequestFromJSON,
  BreachGraphRequestToJSON,
} from "../models/BreachGraphRequest";
import {
  type CloneRevision,
  CloneRevisionFromJSON,
  CloneRevisionToJSON,
} from "../models/CloneRevision";
import { type Commit, CommitFromJSON, CommitToJSON } from "../models/Commit";
import {
  type ConflictError,
  ConflictErrorFromJSON,
  ConflictErrorToJSON,
} from "../models/ConflictError";
import {
  type ConstantLateral,
  ConstantLateralFromJSON,
  ConstantLateralToJSON,
} from "../models/ConstantLateral";
import {
  type ConstantLeakage,
  ConstantLeakageFromJSON,
  ConstantLeakageToJSON,
} from "../models/ConstantLeakage";
import {
  type ConstantLocalRain,
  ConstantLocalRainFromJSON,
  ConstantLocalRainToJSON,
} from "../models/ConstantLocalRain";
import {
  type ConstantRain,
  ConstantRainFromJSON,
  ConstantRainToJSON,
} from "../models/ConstantRain";
import {
  type ConstantSourcesSinks,
  ConstantSourcesSinksFromJSON,
  ConstantSourcesSinksToJSON,
} from "../models/ConstantSourcesSinks";
import {
  type ConstantWind,
  ConstantWindFromJSON,
  ConstantWindToJSON,
} from "../models/ConstantWind";
import { type Contract, ContractFromJSON, ContractToJSON } from "../models/Contract";
import {
  type CreateOrganisation,
  CreateOrganisationFromJSON,
  CreateOrganisationToJSON,
} from "../models/CreateOrganisation";
import {
  type CreateRevision,
  CreateRevisionFromJSON,
  CreateRevisionToJSON,
} from "../models/CreateRevision";
import {
  type CreateTemplate,
  CreateTemplateFromJSON,
  CreateTemplateToJSON,
} from "../models/CreateTemplate";
import {
  type CreateThreedimodel,
  CreateThreedimodelFromJSON,
  CreateThreedimodelToJSON,
} from "../models/CreateThreedimodel";
import {
  type CurrentStatus,
  CurrentStatusFromJSON,
  CurrentStatusToJSON,
} from "../models/CurrentStatus";
import {
  type CustomizedResultArea,
  CustomizedResultAreaFromJSON,
  CustomizedResultAreaToJSON,
} from "../models/CustomizedResultArea";
import {
  type DamagePostProcessing,
  DamagePostProcessingFromJSON,
  DamagePostProcessingToJSON,
} from "../models/DamagePostProcessing";
import {
  type DeleteConflictError,
  DeleteConflictErrorFromJSON,
  DeleteConflictErrorToJSON,
} from "../models/DeleteConflictError";
import {
  type DestroyRevision,
  DestroyRevisionFromJSON,
  DestroyRevisionToJSON,
} from "../models/DestroyRevision";
import { type Download, DownloadFromJSON, DownloadToJSON } from "../models/Download";
import { type Event, EventFromJSON, EventToJSON } from "../models/Event";
import {
  type FileBoundaryCondition,
  FileBoundaryConditionFromJSON,
  FileBoundaryConditionToJSON,
} from "../models/FileBoundaryCondition";
import { type FileLateral, FileLateralFromJSON, FileLateralToJSON } from "../models/FileLateral";
import { type FileMeta, FileMetaFromJSON, FileMetaToJSON } from "../models/FileMeta";
import {
  type FileStructureControl,
  FileStructureControlFromJSON,
  FileStructureControlToJSON,
} from "../models/FileStructureControl";
import {
  type FromTemplate,
  FromTemplateFromJSON,
  FromTemplateToJSON,
} from "../models/FromTemplate";
import {
  type GridEventState,
  GridEventStateFromJSON,
  GridEventStateToJSON,
} from "../models/GridEventState";
import {
  type GroundWaterLevel,
  GroundWaterLevelFromJSON,
  GroundWaterLevelToJSON,
} from "../models/GroundWaterLevel";
import {
  type GroundWaterRaster,
  GroundWaterRasterFromJSON,
  GroundWaterRasterToJSON,
} from "../models/GroundWaterRaster";
import {
  type InitialSavedState,
  InitialSavedStateFromJSON,
  InitialSavedStateToJSON,
} from "../models/InitialSavedState";
import {
  type InitialWaterlevel,
  InitialWaterlevelFromJSON,
  InitialWaterlevelToJSON,
} from "../models/InitialWaterlevel";
import { type InpyVersion, InpyVersionFromJSON, InpyVersionToJSON } from "../models/InpyVersion";
import {
  type LizardRasterRain,
  LizardRasterRainFromJSON,
  LizardRasterRainToJSON,
} from "../models/LizardRasterRain";
import {
  type LizardRasterSourcesSinks,
  LizardRasterSourcesSinksFromJSON,
  LizardRasterSourcesSinksToJSON,
} from "../models/LizardRasterSourcesSinks";
import {
  type LizardTimeseriesRain,
  LizardTimeseriesRainFromJSON,
  LizardTimeseriesRainToJSON,
} from "../models/LizardTimeseriesRain";
import {
  type LizardTimeseriesSourcesSinks,
  LizardTimeseriesSourcesSinksFromJSON,
  LizardTimeseriesSourcesSinksToJSON,
} from "../models/LizardTimeseriesSourcesSinks";
import {
  type MeasureLocationGridEventState,
  MeasureLocationGridEventStateFromJSON,
  MeasureLocationGridEventStateToJSON,
} from "../models/MeasureLocationGridEventState";
import {
  type MemoryStructureControl,
  MemoryStructureControlFromJSON,
  MemoryStructureControlToJSON,
} from "../models/MemoryStructureControl";
import { type ModelFile, ModelFileFromJSON, ModelFileToJSON } from "../models/ModelFile";
import {
  type NetCDFRasterLeakage,
  NetCDFRasterLeakageFromJSON,
  NetCDFRasterLeakageToJSON,
} from "../models/NetCDFRasterLeakage";
import {
  type NetCDFRasterRain,
  NetCDFRasterRainFromJSON,
  NetCDFRasterRainToJSON,
} from "../models/NetCDFRasterRain";
import {
  type NetCDFRasterSourcesSinks,
  NetCDFRasterSourcesSinksFromJSON,
  NetCDFRasterSourcesSinksToJSON,
} from "../models/NetCDFRasterSourcesSinks";
import {
  type NetCDFTimeseriesLeakage,
  NetCDFTimeseriesLeakageFromJSON,
  NetCDFTimeseriesLeakageToJSON,
} from "../models/NetCDFTimeseriesLeakage";
import {
  type NetCDFTimeseriesRain,
  NetCDFTimeseriesRainFromJSON,
  NetCDFTimeseriesRainToJSON,
} from "../models/NetCDFTimeseriesRain";
import {
  type NetCDFTimeseriesSourcesSinks,
  NetCDFTimeseriesSourcesSinksFromJSON,
  NetCDFTimeseriesSourcesSinksToJSON,
} from "../models/NetCDFTimeseriesSourcesSinks";
import {
  type NumericalSettings,
  NumericalSettingsFromJSON,
  NumericalSettingsToJSON,
} from "../models/NumericalSettings";
import {
  type OneDWaterLevel,
  OneDWaterLevelFromJSON,
  OneDWaterLevelToJSON,
} from "../models/OneDWaterLevel";
import {
  type OneDWaterLevelFile,
  OneDWaterLevelFileFromJSON,
  OneDWaterLevelFileToJSON,
} from "../models/OneDWaterLevelFile";
import {
  type OneDWaterLevelPredefined,
  OneDWaterLevelPredefinedFromJSON,
  OneDWaterLevelPredefinedToJSON,
} from "../models/OneDWaterLevelPredefined";
import {
  type Organisation,
  OrganisationFromJSON,
  OrganisationToJSON,
} from "../models/Organisation";
import {
  type OrganisationRole,
  OrganisationRoleFromJSON,
  OrganisationRoleToJSON,
} from "../models/OrganisationRole";
import {
  type OrganisationUser,
  OrganisationUserFromJSON,
  OrganisationUserToJSON,
} from "../models/OrganisationUser";
import {
  type OutputSettings,
  OutputSettingsFromJSON,
  OutputSettingsToJSON,
} from "../models/OutputSettings";
import {
  type PaginatedAggregationSettingsList,
  PaginatedAggregationSettingsListFromJSON,
  PaginatedAggregationSettingsListToJSON,
} from "../models/PaginatedAggregationSettingsList";
import {
  type PaginatedBoundaryConditionList,
  PaginatedBoundaryConditionListFromJSON,
  PaginatedBoundaryConditionListToJSON,
} from "../models/PaginatedBoundaryConditionList";
import {
  type PaginatedBreachList,
  PaginatedBreachListFromJSON,
  PaginatedBreachListToJSON,
} from "../models/PaginatedBreachList";
import {
  type PaginatedConstantLateralList,
  PaginatedConstantLateralListFromJSON,
  PaginatedConstantLateralListToJSON,
} from "../models/PaginatedConstantLateralList";
import {
  type PaginatedConstantLeakageList,
  PaginatedConstantLeakageListFromJSON,
  PaginatedConstantLeakageListToJSON,
} from "../models/PaginatedConstantLeakageList";
import {
  type PaginatedConstantLocalRainList,
  PaginatedConstantLocalRainListFromJSON,
  PaginatedConstantLocalRainListToJSON,
} from "../models/PaginatedConstantLocalRainList";
import {
  type PaginatedConstantRainList,
  PaginatedConstantRainListFromJSON,
  PaginatedConstantRainListToJSON,
} from "../models/PaginatedConstantRainList";
import {
  type PaginatedConstantSourcesSinksList,
  PaginatedConstantSourcesSinksListFromJSON,
  PaginatedConstantSourcesSinksListToJSON,
} from "../models/PaginatedConstantSourcesSinksList";
import {
  type PaginatedConstantWindList,
  PaginatedConstantWindListFromJSON,
  PaginatedConstantWindListToJSON,
} from "../models/PaginatedConstantWindList";
import {
  type PaginatedContractList,
  PaginatedContractListFromJSON,
  PaginatedContractListToJSON,
} from "../models/PaginatedContractList";
import {
  type PaginatedCustomizedResultAreaList,
  PaginatedCustomizedResultAreaListFromJSON,
  PaginatedCustomizedResultAreaListToJSON,
} from "../models/PaginatedCustomizedResultAreaList";
import {
  type PaginatedFileBoundaryConditionList,
  PaginatedFileBoundaryConditionListFromJSON,
  PaginatedFileBoundaryConditionListToJSON,
} from "../models/PaginatedFileBoundaryConditionList";
import {
  type PaginatedFileLateralList,
  PaginatedFileLateralListFromJSON,
  PaginatedFileLateralListToJSON,
} from "../models/PaginatedFileLateralList";
import {
  type PaginatedFileList,
  PaginatedFileListFromJSON,
  PaginatedFileListToJSON,
} from "../models/PaginatedFileList";
import {
  type PaginatedFileStructureControlList,
  PaginatedFileStructureControlListFromJSON,
  PaginatedFileStructureControlListToJSON,
} from "../models/PaginatedFileStructureControlList";
import {
  type PaginatedGroundWaterLevelList,
  PaginatedGroundWaterLevelListFromJSON,
  PaginatedGroundWaterLevelListToJSON,
} from "../models/PaginatedGroundWaterLevelList";
import {
  type PaginatedGroundWaterRasterList,
  PaginatedGroundWaterRasterListFromJSON,
  PaginatedGroundWaterRasterListToJSON,
} from "../models/PaginatedGroundWaterRasterList";
import {
  type PaginatedInitialSavedStateList,
  PaginatedInitialSavedStateListFromJSON,
  PaginatedInitialSavedStateListToJSON,
} from "../models/PaginatedInitialSavedStateList";
import {
  type PaginatedInitialWaterlevelList,
  PaginatedInitialWaterlevelListFromJSON,
  PaginatedInitialWaterlevelListToJSON,
} from "../models/PaginatedInitialWaterlevelList";
import {
  type PaginatedInpyVersionList,
  PaginatedInpyVersionListFromJSON,
  PaginatedInpyVersionListToJSON,
} from "../models/PaginatedInpyVersionList";
import {
  type PaginatedLizardRasterRainList,
  PaginatedLizardRasterRainListFromJSON,
  PaginatedLizardRasterRainListToJSON,
} from "../models/PaginatedLizardRasterRainList";
import {
  type PaginatedLizardRasterSourcesSinksList,
  PaginatedLizardRasterSourcesSinksListFromJSON,
  PaginatedLizardRasterSourcesSinksListToJSON,
} from "../models/PaginatedLizardRasterSourcesSinksList";
import {
  type PaginatedLizardTimeseriesRainList,
  PaginatedLizardTimeseriesRainListFromJSON,
  PaginatedLizardTimeseriesRainListToJSON,
} from "../models/PaginatedLizardTimeseriesRainList";
import {
  type PaginatedLizardTimeseriesSourcesSinksList,
  PaginatedLizardTimeseriesSourcesSinksListFromJSON,
  PaginatedLizardTimeseriesSourcesSinksListToJSON,
} from "../models/PaginatedLizardTimeseriesSourcesSinksList";
import {
  type PaginatedMemoryStructureControlList,
  PaginatedMemoryStructureControlListFromJSON,
  PaginatedMemoryStructureControlListToJSON,
} from "../models/PaginatedMemoryStructureControlList";
import {
  type PaginatedNetCDFRasterLeakageList,
  PaginatedNetCDFRasterLeakageListFromJSON,
  PaginatedNetCDFRasterLeakageListToJSON,
} from "../models/PaginatedNetCDFRasterLeakageList";
import {
  type PaginatedNetCDFRasterRainList,
  PaginatedNetCDFRasterRainListFromJSON,
  PaginatedNetCDFRasterRainListToJSON,
} from "../models/PaginatedNetCDFRasterRainList";
import {
  type PaginatedNetCDFRasterSourcesSinksList,
  PaginatedNetCDFRasterSourcesSinksListFromJSON,
  PaginatedNetCDFRasterSourcesSinksListToJSON,
} from "../models/PaginatedNetCDFRasterSourcesSinksList";
import {
  type PaginatedNetCDFTimeseriesLeakageList,
  PaginatedNetCDFTimeseriesLeakageListFromJSON,
  PaginatedNetCDFTimeseriesLeakageListToJSON,
} from "../models/PaginatedNetCDFTimeseriesLeakageList";
import {
  type PaginatedNetCDFTimeseriesRainList,
  PaginatedNetCDFTimeseriesRainListFromJSON,
  PaginatedNetCDFTimeseriesRainListToJSON,
} from "../models/PaginatedNetCDFTimeseriesRainList";
import {
  type PaginatedNetCDFTimeseriesSourcesSinksList,
  PaginatedNetCDFTimeseriesSourcesSinksListFromJSON,
  PaginatedNetCDFTimeseriesSourcesSinksListToJSON,
} from "../models/PaginatedNetCDFTimeseriesSourcesSinksList";
import {
  type PaginatedOneDWaterLevelFileList,
  PaginatedOneDWaterLevelFileListFromJSON,
  PaginatedOneDWaterLevelFileListToJSON,
} from "../models/PaginatedOneDWaterLevelFileList";
import {
  type PaginatedOneDWaterLevelList,
  PaginatedOneDWaterLevelListFromJSON,
  PaginatedOneDWaterLevelListToJSON,
} from "../models/PaginatedOneDWaterLevelList";
import {
  type PaginatedOneDWaterLevelPredefinedList,
  PaginatedOneDWaterLevelPredefinedListFromJSON,
  PaginatedOneDWaterLevelPredefinedListToJSON,
} from "../models/PaginatedOneDWaterLevelPredefinedList";
import {
  type PaginatedOrganisationList,
  PaginatedOrganisationListFromJSON,
  PaginatedOrganisationListToJSON,
} from "../models/PaginatedOrganisationList";
import {
  type PaginatedOrganisationRoleList,
  PaginatedOrganisationRoleListFromJSON,
  PaginatedOrganisationRoleListToJSON,
} from "../models/PaginatedOrganisationRoleList";
import {
  type PaginatedOrganisationUserList,
  PaginatedOrganisationUserListFromJSON,
  PaginatedOrganisationUserListToJSON,
} from "../models/PaginatedOrganisationUserList";
import {
  type PaginatedPostProcessingQueueList,
  PaginatedPostProcessingQueueListFromJSON,
  PaginatedPostProcessingQueueListToJSON,
} from "../models/PaginatedPostProcessingQueueList";
import {
  type PaginatedPostProcessingStatusHistoryList,
  PaginatedPostProcessingStatusHistoryListFromJSON,
  PaginatedPostProcessingStatusHistoryListToJSON,
} from "../models/PaginatedPostProcessingStatusHistoryList";
import {
  type PaginatedPotentialBreachList,
  PaginatedPotentialBreachListFromJSON,
  PaginatedPotentialBreachListToJSON,
} from "../models/PaginatedPotentialBreachList";
import {
  type PaginatedRasterEditList,
  PaginatedRasterEditListFromJSON,
  PaginatedRasterEditListToJSON,
} from "../models/PaginatedRasterEditList";
import {
  type PaginatedRasterList,
  PaginatedRasterListFromJSON,
  PaginatedRasterListToJSON,
} from "../models/PaginatedRasterList";
import {
  type PaginatedRepositoryList,
  PaginatedRepositoryListFromJSON,
  PaginatedRepositoryListToJSON,
} from "../models/PaginatedRepositoryList";
import {
  type PaginatedResultFileList,
  PaginatedResultFileListFromJSON,
  PaginatedResultFileListToJSON,
} from "../models/PaginatedResultFileList";
import {
  type PaginatedRevisionList,
  PaginatedRevisionListFromJSON,
  PaginatedRevisionListToJSON,
} from "../models/PaginatedRevisionList";
import {
  type PaginatedRevisionRasterList,
  PaginatedRevisionRasterListFromJSON,
  PaginatedRevisionRasterListToJSON,
} from "../models/PaginatedRevisionRasterList";
import {
  type PaginatedRevisionTaskList,
  PaginatedRevisionTaskListFromJSON,
  PaginatedRevisionTaskListToJSON,
} from "../models/PaginatedRevisionTaskList";
import {
  type PaginatedRoleList,
  PaginatedRoleListFromJSON,
  PaginatedRoleListToJSON,
} from "../models/PaginatedRoleList";
import {
  type PaginatedSchematisationList,
  PaginatedSchematisationListFromJSON,
  PaginatedSchematisationListToJSON,
} from "../models/PaginatedSchematisationList";
import {
  type PaginatedSchematisationRevisionList,
  PaginatedSchematisationRevisionListFromJSON,
  PaginatedSchematisationRevisionListToJSON,
} from "../models/PaginatedSchematisationRevisionList";
import {
  type PaginatedSimulationChannelList,
  PaginatedSimulationChannelListFromJSON,
  PaginatedSimulationChannelListToJSON,
} from "../models/PaginatedSimulationChannelList";
import {
  type PaginatedSimulationList,
  PaginatedSimulationListFromJSON,
  PaginatedSimulationListToJSON,
} from "../models/PaginatedSimulationList";
import {
  type PaginatedSimulationStatusList,
  PaginatedSimulationStatusListFromJSON,
  PaginatedSimulationStatusListToJSON,
} from "../models/PaginatedSimulationStatusList";
import {
  type PaginatedStableThresholdSavedStateList,
  PaginatedStableThresholdSavedStateListFromJSON,
  PaginatedStableThresholdSavedStateListToJSON,
} from "../models/PaginatedStableThresholdSavedStateList";
import {
  type PaginatedTableStructureControlList,
  PaginatedTableStructureControlListFromJSON,
  PaginatedTableStructureControlListToJSON,
} from "../models/PaginatedTableStructureControlList";
import {
  type PaginatedTemplateList,
  PaginatedTemplateListFromJSON,
  PaginatedTemplateListToJSON,
} from "../models/PaginatedTemplateList";
import {
  type PaginatedThreediModelList,
  PaginatedThreediModelListFromJSON,
  PaginatedThreediModelListToJSON,
} from "../models/PaginatedThreediModelList";
import {
  type PaginatedThreediModelSavedStateList,
  PaginatedThreediModelSavedStateListFromJSON,
  PaginatedThreediModelSavedStateListToJSON,
} from "../models/PaginatedThreediModelSavedStateList";
import {
  type PaginatedThreediModelTaskList,
  PaginatedThreediModelTaskListFromJSON,
  PaginatedThreediModelTaskListToJSON,
} from "../models/PaginatedThreediModelTaskList";
import {
  type PaginatedTimedSavedStateUpdateList,
  PaginatedTimedSavedStateUpdateListFromJSON,
  PaginatedTimedSavedStateUpdateListToJSON,
} from "../models/PaginatedTimedSavedStateUpdateList";
import {
  type PaginatedTimedStructureControlList,
  PaginatedTimedStructureControlListFromJSON,
  PaginatedTimedStructureControlListToJSON,
} from "../models/PaginatedTimedStructureControlList";
import {
  type PaginatedTimeseriesLateralList,
  PaginatedTimeseriesLateralListFromJSON,
  PaginatedTimeseriesLateralListToJSON,
} from "../models/PaginatedTimeseriesLateralList";
import {
  type PaginatedTimeseriesLeakageList,
  PaginatedTimeseriesLeakageListFromJSON,
  PaginatedTimeseriesLeakageListToJSON,
} from "../models/PaginatedTimeseriesLeakageList";
import {
  type PaginatedTimeseriesLocalRainList,
  PaginatedTimeseriesLocalRainListFromJSON,
  PaginatedTimeseriesLocalRainListToJSON,
} from "../models/PaginatedTimeseriesLocalRainList";
import {
  type PaginatedTimeseriesRainList,
  PaginatedTimeseriesRainListFromJSON,
  PaginatedTimeseriesRainListToJSON,
} from "../models/PaginatedTimeseriesRainList";
import {
  type PaginatedTimeseriesSourcesSinksList,
  PaginatedTimeseriesSourcesSinksListFromJSON,
  PaginatedTimeseriesSourcesSinksListToJSON,
} from "../models/PaginatedTimeseriesSourcesSinksList";
import {
  type PaginatedTimeseriesWindList,
  PaginatedTimeseriesWindListFromJSON,
  PaginatedTimeseriesWindListToJSON,
} from "../models/PaginatedTimeseriesWindList";
import {
  type PaginatedTwoDWaterLevelList,
  PaginatedTwoDWaterLevelListFromJSON,
  PaginatedTwoDWaterLevelListToJSON,
} from "../models/PaginatedTwoDWaterLevelList";
import {
  type PaginatedTwoDWaterRasterList,
  PaginatedTwoDWaterRasterListFromJSON,
  PaginatedTwoDWaterRasterListToJSON,
} from "../models/PaginatedTwoDWaterRasterList";
import {
  type PaginatedUsageList,
  PaginatedUsageListFromJSON,
  PaginatedUsageListToJSON,
} from "../models/PaginatedUsageList";
import {
  type PaginatedUserList,
  PaginatedUserListFromJSON,
  PaginatedUserListToJSON,
} from "../models/PaginatedUserList";
import {
  type PaginatedWaterQualityCustomizedResultAreaList,
  PaginatedWaterQualityCustomizedResultAreaListFromJSON,
  PaginatedWaterQualityCustomizedResultAreaListToJSON,
} from "../models/PaginatedWaterQualityCustomizedResultAreaList";
import {
  type PaginatedWindDragCoefficientList,
  PaginatedWindDragCoefficientListFromJSON,
  PaginatedWindDragCoefficientListToJSON,
} from "../models/PaginatedWindDragCoefficientList";
import {
  type PaginatedsettingsList,
  PaginatedsettingsListFromJSON,
  PaginatedsettingsListToJSON,
} from "../models/PaginatedsettingsList";
import {
  type PatchedAggregationSettings,
  PatchedAggregationSettingsFromJSON,
  PatchedAggregationSettingsToJSON,
} from "../models/PatchedAggregationSettings";
import {
  type PatchedBoundaryCondition,
  PatchedBoundaryConditionFromJSON,
  PatchedBoundaryConditionToJSON,
} from "../models/PatchedBoundaryCondition";
import {
  type PatchedBreach,
  PatchedBreachFromJSON,
  PatchedBreachToJSON,
} from "../models/PatchedBreach";
import {
  type PatchedConstantLateral,
  PatchedConstantLateralFromJSON,
  PatchedConstantLateralToJSON,
} from "../models/PatchedConstantLateral";
import {
  type PatchedConstantLeakage,
  PatchedConstantLeakageFromJSON,
  PatchedConstantLeakageToJSON,
} from "../models/PatchedConstantLeakage";
import {
  type PatchedConstantLocalRain,
  PatchedConstantLocalRainFromJSON,
  PatchedConstantLocalRainToJSON,
} from "../models/PatchedConstantLocalRain";
import {
  type PatchedConstantRain,
  PatchedConstantRainFromJSON,
  PatchedConstantRainToJSON,
} from "../models/PatchedConstantRain";
import {
  type PatchedConstantSourcesSinks,
  PatchedConstantSourcesSinksFromJSON,
  PatchedConstantSourcesSinksToJSON,
} from "../models/PatchedConstantSourcesSinks";
import {
  type PatchedConstantWind,
  PatchedConstantWindFromJSON,
  PatchedConstantWindToJSON,
} from "../models/PatchedConstantWind";
import {
  type PatchedContract,
  PatchedContractFromJSON,
  PatchedContractToJSON,
} from "../models/PatchedContract";
import {
  type PatchedCustomizedResultArea,
  PatchedCustomizedResultAreaFromJSON,
  PatchedCustomizedResultAreaToJSON,
} from "../models/PatchedCustomizedResultArea";
import { type PatchedFile, PatchedFileFromJSON, PatchedFileToJSON } from "../models/PatchedFile";
import {
  type PatchedFileBoundaryCondition,
  PatchedFileBoundaryConditionFromJSON,
  PatchedFileBoundaryConditionToJSON,
} from "../models/PatchedFileBoundaryCondition";
import {
  type PatchedFileLateral,
  PatchedFileLateralFromJSON,
  PatchedFileLateralToJSON,
} from "../models/PatchedFileLateral";
import {
  type PatchedFileStructureControl,
  PatchedFileStructureControlFromJSON,
  PatchedFileStructureControlToJSON,
} from "../models/PatchedFileStructureControl";
import {
  type PatchedGroundWaterLevel,
  PatchedGroundWaterLevelFromJSON,
  PatchedGroundWaterLevelToJSON,
} from "../models/PatchedGroundWaterLevel";
import {
  type PatchedGroundWaterRaster,
  PatchedGroundWaterRasterFromJSON,
  PatchedGroundWaterRasterToJSON,
} from "../models/PatchedGroundWaterRaster";
import {
  type PatchedInitialSavedState,
  PatchedInitialSavedStateFromJSON,
  PatchedInitialSavedStateToJSON,
} from "../models/PatchedInitialSavedState";
import {
  type PatchedInitialWaterlevel,
  PatchedInitialWaterlevelFromJSON,
  PatchedInitialWaterlevelToJSON,
} from "../models/PatchedInitialWaterlevel";
import {
  type PatchedInpyVersion,
  PatchedInpyVersionFromJSON,
  PatchedInpyVersionToJSON,
} from "../models/PatchedInpyVersion";
import {
  type PatchedLizardRasterRain,
  PatchedLizardRasterRainFromJSON,
  PatchedLizardRasterRainToJSON,
} from "../models/PatchedLizardRasterRain";
import {
  type PatchedLizardRasterSourcesSinks,
  PatchedLizardRasterSourcesSinksFromJSON,
  PatchedLizardRasterSourcesSinksToJSON,
} from "../models/PatchedLizardRasterSourcesSinks";
import {
  type PatchedLizardTimeseriesRain,
  PatchedLizardTimeseriesRainFromJSON,
  PatchedLizardTimeseriesRainToJSON,
} from "../models/PatchedLizardTimeseriesRain";
import {
  type PatchedLizardTimeseriesSourcesSinks,
  PatchedLizardTimeseriesSourcesSinksFromJSON,
  PatchedLizardTimeseriesSourcesSinksToJSON,
} from "../models/PatchedLizardTimeseriesSourcesSinks";
import {
  type PatchedMemoryStructureControl,
  PatchedMemoryStructureControlFromJSON,
  PatchedMemoryStructureControlToJSON,
} from "../models/PatchedMemoryStructureControl";
import {
  type PatchedNetCDFRasterRain,
  PatchedNetCDFRasterRainFromJSON,
  PatchedNetCDFRasterRainToJSON,
} from "../models/PatchedNetCDFRasterRain";
import {
  type PatchedNetCDFRasterSourcesSinks,
  PatchedNetCDFRasterSourcesSinksFromJSON,
  PatchedNetCDFRasterSourcesSinksToJSON,
} from "../models/PatchedNetCDFRasterSourcesSinks";
import {
  type PatchedNetCDFTimeseriesRain,
  PatchedNetCDFTimeseriesRainFromJSON,
  PatchedNetCDFTimeseriesRainToJSON,
} from "../models/PatchedNetCDFTimeseriesRain";
import {
  type PatchedNumericalSettings,
  PatchedNumericalSettingsFromJSON,
  PatchedNumericalSettingsToJSON,
} from "../models/PatchedNumericalSettings";
import {
  type PatchedOneDWaterLevel,
  PatchedOneDWaterLevelFromJSON,
  PatchedOneDWaterLevelToJSON,
} from "../models/PatchedOneDWaterLevel";
import {
  type PatchedOneDWaterLevelFile,
  PatchedOneDWaterLevelFileFromJSON,
  PatchedOneDWaterLevelFileToJSON,
} from "../models/PatchedOneDWaterLevelFile";
import {
  type PatchedOneDWaterLevelPredefined,
  PatchedOneDWaterLevelPredefinedFromJSON,
  PatchedOneDWaterLevelPredefinedToJSON,
} from "../models/PatchedOneDWaterLevelPredefined";
import {
  type PatchedOrganisation,
  PatchedOrganisationFromJSON,
  PatchedOrganisationToJSON,
} from "../models/PatchedOrganisation";
import {
  type PatchedOrganisationUserRolePatch,
  PatchedOrganisationUserRolePatchFromJSON,
  PatchedOrganisationUserRolePatchToJSON,
} from "../models/PatchedOrganisationUserRolePatch";
import {
  type PatchedOutputSettings,
  PatchedOutputSettingsFromJSON,
  PatchedOutputSettingsToJSON,
} from "../models/PatchedOutputSettings";
import {
  type PatchedPhysicalSettings,
  PatchedPhysicalSettingsFromJSON,
  PatchedPhysicalSettingsToJSON,
} from "../models/PatchedPhysicalSettings";
import {
  type PatchedRaster,
  PatchedRasterFromJSON,
  PatchedRasterToJSON,
} from "../models/PatchedRaster";
import {
  type PatchedRasterEdit,
  PatchedRasterEditFromJSON,
  PatchedRasterEditToJSON,
} from "../models/PatchedRasterEdit";
import {
  type PatchedRepository,
  PatchedRepositoryFromJSON,
  PatchedRepositoryToJSON,
} from "../models/PatchedRepository";
import {
  type PatchedResource,
  PatchedResourceFromJSON,
  PatchedResourceToJSON,
} from "../models/PatchedResource";
import {
  type PatchedResultFile,
  PatchedResultFileFromJSON,
  PatchedResultFileToJSON,
} from "../models/PatchedResultFile";
import {
  type PatchedRevision,
  PatchedRevisionFromJSON,
  PatchedRevisionToJSON,
} from "../models/PatchedRevision";
import {
  type PatchedRevisionRaster,
  PatchedRevisionRasterFromJSON,
  PatchedRevisionRasterToJSON,
} from "../models/PatchedRevisionRaster";
import {
  type PatchedRevisionTask,
  PatchedRevisionTaskFromJSON,
  PatchedRevisionTaskToJSON,
} from "../models/PatchedRevisionTask";
import {
  type PatchedSchematisation,
  PatchedSchematisationFromJSON,
  PatchedSchematisationToJSON,
} from "../models/PatchedSchematisation";
import {
  type PatchedSimulationStatus,
  PatchedSimulationStatusFromJSON,
  PatchedSimulationStatusToJSON,
} from "../models/PatchedSimulationStatus";
import {
  type PatchedSimulationUpdate,
  PatchedSimulationUpdateFromJSON,
  PatchedSimulationUpdateToJSON,
} from "../models/PatchedSimulationUpdate";
import {
  type PatchedStableThresholdSavedState,
  PatchedStableThresholdSavedStateFromJSON,
  PatchedStableThresholdSavedStateToJSON,
} from "../models/PatchedStableThresholdSavedState";
import {
  type PatchedTableStructureControl,
  PatchedTableStructureControlFromJSON,
  PatchedTableStructureControlToJSON,
} from "../models/PatchedTableStructureControl";
import {
  type PatchedThreediModel,
  PatchedThreediModelFromJSON,
  PatchedThreediModelToJSON,
} from "../models/PatchedThreediModel";
import {
  type PatchedThreediModelTask,
  PatchedThreediModelTaskFromJSON,
  PatchedThreediModelTaskToJSON,
} from "../models/PatchedThreediModelTask";
import {
  type PatchedTimeStepSettings,
  PatchedTimeStepSettingsFromJSON,
  PatchedTimeStepSettingsToJSON,
} from "../models/PatchedTimeStepSettings";
import {
  type PatchedTimedSavedStateUpdate,
  PatchedTimedSavedStateUpdateFromJSON,
  PatchedTimedSavedStateUpdateToJSON,
} from "../models/PatchedTimedSavedStateUpdate";
import {
  type PatchedTimedStructureControl,
  PatchedTimedStructureControlFromJSON,
  PatchedTimedStructureControlToJSON,
} from "../models/PatchedTimedStructureControl";
import {
  type PatchedTimeseriesLateral,
  PatchedTimeseriesLateralFromJSON,
  PatchedTimeseriesLateralToJSON,
} from "../models/PatchedTimeseriesLateral";
import {
  type PatchedTimeseriesLeakage,
  PatchedTimeseriesLeakageFromJSON,
  PatchedTimeseriesLeakageToJSON,
} from "../models/PatchedTimeseriesLeakage";
import {
  type PatchedTimeseriesLocalRain,
  PatchedTimeseriesLocalRainFromJSON,
  PatchedTimeseriesLocalRainToJSON,
} from "../models/PatchedTimeseriesLocalRain";
import {
  type PatchedTimeseriesRain,
  PatchedTimeseriesRainFromJSON,
  PatchedTimeseriesRainToJSON,
} from "../models/PatchedTimeseriesRain";
import {
  type PatchedTimeseriesSourcesSinks,
  PatchedTimeseriesSourcesSinksFromJSON,
  PatchedTimeseriesSourcesSinksToJSON,
} from "../models/PatchedTimeseriesSourcesSinks";
import {
  type PatchedTimeseriesWind,
  PatchedTimeseriesWindFromJSON,
  PatchedTimeseriesWindToJSON,
} from "../models/PatchedTimeseriesWind";
import {
  type PatchedTwoDWaterLevel,
  PatchedTwoDWaterLevelFromJSON,
  PatchedTwoDWaterLevelToJSON,
} from "../models/PatchedTwoDWaterLevel";
import {
  type PatchedTwoDWaterRaster,
  PatchedTwoDWaterRasterFromJSON,
  PatchedTwoDWaterRasterToJSON,
} from "../models/PatchedTwoDWaterRaster";
import {
  type PatchedUpdateRevision,
  PatchedUpdateRevisionFromJSON,
  PatchedUpdateRevisionToJSON,
} from "../models/PatchedUpdateRevision";
import {
  type PatchedUpdateTemplate,
  PatchedUpdateTemplateFromJSON,
  PatchedUpdateTemplateToJSON,
} from "../models/PatchedUpdateTemplate";
import {
  type PatchedWaterQualityCustomizedResultArea,
  PatchedWaterQualityCustomizedResultAreaFromJSON,
  PatchedWaterQualityCustomizedResultAreaToJSON,
} from "../models/PatchedWaterQualityCustomizedResultArea";
import {
  type PatchedWaterQualityOutputSettings,
  PatchedWaterQualityOutputSettingsFromJSON,
  PatchedWaterQualityOutputSettingsToJSON,
} from "../models/PatchedWaterQualityOutputSettings";
import {
  type PatchedWaterQualitySettings,
  PatchedWaterQualitySettingsFromJSON,
  PatchedWaterQualitySettingsToJSON,
} from "../models/PatchedWaterQualitySettings";
import {
  type PatchedWindDragCoefficient,
  PatchedWindDragCoefficientFromJSON,
  PatchedWindDragCoefficientToJSON,
} from "../models/PatchedWindDragCoefficient";
import {
  type Patchedsettings,
  PatchedsettingsFromJSON,
  PatchedsettingsToJSON,
} from "../models/Patchedsettings";
import {
  type PhysicalSettings,
  PhysicalSettingsFromJSON,
  PhysicalSettingsToJSON,
} from "../models/PhysicalSettings";
import {
  type PostProcessingOverview,
  PostProcessingOverviewFromJSON,
  PostProcessingOverviewToJSON,
} from "../models/PostProcessingOverview";
import {
  type PostProcessingStatus,
  PostProcessingStatusFromJSON,
  PostProcessingStatusToJSON,
} from "../models/PostProcessingStatus";
import {
  type PotentialBreach,
  PotentialBreachFromJSON,
  PotentialBreachToJSON,
} from "../models/PotentialBreach";
import { type Profile, ProfileFromJSON, ProfileToJSON } from "../models/Profile";
import { type Progress, ProgressFromJSON, ProgressToJSON } from "../models/Progress";
import {
  type PumpDischargeGraph,
  PumpDischargeGraphFromJSON,
  PumpDischargeGraphToJSON,
} from "../models/PumpDischargeGraph";
import {
  type PumpDischargeGraphRequest,
  PumpDischargeGraphRequestFromJSON,
  PumpDischargeGraphRequestToJSON,
} from "../models/PumpDischargeGraphRequest";
import { type RainGraph, RainGraphFromJSON, RainGraphToJSON } from "../models/RainGraph";
import {
  type RainGraphRequest,
  RainGraphRequestFromJSON,
  RainGraphRequestToJSON,
} from "../models/RainGraphRequest";
import { type Raster, RasterFromJSON, RasterToJSON } from "../models/Raster";
import {
  type RasterCreate,
  RasterCreateFromJSON,
  RasterCreateToJSON,
} from "../models/RasterCreate";
import { type RasterEdit, RasterEditFromJSON, RasterEditToJSON } from "../models/RasterEdit";
import {
  type RasterEditUrls,
  RasterEditUrlsFromJSON,
  RasterEditUrlsToJSON,
} from "../models/RasterEditUrls";
import {
  type RasterOptions,
  RasterOptionsFromJSON,
  RasterOptionsToJSON,
} from "../models/RasterOptions";
import { type Refresh, RefreshFromJSON, RefreshToJSON } from "../models/Refresh";
import { type Repository, RepositoryFromJSON, RepositoryToJSON } from "../models/Repository";
import { type ResultFile, ResultFileFromJSON, ResultFileToJSON } from "../models/ResultFile";
import { type Revision, RevisionFromJSON, RevisionToJSON } from "../models/Revision";
import {
  type RevisionRaster,
  RevisionRasterFromJSON,
  RevisionRasterToJSON,
} from "../models/RevisionRaster";
import {
  type RevisionTask,
  RevisionTaskFromJSON,
  RevisionTaskToJSON,
} from "../models/RevisionTask";
import { type Role, RoleFromJSON, RoleToJSON } from "../models/Role";
import {
  type Schematisation,
  SchematisationFromJSON,
  SchematisationToJSON,
} from "../models/Schematisation";
import {
  type SchematisationRevision,
  SchematisationRevisionFromJSON,
  SchematisationRevisionToJSON,
} from "../models/SchematisationRevision";
import {
  type SetRanaTenant,
  SetRanaTenantFromJSON,
  SetRanaTenantToJSON,
} from "../models/SetRanaTenant";
import { type Settings, SettingsFromJSON, SettingsToJSON } from "../models/Settings";
import { type Simulation, SimulationFromJSON, SimulationToJSON } from "../models/Simulation";
import {
  type SimulationSettingsOverview,
  SimulationSettingsOverviewFromJSON,
  SimulationSettingsOverviewToJSON,
} from "../models/SimulationSettingsOverview";
import {
  type SimulationStatus,
  SimulationStatusFromJSON,
  SimulationStatusToJSON,
} from "../models/SimulationStatus";
import {
  type SimulationStatusStatistics,
  SimulationStatusStatisticsFromJSON,
  SimulationStatusStatisticsToJSON,
} from "../models/SimulationStatusStatistics";
import {
  type SimulationUpdate,
  SimulationUpdateFromJSON,
  SimulationUpdateToJSON,
} from "../models/SimulationUpdate";
import {
  type SqliteFileUpload,
  SqliteFileUploadFromJSON,
  SqliteFileUploadToJSON,
} from "../models/SqliteFileUpload";
import {
  type StableThresholdSavedState,
  StableThresholdSavedStateFromJSON,
  StableThresholdSavedStateToJSON,
} from "../models/StableThresholdSavedState";
import { type TMS, TMSFromJSON, TMSToJSON } from "../models/TMS";
import {
  type TableStructureControl,
  TableStructureControlFromJSON,
  TableStructureControlToJSON,
} from "../models/TableStructureControl";
import { type Template, TemplateFromJSON, TemplateToJSON } from "../models/Template";
import {
  type ThreediModel,
  ThreediModelFromJSON,
  ThreediModelToJSON,
} from "../models/ThreediModel";
import {
  type ThreediModelSavedState,
  ThreediModelSavedStateFromJSON,
  ThreediModelSavedStateToJSON,
} from "../models/ThreediModelSavedState";
import {
  type ThreediModelTask,
  ThreediModelTaskFromJSON,
  ThreediModelTaskToJSON,
} from "../models/ThreediModelTask";
import {
  type TimeStepSettings,
  TimeStepSettingsFromJSON,
  TimeStepSettingsToJSON,
} from "../models/TimeStepSettings";
import {
  type TimedSavedStateUpdate,
  TimedSavedStateUpdateFromJSON,
  TimedSavedStateUpdateToJSON,
} from "../models/TimedSavedStateUpdate";
import {
  type TimedStructureControl,
  TimedStructureControlFromJSON,
  TimedStructureControlToJSON,
} from "../models/TimedStructureControl";
import { type Timeout, TimeoutFromJSON, TimeoutToJSON } from "../models/Timeout";
import {
  type TimeseriesLateral,
  TimeseriesLateralFromJSON,
  TimeseriesLateralToJSON,
} from "../models/TimeseriesLateral";
import {
  type TimeseriesLeakage,
  TimeseriesLeakageFromJSON,
  TimeseriesLeakageToJSON,
} from "../models/TimeseriesLeakage";
import {
  type TimeseriesLocalRain,
  TimeseriesLocalRainFromJSON,
  TimeseriesLocalRainToJSON,
} from "../models/TimeseriesLocalRain";
import {
  type TimeseriesRain,
  TimeseriesRainFromJSON,
  TimeseriesRainToJSON,
} from "../models/TimeseriesRain";
import {
  type TimeseriesSourcesSinks,
  TimeseriesSourcesSinksFromJSON,
  TimeseriesSourcesSinksToJSON,
} from "../models/TimeseriesSourcesSinks";
import {
  type TimeseriesWind,
  TimeseriesWindFromJSON,
  TimeseriesWindToJSON,
} from "../models/TimeseriesWind";
import { type Tokens, TokensFromJSON, TokensToJSON } from "../models/Tokens";
import {
  type TwoDWaterLevel,
  TwoDWaterLevelFromJSON,
  TwoDWaterLevelToJSON,
} from "../models/TwoDWaterLevel";
import {
  type TwoDWaterRaster,
  TwoDWaterRasterFromJSON,
  TwoDWaterRasterToJSON,
} from "../models/TwoDWaterRaster";
import {
  type UpdateRevision,
  UpdateRevisionFromJSON,
  UpdateRevisionToJSON,
} from "../models/UpdateRevision";
import {
  type UpdateTemplate,
  UpdateTemplateFromJSON,
  UpdateTemplateToJSON,
} from "../models/UpdateTemplate";
import { type Upload, UploadFromJSON, UploadToJSON } from "../models/Upload";
import {
  type UploadEventFile,
  UploadEventFileFromJSON,
  UploadEventFileToJSON,
} from "../models/UploadEventFile";
import {
  type UploadLateralFile,
  UploadLateralFileFromJSON,
  UploadLateralFileToJSON,
} from "../models/UploadLateralFile";
import {
  type UploadWithSubstances,
  UploadWithSubstancesFromJSON,
  UploadWithSubstancesToJSON,
} from "../models/UploadWithSubstances";
import { type Usage, UsageFromJSON, UsageToJSON } from "../models/Usage";
import {
  type UsageStatistics,
  UsageStatisticsFromJSON,
  UsageStatisticsToJSON,
} from "../models/UsageStatistics";
import { type User, UserFromJSON, UserToJSON } from "../models/User";
import { type UserTokens, UserTokensFromJSON, UserTokensToJSON } from "../models/UserTokens";
import {
  type WaterFlowGraphRequest,
  WaterFlowGraphRequestFromJSON,
  WaterFlowGraphRequestToJSON,
} from "../models/WaterFlowGraphRequest";
import { type WaterGraph, WaterGraphFromJSON, WaterGraphToJSON } from "../models/WaterGraph";
import {
  type WaterLevelGraphRequest,
  WaterLevelGraphRequestFromJSON,
  WaterLevelGraphRequestToJSON,
} from "../models/WaterLevelGraphRequest";
import {
  type WaterLevelProfile,
  WaterLevelProfileFromJSON,
  WaterLevelProfileToJSON,
} from "../models/WaterLevelProfile";
import {
  type WaterLevelProfileRequest,
  WaterLevelProfileRequestFromJSON,
  WaterLevelProfileRequestToJSON,
} from "../models/WaterLevelProfileRequest";
import {
  type WaterQualityCustomizedResultArea,
  WaterQualityCustomizedResultAreaFromJSON,
  WaterQualityCustomizedResultAreaToJSON,
} from "../models/WaterQualityCustomizedResultArea";
import {
  type WaterQualityOutputSettings,
  WaterQualityOutputSettingsFromJSON,
  WaterQualityOutputSettingsToJSON,
} from "../models/WaterQualityOutputSettings";
import {
  type WaterQualitySettings,
  WaterQualitySettingsFromJSON,
  WaterQualitySettingsToJSON,
} from "../models/WaterQualitySettings";
import { type Waterdepth, WaterdepthFromJSON, WaterdepthToJSON } from "../models/Waterdepth";
import {
  type WindDragCoefficient,
  WindDragCoefficientFromJSON,
  WindDragCoefficientToJSON,
} from "../models/WindDragCoefficient";

export interface AuthRefreshTokenCreateRequest {
  /**
   *
   */
  data: Omit<Refresh, "access">;
}

export interface AuthTokenCreateRequest {
  /**
   *
   */
  data: Authenticate;
}

export interface AuthUsersListRequest {
  /**
   *
   */
  email?: string;
  /**
   *
   */
  emailContains?: string;
  /**
   *
   */
  emailEndswith?: string;
  /**
   *
   */
  emailIcontains?: string;
  /**
   *
   */
  emailIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  emailIn?: Array<string>;
  /**
   *
   */
  emailIstartswith?: string;
  /**
   *
   */
  emailRegex?: string;
  /**
   *
   */
  emailStartswith?: string;
  /**
   *
   */
  isActive?: boolean;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  remoteExternalUserId?: string;
  /**
   *
   */
  username?: string;
  /**
   *
   */
  usernameContains?: string;
  /**
   *
   */
  usernameEndswith?: string;
  /**
   *
   */
  usernameIcontains?: string;
  /**
   *
   */
  usernameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  usernameIn?: Array<string>;
  /**
   *
   */
  usernameIstartswith?: string;
  /**
   *
   */
  usernameRegex?: string;
  /**
   *
   */
  usernameStartswith?: string;
}

export interface AuthUsersReadRequest {
  /**
   * A unique integer value identifying this user.
   */
  id: number;
}

export interface AuthUsersTokensRequest {
  /**
   * A unique integer value identifying this user.
   */
  id: number;
  /**
   *
   */
  requiredScopes?: Array<string>;
}

export interface ContractsCreateRequest {
  /**
   *
   */
  data: Omit<
    Contract,
    "url" | "id" | "organisationName" | "scope" | "hoursUsed" | "currentSessions"
  >;
}

export interface ContractsDeleteRequest {
  /**
   * A unique integer value identifying this contract.
   */
  id: number;
}

export interface ContractsListRequest {
  /**
   * hours_used__gt
   */
  hoursUsedGt?: number;
  /**
   * hours_used__lt
   */
  hoursUsedLt?: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  organisationId?: number;
  /**
   *
   */
  organisationIdGt?: number;
  /**
   *
   */
  organisationIdGte?: number;
  /**
   *
   */
  organisationIdIsnull?: boolean;
  /**
   *
   */
  organisationIdLt?: number;
  /**
   *
   */
  organisationIdLte?: number;
  /**
   *
   */
  organisationName?: string;
  /**
   *
   */
  organisationNameContains?: string;
  /**
   *
   */
  organisationNameEndswith?: string;
  /**
   *
   */
  organisationNameIcontains?: string;
  /**
   *
   */
  organisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationNameIn?: Array<string>;
  /**
   *
   */
  organisationNameIstartswith?: string;
  /**
   *
   */
  organisationNameRegex?: string;
  /**
   *
   */
  organisationNameStartswith?: string;
  /**
   *
   */
  organisationUniqueId?: string;
  /**
   *
   */
  organisationUniqueIdContains?: string;
  /**
   *
   */
  organisationUniqueIdEndswith?: string;
  /**
   *
   */
  organisationUniqueIdIcontains?: string;
  /**
   *
   */
  organisationUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationUniqueIdIn?: Array<string>;
  /**
   *
   */
  organisationUniqueIdIstartswith?: string;
  /**
   *
   */
  organisationUniqueIdRegex?: string;
  /**
   *
   */
  organisationUniqueIdStartswith?: string;
}

export interface ContractsPartialUpdateRequest {
  /**
   * A unique integer value identifying this contract.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    PatchedContract,
    "url" | "id" | "organisationName" | "scope" | "hoursUsed" | "currentSessions"
  >;
}

export interface ContractsReadRequest {
  /**
   * A unique integer value identifying this contract.
   */
  id: number;
}

export interface ContractsUpdateRequest {
  /**
   * A unique integer value identifying this contract.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    Contract,
    "url" | "id" | "organisationName" | "scope" | "hoursUsed" | "currentSessions"
  >;
}

export interface FilesDeleteRequest {
  /**
   * A unique integer value identifying this file.
   */
  id: number;
}

export interface FilesDestroyFileRequest {
  /**
   * A unique integer value identifying this file.
   */
  id: number;
}

export interface FilesDownloadRequest {
  /**
   * A unique integer value identifying this file.
   */
  id: number;
}

export interface FilesListRequest {
  /**
   *
   */
  etag?: string;
  /**
   *
   */
  expiryDate?: Date;
  /**
   *
   */
  expiryDateGt?: Date;
  /**
   *
   */
  expiryDateGte?: Date;
  /**
   *
   */
  expiryDateLt?: Date;
  /**
   *
   */
  expiryDateLte?: Date;
  /**
   *
   */
  filename?: string;
  /**
   *
   */
  filenameIcontains?: string;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  meta?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * * `created` - created
   * * `uploaded` - uploaded
   * * `processed` - processed
   * * `error` - error
   * * `removed` - removed
   */
  state?: FilesListStateEnum;
  /**
   * Multiple values may be separated by commas.
   */
  stateIn?: Array<string>;
  /**
   * * `timeseries` - timeseries
   * * `rastertimeseries` - rastertimeseries
   * * `savedstate` - savedstate
   * * `results` - results
   * * `rasters` - rasters
   * * `gridadmin` - gridadmin
   * * `geopackage` - geopackage
   * * `geojson` - geojson
   * * `initialwaterlevel` - initialwaterlevel
   * * `initial_substance_concentration` - initial_substance_concentration
   * * `bulklateral` - bulklateral
   * * `bulkcontrol` - bulkcontrol
   * * `bulk_boundaryconditions` - bulk_boundaryconditions
   * * `sqlite` - sqlite
   * * `tables` - tables
   * * `bulktimeseriesrain` - bulktimeseriesrain
   */
  type?: FilesListTypeEnum;
  /**
   * Multiple values may be separated by commas.
   */
  typeIn?: Array<string>;
}

export interface FilesPartialUpdateRequest {
  /**
   * A unique integer value identifying this file.
   */
  id: number;
  /**
   *
   */
  data: Omit<PatchedFile, "url" | "storageName" | "relatedObject" | "id">;
}

export interface FilesProcessedRequest {
  /**
   * A unique integer value identifying this file.
   */
  id: number;
  /**
   *
   */
  data: FileMeta;
}

export interface FilesReadRequest {
  /**
   * A unique integer value identifying this file.
   */
  id: number;
}

export interface FilesUpdateRequest {
  /**
   * A unique integer value identifying this file.
   */
  id: number;
  /**
   *
   */
  data: Omit<ModelFile, "url" | "storageName" | "relatedObject" | "id">;
}

export interface InpyVersionsCreateRequest {
  /**
   *
   */
  data: Omit<InpyVersion, "url" | "slug" | "id">;
}

export interface InpyVersionsDeleteRequest {
  /**
   * A unique integer value identifying this inpy version.
   */
  id: number;
}

export interface InpyVersionsListRequest {
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  slugContains?: string;
  /**
   *
   */
  slugEndswith?: string;
  /**
   *
   */
  slugIcontains?: string;
  /**
   *
   */
  slugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  slugIn?: Array<string>;
  /**
   *
   */
  slugIstartswith?: string;
  /**
   *
   */
  slugRegex?: string;
  /**
   *
   */
  slugStartswith?: string;
  /**
   *
   */
  threediVersion?: string;
  /**
   *
   */
  threediVersionContains?: string;
  /**
   *
   */
  threediVersionEndswith?: string;
  /**
   *
   */
  threediVersionIcontains?: string;
  /**
   *
   */
  threediVersionIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  threediVersionIn?: Array<string>;
  /**
   *
   */
  threediVersionIstartswith?: string;
  /**
   *
   */
  threediVersionRegex?: string;
  /**
   *
   */
  threediVersionStartswith?: string;
  /**
   *
   */
  threedicoreVersion?: string;
  /**
   *
   */
  threedicoreVersionContains?: string;
  /**
   *
   */
  threedicoreVersionEndswith?: string;
  /**
   *
   */
  threedicoreVersionIcontains?: string;
  /**
   *
   */
  threedicoreVersionIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  threedicoreVersionIn?: Array<string>;
  /**
   *
   */
  threedicoreVersionIstartswith?: string;
  /**
   *
   */
  threedicoreVersionRegex?: string;
  /**
   *
   */
  threedicoreVersionStartswith?: string;
}

export interface InpyVersionsPartialUpdateRequest {
  /**
   * A unique integer value identifying this inpy version.
   */
  id: number;
  /**
   *
   */
  data: Omit<PatchedInpyVersion, "url" | "slug" | "id">;
}

export interface InpyVersionsReadRequest {
  /**
   * A unique integer value identifying this inpy version.
   */
  id: number;
}

export interface InpyVersionsUpdateRequest {
  /**
   * A unique integer value identifying this inpy version.
   */
  id: number;
  /**
   *
   */
  data: Omit<InpyVersion, "url" | "slug" | "id">;
}

export interface OrganisationSettingsCreateRequest {
  /**
   *
   */
  data: Omit<Settings, "url" | "id" | "organisationName">;
}

export interface OrganisationSettingsDeleteRequest {
  /**
   * A unique integer value identifying this organisation settings.
   */
  id: number;
}

export interface OrganisationSettingsListRequest {
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface OrganisationSettingsPartialUpdateRequest {
  /**
   * A unique integer value identifying this organisation settings.
   */
  id: number;
  /**
   *
   */
  data: Omit<Patchedsettings, "url" | "id" | "organisationName">;
}

export interface OrganisationSettingsReadRequest {
  /**
   * A unique integer value identifying this organisation settings.
   */
  id: number;
}

export interface OrganisationSettingsUpdateRequest {
  /**
   * A unique integer value identifying this organisation settings.
   */
  id: number;
  /**
   *
   */
  data: Omit<Settings, "url" | "id" | "organisationName">;
}

export interface OrganisationsCreateRequest {
  /**
   *
   */
  data: Omit<CreateOrganisation, "url">;
}

export interface OrganisationsDeleteRequest {
  /**
   *
   */
  uniqueId: string;
}

export interface OrganisationsListRequest {
  /**
   * Multiple values may be separated by commas.
   */
  contractScopeIn?: Array<string>;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * logged_in_user_has_role
   */
  loggedInUserHasRole?: string;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  uniqueId?: string;
  /**
   *
   */
  uniqueIdContains?: string;
  /**
   *
   */
  uniqueIdEndswith?: string;
  /**
   *
   */
  uniqueIdIcontains?: string;
  /**
   *
   */
  uniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  uniqueIdIn?: Array<string>;
  /**
   *
   */
  uniqueIdIstartswith?: string;
  /**
   *
   */
  uniqueIdRegex?: string;
  /**
   *
   */
  uniqueIdStartswith?: string;
  /**
   * valid_contracts_only
   */
  validContractsOnly?: boolean;
}

export interface OrganisationsPartialUpdateRequest {
  /**
   *
   */
  uniqueId: string;
  /**
   *
   */
  data: Omit<PatchedOrganisation, "url" | "ranaTenantId">;
}

export interface OrganisationsPermissionsRequest {
  /**
   *
   */
  uniqueId: string;
  /**
   * Multiple values may be separated by commas.
   */
  contractScopeIn?: Array<string>;
  /**
   * logged_in_user_has_role
   */
  loggedInUserHasRole?: string;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   *
   */
  uniqueId2?: string;
  /**
   *
   */
  uniqueIdContains?: string;
  /**
   *
   */
  uniqueIdEndswith?: string;
  /**
   *
   */
  uniqueIdIcontains?: string;
  /**
   *
   */
  uniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  uniqueIdIn?: Array<string>;
  /**
   *
   */
  uniqueIdIstartswith?: string;
  /**
   *
   */
  uniqueIdRegex?: string;
  /**
   *
   */
  uniqueIdStartswith?: string;
  /**
   * valid_contracts_only
   */
  validContractsOnly?: boolean;
}

export interface OrganisationsReadRequest {
  /**
   *
   */
  uniqueId: string;
}

export interface OrganisationsSetRanaTenantIdRequest {
  /**
   *
   */
  uniqueId: string;
  /**
   *
   */
  data: SetRanaTenant;
}

export interface OrganisationsUpdateRequest {
  /**
   *
   */
  uniqueId: string;
  /**
   *
   */
  data: Omit<CreateOrganisation, "url">;
}

export interface OrganisationsUsersListRequest {
  /**
   *
   */
  uniqueId: string;
  /**
   *
   */
  email?: string;
  /**
   *
   */
  emailContains?: string;
  /**
   *
   */
  emailEndswith?: string;
  /**
   *
   */
  emailIcontains?: string;
  /**
   *
   */
  emailIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  emailIn?: Array<string>;
  /**
   *
   */
  emailIstartswith?: string;
  /**
   *
   */
  emailRegex?: string;
  /**
   *
   */
  emailStartswith?: string;
  /**
   *
   */
  isActive?: boolean;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  remoteExternalUserId?: string;
  /**
   *
   */
  username?: string;
  /**
   *
   */
  usernameContains?: string;
  /**
   *
   */
  usernameEndswith?: string;
  /**
   *
   */
  usernameIcontains?: string;
  /**
   *
   */
  usernameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  usernameIn?: Array<string>;
  /**
   *
   */
  usernameIstartswith?: string;
  /**
   *
   */
  usernameRegex?: string;
  /**
   *
   */
  usernameStartswith?: string;
}

export interface OrganisationsUsersPartialUpdateRequest {
  /**
   * A unique integer value identifying this user.
   */
  id: number;
  /**
   *
   */
  uniqueId: string;
  /**
   *
   */
  data: PatchedOrganisationUserRolePatch;
}

export interface OrganisationsUsersReadRequest {
  /**
   * A unique integer value identifying this user.
   */
  id: number;
  /**
   *
   */
  uniqueId: string;
}

export interface PermissionsCreateRequest {
  /**
   *
   */
  data: Omit<OrganisationRole, "id" | "url" | "organisationName">;
}

export interface PermissionsDeleteRequest {
  /**
   * A unique integer value identifying this user organisation role.
   */
  id: number;
}

export interface PermissionsListRequest {
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  organisationName?: string;
  /**
   *
   */
  organisationNameContains?: string;
  /**
   *
   */
  organisationNameEndswith?: string;
  /**
   *
   */
  organisationNameIcontains?: string;
  /**
   *
   */
  organisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationNameIn?: Array<string>;
  /**
   *
   */
  organisationNameIstartswith?: string;
  /**
   *
   */
  organisationNameRegex?: string;
  /**
   *
   */
  organisationNameStartswith?: string;
  /**
   *
   */
  organisationUniqueId?: string;
  /**
   *
   */
  roleName?: string;
  /**
   *
   */
  roleNameContains?: string;
  /**
   *
   */
  roleNameEndswith?: string;
  /**
   *
   */
  roleNameIcontains?: string;
  /**
   *
   */
  roleNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  roleNameIn?: Array<string>;
  /**
   *
   */
  roleNameIstartswith?: string;
  /**
   *
   */
  roleNameRegex?: string;
  /**
   *
   */
  roleNameStartswith?: string;
  /**
   *
   */
  userId?: number;
  /**
   *
   */
  userRemoteExternalUserId?: string;
  /**
   *
   */
  userUsername?: string;
  /**
   *
   */
  userUsernameContains?: string;
  /**
   *
   */
  userUsernameEndswith?: string;
  /**
   *
   */
  userUsernameIcontains?: string;
  /**
   *
   */
  userUsernameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  userUsernameIn?: Array<string>;
  /**
   *
   */
  userUsernameIstartswith?: string;
  /**
   *
   */
  userUsernameRegex?: string;
  /**
   *
   */
  userUsernameStartswith?: string;
}

export interface PermissionsReadRequest {
  /**
   * A unique integer value identifying this user organisation role.
   */
  id: number;
}

export interface RepositoriesCreateRequest {
  /**
   *
   */
  data: Omit<Repository, "url" | "id" | "revision">;
}

export interface RepositoriesDeleteRequest {
  /**
   * A unique integer value identifying this repository.
   */
  id: number;
}

export interface RepositoriesListRequest {
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  organisationId?: number;
  /**
   *
   */
  organisationIdGt?: number;
  /**
   *
   */
  organisationIdGte?: number;
  /**
   *
   */
  organisationIdIsnull?: boolean;
  /**
   *
   */
  organisationIdLt?: number;
  /**
   *
   */
  organisationIdLte?: number;
  /**
   *
   */
  organisationName?: string;
  /**
   *
   */
  organisationNameContains?: string;
  /**
   *
   */
  organisationNameEndswith?: string;
  /**
   *
   */
  organisationNameIcontains?: string;
  /**
   *
   */
  organisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationNameIn?: Array<string>;
  /**
   *
   */
  organisationNameIstartswith?: string;
  /**
   *
   */
  organisationNameRegex?: string;
  /**
   *
   */
  organisationNameStartswith?: string;
  /**
   *
   */
  organisationUniqueId?: string;
  /**
   *
   */
  organisationUniqueIdContains?: string;
  /**
   *
   */
  organisationUniqueIdEndswith?: string;
  /**
   *
   */
  organisationUniqueIdIcontains?: string;
  /**
   *
   */
  organisationUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationUniqueIdIn?: Array<string>;
  /**
   *
   */
  organisationUniqueIdIstartswith?: string;
  /**
   *
   */
  organisationUniqueIdRegex?: string;
  /**
   *
   */
  organisationUniqueIdStartswith?: string;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  slugContains?: string;
  /**
   *
   */
  slugEndswith?: string;
  /**
   *
   */
  slugIcontains?: string;
  /**
   *
   */
  slugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  slugIn?: Array<string>;
  /**
   *
   */
  slugIstartswith?: string;
  /**
   *
   */
  slugRegex?: string;
  /**
   *
   */
  slugStartswith?: string;
}

export interface RepositoriesPartialUpdateRequest {
  /**
   * A unique integer value identifying this repository.
   */
  id: number;
  /**
   *
   */
  data: Omit<PatchedRepository, "url" | "id" | "revision">;
}

export interface RepositoriesReadRequest {
  /**
   * A unique integer value identifying this repository.
   */
  id: number;
}

export interface RepositoriesRevisionsRequest {
  /**
   * A unique integer value identifying this repository.
   */
  id: number;
  /**
   *
   */
  organisationId?: number;
  /**
   *
   */
  organisationIdGt?: number;
  /**
   *
   */
  organisationIdGte?: number;
  /**
   *
   */
  organisationIdIsnull?: boolean;
  /**
   *
   */
  organisationIdLt?: number;
  /**
   *
   */
  organisationIdLte?: number;
  /**
   *
   */
  organisationName?: string;
  /**
   *
   */
  organisationNameContains?: string;
  /**
   *
   */
  organisationNameEndswith?: string;
  /**
   *
   */
  organisationNameIcontains?: string;
  /**
   *
   */
  organisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationNameIn?: Array<string>;
  /**
   *
   */
  organisationNameIstartswith?: string;
  /**
   *
   */
  organisationNameRegex?: string;
  /**
   *
   */
  organisationNameStartswith?: string;
  /**
   *
   */
  organisationUniqueId?: string;
  /**
   *
   */
  organisationUniqueIdContains?: string;
  /**
   *
   */
  organisationUniqueIdEndswith?: string;
  /**
   *
   */
  organisationUniqueIdIcontains?: string;
  /**
   *
   */
  organisationUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationUniqueIdIn?: Array<string>;
  /**
   *
   */
  organisationUniqueIdIstartswith?: string;
  /**
   *
   */
  organisationUniqueIdRegex?: string;
  /**
   *
   */
  organisationUniqueIdStartswith?: string;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  slugContains?: string;
  /**
   *
   */
  slugEndswith?: string;
  /**
   *
   */
  slugIcontains?: string;
  /**
   *
   */
  slugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  slugIn?: Array<string>;
  /**
   *
   */
  slugIstartswith?: string;
  /**
   *
   */
  slugRegex?: string;
  /**
   *
   */
  slugStartswith?: string;
}

export interface RepositoriesThreedimodelsRequest {
  /**
   * A unique integer value identifying this repository.
   */
  id: number;
  /**
   *
   */
  organisationId?: number;
  /**
   *
   */
  organisationIdGt?: number;
  /**
   *
   */
  organisationIdGte?: number;
  /**
   *
   */
  organisationIdIsnull?: boolean;
  /**
   *
   */
  organisationIdLt?: number;
  /**
   *
   */
  organisationIdLte?: number;
  /**
   *
   */
  organisationName?: string;
  /**
   *
   */
  organisationNameContains?: string;
  /**
   *
   */
  organisationNameEndswith?: string;
  /**
   *
   */
  organisationNameIcontains?: string;
  /**
   *
   */
  organisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationNameIn?: Array<string>;
  /**
   *
   */
  organisationNameIstartswith?: string;
  /**
   *
   */
  organisationNameRegex?: string;
  /**
   *
   */
  organisationNameStartswith?: string;
  /**
   *
   */
  organisationUniqueId?: string;
  /**
   *
   */
  organisationUniqueIdContains?: string;
  /**
   *
   */
  organisationUniqueIdEndswith?: string;
  /**
   *
   */
  organisationUniqueIdIcontains?: string;
  /**
   *
   */
  organisationUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  organisationUniqueIdIn?: Array<string>;
  /**
   *
   */
  organisationUniqueIdIstartswith?: string;
  /**
   *
   */
  organisationUniqueIdRegex?: string;
  /**
   *
   */
  organisationUniqueIdStartswith?: string;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  slugContains?: string;
  /**
   *
   */
  slugEndswith?: string;
  /**
   *
   */
  slugIcontains?: string;
  /**
   *
   */
  slugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  slugIn?: Array<string>;
  /**
   *
   */
  slugIstartswith?: string;
  /**
   *
   */
  slugRegex?: string;
  /**
   *
   */
  slugStartswith?: string;
}

export interface RepositoriesUpdateRequest {
  /**
   * A unique integer value identifying this repository.
   */
  id: number;
  /**
   *
   */
  data: Omit<Repository, "url" | "id" | "revision">;
}

export interface RevisionsCreateRequest {
  /**
   *
   */
  data: Omit<Revision, "url" | "id">;
}

export interface RevisionsDeleteRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
}

export interface RevisionsListRequest {
  /**
   *
   */
  hash?: string;
  /**
   *
   */
  hashContains?: string;
  /**
   *
   */
  hashEndswith?: string;
  /**
   *
   */
  hashIcontains?: string;
  /**
   *
   */
  hashIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  hashIn?: Array<string>;
  /**
   *
   */
  hashIstartswith?: string;
  /**
   *
   */
  hashRegex?: string;
  /**
   *
   */
  hashStartswith?: string;
  /**
   *
   */
  isPinned?: boolean;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  number?: number;
  /**
   *
   */
  numberGt?: number;
  /**
   *
   */
  numberGte?: number;
  /**
   *
   */
  numberIsnull?: boolean;
  /**
   *
   */
  numberLt?: number;
  /**
   *
   */
  numberLte?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  repositoryId?: number;
  /**
   *
   */
  repositoryIdGt?: number;
  /**
   *
   */
  repositoryIdGte?: number;
  /**
   *
   */
  repositoryIdIsnull?: boolean;
  /**
   *
   */
  repositoryIdLt?: number;
  /**
   *
   */
  repositoryIdLte?: number;
  /**
   *
   */
  repositoryOrganisationName?: string;
  /**
   *
   */
  repositoryOrganisationNameContains?: string;
  /**
   *
   */
  repositoryOrganisationNameEndswith?: string;
  /**
   *
   */
  repositoryOrganisationNameIcontains?: string;
  /**
   *
   */
  repositoryOrganisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  repositoryOrganisationNameIn?: Array<string>;
  /**
   *
   */
  repositoryOrganisationNameIstartswith?: string;
  /**
   *
   */
  repositoryOrganisationNameRegex?: string;
  /**
   *
   */
  repositoryOrganisationNameStartswith?: string;
  /**
   *
   */
  repositoryOrganisationUniqueId?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdContains?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdEndswith?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdIcontains?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  repositoryOrganisationUniqueIdIn?: Array<string>;
  /**
   *
   */
  repositoryOrganisationUniqueIdIstartswith?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdRegex?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdStartswith?: string;
  /**
   *
   */
  repositorySlug?: string;
  /**
   *
   */
  repositorySlugContains?: string;
  /**
   *
   */
  repositorySlugEndswith?: string;
  /**
   *
   */
  repositorySlugIcontains?: string;
  /**
   *
   */
  repositorySlugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  repositorySlugIn?: Array<string>;
  /**
   *
   */
  repositorySlugIstartswith?: string;
  /**
   *
   */
  repositorySlugRegex?: string;
  /**
   *
   */
  repositorySlugStartswith?: string;
}

export interface RevisionsPartialUpdateRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  data: Omit<PatchedRevision, "url" | "id">;
}

export interface RevisionsReadRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
}

export interface RevisionsThreedimodelsRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  hash?: string;
  /**
   *
   */
  hashContains?: string;
  /**
   *
   */
  hashEndswith?: string;
  /**
   *
   */
  hashIcontains?: string;
  /**
   *
   */
  hashIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  hashIn?: Array<string>;
  /**
   *
   */
  hashIstartswith?: string;
  /**
   *
   */
  hashRegex?: string;
  /**
   *
   */
  hashStartswith?: string;
  /**
   *
   */
  isPinned?: boolean;
  /**
   *
   */
  number?: number;
  /**
   *
   */
  numberGt?: number;
  /**
   *
   */
  numberGte?: number;
  /**
   *
   */
  numberIsnull?: boolean;
  /**
   *
   */
  numberLt?: number;
  /**
   *
   */
  numberLte?: number;
  /**
   *
   */
  repositoryId?: number;
  /**
   *
   */
  repositoryIdGt?: number;
  /**
   *
   */
  repositoryIdGte?: number;
  /**
   *
   */
  repositoryIdIsnull?: boolean;
  /**
   *
   */
  repositoryIdLt?: number;
  /**
   *
   */
  repositoryIdLte?: number;
  /**
   *
   */
  repositoryOrganisationName?: string;
  /**
   *
   */
  repositoryOrganisationNameContains?: string;
  /**
   *
   */
  repositoryOrganisationNameEndswith?: string;
  /**
   *
   */
  repositoryOrganisationNameIcontains?: string;
  /**
   *
   */
  repositoryOrganisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  repositoryOrganisationNameIn?: Array<string>;
  /**
   *
   */
  repositoryOrganisationNameIstartswith?: string;
  /**
   *
   */
  repositoryOrganisationNameRegex?: string;
  /**
   *
   */
  repositoryOrganisationNameStartswith?: string;
  /**
   *
   */
  repositoryOrganisationUniqueId?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdContains?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdEndswith?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdIcontains?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  repositoryOrganisationUniqueIdIn?: Array<string>;
  /**
   *
   */
  repositoryOrganisationUniqueIdIstartswith?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdRegex?: string;
  /**
   *
   */
  repositoryOrganisationUniqueIdStartswith?: string;
  /**
   *
   */
  repositorySlug?: string;
  /**
   *
   */
  repositorySlugContains?: string;
  /**
   *
   */
  repositorySlugEndswith?: string;
  /**
   *
   */
  repositorySlugIcontains?: string;
  /**
   *
   */
  repositorySlugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  repositorySlugIn?: Array<string>;
  /**
   *
   */
  repositorySlugIstartswith?: string;
  /**
   *
   */
  repositorySlugRegex?: string;
  /**
   *
   */
  repositorySlugStartswith?: string;
}

export interface RevisionsUpdateRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  data: Omit<Revision, "url" | "id">;
}

export interface RolesListRequest {
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface RolesReadRequest {
  /**
   * A unique integer value identifying this role.
   */
  id: number;
}

export interface SchematisationsCreateRequest {
  /**
   *
   */
  data: Omit<
    Schematisation,
    | "url"
    | "id"
    | "createdByFirstName"
    | "createdByLastName"
    | "archived"
    | "lastUpdated"
    | "storageUsage"
    | "threedimodelLimit"
    | "latestRevisionNr"
    | "ranaTenantId"
  >;
}

export interface SchematisationsDeleteRequest {
  /**
   * A unique integer value identifying this schematisation.
   */
  id: number;
}

export interface SchematisationsLatestRevisionRequest {
  /**
   * A unique integer value identifying this schematisation.
   */
  id: number;
}

export interface SchematisationsListRequest {
  /**
   * archived
   */
  archived?: boolean;
  /**
   *
   */
  createdDate?: Date;
  /**
   *
   */
  createdDateGt?: Date;
  /**
   *
   */
  createdDateGte?: Date;
  /**
   *
   */
  createdDateLt?: Date;
  /**
   *
   */
  createdDateLte?: Date;
  /**
   *
   */
  createdDay?: number;
  /**
   *
   */
  createdDayLt?: number;
  /**
   *
   */
  createdHour?: number;
  /**
   *
   */
  createdIsnull?: boolean;
  /**
   *
   */
  createdMinute?: number;
  /**
   *
   */
  createdMonth?: number;
  /**
   *
   */
  createdMonthLte?: number;
  /**
   *
   */
  createdQuarter?: number;
  /**
   * Multiple values may be separated by commas.
   */
  createdRange?: Array<Date>;
  /**
   *
   */
  createdSecond?: number;
  /**
   *
   */
  createdTime?: string;
  /**
   *
   */
  createdWeek?: number;
  /**
   *
   */
  createdWeekDay?: number;
  /**
   *
   */
  createdYear?: number;
  /**
   *
   */
  createdYearGt?: number;
  /**
   *
   */
  createdYearGte?: number;
  /**
   *
   */
  createdYearLt?: number;
  /**
   *
   */
  createdYearLte?: number;
  /**
   *
   */
  createdByUsername?: string;
  /**
   *
   */
  createdByUsernameContains?: string;
  /**
   *
   */
  createdByUsernameEndswith?: string;
  /**
   *
   */
  createdByUsernameIcontains?: string;
  /**
   *
   */
  createdByUsernameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  createdByUsernameIn?: Array<string>;
  /**
   *
   */
  createdByUsernameIstartswith?: string;
  /**
   *
   */
  createdByUsernameRegex?: string;
  /**
   *
   */
  createdByUsernameStartswith?: string;
  /**
   *
   */
  lastUpdatedDate?: Date;
  /**
   *
   */
  lastUpdatedDateGt?: Date;
  /**
   *
   */
  lastUpdatedDateGte?: Date;
  /**
   *
   */
  lastUpdatedDateLt?: Date;
  /**
   *
   */
  lastUpdatedDateLte?: Date;
  /**
   *
   */
  lastUpdatedDay?: number;
  /**
   *
   */
  lastUpdatedDayLt?: number;
  /**
   *
   */
  lastUpdatedHour?: number;
  /**
   *
   */
  lastUpdatedIsnull?: boolean;
  /**
   *
   */
  lastUpdatedMinute?: number;
  /**
   *
   */
  lastUpdatedMonth?: number;
  /**
   *
   */
  lastUpdatedMonthLte?: number;
  /**
   *
   */
  lastUpdatedQuarter?: number;
  /**
   * Multiple values may be separated by commas.
   */
  lastUpdatedRange?: Array<Date>;
  /**
   *
   */
  lastUpdatedSecond?: number;
  /**
   *
   */
  lastUpdatedTime?: string;
  /**
   *
   */
  lastUpdatedWeek?: number;
  /**
   *
   */
  lastUpdatedWeekDay?: number;
  /**
   *
   */
  lastUpdatedYear?: number;
  /**
   *
   */
  lastUpdatedYearGt?: number;
  /**
   *
   */
  lastUpdatedYearGte?: number;
  /**
   *
   */
  lastUpdatedYearLt?: number;
  /**
   *
   */
  lastUpdatedYearLte?: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  ownerName?: string;
  /**
   *
   */
  ownerNameContains?: string;
  /**
   *
   */
  ownerNameEndswith?: string;
  /**
   *
   */
  ownerNameIcontains?: string;
  /**
   *
   */
  ownerNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  ownerNameIn?: Array<string>;
  /**
   *
   */
  ownerNameIstartswith?: string;
  /**
   *
   */
  ownerNameRegex?: string;
  /**
   *
   */
  ownerNameStartswith?: string;
  /**
   *
   */
  ownerUniqueId?: string;
  /**
   *
   */
  ownerUniqueIdContains?: string;
  /**
   *
   */
  ownerUniqueIdEndswith?: string;
  /**
   *
   */
  ownerUniqueIdIcontains?: string;
  /**
   *
   */
  ownerUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  ownerUniqueIdIn?: Array<string>;
  /**
   *
   */
  ownerUniqueIdIstartswith?: string;
  /**
   *
   */
  ownerUniqueIdRegex?: string;
  /**
   *
   */
  ownerUniqueIdStartswith?: string;
  /**
   *
   */
  ranaProjectId?: string;
  /**
   *
   */
  ranaProjectIdIsnull?: boolean;
  /**
   *
   */
  ranaTenantId?: string;
  /**
   *
   */
  ranaTenantIdIsnull?: boolean;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  slugContains?: string;
  /**
   *
   */
  slugEndswith?: string;
  /**
   *
   */
  slugIcontains?: string;
  /**
   *
   */
  slugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  slugIn?: Array<string>;
  /**
   *
   */
  slugIstartswith?: string;
  /**
   *
   */
  slugRegex?: string;
  /**
   *
   */
  slugStartswith?: string;
  /**
   * tags__in
   */
  tagsIn?: string;
}

export interface SchematisationsPartialUpdateRequest {
  /**
   * A unique integer value identifying this schematisation.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    PatchedSchematisation,
    | "url"
    | "id"
    | "createdByFirstName"
    | "createdByLastName"
    | "archived"
    | "lastUpdated"
    | "storageUsage"
    | "threedimodelLimit"
    | "latestRevisionNr"
    | "ranaTenantId"
  >;
}

export interface SchematisationsReadRequest {
  /**
   * A unique integer value identifying this schematisation.
   */
  id: number;
}

export interface SchematisationsRevisionsCheckRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsCloneToSchematisationRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: CloneRevision;
}

export interface SchematisationsRevisionsCommitRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Commit;
}

export interface SchematisationsRevisionsCreateRequest {
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: CreateRevision;
}

export interface SchematisationsRevisionsCreateThreedimodelRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: CreateThreedimodel;
}

export interface SchematisationsRevisionsDeleteRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: DestroyRevision;
}

export interface SchematisationsRevisionsListRequest {
  /**
   *
   */
  schematisationPk: number;
  /**
   * archived
   */
  archived?: boolean;
  /**
   *
   */
  commitDate?: Date;
  /**
   *
   */
  commitDateDate?: Date;
  /**
   *
   */
  commitDateDateGt?: Date;
  /**
   *
   */
  commitDateDateGte?: Date;
  /**
   *
   */
  commitDateDateLt?: Date;
  /**
   *
   */
  commitDateDateLte?: Date;
  /**
   *
   */
  commitDateDay?: number;
  /**
   *
   */
  commitDateDayLt?: number;
  /**
   *
   */
  commitDateGt?: Date;
  /**
   *
   */
  commitDateGte?: Date;
  /**
   *
   */
  commitDateLt?: Date;
  /**
   *
   */
  commitDateLte?: Date;
  /**
   *
   */
  commitDateMonth?: number;
  /**
   *
   */
  commitDateMonthLte?: number;
  /**
   *
   */
  commitDateWeek?: number;
  /**
   *
   */
  commitDateWeekDay?: number;
  /**
   *
   */
  commitDateYear?: number;
  /**
   *
   */
  commitDateYearGt?: number;
  /**
   *
   */
  commitDateYearGte?: number;
  /**
   *
   */
  commitDateYearLt?: number;
  /**
   *
   */
  commitDateYearLte?: number;
  /**
   *
   */
  commitMessage?: string;
  /**
   *
   */
  commitMessageContains?: string;
  /**
   *
   */
  commitMessageEndswith?: string;
  /**
   *
   */
  commitMessageIcontains?: string;
  /**
   *
   */
  commitMessageIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  commitMessageIn?: Array<string>;
  /**
   *
   */
  commitMessageIstartswith?: string;
  /**
   *
   */
  commitMessageRegex?: string;
  /**
   *
   */
  commitMessageStartswith?: string;
  /**
   *
   */
  commitUserUsername?: string;
  /**
   *
   */
  commitUserUsernameContains?: string;
  /**
   *
   */
  commitUserUsernameEndswith?: string;
  /**
   *
   */
  commitUserUsernameIcontains?: string;
  /**
   *
   */
  commitUserUsernameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  commitUserUsernameIn?: Array<string>;
  /**
   *
   */
  commitUserUsernameIstartswith?: string;
  /**
   *
   */
  commitUserUsernameRegex?: string;
  /**
   *
   */
  commitUserUsernameStartswith?: string;
  /**
   * committed
   */
  committed?: boolean;
  /**
   * has_threedimodel
   */
  hasThreedimodel?: boolean;
  /**
   * is_valid
   */
  isValid?: boolean;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  number?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  schematisationId?: number;
  /**
   *
   */
  schematisationOwnerName?: string;
  /**
   *
   */
  schematisationOwnerNameContains?: string;
  /**
   *
   */
  schematisationOwnerNameEndswith?: string;
  /**
   *
   */
  schematisationOwnerNameIcontains?: string;
  /**
   *
   */
  schematisationOwnerNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  schematisationOwnerNameIn?: Array<string>;
  /**
   *
   */
  schematisationOwnerNameIstartswith?: string;
  /**
   *
   */
  schematisationOwnerNameRegex?: string;
  /**
   *
   */
  schematisationOwnerNameStartswith?: string;
  /**
   *
   */
  schematisationOwnerUniqueId?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdContains?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdEndswith?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdIcontains?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  schematisationOwnerUniqueIdIn?: Array<string>;
  /**
   *
   */
  schematisationOwnerUniqueIdIstartswith?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdRegex?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdStartswith?: string;
  /**
   *
   */
  schematisationSlug?: string;
  /**
   *
   */
  schematisationSlugContains?: string;
  /**
   *
   */
  schematisationSlugEndswith?: string;
  /**
   *
   */
  schematisationSlugIcontains?: string;
  /**
   *
   */
  schematisationSlugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  schematisationSlugIn?: Array<string>;
  /**
   *
   */
  schematisationSlugIstartswith?: string;
  /**
   *
   */
  schematisationSlugRegex?: string;
  /**
   *
   */
  schematisationSlugStartswith?: string;
}

export interface SchematisationsRevisionsPartialUpdateRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: PatchedUpdateRevision;
}

export interface SchematisationsRevisionsRastersCreateRequest {
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<RasterCreate, "url" | "id" | "epsgCode" | "geotransform">;
}

export interface SchematisationsRevisionsRastersDeleteRequest {
  /**
   * A unique integer value identifying this revision raster.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsRastersDownloadRequest {
  /**
   * A unique integer value identifying this revision raster.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsRastersListRequest {
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SchematisationsRevisionsRastersPartialUpdateRequest {
  /**
   * A unique integer value identifying this revision raster.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<PatchedRevisionRaster, "url" | "file" | "id" | "epsgCode" | "geotransform">;
}

export interface SchematisationsRevisionsRastersReadRequest {
  /**
   * A unique integer value identifying this revision raster.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsRastersUpdateRequest {
  /**
   * A unique integer value identifying this revision raster.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<RevisionRaster, "url" | "file" | "id" | "epsgCode" | "geotransform">;
}

export interface SchematisationsRevisionsRastersUploadRequest {
  /**
   * A unique integer value identifying this revision raster.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface SchematisationsRevisionsReadRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsSqliteDeleteRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsSqliteDownloadRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsSqliteUploadRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<SqliteFileUpload, "putUrl" | "status">;
}

export interface SchematisationsRevisionsTasksCreateRequest {
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<RevisionTask, "url" | "created" | "lastUpdated" | "revision" | "id">;
}

export interface SchematisationsRevisionsTasksDeleteRequest {
  /**
   * A unique integer value identifying this revision task.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsTasksListRequest {
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SchematisationsRevisionsTasksPartialUpdateRequest {
  /**
   * A unique integer value identifying this revision task.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<PatchedRevisionTask, "url" | "created" | "lastUpdated" | "revision" | "id">;
}

export interface SchematisationsRevisionsTasksReadRequest {
  /**
   * A unique integer value identifying this revision task.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
}

export interface SchematisationsRevisionsTasksUpdateRequest {
  /**
   * A unique integer value identifying this revision task.
   */
  id: number;
  /**
   *
   */
  revisionPk: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<RevisionTask, "url" | "created" | "lastUpdated" | "revision" | "id">;
}

export interface SchematisationsRevisionsThreedimodelsRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   * archived
   */
  archived?: boolean;
  /**
   *
   */
  commitDate?: Date;
  /**
   *
   */
  commitDateDate?: Date;
  /**
   *
   */
  commitDateDateGt?: Date;
  /**
   *
   */
  commitDateDateGte?: Date;
  /**
   *
   */
  commitDateDateLt?: Date;
  /**
   *
   */
  commitDateDateLte?: Date;
  /**
   *
   */
  commitDateDay?: number;
  /**
   *
   */
  commitDateDayLt?: number;
  /**
   *
   */
  commitDateGt?: Date;
  /**
   *
   */
  commitDateGte?: Date;
  /**
   *
   */
  commitDateLt?: Date;
  /**
   *
   */
  commitDateLte?: Date;
  /**
   *
   */
  commitDateMonth?: number;
  /**
   *
   */
  commitDateMonthLte?: number;
  /**
   *
   */
  commitDateWeek?: number;
  /**
   *
   */
  commitDateWeekDay?: number;
  /**
   *
   */
  commitDateYear?: number;
  /**
   *
   */
  commitDateYearGt?: number;
  /**
   *
   */
  commitDateYearGte?: number;
  /**
   *
   */
  commitDateYearLt?: number;
  /**
   *
   */
  commitDateYearLte?: number;
  /**
   *
   */
  commitMessage?: string;
  /**
   *
   */
  commitMessageContains?: string;
  /**
   *
   */
  commitMessageEndswith?: string;
  /**
   *
   */
  commitMessageIcontains?: string;
  /**
   *
   */
  commitMessageIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  commitMessageIn?: Array<string>;
  /**
   *
   */
  commitMessageIstartswith?: string;
  /**
   *
   */
  commitMessageRegex?: string;
  /**
   *
   */
  commitMessageStartswith?: string;
  /**
   *
   */
  commitUserUsername?: string;
  /**
   *
   */
  commitUserUsernameContains?: string;
  /**
   *
   */
  commitUserUsernameEndswith?: string;
  /**
   *
   */
  commitUserUsernameIcontains?: string;
  /**
   *
   */
  commitUserUsernameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  commitUserUsernameIn?: Array<string>;
  /**
   *
   */
  commitUserUsernameIstartswith?: string;
  /**
   *
   */
  commitUserUsernameRegex?: string;
  /**
   *
   */
  commitUserUsernameStartswith?: string;
  /**
   * committed
   */
  committed?: boolean;
  /**
   * has_threedimodel
   */
  hasThreedimodel?: boolean;
  /**
   * is_valid
   */
  isValid?: boolean;
  /**
   *
   */
  number?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  schematisationId?: number;
  /**
   *
   */
  schematisationOwnerName?: string;
  /**
   *
   */
  schematisationOwnerNameContains?: string;
  /**
   *
   */
  schematisationOwnerNameEndswith?: string;
  /**
   *
   */
  schematisationOwnerNameIcontains?: string;
  /**
   *
   */
  schematisationOwnerNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  schematisationOwnerNameIn?: Array<string>;
  /**
   *
   */
  schematisationOwnerNameIstartswith?: string;
  /**
   *
   */
  schematisationOwnerNameRegex?: string;
  /**
   *
   */
  schematisationOwnerNameStartswith?: string;
  /**
   *
   */
  schematisationOwnerUniqueId?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdContains?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdEndswith?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdIcontains?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  schematisationOwnerUniqueIdIn?: Array<string>;
  /**
   *
   */
  schematisationOwnerUniqueIdIstartswith?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdRegex?: string;
  /**
   *
   */
  schematisationOwnerUniqueIdStartswith?: string;
  /**
   *
   */
  schematisationSlug?: string;
  /**
   *
   */
  schematisationSlugContains?: string;
  /**
   *
   */
  schematisationSlugEndswith?: string;
  /**
   *
   */
  schematisationSlugIcontains?: string;
  /**
   *
   */
  schematisationSlugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  schematisationSlugIn?: Array<string>;
  /**
   *
   */
  schematisationSlugIstartswith?: string;
  /**
   *
   */
  schematisationSlugRegex?: string;
  /**
   *
   */
  schematisationSlugStartswith?: string;
}

export interface SchematisationsRevisionsUpdateRequest {
  /**
   * A unique integer value identifying this revision.
   */
  id: number;
  /**
   *
   */
  schematisationPk: number;
  /**
   *
   */
  data: Omit<
    SchematisationRevision,
    | "url"
    | "id"
    | "created"
    | "schematisation"
    | "schematisationId"
    | "number"
    | "sqlite"
    | "rasters"
    | "archived"
    | "commitDate"
    | "commitUser"
    | "commitFirstName"
    | "commitLastName"
    | "commitMessage"
    | "isValid"
    | "hasThreedimodel"
    | "clonedFrom"
    | "clonedFromRevisionId"
    | "clonedFromSchematisationId"
  >;
}

export interface SchematisationsUpdateRequest {
  /**
   * A unique integer value identifying this schematisation.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    Schematisation,
    | "url"
    | "id"
    | "createdByFirstName"
    | "createdByLastName"
    | "archived"
    | "lastUpdated"
    | "storageUsage"
    | "threedimodelLimit"
    | "latestRevisionNr"
    | "ranaTenantId"
  >;
}

export interface SimulationTemplatesCreateRequest {
  /**
   *
   */
  data: CreateTemplate;
}

export interface SimulationTemplatesDeleteRequest {
  /**
   * A unique integer value identifying this template.
   */
  id: number;
}

export interface SimulationTemplatesListRequest {
  /**
   *
   */
  createdDate?: Date;
  /**
   *
   */
  createdDateGt?: Date;
  /**
   *
   */
  createdDateGte?: Date;
  /**
   *
   */
  createdDateLt?: Date;
  /**
   *
   */
  createdDateLte?: Date;
  /**
   *
   */
  createdDay?: number;
  /**
   *
   */
  createdDayLt?: number;
  /**
   *
   */
  createdMonth?: number;
  /**
   *
   */
  createdMonthLte?: number;
  /**
   *
   */
  createdYear?: number;
  /**
   *
   */
  createdYearGt?: number;
  /**
   *
   */
  createdYearGte?: number;
  /**
   *
   */
  createdYearLt?: number;
  /**
   *
   */
  createdYearLte?: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  simulationThreedimodelId?: number;
  /**
   * Multiple values may be separated by commas.
   */
  simulationThreedimodelIdRange?: Array<number>;
  /**
   *
   */
  uuid?: string;
  /**
   *
   */
  uuidContains?: string;
  /**
   *
   */
  uuidEndswith?: string;
  /**
   *
   */
  uuidIcontains?: string;
  /**
   *
   */
  uuidIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  uuidIn?: Array<string>;
  /**
   *
   */
  uuidIstartswith?: string;
  /**
   *
   */
  uuidRegex?: string;
  /**
   *
   */
  uuidStartswith?: string;
}

export interface SimulationTemplatesPartialUpdateRequest {
  /**
   * A unique integer value identifying this template.
   */
  id: number;
  /**
   *
   */
  data: PatchedUpdateTemplate;
}

export interface SimulationTemplatesReadRequest {
  /**
   * A unique integer value identifying this template.
   */
  id: number;
}

export interface SimulationTemplatesUpdateRequest {
  /**
   * A unique integer value identifying this template.
   */
  id: number;
  /**
   *
   */
  data: Omit<Template, "url" | "id" | "created" | "simulation">;
}

export interface SimulationsActionsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Action;
}

export interface SimulationsActionsResetPauseTimeoutRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Timeout;
}

export interface SimulationsCloneRequest {
  /**
   * A unique integer value identifying this simulation.
   */
  id: number;
}

export interface SimulationsCreateRequest {
  /**
   *
   */
  data: Omit<
    Simulation,
    | "url"
    | "slug"
    | "uuid"
    | "created"
    | "organisationName"
    | "user"
    | "durationHumanized"
    | "threedimodelId"
    | "id"
    | "clonedFrom"
    | "computeCluster"
    | "ranaTenantId"
    | "ranaProjectId"
  >;
}

export interface SimulationsCreateSavedStatesStableThresholdCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<StableThresholdSavedState, "url" | "simulation" | "created">;
}

export interface SimulationsCreateSavedStatesStableThresholdDeleteRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsCreateSavedStatesStableThresholdListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsCreateSavedStatesStableThresholdPartialUpdateRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedStableThresholdSavedState, "url" | "simulation" | "created">;
}

export interface SimulationsCreateSavedStatesStableThresholdReadRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsCreateSavedStatesStableThresholdUpdateRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<StableThresholdSavedState, "url" | "simulation" | "created">;
}

export interface SimulationsCreateSavedStatesStableThresholdUploadRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface SimulationsCreateSavedStatesTimedCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimedSavedStateUpdate, "url" | "simulation" | "file" | "id">;
}

export interface SimulationsCreateSavedStatesTimedDeleteRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsCreateSavedStatesTimedListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsCreateSavedStatesTimedPartialUpdateRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTimedSavedStateUpdate, "url" | "simulation" | "file" | "id">;
}

export interface SimulationsCreateSavedStatesTimedReadRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsCreateSavedStatesTimedUpdateRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimedSavedStateUpdate, "url" | "simulation" | "file" | "id">;
}

export interface SimulationsCreateSavedStatesTimedUploadRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface SimulationsDeleteRequest {
  /**
   * A unique integer value identifying this simulation.
   */
  id: number;
}

export interface SimulationsEventsRequest {
  /**
   * A unique integer value identifying this simulation.
   */
  id: number;
}

export interface SimulationsEventsBoundaryconditionsFileCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface SimulationsEventsBoundaryconditionsFileDeleteRequest {
  /**
   * A unique integer value identifying this bulk boundary condition.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsBoundaryconditionsFileDownloadRequest {
  /**
   * A unique integer value identifying this bulk boundary condition.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsBoundaryconditionsFileListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsBoundaryconditionsFilePartialUpdateRequest {
  /**
   * A unique integer value identifying this bulk boundary condition.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedFileBoundaryCondition,
    "url" | "id" | "uid" | "simulation" | "file" | "state" | "stateDetail"
  >;
}

export interface SimulationsEventsBoundaryconditionsFileProcessedRequest {
  /**
   * A unique integer value identifying this bulk boundary condition.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: BaseEventState;
}

export interface SimulationsEventsBoundaryconditionsFileReadRequest {
  /**
   * A unique integer value identifying this bulk boundary condition.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsBoundaryconditionsFileUpdateRequest {
  /**
   * A unique integer value identifying this bulk boundary condition.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    FileBoundaryCondition,
    "url" | "id" | "uid" | "simulation" | "file" | "state" | "stateDetail"
  >;
}

export interface SimulationsEventsBreachesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Breach, "url" | "simulation" | "id" | "uid">;
}

export interface SimulationsEventsBreachesDeleteRequest {
  /**
   * A unique integer value identifying this breach.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsBreachesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsBreachesPartialUpdateRequest {
  /**
   * A unique integer value identifying this breach.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedBreach, "url" | "simulation" | "id" | "uid">;
}

export interface SimulationsEventsBreachesReadRequest {
  /**
   * A unique integer value identifying this breach.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsBreachesUpdateRequest {
  /**
   * A unique integer value identifying this breach.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Breach, "url" | "simulation" | "id" | "uid">;
}

export interface SimulationsEventsLateralConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    ConstantLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "uid" | "id"
  >;
}

export interface SimulationsEventsLateralConstantDeleteRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLateralConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsLateralConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedConstantLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "uid" | "id"
  >;
}

export interface SimulationsEventsLateralConstantProcessedRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: GridEventState;
}

export interface SimulationsEventsLateralConstantReadRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLateralConstantUpdateRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    ConstantLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "uid" | "id"
  >;
}

export interface SimulationsEventsLateralFileCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadLateralFile, "putUrl" | "status">;
}

export interface SimulationsEventsLateralFileDeleteRequest {
  /**
   * A unique integer value identifying this bulk lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLateralFileDownloadRequest {
  /**
   * A unique integer value identifying this bulk lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLateralFileListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsLateralFilePartialUpdateRequest {
  /**
   * A unique integer value identifying this bulk lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedFileLateral,
    "url" | "id" | "uid" | "simulation" | "state" | "stateDetail" | "periodic"
  >;
}

export interface SimulationsEventsLateralFileProcessedRequest {
  /**
   * A unique integer value identifying this bulk lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: BaseEventState;
}

export interface SimulationsEventsLateralFileReadRequest {
  /**
   * A unique integer value identifying this bulk lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLateralFileUpdateRequest {
  /**
   * A unique integer value identifying this bulk lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    FileLateral,
    "url" | "id" | "uid" | "simulation" | "state" | "stateDetail" | "periodic"
  >;
}

export interface SimulationsEventsLateralTimeseriesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    TimeseriesLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "id" | "uid"
  >;
}

export interface SimulationsEventsLateralTimeseriesDeleteRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLateralTimeseriesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsLateralTimeseriesPartialUpdateRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedTimeseriesLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "id" | "uid"
  >;
}

export interface SimulationsEventsLateralTimeseriesProcessedRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: GridEventState;
}

export interface SimulationsEventsLateralTimeseriesReadRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLateralTimeseriesUpdateRequest {
  /**
   * A unique integer value identifying this lateral.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    TimeseriesLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "id" | "uid"
  >;
}

export interface SimulationsEventsLeakageConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantLeakage, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsLeakageConstantDeleteRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsLeakageConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedConstantLeakage, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsLeakageConstantReadRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageConstantUpdateRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantLeakage, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsLeakageRastersNetcdfCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadWithSubstances, "putUrl" | "status">;
}

export interface SimulationsEventsLeakageRastersNetcdfDeleteRequest {
  /**
   * A unique integer value identifying this file raster leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageRastersNetcdfListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsLeakageRastersNetcdfReadRequest {
  /**
   * A unique integer value identifying this file raster leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageTimeseriesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesLeakage, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsLeakageTimeseriesDeleteRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageTimeseriesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsLeakageTimeseriesNetcdfCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadWithSubstances, "putUrl" | "status">;
}

export interface SimulationsEventsLeakageTimeseriesNetcdfDeleteRequest {
  /**
   * A unique integer value identifying this file timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageTimeseriesNetcdfListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsLeakageTimeseriesNetcdfReadRequest {
  /**
   * A unique integer value identifying this file timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageTimeseriesPartialUpdateRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTimeseriesLeakage, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsLeakageTimeseriesReadRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsLeakageTimeseriesUpdateRequest {
  /**
   * A unique integer value identifying this timeseries leakage.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesLeakage, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainConstantDeleteRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedConstantRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainConstantReadRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainConstantUpdateRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainLocalConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantLocalRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainLocalConstantDeleteRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainLocalConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainLocalConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedConstantLocalRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainLocalConstantReadRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainLocalConstantUpdateRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantLocalRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainLocalTimeseriesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesLocalRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainLocalTimeseriesDeleteRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainLocalTimeseriesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainLocalTimeseriesPartialUpdateRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTimeseriesLocalRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainLocalTimeseriesReadRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainLocalTimeseriesUpdateRequest {
  /**
   * A unique integer value identifying this local rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesLocalRain, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRainRastersLizardCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    LizardRasterRain,
    | "url"
    | "uid"
    | "simulation"
    | "interval"
    | "user"
    | "userId"
    | "originOffset"
    | "storePath"
    | "id"
  >;
}

export interface SimulationsEventsRainRastersLizardDeleteRequest {
  /**
   * A unique integer value identifying this lizard raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainRastersLizardListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainRastersLizardPartialUpdateRequest {
  /**
   * A unique integer value identifying this lizard raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedLizardRasterRain,
    | "url"
    | "uid"
    | "simulation"
    | "interval"
    | "user"
    | "userId"
    | "originOffset"
    | "storePath"
    | "id"
  >;
}

export interface SimulationsEventsRainRastersLizardReadRequest {
  /**
   * A unique integer value identifying this lizard raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainRastersLizardUpdateRequest {
  /**
   * A unique integer value identifying this lizard raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    LizardRasterRain,
    | "url"
    | "uid"
    | "simulation"
    | "interval"
    | "user"
    | "userId"
    | "originOffset"
    | "storePath"
    | "id"
  >;
}

export interface SimulationsEventsRainRastersNetcdfCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadWithSubstances, "putUrl" | "status">;
}

export interface SimulationsEventsRainRastersNetcdfDeleteRequest {
  /**
   * A unique integer value identifying this file raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainRastersNetcdfListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainRastersNetcdfPartialUpdateRequest {
  /**
   * A unique integer value identifying this file raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedNetCDFRasterRain, "url" | "simulation" | "uid">;
}

export interface SimulationsEventsRainRastersNetcdfReadRequest {
  /**
   * A unique integer value identifying this file raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainRastersNetcdfUpdateRequest {
  /**
   * A unique integer value identifying this file raster rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<NetCDFRasterRain, "url" | "simulation" | "uid">;
}

export interface SimulationsEventsRainTimeseriesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesRain, "url" | "simulation" | "duration" | "uid" | "id">;
}

export interface SimulationsEventsRainTimeseriesDeleteRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainTimeseriesLizardCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<LizardTimeseriesRain, "url" | "simulation" | "values" | "id" | "uid">;
}

export interface SimulationsEventsRainTimeseriesLizardDeleteRequest {
  /**
   * A unique integer value identifying this lizard timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesLizardListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainTimeseriesLizardPartialUpdateRequest {
  /**
   * A unique integer value identifying this lizard timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedLizardTimeseriesRain, "url" | "simulation" | "values" | "id" | "uid">;
}

export interface SimulationsEventsRainTimeseriesLizardReadRequest {
  /**
   * A unique integer value identifying this lizard timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesLizardUpdateRequest {
  /**
   * A unique integer value identifying this lizard timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<LizardTimeseriesRain, "url" | "simulation" | "values" | "id" | "uid">;
}

export interface SimulationsEventsRainTimeseriesNetcdfCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadWithSubstances, "putUrl" | "status">;
}

export interface SimulationsEventsRainTimeseriesNetcdfDeleteRequest {
  /**
   * A unique integer value identifying this file timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesNetcdfListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainTimeseriesNetcdfPartialUpdateRequest {
  /**
   * A unique integer value identifying this file timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedNetCDFTimeseriesRain, "url" | "simulation" | "uid">;
}

export interface SimulationsEventsRainTimeseriesNetcdfReadRequest {
  /**
   * A unique integer value identifying this file timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesNetcdfUpdateRequest {
  /**
   * A unique integer value identifying this file timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<NetCDFTimeseriesRain, "url" | "simulation" | "uid">;
}

export interface SimulationsEventsRainTimeseriesPartialUpdateRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTimeseriesRain, "url" | "simulation" | "duration" | "uid" | "id">;
}

export interface SimulationsEventsRainTimeseriesReadRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesUpdateRequest {
  /**
   * A unique integer value identifying this timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesRain, "url" | "simulation" | "duration" | "uid" | "id">;
}

export interface SimulationsEventsRasterEditsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<RasterEdit, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRasterEditsDeleteRequest {
  /**
   * A unique integer value identifying this raster edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRasterEditsListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRasterEditsPartialUpdateRequest {
  /**
   * A unique integer value identifying this raster edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedRasterEdit, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsRasterEditsReadRequest {
  /**
   * A unique integer value identifying this raster edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRasterEditsRegisterRelatedRastersRequest {
  /**
   * A unique integer value identifying this raster edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRasterEditsUpdateRequest {
  /**
   * A unique integer value identifying this raster edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<RasterEdit, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsSourcesSinksConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantSourcesSinks, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsSourcesSinksConstantDeleteRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsSourcesSinksConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedConstantSourcesSinks, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsSourcesSinksConstantReadRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksConstantUpdateRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ConstantSourcesSinks, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsSourcesSinksRastersLizardCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    LizardRasterSourcesSinks,
    | "url"
    | "simulation"
    | "interval"
    | "originOffset"
    | "storePath"
    | "id"
    | "uid"
    | "user"
    | "userId"
  >;
}

export interface SimulationsEventsSourcesSinksRastersLizardDeleteRequest {
  /**
   * A unique integer value identifying this lizard raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksRastersLizardListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsSourcesSinksRastersLizardPartialUpdateRequest {
  /**
   * A unique integer value identifying this lizard raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedLizardRasterSourcesSinks,
    | "url"
    | "simulation"
    | "interval"
    | "originOffset"
    | "storePath"
    | "id"
    | "uid"
    | "user"
    | "userId"
  >;
}

export interface SimulationsEventsSourcesSinksRastersLizardReadRequest {
  /**
   * A unique integer value identifying this lizard raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksRastersLizardUpdateRequest {
  /**
   * A unique integer value identifying this lizard raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    LizardRasterSourcesSinks,
    | "url"
    | "simulation"
    | "interval"
    | "originOffset"
    | "storePath"
    | "id"
    | "uid"
    | "user"
    | "userId"
  >;
}

export interface SimulationsEventsSourcesSinksRastersNetcdfCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadWithSubstances, "putUrl" | "status">;
}

export interface SimulationsEventsSourcesSinksRastersNetcdfDeleteRequest {
  /**
   * A unique integer value identifying this file raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksRastersNetcdfListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsSourcesSinksRastersNetcdfPartialUpdateRequest {
  /**
   * A unique integer value identifying this file raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedNetCDFRasterSourcesSinks, "url" | "simulation" | "id" | "uid">;
}

export interface SimulationsEventsSourcesSinksRastersNetcdfReadRequest {
  /**
   * A unique integer value identifying this file raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksRastersNetcdfUpdateRequest {
  /**
   * A unique integer value identifying this file raster sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<NetCDFRasterSourcesSinks, "url" | "simulation" | "id" | "uid">;
}

export interface SimulationsEventsSourcesSinksTimeseriesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesSourcesSinks, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsSourcesSinksTimeseriesDeleteRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesLizardCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<LizardTimeseriesSourcesSinks, "url" | "simulation" | "uid" | "values">;
}

export interface SimulationsEventsSourcesSinksTimeseriesLizardDeleteRequest {
  /**
   * A unique integer value identifying this lizard timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesLizardListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRequest {
  /**
   * A unique integer value identifying this lizard timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedLizardTimeseriesSourcesSinks, "url" | "simulation" | "uid" | "values">;
}

export interface SimulationsEventsSourcesSinksTimeseriesLizardReadRequest {
  /**
   * A unique integer value identifying this lizard timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesLizardUpdateRequest {
  /**
   * A unique integer value identifying this lizard timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<LizardTimeseriesSourcesSinks, "url" | "simulation" | "uid" | "values">;
}

export interface SimulationsEventsSourcesSinksTimeseriesNetcdfCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadWithSubstances, "putUrl" | "status">;
}

export interface SimulationsEventsSourcesSinksTimeseriesNetcdfDeleteRequest {
  /**
   * A unique integer value identifying this file timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesNetcdfListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesNetcdfReadRequest {
  /**
   * A unique integer value identifying this file timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesPartialUpdateRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTimeseriesSourcesSinks, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsSourcesSinksTimeseriesReadRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsSourcesSinksTimeseriesUpdateRequest {
  /**
   * A unique integer value identifying this timeseries sources sinks.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeseriesSourcesSinks, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsEventsStructureControlFileCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadEventFile, "putUrl" | "status">;
}

export interface SimulationsEventsStructureControlFileDeleteRequest {
  /**
   * A unique integer value identifying this bulk control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlFileDownloadRequest {
  /**
   * A unique integer value identifying this bulk control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlFileListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsStructureControlFilePartialUpdateRequest {
  /**
   * A unique integer value identifying this bulk control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedFileStructureControl,
    "url" | "id" | "uid" | "simulation" | "state" | "stateDetail"
  >;
}

export interface SimulationsEventsStructureControlFileProcessedRequest {
  /**
   * A unique integer value identifying this bulk control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: BaseEventState;
}

export interface SimulationsEventsStructureControlFileReadRequest {
  /**
   * A unique integer value identifying this bulk control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlFileUpdateRequest {
  /**
   * A unique integer value identifying this bulk control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<FileStructureControl, "url" | "id" | "uid" | "simulation" | "state" | "stateDetail">;
}

export interface SimulationsEventsStructureControlMemoryCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<MemoryStructureControl, "id" | "url" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsStructureControlMemoryDeleteRequest {
  /**
   * A unique integer value identifying this memory structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlMemoryListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsStructureControlMemoryPartialUpdateRequest {
  /**
   * A unique integer value identifying this memory structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedMemoryStructureControl, "id" | "url" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsStructureControlMemoryProcessedRequest {
  /**
   * A unique integer value identifying this memory structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: MeasureLocationGridEventState;
}

export interface SimulationsEventsStructureControlMemoryReadRequest {
  /**
   * A unique integer value identifying this memory structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlMemoryUpdateRequest {
  /**
   * A unique integer value identifying this memory structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<MemoryStructureControl, "id" | "url" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsStructureControlTableCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TableStructureControl, "id" | "url" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsStructureControlTableDeleteRequest {
  /**
   * A unique integer value identifying this table structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlTableListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsStructureControlTablePartialUpdateRequest {
  /**
   * A unique integer value identifying this table structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTableStructureControl, "id" | "url" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsStructureControlTableProcessedRequest {
  /**
   * A unique integer value identifying this table structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: MeasureLocationGridEventState;
}

export interface SimulationsEventsStructureControlTableReadRequest {
  /**
   * A unique integer value identifying this table structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlTableUpdateRequest {
  /**
   * A unique integer value identifying this table structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TableStructureControl, "id" | "url" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsStructureControlTimedCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimedStructureControl, "id" | "url" | "simulation" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsStructureControlTimedDeleteRequest {
  /**
   * A unique integer value identifying this timed structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlTimedListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsStructureControlTimedPartialUpdateRequest {
  /**
   * A unique integer value identifying this timed structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedTimedStructureControl,
    "id" | "url" | "simulation" | "state" | "stateDetail" | "uid"
  >;
}

export interface SimulationsEventsStructureControlTimedProcessedRequest {
  /**
   * A unique integer value identifying this timed structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: GridEventState;
}

export interface SimulationsEventsStructureControlTimedReadRequest {
  /**
   * A unique integer value identifying this timed structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsStructureControlTimedUpdateRequest {
  /**
   * A unique integer value identifying this timed structure control.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimedStructureControl, "id" | "url" | "simulation" | "state" | "stateDetail" | "uid">;
}

export interface SimulationsEventsWindConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    ConstantWind,
    | "id"
    | "uid"
    | "url"
    | "simulation"
    | "values"
    | "speedInterpolate"
    | "speedConstant"
    | "directionInterpolate"
    | "directionConstant"
  >;
}

export interface SimulationsEventsWindConstantDeleteRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsWindConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsWindConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedConstantWind,
    | "id"
    | "uid"
    | "url"
    | "simulation"
    | "values"
    | "speedInterpolate"
    | "speedConstant"
    | "directionInterpolate"
    | "directionConstant"
  >;
}

export interface SimulationsEventsWindConstantReadRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsWindConstantUpdateRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    ConstantWind,
    | "id"
    | "uid"
    | "url"
    | "simulation"
    | "values"
    | "speedInterpolate"
    | "speedConstant"
    | "directionInterpolate"
    | "directionConstant"
  >;
}

export interface SimulationsEventsWindTimeseriesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    TimeseriesWind,
    "id" | "uid" | "url" | "simulation" | "speedConstant" | "directionConstant"
  >;
}

export interface SimulationsEventsWindTimeseriesDeleteRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsWindTimeseriesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsWindTimeseriesPartialUpdateRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedTimeseriesWind,
    "id" | "uid" | "url" | "simulation" | "speedConstant" | "directionConstant"
  >;
}

export interface SimulationsEventsWindTimeseriesReadRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsWindTimeseriesUpdateRequest {
  /**
   * A unique integer value identifying this wind.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    TimeseriesWind,
    "id" | "uid" | "url" | "simulation" | "speedConstant" | "directionConstant"
  >;
}

export interface SimulationsFromTemplateRequest {
  /**
   *
   */
  data: FromTemplate;
}

export interface SimulationsInitial1dWaterLevelConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OneDWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial1dWaterLevelConstantDeleteRequest {
  /**
   * A unique integer value identifying this one d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dWaterLevelConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitial1dWaterLevelConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this one d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedOneDWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial1dWaterLevelConstantReadRequest {
  /**
   * A unique integer value identifying this one d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dWaterLevelConstantUpdateRequest {
  /**
   * A unique integer value identifying this one d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OneDWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial1dWaterLevelFileCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OneDWaterLevelFile, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitial1dWaterLevelFileDeleteRequest {
  /**
   * A unique integer value identifying this one d water level file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dWaterLevelFileListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitial1dWaterLevelFilePartialUpdateRequest {
  /**
   * A unique integer value identifying this one d water level file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedOneDWaterLevelFile,
    "url" | "simulation" | "initialWaterlevelId" | "uid" | "id"
  >;
}

export interface SimulationsInitial1dWaterLevelFileReadRequest {
  /**
   * A unique integer value identifying this one d water level file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dWaterLevelFileUpdateRequest {
  /**
   * A unique integer value identifying this one d water level file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OneDWaterLevelFile, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitial1dWaterLevelPredefinedCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OneDWaterLevelPredefined, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial1dWaterLevelPredefinedDeleteRequest {
  /**
   * A unique integer value identifying this one d water level predefined.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dWaterLevelPredefinedListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitial1dWaterLevelPredefinedPartialUpdateRequest {
  /**
   * A unique integer value identifying this one d water level predefined.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedOneDWaterLevelPredefined, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial1dWaterLevelPredefinedReadRequest {
  /**
   * A unique integer value identifying this one d water level predefined.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dWaterLevelPredefinedUpdateRequest {
  /**
   * A unique integer value identifying this one d water level predefined.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OneDWaterLevelPredefined, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial2dWaterLevelConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TwoDWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial2dWaterLevelConstantDeleteRequest {
  /**
   * A unique integer value identifying this two d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial2dWaterLevelConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitial2dWaterLevelConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this two d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTwoDWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial2dWaterLevelConstantReadRequest {
  /**
   * A unique integer value identifying this two d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial2dWaterLevelConstantUpdateRequest {
  /**
   * A unique integer value identifying this two d water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TwoDWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitial2dWaterLevelRasterCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TwoDWaterRaster, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitial2dWaterLevelRasterDeleteRequest {
  /**
   * A unique integer value identifying this two d water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial2dWaterLevelRasterListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitial2dWaterLevelRasterPartialUpdateRequest {
  /**
   * A unique integer value identifying this two d water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTwoDWaterRaster, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitial2dWaterLevelRasterReadRequest {
  /**
   * A unique integer value identifying this two d water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial2dWaterLevelRasterUpdateRequest {
  /**
   * A unique integer value identifying this two d water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TwoDWaterRaster, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitialGroundwaterLevelConstantCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<GroundWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitialGroundwaterLevelConstantDeleteRequest {
  /**
   * A unique integer value identifying this ground water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialGroundwaterLevelConstantListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitialGroundwaterLevelConstantPartialUpdateRequest {
  /**
   * A unique integer value identifying this ground water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedGroundWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitialGroundwaterLevelConstantReadRequest {
  /**
   * A unique integer value identifying this ground water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialGroundwaterLevelConstantUpdateRequest {
  /**
   * A unique integer value identifying this ground water level.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<GroundWaterLevel, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitialGroundwaterLevelRasterCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<GroundWaterRaster, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitialGroundwaterLevelRasterDeleteRequest {
  /**
   * A unique integer value identifying this ground water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialGroundwaterLevelRasterListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitialGroundwaterLevelRasterPartialUpdateRequest {
  /**
   * A unique integer value identifying this ground water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedGroundWaterRaster, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitialGroundwaterLevelRasterReadRequest {
  /**
   * A unique integer value identifying this ground water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialGroundwaterLevelRasterUpdateRequest {
  /**
   * A unique integer value identifying this ground water raster.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<GroundWaterRaster, "url" | "simulation" | "initialWaterlevelId" | "uid" | "id">;
}

export interface SimulationsInitialSavedStateCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<InitialSavedState, "url" | "simulation" | "id" | "uuid">;
}

export interface SimulationsInitialSavedStateDeleteRequest {
  /**
   * A unique integer value identifying this initial saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialSavedStateListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitialSavedStatePartialUpdateRequest {
  /**
   * A unique integer value identifying this initial saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedInitialSavedState, "url" | "simulation" | "id" | "uuid">;
}

export interface SimulationsInitialSavedStateReadRequest {
  /**
   * A unique integer value identifying this initial saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialSavedStateUpdateRequest {
  /**
   * A unique integer value identifying this initial saved state.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<InitialSavedState, "url" | "simulation" | "id" | "uuid">;
}

export interface SimulationsInitialWindDragCoefficientCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WindDragCoefficient, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitialWindDragCoefficientDeleteRequest {
  /**
   * A unique integer value identifying this wind drag coefficient.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialWindDragCoefficientListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitialWindDragCoefficientPartialUpdateRequest {
  /**
   * A unique integer value identifying this wind drag coefficient.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedWindDragCoefficient, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsInitialWindDragCoefficientReadRequest {
  /**
   * A unique integer value identifying this wind drag coefficient.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialWindDragCoefficientUpdateRequest {
  /**
   * A unique integer value identifying this wind drag coefficient.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WindDragCoefficient, "url" | "simulation" | "uid" | "id">;
}

export interface SimulationsListRequest {
  /**
   *
   */
  createdDate?: Date;
  /**
   *
   */
  createdDateGt?: Date;
  /**
   *
   */
  createdDateGte?: Date;
  /**
   *
   */
  createdDateLt?: Date;
  /**
   *
   */
  createdDateLte?: Date;
  /**
   *
   */
  createdDay?: number;
  /**
   *
   */
  createdDayLt?: number;
  /**
   *
   */
  createdMonth?: number;
  /**
   *
   */
  createdMonthLte?: number;
  /**
   *
   */
  createdYear?: number;
  /**
   *
   */
  createdYearGt?: number;
  /**
   *
   */
  createdYearGte?: number;
  /**
   *
   */
  createdYearLt?: number;
  /**
   *
   */
  createdYearLte?: number;
  /**
   *
   */
  idContains?: number;
  /**
   * is_template
   */
  isTemplate?: boolean;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  organisationUniqueId?: string;
  /**
   *
   */
  ranaProjectId?: string;
  /**
   *
   */
  ranaProjectIdIsnull?: boolean;
  /**
   *
   */
  ranaTenantId?: string;
  /**
   *
   */
  ranaTenantIdIsnull?: boolean;
  /**
   * * `` -
   * * `3Di Live` - 3Di Live
   * * `3Di Modeller Interface` - 3Di Modeller Interface
   * * `Rana Desktop Client` - Rana Desktop Client
   */
  startedFrom?: SimulationsListStartedFromEnum;
  /**
   * tags__in
   */
  tagsIn?: string;
  /**
   *
   */
  threedimodelId?: number;
  /**
   *
   */
  threedimodelRevisionId?: number;
  /**
   *
   */
  userUsername?: string;
  /**
   *
   */
  userUsernameIstartswith?: string;
  /**
   *
   */
  uuid?: string;
  /**
   *
   */
  uuidContains?: string;
  /**
   *
   */
  uuidEndswith?: string;
  /**
   *
   */
  uuidIcontains?: string;
  /**
   *
   */
  uuidIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  uuidIn?: Array<string>;
  /**
   *
   */
  uuidIstartswith?: string;
  /**
   *
   */
  uuidRegex?: string;
  /**
   *
   */
  uuidStartswith?: string;
}

export interface SimulationsPartialUpdateRequest {
  /**
   * A unique integer value identifying this simulation.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    PatchedSimulationUpdate,
    | "url"
    | "slug"
    | "uuid"
    | "created"
    | "threedimodel"
    | "organisation"
    | "organisationName"
    | "user"
    | "startDatetime"
    | "durationHumanized"
    | "threedimodelId"
    | "id"
    | "clonedFrom"
    | "computeCluster"
    | "ranaTenantId"
    | "ranaProjectId"
  >;
}

export interface SimulationsPostProcessingLizardQueueListRequest {
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsProgressListRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsReadRequest {
  /**
   * A unique integer value identifying this simulation.
   */
  id: number;
}

export interface SimulationsResultsFilesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ResultFile, "url" | "simulation" | "id">;
}

export interface SimulationsResultsFilesDeleteRequest {
  /**
   * A unique integer value identifying this result file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsFilesDownloadRequest {
  /**
   * A unique integer value identifying this result file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsFilesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsResultsFilesPartialUpdateRequest {
  /**
   * A unique integer value identifying this result file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedResultFile, "url" | "simulation" | "id">;
}

export interface SimulationsResultsFilesReadRequest {
  /**
   * A unique integer value identifying this result file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsFilesUpdateRequest {
  /**
   * A unique integer value identifying this result file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ResultFile, "url" | "simulation" | "id">;
}

export interface SimulationsResultsFilesUploadRequest {
  /**
   * A unique integer value identifying this result file.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface SimulationsResultsPostProcessingLizardArrivalCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ArrivalTimePostProcessing, "basicPostProcessing">;
}

export interface SimulationsResultsPostProcessingLizardArrivalDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardArrivalListRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardBasicCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<BasicPostProcessing, "simulation">;
}

export interface SimulationsResultsPostProcessingLizardBasicDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardBasicListRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardDamageCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<DamagePostProcessing, "basicPostProcessing">;
}

export interface SimulationsResultsPostProcessingLizardDamageDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardDamageListRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardOverviewListRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardStartCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: { [key: string]: any };
}

export interface SimulationsResultsPostProcessingLizardStartRetryRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: { [key: string]: any };
}

export interface SimulationsResultsPostProcessingLizardStatusCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PostProcessingStatus, "simulation" | "created">;
}

export interface SimulationsResultsPostProcessingLizardStatusDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsResultsPostProcessingLizardStatusHistoryListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsResultsPostProcessingLizardStatusListRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsAggregationCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<AggregationSettings, "url">;
}

export interface SimulationsSettingsAggregationDeleteRequest {
  /**
   * A unique integer value identifying this aggregation settings.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsAggregationListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsSettingsAggregationPartialUpdateRequest {
  /**
   * A unique integer value identifying this aggregation settings.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedAggregationSettings, "url">;
}

export interface SimulationsSettingsAggregationReadRequest {
  /**
   * A unique integer value identifying this aggregation settings.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsAggregationUpdateRequest {
  /**
   * A unique integer value identifying this aggregation settings.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<AggregationSettings, "url">;
}

export interface SimulationsSettingsCustomizedResultAreasCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<CustomizedResultArea, "url">;
}

export interface SimulationsSettingsCustomizedResultAreasDeleteRequest {
  /**
   * A unique integer value identifying this customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsCustomizedResultAreasListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsSettingsCustomizedResultAreasPartialUpdateRequest {
  /**
   * A unique integer value identifying this customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedCustomizedResultArea, "url">;
}

export interface SimulationsSettingsCustomizedResultAreasReadRequest {
  /**
   * A unique integer value identifying this customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsCustomizedResultAreasUpdateRequest {
  /**
   * A unique integer value identifying this customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<CustomizedResultArea, "url">;
}

export interface SimulationsSettingsNumericalCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<NumericalSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsNumericalDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsNumericalPartialUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedNumericalSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsNumericalUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<NumericalSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsOutputSettingsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OutputSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsOutputSettingsDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsOutputSettingsPartialUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedOutputSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsOutputSettingsUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<OutputSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsOverviewRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsPhysicalCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PhysicalSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsPhysicalDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsPhysicalPartialUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedPhysicalSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsPhysicalUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PhysicalSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsTimeStepCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeStepSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsTimeStepDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsTimeStepPartialUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedTimeStepSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsTimeStepUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<TimeStepSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsWaterQualityCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WaterQualitySettings, "id" | "simulationId">;
}

export interface SimulationsSettingsWaterQualityCustomizedResultAreasCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WaterQualityCustomizedResultArea, "url">;
}

export interface SimulationsSettingsWaterQualityCustomizedResultAreasDeleteRequest {
  /**
   * A unique integer value identifying this water quality customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsWaterQualityCustomizedResultAreasListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRequest {
  /**
   * A unique integer value identifying this water quality customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedWaterQualityCustomizedResultArea, "url">;
}

export interface SimulationsSettingsWaterQualityCustomizedResultAreasReadRequest {
  /**
   * A unique integer value identifying this water quality customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsWaterQualityCustomizedResultAreasUpdateRequest {
  /**
   * A unique integer value identifying this water quality customized result area.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WaterQualityCustomizedResultArea, "url">;
}

export interface SimulationsSettingsWaterQualityDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsWaterQualityOutputSettingsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WaterQualityOutputSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsWaterQualityOutputSettingsDeleteRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSettingsWaterQualityOutputSettingsPartialUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedWaterQualityOutputSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsWaterQualityOutputSettingsUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WaterQualityOutputSettings, "id" | "simulationId">;
}

export interface SimulationsSettingsWaterQualityPartialUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedWaterQualitySettings, "id" | "simulationId">;
}

export interface SimulationsSettingsWaterQualityUpdateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<WaterQualitySettings, "id" | "simulationId">;
}

export interface SimulationsStatusCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    SimulationStatus,
    | "url"
    | "simulation"
    | "simulationId"
    | "simulationName"
    | "simulationUserEmail"
    | "simulationOrganisationUniqueId"
    | "simulationTags"
    | "simulationUserFirstName"
    | "simulationUserLastName"
    | "threedimodelSlug"
    | "threedimodelId"
    | "hasResults"
    | "created"
    | "expiry"
    | "id"
  >;
}

export interface SimulationsStatusDeleteRequest {
  /**
   * A unique integer value identifying this simulation status.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsStatusHistoryListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsStatusHistoryReadRequest {
  /**
   * A unique integer value identifying this simulation status.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsStatusListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
}

export interface SimulationsStatusPartialUpdateRequest {
  /**
   * A unique integer value identifying this simulation status.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedSimulationStatus,
    | "url"
    | "simulation"
    | "simulationId"
    | "simulationName"
    | "simulationUserEmail"
    | "simulationOrganisationUniqueId"
    | "simulationTags"
    | "simulationUserFirstName"
    | "simulationUserLastName"
    | "threedimodelSlug"
    | "threedimodelId"
    | "hasResults"
    | "created"
    | "expiry"
    | "id"
  >;
}

export interface SimulationsStatusPatchRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedSimulationStatus,
    | "url"
    | "simulation"
    | "simulationId"
    | "simulationName"
    | "simulationUserEmail"
    | "simulationOrganisationUniqueId"
    | "simulationTags"
    | "simulationUserFirstName"
    | "simulationUserLastName"
    | "threedimodelSlug"
    | "threedimodelId"
    | "hasResults"
    | "created"
    | "expiry"
    | "id"
  >;
}

export interface SimulationsStatusUpdateRequest {
  /**
   * A unique integer value identifying this simulation status.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    SimulationStatus,
    | "url"
    | "simulation"
    | "simulationId"
    | "simulationName"
    | "simulationUserEmail"
    | "simulationOrganisationUniqueId"
    | "simulationTags"
    | "simulationUserFirstName"
    | "simulationUserLastName"
    | "threedimodelSlug"
    | "threedimodelId"
    | "hasResults"
    | "created"
    | "expiry"
    | "id"
  >;
}

export interface SimulationsUpdateRequest {
  /**
   * A unique integer value identifying this simulation.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    SimulationUpdate,
    | "url"
    | "slug"
    | "uuid"
    | "created"
    | "threedimodel"
    | "organisation"
    | "organisationName"
    | "user"
    | "startDatetime"
    | "durationHumanized"
    | "threedimodelId"
    | "id"
    | "clonedFrom"
    | "computeCluster"
    | "ranaTenantId"
    | "ranaProjectId"
  >;
}

export interface SimulationsVisualisationsBreachGraphCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: BreachGraphRequest;
}

export interface SimulationsVisualisationsProfileListRequest {
  /**
   *
   */
  layer: string;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsVisualisationsPumpDischargeGraphCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: PumpDischargeGraphRequest;
}

export interface SimulationsVisualisationsRainGraphCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: RainGraphRequest;
}

export interface SimulationsVisualisationsTmsListRequest {
  /**
   *
   */
  layer: string;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsVisualisationsWaterFlowGraphCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: WaterFlowGraphRequest;
}

export interface SimulationsVisualisationsWaterLevelGraphCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: WaterLevelGraphRequest;
}

export interface SimulationsVisualisationsWaterLevelProfileCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: WaterLevelProfileRequest;
}

export interface SimulationsVisualisationsWaterdepthListRequest {
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsWebsocketsListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface StatusesListRequest {
  /**
   *
   */
  created?: Date;
  /**
   *
   */
  createdDate?: Date;
  /**
   *
   */
  createdDateGt?: Date;
  /**
   *
   */
  createdDateGte?: Date;
  /**
   *
   */
  createdDateLt?: Date;
  /**
   *
   */
  createdDateLte?: Date;
  /**
   *
   */
  createdDay?: number;
  /**
   *
   */
  createdDayLt?: number;
  /**
   *
   */
  createdGt?: Date;
  /**
   *
   */
  createdGte?: Date;
  /**
   *
   */
  createdLt?: Date;
  /**
   *
   */
  createdLte?: Date;
  /**
   *
   */
  createdMonth?: number;
  /**
   *
   */
  createdMonthLte?: number;
  /**
   *
   */
  createdWeek?: number;
  /**
   *
   */
  createdWeekDay?: number;
  /**
   *
   */
  createdYear?: number;
  /**
   *
   */
  createdYearGt?: number;
  /**
   *
   */
  createdYearGte?: number;
  /**
   *
   */
  createdYearLt?: number;
  /**
   *
   */
  createdYearLte?: number;
  /**
   * only available for final statuses like 'finished' or 'crashed'. Gives detailed insight to the application state when the simulation finished
   *
   * * `1110` - user_shutdown_premature
   * * `1210` - user_shutdown
   * * `1240` - finished
   * * `4161` - health_check_premature_container_error
   * * `4262` - health_check_container_error
   * * `4263` - health_check_initialized_error
   * * `4264` - health_check_ended_error
   * * `4265` - health_check_postprocessing_error
   * * `4120` - initial_condition_worker_error
   * * `4220` - event_worker_error
   * * `4150` - container_startup_error
   * * `4280` - out_of_resources
   * * `4240` - calculation_core_error
   * * `4270` - calculation_python_error
   * * `4230` - api_ressource_error
   * * `4231` - upload_request_error
   * * `4232` - unfinished_tasks_error
   * * `2150` - ignition_timeout
   * * `2110` - initialized_paused_timeout
   * * `2210` - paused_timeout
   * * `2120` - initial_condition_worker_timeout
   * * `2220` - event_worker_timeout
   * * `2230` - enque_action_collection_timeout
   * * `2240` - clear_event_data_timeout
   */
  exitCode?: StatusesListExitCodeEnum;
  /**
   *
   */
  exitCodeGt?: number;
  /**
   *
   */
  exitCodeGte?: number;
  /**
   *
   */
  exitCodeIsnull?: boolean;
  /**
   *
   */
  exitCodeLt?: number;
  /**
   *
   */
  exitCodeLte?: number;
  /**
   *
   */
  id?: number;
  /**
   *
   */
  idGt?: number;
  /**
   *
   */
  idGte?: number;
  /**
   *
   */
  idIsnull?: boolean;
  /**
   *
   */
  idLt?: number;
  /**
   *
   */
  idLte?: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * * `created` - created
   * * `starting` - starting
   * * `initialized` - initialized
   * * `queued` - queued
   * * `ended` - ended
   * * `postprocessing` - postprocessing
   * * `finished` - finished
   * * `crashed` - crashed
   */
  name?: StatusesListNameEnum;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  simulationComputeClusterName?: string;
  /**
   *
   */
  simulationName?: string;
  /**
   *
   */
  simulationNameContains?: string;
  /**
   *
   */
  simulationNameEndswith?: string;
  /**
   *
   */
  simulationNameIcontains?: string;
  /**
   *
   */
  simulationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationNameIn?: Array<string>;
  /**
   *
   */
  simulationNameIstartswith?: string;
  /**
   *
   */
  simulationNameRegex?: string;
  /**
   *
   */
  simulationNameStartswith?: string;
  /**
   * simulation__organisation__name__istartswith
   */
  simulationOrganisationNameIstartswith?: string;
  /**
   * simulation__organisation__unique_id
   */
  simulationOrganisationUniqueId?: string;
  /**
   * simulation_tags_contains
   */
  simulationTagsContains?: string;
  /**
   *
   */
  simulationThreedimodelSlug?: string;
  /**
   *
   */
  simulationThreedimodelSlugContains?: string;
  /**
   *
   */
  simulationThreedimodelSlugEndswith?: string;
  /**
   *
   */
  simulationThreedimodelSlugIcontains?: string;
  /**
   *
   */
  simulationThreedimodelSlugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationThreedimodelSlugIn?: Array<string>;
  /**
   *
   */
  simulationThreedimodelSlugIstartswith?: string;
  /**
   *
   */
  simulationThreedimodelSlugRegex?: string;
  /**
   *
   */
  simulationThreedimodelSlugStartswith?: string;
  /**
   * simulation__type__live
   */
  simulationTypeLive?: boolean;
  /**
   * simulation__user__username
   */
  simulationUserUsername?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationIdIn?: Array<number>;
}

export interface StatusesReadRequest {
  /**
   * A unique integer value identifying this simulation status.
   */
  id: number;
}

export interface StatusesStatisticsRequest {
  /**
   *
   */
  created?: Date;
  /**
   *
   */
  createdDate?: Date;
  /**
   *
   */
  createdDateGt?: Date;
  /**
   *
   */
  createdDateGte?: Date;
  /**
   *
   */
  createdDateLt?: Date;
  /**
   *
   */
  createdDateLte?: Date;
  /**
   *
   */
  createdDay?: number;
  /**
   *
   */
  createdDayLt?: number;
  /**
   *
   */
  createdGt?: Date;
  /**
   *
   */
  createdGte?: Date;
  /**
   *
   */
  createdLt?: Date;
  /**
   *
   */
  createdLte?: Date;
  /**
   *
   */
  createdMonth?: number;
  /**
   *
   */
  createdMonthLte?: number;
  /**
   *
   */
  createdWeek?: number;
  /**
   *
   */
  createdWeekDay?: number;
  /**
   *
   */
  createdYear?: number;
  /**
   *
   */
  createdYearGt?: number;
  /**
   *
   */
  createdYearGte?: number;
  /**
   *
   */
  createdYearLt?: number;
  /**
   *
   */
  createdYearLte?: number;
  /**
   * only available for final statuses like 'finished' or 'crashed'. Gives detailed insight to the application state when the simulation finished
   *
   * * `1110` - user_shutdown_premature
   * * `1210` - user_shutdown
   * * `1240` - finished
   * * `4161` - health_check_premature_container_error
   * * `4262` - health_check_container_error
   * * `4263` - health_check_initialized_error
   * * `4264` - health_check_ended_error
   * * `4265` - health_check_postprocessing_error
   * * `4120` - initial_condition_worker_error
   * * `4220` - event_worker_error
   * * `4150` - container_startup_error
   * * `4280` - out_of_resources
   * * `4240` - calculation_core_error
   * * `4270` - calculation_python_error
   * * `4230` - api_ressource_error
   * * `4231` - upload_request_error
   * * `4232` - unfinished_tasks_error
   * * `2150` - ignition_timeout
   * * `2110` - initialized_paused_timeout
   * * `2210` - paused_timeout
   * * `2120` - initial_condition_worker_timeout
   * * `2220` - event_worker_timeout
   * * `2230` - enque_action_collection_timeout
   * * `2240` - clear_event_data_timeout
   */
  exitCode?: StatusesStatisticsExitCodeEnum;
  /**
   *
   */
  exitCodeGt?: number;
  /**
   *
   */
  exitCodeGte?: number;
  /**
   *
   */
  exitCodeIsnull?: boolean;
  /**
   *
   */
  exitCodeLt?: number;
  /**
   *
   */
  exitCodeLte?: number;
  /**
   *
   */
  id?: number;
  /**
   *
   */
  idGt?: number;
  /**
   *
   */
  idGte?: number;
  /**
   *
   */
  idIsnull?: boolean;
  /**
   *
   */
  idLt?: number;
  /**
   *
   */
  idLte?: number;
  /**
   * * `created` - created
   * * `starting` - starting
   * * `initialized` - initialized
   * * `queued` - queued
   * * `ended` - ended
   * * `postprocessing` - postprocessing
   * * `finished` - finished
   * * `crashed` - crashed
   */
  name?: StatusesStatisticsNameEnum;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  simulationComputeClusterName?: string;
  /**
   *
   */
  simulationName?: string;
  /**
   *
   */
  simulationNameContains?: string;
  /**
   *
   */
  simulationNameEndswith?: string;
  /**
   *
   */
  simulationNameIcontains?: string;
  /**
   *
   */
  simulationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationNameIn?: Array<string>;
  /**
   *
   */
  simulationNameIstartswith?: string;
  /**
   *
   */
  simulationNameRegex?: string;
  /**
   *
   */
  simulationNameStartswith?: string;
  /**
   * simulation__organisation__name__istartswith
   */
  simulationOrganisationNameIstartswith?: string;
  /**
   * simulation__organisation__unique_id
   */
  simulationOrganisationUniqueId?: string;
  /**
   * simulation_tags_contains
   */
  simulationTagsContains?: string;
  /**
   *
   */
  simulationThreedimodelSlug?: string;
  /**
   *
   */
  simulationThreedimodelSlugContains?: string;
  /**
   *
   */
  simulationThreedimodelSlugEndswith?: string;
  /**
   *
   */
  simulationThreedimodelSlugIcontains?: string;
  /**
   *
   */
  simulationThreedimodelSlugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationThreedimodelSlugIn?: Array<string>;
  /**
   *
   */
  simulationThreedimodelSlugIstartswith?: string;
  /**
   *
   */
  simulationThreedimodelSlugRegex?: string;
  /**
   *
   */
  simulationThreedimodelSlugStartswith?: string;
  /**
   * simulation__type__live
   */
  simulationTypeLive?: boolean;
  /**
   * simulation__user__username
   */
  simulationUserUsername?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationIdIn?: Array<number>;
}

export interface ThreedimodelsBoundaryconditionsCreateRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<BoundaryCondition, "id" | "url" | "threedimodel">;
}

export interface ThreedimodelsBoundaryconditionsDeleteRequest {
  /**
   * A unique integer value identifying this boundary condition.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsBoundaryconditionsListRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface ThreedimodelsBoundaryconditionsPartialUpdateRequest {
  /**
   * A unique integer value identifying this boundary condition.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<PatchedBoundaryCondition, "id" | "url" | "threedimodel">;
}

export interface ThreedimodelsBoundaryconditionsReadRequest {
  /**
   * A unique integer value identifying this boundary condition.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsBoundaryconditionsUpdateRequest {
  /**
   * A unique integer value identifying this boundary condition.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<BoundaryCondition, "id" | "url" | "threedimodel">;
}

export interface ThreedimodelsBreachesGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsBulkRastersCreateRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Array<Raster>;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface ThreedimodelsCellsGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsChannelsGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsCreateRequest {
  /**
   *
   */
  data: Omit<
    ThreediModel,
    | "url"
    | "id"
    | "user"
    | "threediVersion"
    | "revisionId"
    | "revisionHash"
    | "revisionNumber"
    | "revisionCommitDate"
    | "schematisationId"
    | "schematisationName"
    | "repositorySlug"
    | "storageSpaceHumanized"
    | "created"
  >;
}

export interface ThreedimodelsCulvertsGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsDeleteRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsFlowlinesGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsGeojsonBreachesDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonCellsDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonChannelsDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonCulvertsDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonFlowlinesDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonLeveesDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonManholesDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonOrificesDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonPipesDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonPumpsDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsGeojsonWeirsDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeopackageDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGeopackageUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsGridadminDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsGridadminUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsInitialWaterlevelsCreateRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<
    InitialWaterlevel,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  >;
}

export interface ThreedimodelsInitialWaterlevelsDeleteRequest {
  /**
   * A unique integer value identifying this initial waterlevel.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsInitialWaterlevelsDownloadRequest {
  /**
   * A unique integer value identifying this initial waterlevel.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsInitialWaterlevelsListRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface ThreedimodelsInitialWaterlevelsPartialUpdateRequest {
  /**
   * A unique integer value identifying this initial waterlevel.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<
    PatchedInitialWaterlevel,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  >;
}

export interface ThreedimodelsInitialWaterlevelsProcessedRequest {
  /**
   * A unique integer value identifying this initial waterlevel.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: BaseEventState;
}

export interface ThreedimodelsInitialWaterlevelsReadRequest {
  /**
   * A unique integer value identifying this initial waterlevel.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsInitialWaterlevelsUpdateRequest {
  /**
   * A unique integer value identifying this initial waterlevel.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<
    InitialWaterlevel,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  >;
}

export interface ThreedimodelsInitialWaterlevelsUploadRequest {
  /**
   * A unique integer value identifying this initial waterlevel.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsLeveesGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsListRequest {
  /**
   *
   */
  createdDate?: Date;
  /**
   *
   */
  createdDateGt?: Date;
  /**
   *
   */
  createdDateGte?: Date;
  /**
   *
   */
  createdDateLt?: Date;
  /**
   *
   */
  createdDateLte?: Date;
  /**
   *
   */
  createdDay?: number;
  /**
   *
   */
  createdDayLt?: number;
  /**
   *
   */
  createdHour?: number;
  /**
   *
   */
  createdIsnull?: boolean;
  /**
   *
   */
  createdMinute?: number;
  /**
   *
   */
  createdMonth?: number;
  /**
   *
   */
  createdMonthLte?: number;
  /**
   *
   */
  createdQuarter?: number;
  /**
   * Multiple values may be separated by commas.
   */
  createdRange?: Array<Date>;
  /**
   *
   */
  createdSecond?: number;
  /**
   *
   */
  createdTime?: string;
  /**
   *
   */
  createdWeek?: number;
  /**
   *
   */
  createdWeekDay?: number;
  /**
   *
   */
  createdYear?: number;
  /**
   *
   */
  createdYearGt?: number;
  /**
   *
   */
  createdYearGte?: number;
  /**
   *
   */
  createdYearLt?: number;
  /**
   *
   */
  createdYearLte?: number;
  /**
   *
   */
  disabled?: boolean;
  /**
   *
   */
  epsg?: number;
  /**
   *
   */
  id?: number;
  /**
   *
   */
  inpSuccess?: boolean;
  /**
   *
   */
  inpyVersionActive?: boolean;
  /**
   *
   */
  inpyVersionSlug?: string;
  /**
   *
   */
  inpyVersionSlugContains?: string;
  /**
   *
   */
  inpyVersionSlugEndswith?: string;
  /**
   *
   */
  inpyVersionSlugIcontains?: string;
  /**
   *
   */
  inpyVersionSlugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  inpyVersionSlugIn?: Array<string>;
  /**
   *
   */
  inpyVersionSlugIstartswith?: string;
  /**
   *
   */
  inpyVersionSlugRegex?: string;
  /**
   *
   */
  inpyVersionSlugStartswith?: string;
  /**
   *
   */
  inpyVersionThreediVersion?: string;
  /**
   *
   */
  inpyVersionThreediVersionContains?: string;
  /**
   *
   */
  inpyVersionThreediVersionEndswith?: string;
  /**
   *
   */
  inpyVersionThreediVersionIcontains?: string;
  /**
   *
   */
  inpyVersionThreediVersionIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  inpyVersionThreediVersionIn?: Array<string>;
  /**
   *
   */
  inpyVersionThreediVersionIstartswith?: string;
  /**
   *
   */
  inpyVersionThreediVersionRegex?: string;
  /**
   *
   */
  inpyVersionThreediVersionStartswith?: string;
  /**
   *
   */
  inpyVersionThreedicoreVersion?: string;
  /**
   *
   */
  inpyVersionThreedicoreVersionContains?: string;
  /**
   *
   */
  inpyVersionThreedicoreVersionEndswith?: string;
  /**
   *
   */
  inpyVersionThreedicoreVersionIcontains?: string;
  /**
   *
   */
  inpyVersionThreedicoreVersionIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  inpyVersionThreedicoreVersionIn?: Array<string>;
  /**
   *
   */
  inpyVersionThreedicoreVersionIstartswith?: string;
  /**
   *
   */
  inpyVersionThreedicoreVersionRegex?: string;
  /**
   *
   */
  inpyVersionThreedicoreVersionStartswith?: string;
  /**
   * is_generating
   */
  isGenerating?: boolean;
  /**
   *
   */
  isValid?: boolean;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   *
   */
  revisionCommitUserUsername?: string;
  /**
   *
   */
  revisionCommitUserUsernameIstartswith?: string;
  /**
   *
   */
  revisionHash?: string;
  /**
   *
   */
  revisionHashContains?: string;
  /**
   *
   */
  revisionHashEndswith?: string;
  /**
   *
   */
  revisionHashIcontains?: string;
  /**
   *
   */
  revisionHashIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  revisionHashIn?: Array<string>;
  /**
   *
   */
  revisionHashIstartswith?: string;
  /**
   *
   */
  revisionHashRegex?: string;
  /**
   *
   */
  revisionHashStartswith?: string;
  /**
   *
   */
  revisionId?: number;
  /**
   *
   */
  revisionIsPinned?: boolean;
  /**
   *
   */
  revisionNumber?: number;
  /**
   *
   */
  revisionNumberGt?: number;
  /**
   *
   */
  revisionNumberGte?: number;
  /**
   *
   */
  revisionNumberIsnull?: boolean;
  /**
   *
   */
  revisionNumberLt?: number;
  /**
   *
   */
  revisionNumberLte?: number;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueId?: string;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueIdContains?: string;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueIdEndswith?: string;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueIdIcontains?: string;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueIdIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  revisionRepositoryOrganisationUniqueIdIn?: Array<string>;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueIdIstartswith?: string;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueIdRegex?: string;
  /**
   *
   */
  revisionRepositoryOrganisationUniqueIdStartswith?: string;
  /**
   *
   */
  revisionSchematisationId?: number;
  /**
   *
   */
  revisionSchematisationIsnull?: boolean;
  /**
   *
   */
  revisionSchematisationName?: string;
  /**
   *
   */
  revisionSchematisationNameContains?: string;
  /**
   *
   */
  revisionSchematisationNameEndswith?: string;
  /**
   *
   */
  revisionSchematisationNameIcontains?: string;
  /**
   *
   */
  revisionSchematisationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  revisionSchematisationNameIn?: Array<string>;
  /**
   *
   */
  revisionSchematisationNameIstartswith?: string;
  /**
   *
   */
  revisionSchematisationNameRegex?: string;
  /**
   *
   */
  revisionSchematisationNameStartswith?: string;
  /**
   *
   */
  revisionSchematisationOwnerUniqueId?: string;
  /**
   *
   */
  revisionSchematisationRanaProjectId?: string;
  /**
   *
   */
  revisionSchematisationRanaProjectIdIsnull?: boolean;
  /**
   *
   */
  revisionSchematisationRanaTenantId?: string;
  /**
   *
   */
  revisionSchematisationRanaTenantIdIsnull?: boolean;
  /**
   * revision__schematisation__tags__in
   */
  revisionSchematisationTagsIn?: string;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  slugContains?: string;
  /**
   *
   */
  slugEndswith?: string;
  /**
   *
   */
  slugIcontains?: string;
  /**
   *
   */
  slugIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  slugIn?: Array<string>;
  /**
   *
   */
  slugIstartswith?: string;
  /**
   *
   */
  slugRegex?: string;
  /**
   *
   */
  slugStartswith?: string;
}

export interface ThreedimodelsManholesGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsOrificesGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsPartialUpdateRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    PatchedThreediModel,
    | "url"
    | "id"
    | "user"
    | "threediVersion"
    | "revisionId"
    | "revisionHash"
    | "revisionNumber"
    | "revisionCommitDate"
    | "schematisationId"
    | "schematisationName"
    | "repositorySlug"
    | "storageSpaceHumanized"
    | "created"
  >;
}

export interface ThreedimodelsPipesGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsPotentialbreachesCreateRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<PotentialBreach, "url" | "threedimodel" | "id">;
}

export interface ThreedimodelsPotentialbreachesListRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  connectedPntId?: number;
  /**
   *
   */
  connectedPntIdGt?: number;
  /**
   *
   */
  connectedPntIdGte?: number;
  /**
   *
   */
  connectedPntIdIsnull?: boolean;
  /**
   *
   */
  connectedPntIdLt?: number;
  /**
   *
   */
  connectedPntIdLte?: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   *
   */
  threedimodelId?: number;
  /**
   *
   */
  threedimodelIdGt?: number;
  /**
   *
   */
  threedimodelIdGte?: number;
  /**
   *
   */
  threedimodelIdIsnull?: boolean;
  /**
   *
   */
  threedimodelIdLt?: number;
  /**
   *
   */
  threedimodelIdLte?: number;
}

export interface ThreedimodelsPotentialbreachesReadRequest {
  /**
   * A unique integer value identifying this potential breach.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsPumpsGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsRasterOptionsRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsRastersCreateRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<Raster, "url" | "threedimodel" | "file" | "id">;
}

export interface ThreedimodelsRastersDeleteRequest {
  /**
   * A unique integer value identifying this raster.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsRastersDownloadRequest {
  /**
   * A unique integer value identifying this raster.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsRastersListRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  nameContains?: string;
  /**
   *
   */
  nameEndswith?: string;
  /**
   *
   */
  nameIcontains?: string;
  /**
   *
   */
  nameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  nameIn?: Array<string>;
  /**
   *
   */
  nameIstartswith?: string;
  /**
   *
   */
  nameRegex?: string;
  /**
   *
   */
  nameStartswith?: string;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * * `dem_file` - dem_file
   * * `dem_raw_file` - dem_raw_file
   * * `equilibrium_infiltration_rate_file` - equilibrium_infiltration_rate_file
   * * `frict_coef_file` - frict_coef_file
   * * `initial_groundwater_level_file` - initial_groundwater_level_file
   * * `initial_waterlevel_file` - initial_waterlevel_file
   * * `groundwater_hydro_connectivity_file` - groundwater_hydro_connectivity_file
   * * `groundwater_impervious_layer_level_file` - groundwater_impervious_layer_level_file
   * * `infiltration_decay_period_file` - infiltration_decay_period_file
   * * `initial_infiltration_rate_file` - initial_infiltration_rate_file
   * * `leakage_file` - leakage_file
   * * `phreatic_storage_capacity_file` - phreatic_storage_capacity_file
   * * `hydraulic_conductivity_file` - hydraulic_conductivity_file
   * * `porosity_file` - porosity_file
   * * `infiltration_rate_file` - infiltration_rate_file
   * * `max_infiltration_capacity_file` - max_infiltration_capacity_file
   * * `interception_file` - interception_file
   * * `vegetation_height_file` - vegetation_height_file
   * * `vegetation_drag_coefficient_file` - vegetation_drag_coefficient_file
   * * `vegetation_stem_count_file` - vegetation_stem_count_file
   * * `vegetation_stem_diameter_file` - vegetation_stem_diameter_file
   * * `initial_concentration_file` - initial_concentration_file
   * * `initial_groundwater_concentration_file` - initial_groundwater_concentration_file
   */
  type?: ThreedimodelsRastersListTypeEnum;
  /**
   *
   */
  typeContains?: string;
  /**
   *
   */
  typeEndswith?: string;
  /**
   *
   */
  typeIcontains?: string;
  /**
   *
   */
  typeIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  typeIn?: Array<string>;
  /**
   *
   */
  typeIstartswith?: string;
  /**
   *
   */
  typeRegex?: string;
  /**
   *
   */
  typeStartswith?: string;
}

export interface ThreedimodelsRastersPartialUpdateRequest {
  /**
   * A unique integer value identifying this raster.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<PatchedRaster, "url" | "threedimodel" | "file" | "id">;
}

export interface ThreedimodelsRastersReadRequest {
  /**
   * A unique integer value identifying this raster.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsRastersUpdateRequest {
  /**
   * A unique integer value identifying this raster.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<Raster, "url" | "threedimodel" | "file" | "id">;
}

export interface ThreedimodelsRastersUploadRequest {
  /**
   * A unique integer value identifying this raster.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsReadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsSavedStatesDeleteRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsSavedStatesListRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
}

export interface ThreedimodelsSavedStatesReadRequest {
  /**
   * A unique integer value identifying this saved state.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsTablesDownloadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
}

export interface ThreedimodelsTablesUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface ThreedimodelsTasksCreateRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<ThreediModelTask, "url" | "created" | "lastUpdated" | "threedimodel" | "id">;
}

export interface ThreedimodelsTasksDeleteRequest {
  /**
   * A unique integer value identifying this threedi model task.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsTasksListRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface ThreedimodelsTasksPartialUpdateRequest {
  /**
   * A unique integer value identifying this threedi model task.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<PatchedThreediModelTask, "url" | "created" | "lastUpdated" | "threedimodel" | "id">;
}

export interface ThreedimodelsTasksReadRequest {
  /**
   * A unique integer value identifying this threedi model task.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsTasksUpdateRequest {
  /**
   * A unique integer value identifying this threedi model task.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<ThreediModelTask, "url" | "created" | "lastUpdated" | "threedimodel" | "id">;
}

export interface ThreedimodelsUpdateRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<
    ThreediModel,
    | "url"
    | "id"
    | "user"
    | "threediVersion"
    | "revisionId"
    | "revisionHash"
    | "revisionNumber"
    | "revisionCommitDate"
    | "schematisationId"
    | "schematisationName"
    | "repositorySlug"
    | "storageSpaceHumanized"
    | "created"
  >;
}

export interface ThreedimodelsWeirsGeojsonUploadRequest {
  /**
   * A unique integer value identifying this threedi model.
   */
  id: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

export interface UsageListRequest {
  /**
   *
   */
  finishedDate?: Date;
  /**
   *
   */
  finishedDateGt?: Date;
  /**
   *
   */
  finishedDateGte?: Date;
  /**
   *
   */
  finishedDateLt?: Date;
  /**
   *
   */
  finishedDateLte?: Date;
  /**
   *
   */
  finishedGt?: Date;
  /**
   *
   */
  finishedGte?: Date;
  /**
   *
   */
  finishedLt?: Date;
  /**
   *
   */
  finishedLte?: Date;
  /**
   *
   */
  finishedMonth?: number;
  /**
   *
   */
  finishedMonthLte?: number;
  /**
   *
   */
  finishedYear?: number;
  /**
   *
   */
  finishedYearGt?: number;
  /**
   *
   */
  finishedYearGte?: number;
  /**
   *
   */
  finishedYearLt?: number;
  /**
   *
   */
  finishedYearLte?: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * * `created` - created
   * * `starting` - starting
   * * `initialized` - initialized
   * * `queued` - queued
   * * `ended` - ended
   * * `postprocessing` - postprocessing
   * * `finished` - finished
   * * `crashed` - crashed
   */
  simulationActiveStatusName?: UsageListSimulationActiveStatusNameEnum;
  /**
   *
   */
  simulationActiveStatusNameContains?: string;
  /**
   *
   */
  simulationActiveStatusNameEndswith?: string;
  /**
   *
   */
  simulationActiveStatusNameIcontains?: string;
  /**
   *
   */
  simulationActiveStatusNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationActiveStatusNameIn?: Array<string>;
  /**
   *
   */
  simulationActiveStatusNameIstartswith?: string;
  /**
   *
   */
  simulationActiveStatusNameRegex?: string;
  /**
   *
   */
  simulationActiveStatusNameStartswith?: string;
  /**
   *
   */
  simulationId?: number;
  /**
   *
   */
  simulationName?: string;
  /**
   *
   */
  simulationNameContains?: string;
  /**
   *
   */
  simulationNameEndswith?: string;
  /**
   *
   */
  simulationNameIcontains?: string;
  /**
   *
   */
  simulationNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationNameIn?: Array<string>;
  /**
   *
   */
  simulationNameIstartswith?: string;
  /**
   *
   */
  simulationNameRegex?: string;
  /**
   *
   */
  simulationNameStartswith?: string;
  /**
   * simulation__organisation__name__istartswith
   */
  simulationOrganisationNameIstartswith?: string;
  /**
   * simulation__organisation__unique_id
   */
  simulationOrganisationUniqueId?: string;
  /**
   * simulation__active_status__name
   *
   * * `finished` - finished
   * * `crashed` - crashed
   */
  simulationStatus?: UsageListSimulationStatusEnum;
  /**
   * simulation__tags__in
   */
  simulationTagsIn?: string;
  /**
   *
   */
  simulationThreedimodelId?: number;
  /**
   *
   */
  simulationThreedimodelIdGt?: number;
  /**
   *
   */
  simulationThreedimodelIdGte?: number;
  /**
   *
   */
  simulationThreedimodelIdIsnull?: boolean;
  /**
   *
   */
  simulationThreedimodelIdLt?: number;
  /**
   *
   */
  simulationThreedimodelIdLte?: number;
  /**
   *
   */
  simulationThreedimodelName?: string;
  /**
   *
   */
  simulationThreedimodelNameContains?: string;
  /**
   *
   */
  simulationThreedimodelNameEndswith?: string;
  /**
   *
   */
  simulationThreedimodelNameIcontains?: string;
  /**
   *
   */
  simulationThreedimodelNameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationThreedimodelNameIn?: Array<string>;
  /**
   *
   */
  simulationThreedimodelNameIstartswith?: string;
  /**
   *
   */
  simulationThreedimodelNameRegex?: string;
  /**
   *
   */
  simulationThreedimodelNameStartswith?: string;
  /**
   * simulation__type__live
   */
  simulationTypeLive?: boolean;
  /**
   *
   */
  simulationUserUsername?: string;
  /**
   *
   */
  simulationUserUsernameContains?: string;
  /**
   *
   */
  simulationUserUsernameEndswith?: string;
  /**
   *
   */
  simulationUserUsernameIcontains?: string;
  /**
   *
   */
  simulationUserUsernameIexact?: string;
  /**
   * Multiple values may be separated by commas.
   */
  simulationUserUsernameIn?: Array<string>;
  /**
   *
   */
  simulationUserUsernameIstartswith?: string;
  /**
   *
   */
  simulationUserUsernameRegex?: string;
  /**
   *
   */
  simulationUserUsernameStartswith?: string;
  /**
   *
   */
  startedDate?: Date;
  /**
   *
   */
  startedDateGt?: Date;
  /**
   *
   */
  startedDateGte?: Date;
  /**
   *
   */
  startedDateLt?: Date;
  /**
   *
   */
  startedDateLte?: Date;
  /**
   *
   */
  startedGt?: Date;
  /**
   *
   */
  startedGte?: Date;
  /**
   *
   */
  startedLt?: Date;
  /**
   *
   */
  startedLte?: Date;
  /**
   *
   */
  startedMonth?: number;
  /**
   *
   */
  startedMonthLte?: number;
  /**
   *
   */
  startedYear?: number;
  /**
   *
   */
  startedYearGt?: number;
  /**
   *
   */
  startedYearGte?: number;
  /**
   *
   */
  startedYearLt?: number;
  /**
   *
   */
  startedYearLte?: number;
  /**
   *
   */
  totalTime?: number;
  /**
   *
   */
  totalTimeGt?: number;
  /**
   *
   */
  totalTimeGte?: number;
  /**
   *
   */
  totalTimeIsnull?: boolean;
  /**
   *
   */
  totalTimeLt?: number;
  /**
   *
   */
  totalTimeLte?: number;
}

export interface UsageReadRequest {
  /**
   * A unique integer value identifying this usage.
   */
  id: number;
}

/**
 *
 */
export class V3Api extends runtime.BaseAPI {
  /**
   * Creates request options for authProfileList without sending the request
   */
  async authProfileListRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/auth/profile/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for viewing user details for current user
   */
  async authProfileListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AuthProfile>> {
    const requestOptions = await this.authProfileListRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => AuthProfileFromJSON(jsonValue));
  }

  /**
   * Read-only API endpoint for viewing user details for current user
   */
  async authProfileList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AuthProfile> {
    const response = await this.authProfileListRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authRefreshTokenCreate without sending the request
   */
  async authRefreshTokenCreateRequestOpts(
    requestParameters: AuthRefreshTokenCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling authRefreshTokenCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/auth/refresh-token/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RefreshToJSON(requestParameters["data"]),
    };
  }

  /**
   * Refresh API authentication token by refresh_token.  Post \"refresh\" token as \"refresh\".  The return \"access\" token needs to be sent as HTTP authentication header with every request with \'Bearer \' prefix (case-sensitive).
   */
  async authRefreshTokenCreateRaw(
    requestParameters: AuthRefreshTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Tokens>> {
    const requestOptions = await this.authRefreshTokenCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TokensFromJSON(jsonValue));
  }

  /**
   * Refresh API authentication token by refresh_token.  Post \"refresh\" token as \"refresh\".  The return \"access\" token needs to be sent as HTTP authentication header with every request with \'Bearer \' prefix (case-sensitive).
   */
  async authRefreshTokenCreate(
    requestParameters: AuthRefreshTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Tokens> {
    const response = await this.authRefreshTokenCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authTokenCreate without sending the request
   */
  async authTokenCreateRequestOpts(
    requestParameters: AuthTokenCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling authTokenCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/auth/token/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AuthenticateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Retrieve tokens for API authentication.  There are two ways for retrieving a tokens. The preferred way is attaching a Personal API Key to the request and leave the request body empty. For backwards compatibility, you can also supply your username and password in the request body directly.  The response will contain an \"access\" and \"refresh\" JWT token.  The \"access\" token needs to be sent as HTTP authentication header with every request with a \'Bearer \' prefix (case-sensitive).  Note that the \"access\" token expires after some time.  The \"refresh\" token can be used to get a new access token via the \"refresh\" endpoint.
   */
  async authTokenCreateRaw(
    requestParameters: AuthTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Tokens>> {
    const requestOptions = await this.authTokenCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TokensFromJSON(jsonValue));
  }

  /**
   * Retrieve tokens for API authentication.  There are two ways for retrieving a tokens. The preferred way is attaching a Personal API Key to the request and leave the request body empty. For backwards compatibility, you can also supply your username and password in the request body directly.  The response will contain an \"access\" and \"refresh\" JWT token.  The \"access\" token needs to be sent as HTTP authentication header with every request with a \'Bearer \' prefix (case-sensitive).  Note that the \"access\" token expires after some time.  The \"refresh\" token can be used to get a new access token via the \"refresh\" endpoint.
   */
  async authTokenCreate(
    requestParameters: AuthTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Tokens> {
    const response = await this.authTokenCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authUsersList without sending the request
   */
  async authUsersListRequestOpts(
    requestParameters: AuthUsersListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["email"] != null) {
      queryParameters["email"] = requestParameters["email"];
    }

    if (requestParameters["emailContains"] != null) {
      queryParameters["email__contains"] = requestParameters["emailContains"];
    }

    if (requestParameters["emailEndswith"] != null) {
      queryParameters["email__endswith"] = requestParameters["emailEndswith"];
    }

    if (requestParameters["emailIcontains"] != null) {
      queryParameters["email__icontains"] = requestParameters["emailIcontains"];
    }

    if (requestParameters["emailIexact"] != null) {
      queryParameters["email__iexact"] = requestParameters["emailIexact"];
    }

    if (requestParameters["emailIn"] != null) {
      queryParameters["email__in"] = requestParameters["emailIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["emailIstartswith"] != null) {
      queryParameters["email__istartswith"] = requestParameters["emailIstartswith"];
    }

    if (requestParameters["emailRegex"] != null) {
      queryParameters["email__regex"] = requestParameters["emailRegex"];
    }

    if (requestParameters["emailStartswith"] != null) {
      queryParameters["email__startswith"] = requestParameters["emailStartswith"];
    }

    if (requestParameters["isActive"] != null) {
      queryParameters["is_active"] = requestParameters["isActive"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["remoteExternalUserId"] != null) {
      queryParameters["remote__external_user_id"] = requestParameters["remoteExternalUserId"];
    }

    if (requestParameters["username"] != null) {
      queryParameters["username"] = requestParameters["username"];
    }

    if (requestParameters["usernameContains"] != null) {
      queryParameters["username__contains"] = requestParameters["usernameContains"];
    }

    if (requestParameters["usernameEndswith"] != null) {
      queryParameters["username__endswith"] = requestParameters["usernameEndswith"];
    }

    if (requestParameters["usernameIcontains"] != null) {
      queryParameters["username__icontains"] = requestParameters["usernameIcontains"];
    }

    if (requestParameters["usernameIexact"] != null) {
      queryParameters["username__iexact"] = requestParameters["usernameIexact"];
    }

    if (requestParameters["usernameIn"] != null) {
      queryParameters["username__in"] = requestParameters["usernameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["usernameIstartswith"] != null) {
      queryParameters["username__istartswith"] = requestParameters["usernameIstartswith"];
    }

    if (requestParameters["usernameRegex"] != null) {
      queryParameters["username__regex"] = requestParameters["usernameRegex"];
    }

    if (requestParameters["usernameStartswith"] != null) {
      queryParameters["username__startswith"] = requestParameters["usernameStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/auth/users/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for viewing user details.  - superusers and staff users might view all users - user with a manager role might view all users for the   organisations they have the manager role for - regular users might view their user details
   */
  async authUsersListRaw(
    requestParameters: AuthUsersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedUserList>> {
    const requestOptions = await this.authUsersListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedUserListFromJSON(jsonValue)
    );
  }

  /**
   * Read-only API endpoint for viewing user details.  - superusers and staff users might view all users - user with a manager role might view all users for the   organisations they have the manager role for - regular users might view their user details
   */
  async authUsersList(
    requestParameters: AuthUsersListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedUserList> {
    const response = await this.authUsersListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authUsersRead without sending the request
   */
  async authUsersReadRequestOpts(
    requestParameters: AuthUsersReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling authUsersRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/auth/users/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async authUsersReadRaw(
    requestParameters: AuthUsersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<User>> {
    const requestOptions = await this.authUsersReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
  }

  /**
   */
  async authUsersRead(
    requestParameters: AuthUsersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<User> {
    const response = await this.authUsersReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authUsersTokens without sending the request
   */
  async authUsersTokensRequestOpts(
    requestParameters: AuthUsersTokensRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling authUsersTokens().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["requiredScopes"] != null) {
      queryParameters["required_scopes"] = requestParameters["requiredScopes"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/auth/users/{id}/tokens/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async authUsersTokensRaw(
    requestParameters: AuthUsersTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UserTokens>> {
    const requestOptions = await this.authUsersTokensRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserTokensFromJSON(jsonValue));
  }

  /**
   */
  async authUsersTokens(
    requestParameters: AuthUsersTokensRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UserTokens> {
    const response = await this.authUsersTokensRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for contractsCreate without sending the request
   */
  async contractsCreateRequestOpts(
    requestParameters: ContractsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling contractsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/contracts/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ContractToJSON(requestParameters["data"]),
    };
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsCreateRaw(
    requestParameters: ContractsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Contract>> {
    const requestOptions = await this.contractsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ContractFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsCreate(
    requestParameters: ContractsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Contract> {
    const response = await this.contractsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for contractsDelete without sending the request
   */
  async contractsDeleteRequestOpts(
    requestParameters: ContractsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling contractsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/contracts/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsDeleteRaw(
    requestParameters: ContractsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.contractsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsDelete(
    requestParameters: ContractsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.contractsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for contractsList without sending the request
   */
  async contractsListRequestOpts(
    requestParameters: ContractsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["hoursUsedGt"] != null) {
      queryParameters["hours_used__gt"] = requestParameters["hoursUsedGt"];
    }

    if (requestParameters["hoursUsedLt"] != null) {
      queryParameters["hours_used__lt"] = requestParameters["hoursUsedLt"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["organisationId"] != null) {
      queryParameters["organisation__id"] = requestParameters["organisationId"];
    }

    if (requestParameters["organisationIdGt"] != null) {
      queryParameters["organisation__id__gt"] = requestParameters["organisationIdGt"];
    }

    if (requestParameters["organisationIdGte"] != null) {
      queryParameters["organisation__id__gte"] = requestParameters["organisationIdGte"];
    }

    if (requestParameters["organisationIdIsnull"] != null) {
      queryParameters["organisation__id__isnull"] = requestParameters["organisationIdIsnull"];
    }

    if (requestParameters["organisationIdLt"] != null) {
      queryParameters["organisation__id__lt"] = requestParameters["organisationIdLt"];
    }

    if (requestParameters["organisationIdLte"] != null) {
      queryParameters["organisation__id__lte"] = requestParameters["organisationIdLte"];
    }

    if (requestParameters["organisationName"] != null) {
      queryParameters["organisation__name"] = requestParameters["organisationName"];
    }

    if (requestParameters["organisationNameContains"] != null) {
      queryParameters["organisation__name__contains"] =
        requestParameters["organisationNameContains"];
    }

    if (requestParameters["organisationNameEndswith"] != null) {
      queryParameters["organisation__name__endswith"] =
        requestParameters["organisationNameEndswith"];
    }

    if (requestParameters["organisationNameIcontains"] != null) {
      queryParameters["organisation__name__icontains"] =
        requestParameters["organisationNameIcontains"];
    }

    if (requestParameters["organisationNameIexact"] != null) {
      queryParameters["organisation__name__iexact"] = requestParameters["organisationNameIexact"];
    }

    if (requestParameters["organisationNameIn"] != null) {
      queryParameters["organisation__name__in"] = requestParameters["organisationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["organisationNameIstartswith"] != null) {
      queryParameters["organisation__name__istartswith"] =
        requestParameters["organisationNameIstartswith"];
    }

    if (requestParameters["organisationNameRegex"] != null) {
      queryParameters["organisation__name__regex"] = requestParameters["organisationNameRegex"];
    }

    if (requestParameters["organisationNameStartswith"] != null) {
      queryParameters["organisation__name__startswith"] =
        requestParameters["organisationNameStartswith"];
    }

    if (requestParameters["organisationUniqueId"] != null) {
      queryParameters["organisation__unique_id"] = requestParameters["organisationUniqueId"];
    }

    if (requestParameters["organisationUniqueIdContains"] != null) {
      queryParameters["organisation__unique_id__contains"] =
        requestParameters["organisationUniqueIdContains"];
    }

    if (requestParameters["organisationUniqueIdEndswith"] != null) {
      queryParameters["organisation__unique_id__endswith"] =
        requestParameters["organisationUniqueIdEndswith"];
    }

    if (requestParameters["organisationUniqueIdIcontains"] != null) {
      queryParameters["organisation__unique_id__icontains"] =
        requestParameters["organisationUniqueIdIcontains"];
    }

    if (requestParameters["organisationUniqueIdIexact"] != null) {
      queryParameters["organisation__unique_id__iexact"] =
        requestParameters["organisationUniqueIdIexact"];
    }

    if (requestParameters["organisationUniqueIdIn"] != null) {
      queryParameters["organisation__unique_id__in"] = requestParameters[
        "organisationUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["organisationUniqueIdIstartswith"] != null) {
      queryParameters["organisation__unique_id__istartswith"] =
        requestParameters["organisationUniqueIdIstartswith"];
    }

    if (requestParameters["organisationUniqueIdRegex"] != null) {
      queryParameters["organisation__unique_id__regex"] =
        requestParameters["organisationUniqueIdRegex"];
    }

    if (requestParameters["organisationUniqueIdStartswith"] != null) {
      queryParameters["organisation__unique_id__startswith"] =
        requestParameters["organisationUniqueIdStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/contracts/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Overview of organisations that have a valid 3Di contract.  List all organisations that already have used some fraction of their calculation quota (for the current year - the `hours_used` property is based on the current calender year) ``` ?hours_used__gt=0 ```
   */
  async contractsListRaw(
    requestParameters: ContractsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedContractList>> {
    const requestOptions = await this.contractsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedContractListFromJSON(jsonValue)
    );
  }

  /**
   * Overview of organisations that have a valid 3Di contract.  List all organisations that already have used some fraction of their calculation quota (for the current year - the `hours_used` property is based on the current calender year) ``` ?hours_used__gt=0 ```
   */
  async contractsList(
    requestParameters: ContractsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedContractList> {
    const response = await this.contractsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for contractsPartialUpdate without sending the request
   */
  async contractsPartialUpdateRequestOpts(
    requestParameters: ContractsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling contractsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling contractsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/contracts/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedContractToJSON(requestParameters["data"]),
    };
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsPartialUpdateRaw(
    requestParameters: ContractsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Contract>> {
    const requestOptions = await this.contractsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ContractFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsPartialUpdate(
    requestParameters: ContractsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Contract> {
    const response = await this.contractsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for contractsRead without sending the request
   */
  async contractsReadRequestOpts(
    requestParameters: ContractsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling contractsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/contracts/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsReadRaw(
    requestParameters: ContractsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Contract>> {
    const requestOptions = await this.contractsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ContractFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsRead(
    requestParameters: ContractsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Contract> {
    const response = await this.contractsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for contractsUpdate without sending the request
   */
  async contractsUpdateRequestOpts(
    requestParameters: ContractsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling contractsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling contractsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/contracts/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ContractToJSON(requestParameters["data"]),
    };
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsUpdateRaw(
    requestParameters: ContractsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Contract>> {
    const requestOptions = await this.contractsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ContractFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with contracts.
   */
  async contractsUpdate(
    requestParameters: ContractsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Contract> {
    const response = await this.contractsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for filesDelete without sending the request
   */
  async filesDeleteRequestOpts(
    requestParameters: FilesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling filesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesDeleteRaw(
    requestParameters: FilesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.filesDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesDelete(
    requestParameters: FilesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.filesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for filesDestroyFile without sending the request
   */
  async filesDestroyFileRequestOpts(
    requestParameters: FilesDestroyFileRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling filesDestroyFile().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/{id}/destroy_file/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesDestroyFileRaw(
    requestParameters: FilesDestroyFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.filesDestroyFileRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesDestroyFile(
    requestParameters: FilesDestroyFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.filesDestroyFileRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for filesDownload without sending the request
   */
  async filesDownloadRequestOpts(
    requestParameters: FilesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling filesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async filesDownloadRaw(
    requestParameters: FilesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.filesDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async filesDownload(
    requestParameters: FilesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.filesDownloadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for filesList without sending the request
   */
  async filesListRequestOpts(requestParameters: FilesListRequest): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["etag"] != null) {
      queryParameters["etag"] = requestParameters["etag"];
    }

    if (requestParameters["expiryDate"] != null) {
      queryParameters["expiry_date"] = runtime.serializeDate(
        requestParameters["expiryDate"] as any
      );
    }

    if (requestParameters["expiryDateGt"] != null) {
      queryParameters["expiry_date__gt"] = runtime.serializeDate(
        requestParameters["expiryDateGt"] as any
      );
    }

    if (requestParameters["expiryDateGte"] != null) {
      queryParameters["expiry_date__gte"] = runtime.serializeDate(
        requestParameters["expiryDateGte"] as any
      );
    }

    if (requestParameters["expiryDateLt"] != null) {
      queryParameters["expiry_date__lt"] = runtime.serializeDate(
        requestParameters["expiryDateLt"] as any
      );
    }

    if (requestParameters["expiryDateLte"] != null) {
      queryParameters["expiry_date__lte"] = runtime.serializeDate(
        requestParameters["expiryDateLte"] as any
      );
    }

    if (requestParameters["filename"] != null) {
      queryParameters["filename"] = requestParameters["filename"];
    }

    if (requestParameters["filenameIcontains"] != null) {
      queryParameters["filename__icontains"] = requestParameters["filenameIcontains"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["meta"] != null) {
      queryParameters["meta"] = requestParameters["meta"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["state"] != null) {
      queryParameters["state"] = requestParameters["state"];
    }

    if (requestParameters["stateIn"] != null) {
      queryParameters["state__in"] = requestParameters["stateIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["type"] != null) {
      queryParameters["type"] = requestParameters["type"];
    }

    if (requestParameters["typeIn"] != null) {
      queryParameters["type__in"] = requestParameters["typeIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesListRaw(
    requestParameters: FilesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedFileList>> {
    const requestOptions = await this.filesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedFileListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesList(
    requestParameters: FilesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedFileList> {
    const response = await this.filesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for filesPartialUpdate without sending the request
   */
  async filesPartialUpdateRequestOpts(
    requestParameters: FilesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling filesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling filesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesPartialUpdateRaw(
    requestParameters: FilesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.filesPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesPartialUpdate(
    requestParameters: FilesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.filesPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for filesProcessed without sending the request
   */
  async filesProcessedRequestOpts(
    requestParameters: FilesProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling filesProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling filesProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: FileMetaToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint to which the upload-processor can enrich file objects (and their related objects) with metadata.  For example the geotransform of raster files.
   */
  async filesProcessedRaw(
    requestParameters: FilesProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.filesProcessedRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Endpoint to which the upload-processor can enrich file objects (and their related objects) with metadata.  For example the geotransform of raster files.
   */
  async filesProcessed(
    requestParameters: FilesProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.filesProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for filesRead without sending the request
   */
  async filesReadRequestOpts(requestParameters: FilesReadRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling filesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesReadRaw(
    requestParameters: FilesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.filesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesRead(
    requestParameters: FilesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.filesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for filesUpdate without sending the request
   */
  async filesUpdateRequestOpts(
    requestParameters: FilesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling filesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling filesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ModelFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesUpdateRaw(
    requestParameters: FilesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.filesUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * A simple ViewSet for viewing files
   */
  async filesUpdate(
    requestParameters: FilesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.filesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for inpyVersionsCreate without sending the request
   */
  async inpyVersionsCreateRequestOpts(
    requestParameters: InpyVersionsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling inpyVersionsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/inpy-versions/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: InpyVersionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsCreateRaw(
    requestParameters: InpyVersionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InpyVersion>> {
    const requestOptions = await this.inpyVersionsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InpyVersionFromJSON(jsonValue));
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsCreate(
    requestParameters: InpyVersionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InpyVersion> {
    const response = await this.inpyVersionsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for inpyVersionsDelete without sending the request
   */
  async inpyVersionsDeleteRequestOpts(
    requestParameters: InpyVersionsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling inpyVersionsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/inpy-versions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsDeleteRaw(
    requestParameters: InpyVersionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.inpyVersionsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsDelete(
    requestParameters: InpyVersionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.inpyVersionsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for inpyVersionsList without sending the request
   */
  async inpyVersionsListRequestOpts(
    requestParameters: InpyVersionsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    if (requestParameters["slugContains"] != null) {
      queryParameters["slug__contains"] = requestParameters["slugContains"];
    }

    if (requestParameters["slugEndswith"] != null) {
      queryParameters["slug__endswith"] = requestParameters["slugEndswith"];
    }

    if (requestParameters["slugIcontains"] != null) {
      queryParameters["slug__icontains"] = requestParameters["slugIcontains"];
    }

    if (requestParameters["slugIexact"] != null) {
      queryParameters["slug__iexact"] = requestParameters["slugIexact"];
    }

    if (requestParameters["slugIn"] != null) {
      queryParameters["slug__in"] = requestParameters["slugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["slugIstartswith"] != null) {
      queryParameters["slug__istartswith"] = requestParameters["slugIstartswith"];
    }

    if (requestParameters["slugRegex"] != null) {
      queryParameters["slug__regex"] = requestParameters["slugRegex"];
    }

    if (requestParameters["slugStartswith"] != null) {
      queryParameters["slug__startswith"] = requestParameters["slugStartswith"];
    }

    if (requestParameters["threediVersion"] != null) {
      queryParameters["threedi_version"] = requestParameters["threediVersion"];
    }

    if (requestParameters["threediVersionContains"] != null) {
      queryParameters["threedi_version__contains"] = requestParameters["threediVersionContains"];
    }

    if (requestParameters["threediVersionEndswith"] != null) {
      queryParameters["threedi_version__endswith"] = requestParameters["threediVersionEndswith"];
    }

    if (requestParameters["threediVersionIcontains"] != null) {
      queryParameters["threedi_version__icontains"] = requestParameters["threediVersionIcontains"];
    }

    if (requestParameters["threediVersionIexact"] != null) {
      queryParameters["threedi_version__iexact"] = requestParameters["threediVersionIexact"];
    }

    if (requestParameters["threediVersionIn"] != null) {
      queryParameters["threedi_version__in"] = requestParameters["threediVersionIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["threediVersionIstartswith"] != null) {
      queryParameters["threedi_version__istartswith"] =
        requestParameters["threediVersionIstartswith"];
    }

    if (requestParameters["threediVersionRegex"] != null) {
      queryParameters["threedi_version__regex"] = requestParameters["threediVersionRegex"];
    }

    if (requestParameters["threediVersionStartswith"] != null) {
      queryParameters["threedi_version__startswith"] =
        requestParameters["threediVersionStartswith"];
    }

    if (requestParameters["threedicoreVersion"] != null) {
      queryParameters["threedicore_version"] = requestParameters["threedicoreVersion"];
    }

    if (requestParameters["threedicoreVersionContains"] != null) {
      queryParameters["threedicore_version__contains"] =
        requestParameters["threedicoreVersionContains"];
    }

    if (requestParameters["threedicoreVersionEndswith"] != null) {
      queryParameters["threedicore_version__endswith"] =
        requestParameters["threedicoreVersionEndswith"];
    }

    if (requestParameters["threedicoreVersionIcontains"] != null) {
      queryParameters["threedicore_version__icontains"] =
        requestParameters["threedicoreVersionIcontains"];
    }

    if (requestParameters["threedicoreVersionIexact"] != null) {
      queryParameters["threedicore_version__iexact"] =
        requestParameters["threedicoreVersionIexact"];
    }

    if (requestParameters["threedicoreVersionIn"] != null) {
      queryParameters["threedicore_version__in"] = requestParameters["threedicoreVersionIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["threedicoreVersionIstartswith"] != null) {
      queryParameters["threedicore_version__istartswith"] =
        requestParameters["threedicoreVersionIstartswith"];
    }

    if (requestParameters["threedicoreVersionRegex"] != null) {
      queryParameters["threedicore_version__regex"] = requestParameters["threedicoreVersionRegex"];
    }

    if (requestParameters["threedicoreVersionStartswith"] != null) {
      queryParameters["threedicore_version__startswith"] =
        requestParameters["threedicoreVersionStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/inpy-versions/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsListRaw(
    requestParameters: InpyVersionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedInpyVersionList>> {
    const requestOptions = await this.inpyVersionsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedInpyVersionListFromJSON(jsonValue)
    );
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsList(
    requestParameters: InpyVersionsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedInpyVersionList> {
    const response = await this.inpyVersionsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for inpyVersionsPartialUpdate without sending the request
   */
  async inpyVersionsPartialUpdateRequestOpts(
    requestParameters: InpyVersionsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling inpyVersionsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling inpyVersionsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/inpy-versions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedInpyVersionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsPartialUpdateRaw(
    requestParameters: InpyVersionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InpyVersion>> {
    const requestOptions = await this.inpyVersionsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InpyVersionFromJSON(jsonValue));
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsPartialUpdate(
    requestParameters: InpyVersionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InpyVersion> {
    const response = await this.inpyVersionsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for inpyVersionsRead without sending the request
   */
  async inpyVersionsReadRequestOpts(
    requestParameters: InpyVersionsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling inpyVersionsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/inpy-versions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsReadRaw(
    requestParameters: InpyVersionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InpyVersion>> {
    const requestOptions = await this.inpyVersionsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InpyVersionFromJSON(jsonValue));
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsRead(
    requestParameters: InpyVersionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InpyVersion> {
    const response = await this.inpyVersionsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for inpyVersionsUpdate without sending the request
   */
  async inpyVersionsUpdateRequestOpts(
    requestParameters: InpyVersionsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling inpyVersionsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling inpyVersionsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/inpy-versions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: InpyVersionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsUpdateRaw(
    requestParameters: InpyVersionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InpyVersion>> {
    const requestOptions = await this.inpyVersionsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InpyVersionFromJSON(jsonValue));
  }

  /**
   * Inpy was the service for preparing user-supplied schematisations into 3Di models (threedimodels) usable by the 3Di calculation core.  Currently, this route is pending deprecation: most newly generated 3Di models will carry an empty inpy_version.
   */
  async inpyVersionsUpdate(
    requestParameters: InpyVersionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InpyVersion> {
    const response = await this.inpyVersionsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationSettingsCreate without sending the request
   */
  async organisationSettingsCreateRequestOpts(
    requestParameters: OrganisationSettingsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationSettingsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisation-settings/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsCreateRaw(
    requestParameters: OrganisationSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Settings>> {
    const requestOptions = await this.organisationSettingsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsCreate(
    requestParameters: OrganisationSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Settings> {
    const response = await this.organisationSettingsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationSettingsDelete without sending the request
   */
  async organisationSettingsDeleteRequestOpts(
    requestParameters: OrganisationSettingsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling organisationSettingsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisation-settings/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsDeleteRaw(
    requestParameters: OrganisationSettingsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.organisationSettingsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsDelete(
    requestParameters: OrganisationSettingsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.organisationSettingsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for organisationSettingsList without sending the request
   */
  async organisationSettingsListRequestOpts(
    requestParameters: OrganisationSettingsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisation-settings/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsListRaw(
    requestParameters: OrganisationSettingsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedsettingsList>> {
    const requestOptions = await this.organisationSettingsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedsettingsListFromJSON(jsonValue)
    );
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsList(
    requestParameters: OrganisationSettingsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedsettingsList> {
    const response = await this.organisationSettingsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationSettingsPartialUpdate without sending the request
   */
  async organisationSettingsPartialUpdateRequestOpts(
    requestParameters: OrganisationSettingsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling organisationSettingsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationSettingsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisation-settings/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedsettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsPartialUpdateRaw(
    requestParameters: OrganisationSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Settings>> {
    const requestOptions = await this.organisationSettingsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsPartialUpdate(
    requestParameters: OrganisationSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Settings> {
    const response = await this.organisationSettingsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for organisationSettingsRead without sending the request
   */
  async organisationSettingsReadRequestOpts(
    requestParameters: OrganisationSettingsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling organisationSettingsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisation-settings/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsReadRaw(
    requestParameters: OrganisationSettingsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Settings>> {
    const requestOptions = await this.organisationSettingsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsRead(
    requestParameters: OrganisationSettingsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Settings> {
    const response = await this.organisationSettingsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationSettingsUpdate without sending the request
   */
  async organisationSettingsUpdateRequestOpts(
    requestParameters: OrganisationSettingsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling organisationSettingsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationSettingsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisation-settings/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsUpdateRaw(
    requestParameters: OrganisationSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Settings>> {
    const requestOptions = await this.organisationSettingsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
  }

  /**
   * API endpoint for interacting with organisation settings.
   */
  async organisationSettingsUpdate(
    requestParameters: OrganisationSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Settings> {
    const response = await this.organisationSettingsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsCreate without sending the request
   */
  async organisationsCreateRequestOpts(
    requestParameters: OrganisationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateOrganisationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create organisation (superuser only).
   */
  async organisationsCreateRaw(
    requestParameters: OrganisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateOrganisation>> {
    const requestOptions = await this.organisationsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateOrganisationFromJSON(jsonValue)
    );
  }

  /**
   * Create organisation (superuser only).
   */
  async organisationsCreate(
    requestParameters: OrganisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateOrganisation> {
    const response = await this.organisationsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsDelete without sending the request
   */
  async organisationsDeleteRequestOpts(
    requestParameters: OrganisationsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/`;
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsDeleteRaw(
    requestParameters: OrganisationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.organisationsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsDelete(
    requestParameters: OrganisationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.organisationsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for organisationsList without sending the request
   */
  async organisationsListRequestOpts(
    requestParameters: OrganisationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["contractScopeIn"] != null) {
      queryParameters["contract__scope__in"] = requestParameters["contractScopeIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["loggedInUserHasRole"] != null) {
      queryParameters["logged_in_user_has_role"] = requestParameters["loggedInUserHasRole"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["uniqueId"] != null) {
      queryParameters["unique_id"] = requestParameters["uniqueId"];
    }

    if (requestParameters["uniqueIdContains"] != null) {
      queryParameters["unique_id__contains"] = requestParameters["uniqueIdContains"];
    }

    if (requestParameters["uniqueIdEndswith"] != null) {
      queryParameters["unique_id__endswith"] = requestParameters["uniqueIdEndswith"];
    }

    if (requestParameters["uniqueIdIcontains"] != null) {
      queryParameters["unique_id__icontains"] = requestParameters["uniqueIdIcontains"];
    }

    if (requestParameters["uniqueIdIexact"] != null) {
      queryParameters["unique_id__iexact"] = requestParameters["uniqueIdIexact"];
    }

    if (requestParameters["uniqueIdIn"] != null) {
      queryParameters["unique_id__in"] = requestParameters["uniqueIdIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["uniqueIdIstartswith"] != null) {
      queryParameters["unique_id__istartswith"] = requestParameters["uniqueIdIstartswith"];
    }

    if (requestParameters["uniqueIdRegex"] != null) {
      queryParameters["unique_id__regex"] = requestParameters["uniqueIdRegex"];
    }

    if (requestParameters["uniqueIdStartswith"] != null) {
      queryParameters["unique_id__startswith"] = requestParameters["uniqueIdStartswith"];
    }

    if (requestParameters["validContractsOnly"] != null) {
      queryParameters["valid_contracts_only"] = requestParameters["validContractsOnly"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsListRaw(
    requestParameters: OrganisationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedOrganisationList>> {
    const requestOptions = await this.organisationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedOrganisationListFromJSON(jsonValue)
    );
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsList(
    requestParameters: OrganisationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedOrganisationList> {
    const response = await this.organisationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsPartialUpdate without sending the request
   */
  async organisationsPartialUpdateRequestOpts(
    requestParameters: OrganisationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/`;
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedOrganisationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsPartialUpdateRaw(
    requestParameters: OrganisationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Organisation>> {
    const requestOptions = await this.organisationsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsPartialUpdate(
    requestParameters: OrganisationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Organisation> {
    const response = await this.organisationsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsPermissions without sending the request
   */
  async organisationsPermissionsRequestOpts(
    requestParameters: OrganisationsPermissionsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsPermissions().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["contractScopeIn"] != null) {
      queryParameters["contract__scope__in"] = requestParameters["contractScopeIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["loggedInUserHasRole"] != null) {
      queryParameters["logged_in_user_has_role"] = requestParameters["loggedInUserHasRole"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["uniqueId2"] != null) {
      queryParameters["unique_id"] = requestParameters["uniqueId2"];
    }

    if (requestParameters["uniqueIdContains"] != null) {
      queryParameters["unique_id__contains"] = requestParameters["uniqueIdContains"];
    }

    if (requestParameters["uniqueIdEndswith"] != null) {
      queryParameters["unique_id__endswith"] = requestParameters["uniqueIdEndswith"];
    }

    if (requestParameters["uniqueIdIcontains"] != null) {
      queryParameters["unique_id__icontains"] = requestParameters["uniqueIdIcontains"];
    }

    if (requestParameters["uniqueIdIexact"] != null) {
      queryParameters["unique_id__iexact"] = requestParameters["uniqueIdIexact"];
    }

    if (requestParameters["uniqueIdIn"] != null) {
      queryParameters["unique_id__in"] = requestParameters["uniqueIdIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["uniqueIdIstartswith"] != null) {
      queryParameters["unique_id__istartswith"] = requestParameters["uniqueIdIstartswith"];
    }

    if (requestParameters["uniqueIdRegex"] != null) {
      queryParameters["unique_id__regex"] = requestParameters["uniqueIdRegex"];
    }

    if (requestParameters["uniqueIdStartswith"] != null) {
      queryParameters["unique_id__startswith"] = requestParameters["uniqueIdStartswith"];
    }

    if (requestParameters["validContractsOnly"] != null) {
      queryParameters["valid_contracts_only"] = requestParameters["validContractsOnly"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/permissions/`;
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsPermissionsRaw(
    requestParameters: OrganisationsPermissionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<OrganisationRole>>> {
    const requestOptions = await this.organisationsPermissionsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(OrganisationRoleFromJSON)
    );
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsPermissions(
    requestParameters: OrganisationsPermissionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<OrganisationRole>> {
    const response = await this.organisationsPermissionsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsRead without sending the request
   */
  async organisationsReadRequestOpts(
    requestParameters: OrganisationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/`;
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsReadRaw(
    requestParameters: OrganisationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Organisation>> {
    const requestOptions = await this.organisationsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsRead(
    requestParameters: OrganisationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Organisation> {
    const response = await this.organisationsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsSetRanaTenantId without sending the request
   */
  async organisationsSetRanaTenantIdRequestOpts(
    requestParameters: OrganisationsSetRanaTenantIdRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsSetRanaTenantId().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationsSetRanaTenantId().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/set_rana_tenant_id/`;
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SetRanaTenantToJSON(requestParameters["data"]),
    };
  }

  /**
   * Set the rana_tenant_id for an organisation. (only allowed for superusers)
   */
  async organisationsSetRanaTenantIdRaw(
    requestParameters: OrganisationsSetRanaTenantIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Organisation>> {
    const requestOptions = await this.organisationsSetRanaTenantIdRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
  }

  /**
   * Set the rana_tenant_id for an organisation. (only allowed for superusers)
   */
  async organisationsSetRanaTenantId(
    requestParameters: OrganisationsSetRanaTenantIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Organisation> {
    const response = await this.organisationsSetRanaTenantIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsUpdate without sending the request
   */
  async organisationsUpdateRequestOpts(
    requestParameters: OrganisationsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/`;
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: CreateOrganisationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsUpdateRaw(
    requestParameters: OrganisationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateOrganisation>> {
    const requestOptions = await this.organisationsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateOrganisationFromJSON(jsonValue)
    );
  }

  /**
   * Read-only API endpoint for interacting with organisations.
   */
  async organisationsUpdate(
    requestParameters: OrganisationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateOrganisation> {
    const response = await this.organisationsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsUsersList without sending the request
   */
  async organisationsUsersListRequestOpts(
    requestParameters: OrganisationsUsersListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsUsersList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["email"] != null) {
      queryParameters["email"] = requestParameters["email"];
    }

    if (requestParameters["emailContains"] != null) {
      queryParameters["email__contains"] = requestParameters["emailContains"];
    }

    if (requestParameters["emailEndswith"] != null) {
      queryParameters["email__endswith"] = requestParameters["emailEndswith"];
    }

    if (requestParameters["emailIcontains"] != null) {
      queryParameters["email__icontains"] = requestParameters["emailIcontains"];
    }

    if (requestParameters["emailIexact"] != null) {
      queryParameters["email__iexact"] = requestParameters["emailIexact"];
    }

    if (requestParameters["emailIn"] != null) {
      queryParameters["email__in"] = requestParameters["emailIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["emailIstartswith"] != null) {
      queryParameters["email__istartswith"] = requestParameters["emailIstartswith"];
    }

    if (requestParameters["emailRegex"] != null) {
      queryParameters["email__regex"] = requestParameters["emailRegex"];
    }

    if (requestParameters["emailStartswith"] != null) {
      queryParameters["email__startswith"] = requestParameters["emailStartswith"];
    }

    if (requestParameters["isActive"] != null) {
      queryParameters["is_active"] = requestParameters["isActive"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["remoteExternalUserId"] != null) {
      queryParameters["remote__external_user_id"] = requestParameters["remoteExternalUserId"];
    }

    if (requestParameters["username"] != null) {
      queryParameters["username"] = requestParameters["username"];
    }

    if (requestParameters["usernameContains"] != null) {
      queryParameters["username__contains"] = requestParameters["usernameContains"];
    }

    if (requestParameters["usernameEndswith"] != null) {
      queryParameters["username__endswith"] = requestParameters["usernameEndswith"];
    }

    if (requestParameters["usernameIcontains"] != null) {
      queryParameters["username__icontains"] = requestParameters["usernameIcontains"];
    }

    if (requestParameters["usernameIexact"] != null) {
      queryParameters["username__iexact"] = requestParameters["usernameIexact"];
    }

    if (requestParameters["usernameIn"] != null) {
      queryParameters["username__in"] = requestParameters["usernameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["usernameIstartswith"] != null) {
      queryParameters["username__istartswith"] = requestParameters["usernameIstartswith"];
    }

    if (requestParameters["usernameRegex"] != null) {
      queryParameters["username__regex"] = requestParameters["usernameRegex"];
    }

    if (requestParameters["usernameStartswith"] != null) {
      queryParameters["username__startswith"] = requestParameters["usernameStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/users/`;
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for interacting with users in an organisation.
   */
  async organisationsUsersListRaw(
    requestParameters: OrganisationsUsersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedOrganisationUserList>> {
    const requestOptions = await this.organisationsUsersListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedOrganisationUserListFromJSON(jsonValue)
    );
  }

  /**
   * Endpoint for interacting with users in an organisation.
   */
  async organisationsUsersList(
    requestParameters: OrganisationsUsersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedOrganisationUserList> {
    const response = await this.organisationsUsersListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for organisationsUsersPartialUpdate without sending the request
   */
  async organisationsUsersPartialUpdateRequestOpts(
    requestParameters: OrganisationsUsersPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling organisationsUsersPartialUpdate().'
      );
    }

    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsUsersPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling organisationsUsersPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/users/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedOrganisationUserRolePatchToJSON(requestParameters["data"]),
    };
  }

  /**
   * Patch the roles of a user in this organisation.
   */
  async organisationsUsersPartialUpdateRaw(
    requestParameters: OrganisationsUsersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OrganisationUser>> {
    const requestOptions = await this.organisationsUsersPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OrganisationUserFromJSON(jsonValue)
    );
  }

  /**
   * Patch the roles of a user in this organisation.
   */
  async organisationsUsersPartialUpdate(
    requestParameters: OrganisationsUsersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OrganisationUser> {
    const response = await this.organisationsUsersPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for organisationsUsersRead without sending the request
   */
  async organisationsUsersReadRequestOpts(
    requestParameters: OrganisationsUsersReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling organisationsUsersRead().'
      );
    }

    if (requestParameters["uniqueId"] == null) {
      throw new runtime.RequiredError(
        "uniqueId",
        'Required parameter "uniqueId" was null or undefined when calling organisationsUsersRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/organisations/{unique_id}/users/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{unique_id}",
      encodeURIComponent(String(requestParameters["uniqueId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for interacting with users in an organisation.
   */
  async organisationsUsersReadRaw(
    requestParameters: OrganisationsUsersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OrganisationUser>> {
    const requestOptions = await this.organisationsUsersReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OrganisationUserFromJSON(jsonValue)
    );
  }

  /**
   * Endpoint for interacting with users in an organisation.
   */
  async organisationsUsersRead(
    requestParameters: OrganisationsUsersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OrganisationUser> {
    const response = await this.organisationsUsersReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for permissionsCreate without sending the request
   */
  async permissionsCreateRequestOpts(
    requestParameters: PermissionsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling permissionsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/permissions/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: OrganisationRoleToJSON(requestParameters["data"]),
    };
  }

  /**
   * create a role for an existing user in an existing organisation  Example payload:      {       \"user\": \"chuck.norris\",  # user name       \"role\": \"simulation_runner\",  # role name       \"organisation\": \"48dac75bef8a42ebbb52e8f89bbdb9f2\"  # unique id     }
   */
  async permissionsCreateRaw(
    requestParameters: PermissionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OrganisationRole>> {
    const requestOptions = await this.permissionsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OrganisationRoleFromJSON(jsonValue)
    );
  }

  /**
   * create a role for an existing user in an existing organisation  Example payload:      {       \"user\": \"chuck.norris\",  # user name       \"role\": \"simulation_runner\",  # role name       \"organisation\": \"48dac75bef8a42ebbb52e8f89bbdb9f2\"  # unique id     }
   */
  async permissionsCreate(
    requestParameters: PermissionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OrganisationRole> {
    const response = await this.permissionsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for permissionsDelete without sending the request
   */
  async permissionsDeleteRequestOpts(
    requestParameters: PermissionsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling permissionsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/permissions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Permissions management endpoints.
   */
  async permissionsDeleteRaw(
    requestParameters: PermissionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.permissionsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Permissions management endpoints.
   */
  async permissionsDelete(
    requestParameters: PermissionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.permissionsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for permissionsList without sending the request
   */
  async permissionsListRequestOpts(
    requestParameters: PermissionsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["organisationName"] != null) {
      queryParameters["organisation__name"] = requestParameters["organisationName"];
    }

    if (requestParameters["organisationNameContains"] != null) {
      queryParameters["organisation__name__contains"] =
        requestParameters["organisationNameContains"];
    }

    if (requestParameters["organisationNameEndswith"] != null) {
      queryParameters["organisation__name__endswith"] =
        requestParameters["organisationNameEndswith"];
    }

    if (requestParameters["organisationNameIcontains"] != null) {
      queryParameters["organisation__name__icontains"] =
        requestParameters["organisationNameIcontains"];
    }

    if (requestParameters["organisationNameIexact"] != null) {
      queryParameters["organisation__name__iexact"] = requestParameters["organisationNameIexact"];
    }

    if (requestParameters["organisationNameIn"] != null) {
      queryParameters["organisation__name__in"] = requestParameters["organisationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["organisationNameIstartswith"] != null) {
      queryParameters["organisation__name__istartswith"] =
        requestParameters["organisationNameIstartswith"];
    }

    if (requestParameters["organisationNameRegex"] != null) {
      queryParameters["organisation__name__regex"] = requestParameters["organisationNameRegex"];
    }

    if (requestParameters["organisationNameStartswith"] != null) {
      queryParameters["organisation__name__startswith"] =
        requestParameters["organisationNameStartswith"];
    }

    if (requestParameters["organisationUniqueId"] != null) {
      queryParameters["organisation__unique_id"] = requestParameters["organisationUniqueId"];
    }

    if (requestParameters["roleName"] != null) {
      queryParameters["role__name"] = requestParameters["roleName"];
    }

    if (requestParameters["roleNameContains"] != null) {
      queryParameters["role__name__contains"] = requestParameters["roleNameContains"];
    }

    if (requestParameters["roleNameEndswith"] != null) {
      queryParameters["role__name__endswith"] = requestParameters["roleNameEndswith"];
    }

    if (requestParameters["roleNameIcontains"] != null) {
      queryParameters["role__name__icontains"] = requestParameters["roleNameIcontains"];
    }

    if (requestParameters["roleNameIexact"] != null) {
      queryParameters["role__name__iexact"] = requestParameters["roleNameIexact"];
    }

    if (requestParameters["roleNameIn"] != null) {
      queryParameters["role__name__in"] = requestParameters["roleNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["roleNameIstartswith"] != null) {
      queryParameters["role__name__istartswith"] = requestParameters["roleNameIstartswith"];
    }

    if (requestParameters["roleNameRegex"] != null) {
      queryParameters["role__name__regex"] = requestParameters["roleNameRegex"];
    }

    if (requestParameters["roleNameStartswith"] != null) {
      queryParameters["role__name__startswith"] = requestParameters["roleNameStartswith"];
    }

    if (requestParameters["userId"] != null) {
      queryParameters["user__id"] = requestParameters["userId"];
    }

    if (requestParameters["userRemoteExternalUserId"] != null) {
      queryParameters["user__remote__external_user_id"] =
        requestParameters["userRemoteExternalUserId"];
    }

    if (requestParameters["userUsername"] != null) {
      queryParameters["user__username"] = requestParameters["userUsername"];
    }

    if (requestParameters["userUsernameContains"] != null) {
      queryParameters["user__username__contains"] = requestParameters["userUsernameContains"];
    }

    if (requestParameters["userUsernameEndswith"] != null) {
      queryParameters["user__username__endswith"] = requestParameters["userUsernameEndswith"];
    }

    if (requestParameters["userUsernameIcontains"] != null) {
      queryParameters["user__username__icontains"] = requestParameters["userUsernameIcontains"];
    }

    if (requestParameters["userUsernameIexact"] != null) {
      queryParameters["user__username__iexact"] = requestParameters["userUsernameIexact"];
    }

    if (requestParameters["userUsernameIn"] != null) {
      queryParameters["user__username__in"] = requestParameters["userUsernameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["userUsernameIstartswith"] != null) {
      queryParameters["user__username__istartswith"] = requestParameters["userUsernameIstartswith"];
    }

    if (requestParameters["userUsernameRegex"] != null) {
      queryParameters["user__username__regex"] = requestParameters["userUsernameRegex"];
    }

    if (requestParameters["userUsernameStartswith"] != null) {
      queryParameters["user__username__startswith"] = requestParameters["userUsernameStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/permissions/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Permissions management endpoints.
   */
  async permissionsListRaw(
    requestParameters: PermissionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedOrganisationRoleList>> {
    const requestOptions = await this.permissionsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedOrganisationRoleListFromJSON(jsonValue)
    );
  }

  /**
   * Permissions management endpoints.
   */
  async permissionsList(
    requestParameters: PermissionsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedOrganisationRoleList> {
    const response = await this.permissionsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for permissionsRead without sending the request
   */
  async permissionsReadRequestOpts(
    requestParameters: PermissionsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling permissionsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/permissions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Permissions management endpoints.
   */
  async permissionsReadRaw(
    requestParameters: PermissionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OrganisationRole>> {
    const requestOptions = await this.permissionsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OrganisationRoleFromJSON(jsonValue)
    );
  }

  /**
   * Permissions management endpoints.
   */
  async permissionsRead(
    requestParameters: PermissionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OrganisationRole> {
    const response = await this.permissionsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for repositoriesCreate without sending the request
   */
  async repositoriesCreateRequestOpts(
    requestParameters: RepositoriesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling repositoriesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RepositoryToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesCreateRaw(
    requestParameters: RepositoriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Repository>> {
    const requestOptions = await this.repositoriesCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RepositoryFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesCreate(
    requestParameters: RepositoriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Repository> {
    const response = await this.repositoriesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for repositoriesDelete without sending the request
   */
  async repositoriesDeleteRequestOpts(
    requestParameters: RepositoriesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling repositoriesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesDeleteRaw(
    requestParameters: RepositoriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.repositoriesDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesDelete(
    requestParameters: RepositoriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.repositoriesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for repositoriesList without sending the request
   */
  async repositoriesListRequestOpts(
    requestParameters: RepositoriesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["organisationId"] != null) {
      queryParameters["organisation__id"] = requestParameters["organisationId"];
    }

    if (requestParameters["organisationIdGt"] != null) {
      queryParameters["organisation__id__gt"] = requestParameters["organisationIdGt"];
    }

    if (requestParameters["organisationIdGte"] != null) {
      queryParameters["organisation__id__gte"] = requestParameters["organisationIdGte"];
    }

    if (requestParameters["organisationIdIsnull"] != null) {
      queryParameters["organisation__id__isnull"] = requestParameters["organisationIdIsnull"];
    }

    if (requestParameters["organisationIdLt"] != null) {
      queryParameters["organisation__id__lt"] = requestParameters["organisationIdLt"];
    }

    if (requestParameters["organisationIdLte"] != null) {
      queryParameters["organisation__id__lte"] = requestParameters["organisationIdLte"];
    }

    if (requestParameters["organisationName"] != null) {
      queryParameters["organisation__name"] = requestParameters["organisationName"];
    }

    if (requestParameters["organisationNameContains"] != null) {
      queryParameters["organisation__name__contains"] =
        requestParameters["organisationNameContains"];
    }

    if (requestParameters["organisationNameEndswith"] != null) {
      queryParameters["organisation__name__endswith"] =
        requestParameters["organisationNameEndswith"];
    }

    if (requestParameters["organisationNameIcontains"] != null) {
      queryParameters["organisation__name__icontains"] =
        requestParameters["organisationNameIcontains"];
    }

    if (requestParameters["organisationNameIexact"] != null) {
      queryParameters["organisation__name__iexact"] = requestParameters["organisationNameIexact"];
    }

    if (requestParameters["organisationNameIn"] != null) {
      queryParameters["organisation__name__in"] = requestParameters["organisationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["organisationNameIstartswith"] != null) {
      queryParameters["organisation__name__istartswith"] =
        requestParameters["organisationNameIstartswith"];
    }

    if (requestParameters["organisationNameRegex"] != null) {
      queryParameters["organisation__name__regex"] = requestParameters["organisationNameRegex"];
    }

    if (requestParameters["organisationNameStartswith"] != null) {
      queryParameters["organisation__name__startswith"] =
        requestParameters["organisationNameStartswith"];
    }

    if (requestParameters["organisationUniqueId"] != null) {
      queryParameters["organisation__unique_id"] = requestParameters["organisationUniqueId"];
    }

    if (requestParameters["organisationUniqueIdContains"] != null) {
      queryParameters["organisation__unique_id__contains"] =
        requestParameters["organisationUniqueIdContains"];
    }

    if (requestParameters["organisationUniqueIdEndswith"] != null) {
      queryParameters["organisation__unique_id__endswith"] =
        requestParameters["organisationUniqueIdEndswith"];
    }

    if (requestParameters["organisationUniqueIdIcontains"] != null) {
      queryParameters["organisation__unique_id__icontains"] =
        requestParameters["organisationUniqueIdIcontains"];
    }

    if (requestParameters["organisationUniqueIdIexact"] != null) {
      queryParameters["organisation__unique_id__iexact"] =
        requestParameters["organisationUniqueIdIexact"];
    }

    if (requestParameters["organisationUniqueIdIn"] != null) {
      queryParameters["organisation__unique_id__in"] = requestParameters[
        "organisationUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["organisationUniqueIdIstartswith"] != null) {
      queryParameters["organisation__unique_id__istartswith"] =
        requestParameters["organisationUniqueIdIstartswith"];
    }

    if (requestParameters["organisationUniqueIdRegex"] != null) {
      queryParameters["organisation__unique_id__regex"] =
        requestParameters["organisationUniqueIdRegex"];
    }

    if (requestParameters["organisationUniqueIdStartswith"] != null) {
      queryParameters["organisation__unique_id__startswith"] =
        requestParameters["organisationUniqueIdStartswith"];
    }

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    if (requestParameters["slugContains"] != null) {
      queryParameters["slug__contains"] = requestParameters["slugContains"];
    }

    if (requestParameters["slugEndswith"] != null) {
      queryParameters["slug__endswith"] = requestParameters["slugEndswith"];
    }

    if (requestParameters["slugIcontains"] != null) {
      queryParameters["slug__icontains"] = requestParameters["slugIcontains"];
    }

    if (requestParameters["slugIexact"] != null) {
      queryParameters["slug__iexact"] = requestParameters["slugIexact"];
    }

    if (requestParameters["slugIn"] != null) {
      queryParameters["slug__in"] = requestParameters["slugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["slugIstartswith"] != null) {
      queryParameters["slug__istartswith"] = requestParameters["slugIstartswith"];
    }

    if (requestParameters["slugRegex"] != null) {
      queryParameters["slug__regex"] = requestParameters["slugRegex"];
    }

    if (requestParameters["slugStartswith"] != null) {
      queryParameters["slug__startswith"] = requestParameters["slugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesListRaw(
    requestParameters: RepositoriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRepositoryList>> {
    const requestOptions = await this.repositoriesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRepositoryListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesList(
    requestParameters: RepositoriesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRepositoryList> {
    const response = await this.repositoriesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for repositoriesPartialUpdate without sending the request
   */
  async repositoriesPartialUpdateRequestOpts(
    requestParameters: RepositoriesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling repositoriesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling repositoriesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedRepositoryToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesPartialUpdateRaw(
    requestParameters: RepositoriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Repository>> {
    const requestOptions = await this.repositoriesPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RepositoryFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesPartialUpdate(
    requestParameters: RepositoriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Repository> {
    const response = await this.repositoriesPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for repositoriesRead without sending the request
   */
  async repositoriesReadRequestOpts(
    requestParameters: RepositoriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling repositoriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesReadRaw(
    requestParameters: RepositoriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Repository>> {
    const requestOptions = await this.repositoriesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RepositoryFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesRead(
    requestParameters: RepositoriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Repository> {
    const response = await this.repositoriesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for repositoriesRevisions without sending the request
   */
  async repositoriesRevisionsRequestOpts(
    requestParameters: RepositoriesRevisionsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling repositoriesRevisions().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["organisationId"] != null) {
      queryParameters["organisation__id"] = requestParameters["organisationId"];
    }

    if (requestParameters["organisationIdGt"] != null) {
      queryParameters["organisation__id__gt"] = requestParameters["organisationIdGt"];
    }

    if (requestParameters["organisationIdGte"] != null) {
      queryParameters["organisation__id__gte"] = requestParameters["organisationIdGte"];
    }

    if (requestParameters["organisationIdIsnull"] != null) {
      queryParameters["organisation__id__isnull"] = requestParameters["organisationIdIsnull"];
    }

    if (requestParameters["organisationIdLt"] != null) {
      queryParameters["organisation__id__lt"] = requestParameters["organisationIdLt"];
    }

    if (requestParameters["organisationIdLte"] != null) {
      queryParameters["organisation__id__lte"] = requestParameters["organisationIdLte"];
    }

    if (requestParameters["organisationName"] != null) {
      queryParameters["organisation__name"] = requestParameters["organisationName"];
    }

    if (requestParameters["organisationNameContains"] != null) {
      queryParameters["organisation__name__contains"] =
        requestParameters["organisationNameContains"];
    }

    if (requestParameters["organisationNameEndswith"] != null) {
      queryParameters["organisation__name__endswith"] =
        requestParameters["organisationNameEndswith"];
    }

    if (requestParameters["organisationNameIcontains"] != null) {
      queryParameters["organisation__name__icontains"] =
        requestParameters["organisationNameIcontains"];
    }

    if (requestParameters["organisationNameIexact"] != null) {
      queryParameters["organisation__name__iexact"] = requestParameters["organisationNameIexact"];
    }

    if (requestParameters["organisationNameIn"] != null) {
      queryParameters["organisation__name__in"] = requestParameters["organisationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["organisationNameIstartswith"] != null) {
      queryParameters["organisation__name__istartswith"] =
        requestParameters["organisationNameIstartswith"];
    }

    if (requestParameters["organisationNameRegex"] != null) {
      queryParameters["organisation__name__regex"] = requestParameters["organisationNameRegex"];
    }

    if (requestParameters["organisationNameStartswith"] != null) {
      queryParameters["organisation__name__startswith"] =
        requestParameters["organisationNameStartswith"];
    }

    if (requestParameters["organisationUniqueId"] != null) {
      queryParameters["organisation__unique_id"] = requestParameters["organisationUniqueId"];
    }

    if (requestParameters["organisationUniqueIdContains"] != null) {
      queryParameters["organisation__unique_id__contains"] =
        requestParameters["organisationUniqueIdContains"];
    }

    if (requestParameters["organisationUniqueIdEndswith"] != null) {
      queryParameters["organisation__unique_id__endswith"] =
        requestParameters["organisationUniqueIdEndswith"];
    }

    if (requestParameters["organisationUniqueIdIcontains"] != null) {
      queryParameters["organisation__unique_id__icontains"] =
        requestParameters["organisationUniqueIdIcontains"];
    }

    if (requestParameters["organisationUniqueIdIexact"] != null) {
      queryParameters["organisation__unique_id__iexact"] =
        requestParameters["organisationUniqueIdIexact"];
    }

    if (requestParameters["organisationUniqueIdIn"] != null) {
      queryParameters["organisation__unique_id__in"] = requestParameters[
        "organisationUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["organisationUniqueIdIstartswith"] != null) {
      queryParameters["organisation__unique_id__istartswith"] =
        requestParameters["organisationUniqueIdIstartswith"];
    }

    if (requestParameters["organisationUniqueIdRegex"] != null) {
      queryParameters["organisation__unique_id__regex"] =
        requestParameters["organisationUniqueIdRegex"];
    }

    if (requestParameters["organisationUniqueIdStartswith"] != null) {
      queryParameters["organisation__unique_id__startswith"] =
        requestParameters["organisationUniqueIdStartswith"];
    }

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    if (requestParameters["slugContains"] != null) {
      queryParameters["slug__contains"] = requestParameters["slugContains"];
    }

    if (requestParameters["slugEndswith"] != null) {
      queryParameters["slug__endswith"] = requestParameters["slugEndswith"];
    }

    if (requestParameters["slugIcontains"] != null) {
      queryParameters["slug__icontains"] = requestParameters["slugIcontains"];
    }

    if (requestParameters["slugIexact"] != null) {
      queryParameters["slug__iexact"] = requestParameters["slugIexact"];
    }

    if (requestParameters["slugIn"] != null) {
      queryParameters["slug__in"] = requestParameters["slugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["slugIstartswith"] != null) {
      queryParameters["slug__istartswith"] = requestParameters["slugIstartswith"];
    }

    if (requestParameters["slugRegex"] != null) {
      queryParameters["slug__regex"] = requestParameters["slugRegex"];
    }

    if (requestParameters["slugStartswith"] != null) {
      queryParameters["slug__startswith"] = requestParameters["slugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/{id}/revisions/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesRevisionsRaw(
    requestParameters: RepositoriesRevisionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Revision>>> {
    const requestOptions = await this.repositoriesRevisionsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RevisionFromJSON));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesRevisions(
    requestParameters: RepositoriesRevisionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Revision>> {
    const response = await this.repositoriesRevisionsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for repositoriesThreedimodels without sending the request
   */
  async repositoriesThreedimodelsRequestOpts(
    requestParameters: RepositoriesThreedimodelsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling repositoriesThreedimodels().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["organisationId"] != null) {
      queryParameters["organisation__id"] = requestParameters["organisationId"];
    }

    if (requestParameters["organisationIdGt"] != null) {
      queryParameters["organisation__id__gt"] = requestParameters["organisationIdGt"];
    }

    if (requestParameters["organisationIdGte"] != null) {
      queryParameters["organisation__id__gte"] = requestParameters["organisationIdGte"];
    }

    if (requestParameters["organisationIdIsnull"] != null) {
      queryParameters["organisation__id__isnull"] = requestParameters["organisationIdIsnull"];
    }

    if (requestParameters["organisationIdLt"] != null) {
      queryParameters["organisation__id__lt"] = requestParameters["organisationIdLt"];
    }

    if (requestParameters["organisationIdLte"] != null) {
      queryParameters["organisation__id__lte"] = requestParameters["organisationIdLte"];
    }

    if (requestParameters["organisationName"] != null) {
      queryParameters["organisation__name"] = requestParameters["organisationName"];
    }

    if (requestParameters["organisationNameContains"] != null) {
      queryParameters["organisation__name__contains"] =
        requestParameters["organisationNameContains"];
    }

    if (requestParameters["organisationNameEndswith"] != null) {
      queryParameters["organisation__name__endswith"] =
        requestParameters["organisationNameEndswith"];
    }

    if (requestParameters["organisationNameIcontains"] != null) {
      queryParameters["organisation__name__icontains"] =
        requestParameters["organisationNameIcontains"];
    }

    if (requestParameters["organisationNameIexact"] != null) {
      queryParameters["organisation__name__iexact"] = requestParameters["organisationNameIexact"];
    }

    if (requestParameters["organisationNameIn"] != null) {
      queryParameters["organisation__name__in"] = requestParameters["organisationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["organisationNameIstartswith"] != null) {
      queryParameters["organisation__name__istartswith"] =
        requestParameters["organisationNameIstartswith"];
    }

    if (requestParameters["organisationNameRegex"] != null) {
      queryParameters["organisation__name__regex"] = requestParameters["organisationNameRegex"];
    }

    if (requestParameters["organisationNameStartswith"] != null) {
      queryParameters["organisation__name__startswith"] =
        requestParameters["organisationNameStartswith"];
    }

    if (requestParameters["organisationUniqueId"] != null) {
      queryParameters["organisation__unique_id"] = requestParameters["organisationUniqueId"];
    }

    if (requestParameters["organisationUniqueIdContains"] != null) {
      queryParameters["organisation__unique_id__contains"] =
        requestParameters["organisationUniqueIdContains"];
    }

    if (requestParameters["organisationUniqueIdEndswith"] != null) {
      queryParameters["organisation__unique_id__endswith"] =
        requestParameters["organisationUniqueIdEndswith"];
    }

    if (requestParameters["organisationUniqueIdIcontains"] != null) {
      queryParameters["organisation__unique_id__icontains"] =
        requestParameters["organisationUniqueIdIcontains"];
    }

    if (requestParameters["organisationUniqueIdIexact"] != null) {
      queryParameters["organisation__unique_id__iexact"] =
        requestParameters["organisationUniqueIdIexact"];
    }

    if (requestParameters["organisationUniqueIdIn"] != null) {
      queryParameters["organisation__unique_id__in"] = requestParameters[
        "organisationUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["organisationUniqueIdIstartswith"] != null) {
      queryParameters["organisation__unique_id__istartswith"] =
        requestParameters["organisationUniqueIdIstartswith"];
    }

    if (requestParameters["organisationUniqueIdRegex"] != null) {
      queryParameters["organisation__unique_id__regex"] =
        requestParameters["organisationUniqueIdRegex"];
    }

    if (requestParameters["organisationUniqueIdStartswith"] != null) {
      queryParameters["organisation__unique_id__startswith"] =
        requestParameters["organisationUniqueIdStartswith"];
    }

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    if (requestParameters["slugContains"] != null) {
      queryParameters["slug__contains"] = requestParameters["slugContains"];
    }

    if (requestParameters["slugEndswith"] != null) {
      queryParameters["slug__endswith"] = requestParameters["slugEndswith"];
    }

    if (requestParameters["slugIcontains"] != null) {
      queryParameters["slug__icontains"] = requestParameters["slugIcontains"];
    }

    if (requestParameters["slugIexact"] != null) {
      queryParameters["slug__iexact"] = requestParameters["slugIexact"];
    }

    if (requestParameters["slugIn"] != null) {
      queryParameters["slug__in"] = requestParameters["slugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["slugIstartswith"] != null) {
      queryParameters["slug__istartswith"] = requestParameters["slugIstartswith"];
    }

    if (requestParameters["slugRegex"] != null) {
      queryParameters["slug__regex"] = requestParameters["slugRegex"];
    }

    if (requestParameters["slugStartswith"] != null) {
      queryParameters["slug__startswith"] = requestParameters["slugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/{id}/threedimodels/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesThreedimodelsRaw(
    requestParameters: RepositoriesThreedimodelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<ThreediModel>>> {
    const requestOptions = await this.repositoriesThreedimodelsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ThreediModelFromJSON)
    );
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesThreedimodels(
    requestParameters: RepositoriesThreedimodelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<ThreediModel>> {
    const response = await this.repositoriesThreedimodelsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for repositoriesUpdate without sending the request
   */
  async repositoriesUpdateRequestOpts(
    requestParameters: RepositoriesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling repositoriesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling repositoriesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/repositories/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RepositoryToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesUpdateRaw(
    requestParameters: RepositoriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Repository>> {
    const requestOptions = await this.repositoriesUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RepositoryFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async repositoriesUpdate(
    requestParameters: RepositoriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Repository> {
    const response = await this.repositoriesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for revisionsCreate without sending the request
   */
  async revisionsCreateRequestOpts(
    requestParameters: RevisionsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling revisionsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/revisions/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsCreateRaw(
    requestParameters: RevisionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Revision>> {
    const requestOptions = await this.revisionsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsCreate(
    requestParameters: RevisionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Revision> {
    const response = await this.revisionsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for revisionsDelete without sending the request
   */
  async revisionsDeleteRequestOpts(
    requestParameters: RevisionsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling revisionsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsDeleteRaw(
    requestParameters: RevisionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.revisionsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsDelete(
    requestParameters: RevisionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.revisionsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for revisionsList without sending the request
   */
  async revisionsListRequestOpts(
    requestParameters: RevisionsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["hash"] != null) {
      queryParameters["hash"] = requestParameters["hash"];
    }

    if (requestParameters["hashContains"] != null) {
      queryParameters["hash__contains"] = requestParameters["hashContains"];
    }

    if (requestParameters["hashEndswith"] != null) {
      queryParameters["hash__endswith"] = requestParameters["hashEndswith"];
    }

    if (requestParameters["hashIcontains"] != null) {
      queryParameters["hash__icontains"] = requestParameters["hashIcontains"];
    }

    if (requestParameters["hashIexact"] != null) {
      queryParameters["hash__iexact"] = requestParameters["hashIexact"];
    }

    if (requestParameters["hashIn"] != null) {
      queryParameters["hash__in"] = requestParameters["hashIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["hashIstartswith"] != null) {
      queryParameters["hash__istartswith"] = requestParameters["hashIstartswith"];
    }

    if (requestParameters["hashRegex"] != null) {
      queryParameters["hash__regex"] = requestParameters["hashRegex"];
    }

    if (requestParameters["hashStartswith"] != null) {
      queryParameters["hash__startswith"] = requestParameters["hashStartswith"];
    }

    if (requestParameters["isPinned"] != null) {
      queryParameters["is_pinned"] = requestParameters["isPinned"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["number"] != null) {
      queryParameters["number"] = requestParameters["number"];
    }

    if (requestParameters["numberGt"] != null) {
      queryParameters["number__gt"] = requestParameters["numberGt"];
    }

    if (requestParameters["numberGte"] != null) {
      queryParameters["number__gte"] = requestParameters["numberGte"];
    }

    if (requestParameters["numberIsnull"] != null) {
      queryParameters["number__isnull"] = requestParameters["numberIsnull"];
    }

    if (requestParameters["numberLt"] != null) {
      queryParameters["number__lt"] = requestParameters["numberLt"];
    }

    if (requestParameters["numberLte"] != null) {
      queryParameters["number__lte"] = requestParameters["numberLte"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["repositoryId"] != null) {
      queryParameters["repository__id"] = requestParameters["repositoryId"];
    }

    if (requestParameters["repositoryIdGt"] != null) {
      queryParameters["repository__id__gt"] = requestParameters["repositoryIdGt"];
    }

    if (requestParameters["repositoryIdGte"] != null) {
      queryParameters["repository__id__gte"] = requestParameters["repositoryIdGte"];
    }

    if (requestParameters["repositoryIdIsnull"] != null) {
      queryParameters["repository__id__isnull"] = requestParameters["repositoryIdIsnull"];
    }

    if (requestParameters["repositoryIdLt"] != null) {
      queryParameters["repository__id__lt"] = requestParameters["repositoryIdLt"];
    }

    if (requestParameters["repositoryIdLte"] != null) {
      queryParameters["repository__id__lte"] = requestParameters["repositoryIdLte"];
    }

    if (requestParameters["repositoryOrganisationName"] != null) {
      queryParameters["repository__organisation__name"] =
        requestParameters["repositoryOrganisationName"];
    }

    if (requestParameters["repositoryOrganisationNameContains"] != null) {
      queryParameters["repository__organisation__name__contains"] =
        requestParameters["repositoryOrganisationNameContains"];
    }

    if (requestParameters["repositoryOrganisationNameEndswith"] != null) {
      queryParameters["repository__organisation__name__endswith"] =
        requestParameters["repositoryOrganisationNameEndswith"];
    }

    if (requestParameters["repositoryOrganisationNameIcontains"] != null) {
      queryParameters["repository__organisation__name__icontains"] =
        requestParameters["repositoryOrganisationNameIcontains"];
    }

    if (requestParameters["repositoryOrganisationNameIexact"] != null) {
      queryParameters["repository__organisation__name__iexact"] =
        requestParameters["repositoryOrganisationNameIexact"];
    }

    if (requestParameters["repositoryOrganisationNameIn"] != null) {
      queryParameters["repository__organisation__name__in"] = requestParameters[
        "repositoryOrganisationNameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["repositoryOrganisationNameIstartswith"] != null) {
      queryParameters["repository__organisation__name__istartswith"] =
        requestParameters["repositoryOrganisationNameIstartswith"];
    }

    if (requestParameters["repositoryOrganisationNameRegex"] != null) {
      queryParameters["repository__organisation__name__regex"] =
        requestParameters["repositoryOrganisationNameRegex"];
    }

    if (requestParameters["repositoryOrganisationNameStartswith"] != null) {
      queryParameters["repository__organisation__name__startswith"] =
        requestParameters["repositoryOrganisationNameStartswith"];
    }

    if (requestParameters["repositoryOrganisationUniqueId"] != null) {
      queryParameters["repository__organisation__unique_id"] =
        requestParameters["repositoryOrganisationUniqueId"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdContains"] != null) {
      queryParameters["repository__organisation__unique_id__contains"] =
        requestParameters["repositoryOrganisationUniqueIdContains"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdEndswith"] != null) {
      queryParameters["repository__organisation__unique_id__endswith"] =
        requestParameters["repositoryOrganisationUniqueIdEndswith"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdIcontains"] != null) {
      queryParameters["repository__organisation__unique_id__icontains"] =
        requestParameters["repositoryOrganisationUniqueIdIcontains"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdIexact"] != null) {
      queryParameters["repository__organisation__unique_id__iexact"] =
        requestParameters["repositoryOrganisationUniqueIdIexact"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdIn"] != null) {
      queryParameters["repository__organisation__unique_id__in"] = requestParameters[
        "repositoryOrganisationUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["repositoryOrganisationUniqueIdIstartswith"] != null) {
      queryParameters["repository__organisation__unique_id__istartswith"] =
        requestParameters["repositoryOrganisationUniqueIdIstartswith"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdRegex"] != null) {
      queryParameters["repository__organisation__unique_id__regex"] =
        requestParameters["repositoryOrganisationUniqueIdRegex"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdStartswith"] != null) {
      queryParameters["repository__organisation__unique_id__startswith"] =
        requestParameters["repositoryOrganisationUniqueIdStartswith"];
    }

    if (requestParameters["repositorySlug"] != null) {
      queryParameters["repository__slug"] = requestParameters["repositorySlug"];
    }

    if (requestParameters["repositorySlugContains"] != null) {
      queryParameters["repository__slug__contains"] = requestParameters["repositorySlugContains"];
    }

    if (requestParameters["repositorySlugEndswith"] != null) {
      queryParameters["repository__slug__endswith"] = requestParameters["repositorySlugEndswith"];
    }

    if (requestParameters["repositorySlugIcontains"] != null) {
      queryParameters["repository__slug__icontains"] = requestParameters["repositorySlugIcontains"];
    }

    if (requestParameters["repositorySlugIexact"] != null) {
      queryParameters["repository__slug__iexact"] = requestParameters["repositorySlugIexact"];
    }

    if (requestParameters["repositorySlugIn"] != null) {
      queryParameters["repository__slug__in"] = requestParameters["repositorySlugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["repositorySlugIstartswith"] != null) {
      queryParameters["repository__slug__istartswith"] =
        requestParameters["repositorySlugIstartswith"];
    }

    if (requestParameters["repositorySlugRegex"] != null) {
      queryParameters["repository__slug__regex"] = requestParameters["repositorySlugRegex"];
    }

    if (requestParameters["repositorySlugStartswith"] != null) {
      queryParameters["repository__slug__startswith"] =
        requestParameters["repositorySlugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/revisions/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsListRaw(
    requestParameters: RevisionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRevisionList>> {
    const requestOptions = await this.revisionsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRevisionListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsList(
    requestParameters: RevisionsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRevisionList> {
    const response = await this.revisionsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for revisionsPartialUpdate without sending the request
   */
  async revisionsPartialUpdateRequestOpts(
    requestParameters: RevisionsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling revisionsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling revisionsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedRevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsPartialUpdateRaw(
    requestParameters: RevisionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Revision>> {
    const requestOptions = await this.revisionsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsPartialUpdate(
    requestParameters: RevisionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Revision> {
    const response = await this.revisionsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for revisionsRead without sending the request
   */
  async revisionsReadRequestOpts(
    requestParameters: RevisionsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling revisionsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsReadRaw(
    requestParameters: RevisionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Revision>> {
    const requestOptions = await this.revisionsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsRead(
    requestParameters: RevisionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Revision> {
    const response = await this.revisionsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for revisionsThreedimodels without sending the request
   */
  async revisionsThreedimodelsRequestOpts(
    requestParameters: RevisionsThreedimodelsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling revisionsThreedimodels().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["hash"] != null) {
      queryParameters["hash"] = requestParameters["hash"];
    }

    if (requestParameters["hashContains"] != null) {
      queryParameters["hash__contains"] = requestParameters["hashContains"];
    }

    if (requestParameters["hashEndswith"] != null) {
      queryParameters["hash__endswith"] = requestParameters["hashEndswith"];
    }

    if (requestParameters["hashIcontains"] != null) {
      queryParameters["hash__icontains"] = requestParameters["hashIcontains"];
    }

    if (requestParameters["hashIexact"] != null) {
      queryParameters["hash__iexact"] = requestParameters["hashIexact"];
    }

    if (requestParameters["hashIn"] != null) {
      queryParameters["hash__in"] = requestParameters["hashIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["hashIstartswith"] != null) {
      queryParameters["hash__istartswith"] = requestParameters["hashIstartswith"];
    }

    if (requestParameters["hashRegex"] != null) {
      queryParameters["hash__regex"] = requestParameters["hashRegex"];
    }

    if (requestParameters["hashStartswith"] != null) {
      queryParameters["hash__startswith"] = requestParameters["hashStartswith"];
    }

    if (requestParameters["isPinned"] != null) {
      queryParameters["is_pinned"] = requestParameters["isPinned"];
    }

    if (requestParameters["number"] != null) {
      queryParameters["number"] = requestParameters["number"];
    }

    if (requestParameters["numberGt"] != null) {
      queryParameters["number__gt"] = requestParameters["numberGt"];
    }

    if (requestParameters["numberGte"] != null) {
      queryParameters["number__gte"] = requestParameters["numberGte"];
    }

    if (requestParameters["numberIsnull"] != null) {
      queryParameters["number__isnull"] = requestParameters["numberIsnull"];
    }

    if (requestParameters["numberLt"] != null) {
      queryParameters["number__lt"] = requestParameters["numberLt"];
    }

    if (requestParameters["numberLte"] != null) {
      queryParameters["number__lte"] = requestParameters["numberLte"];
    }

    if (requestParameters["repositoryId"] != null) {
      queryParameters["repository__id"] = requestParameters["repositoryId"];
    }

    if (requestParameters["repositoryIdGt"] != null) {
      queryParameters["repository__id__gt"] = requestParameters["repositoryIdGt"];
    }

    if (requestParameters["repositoryIdGte"] != null) {
      queryParameters["repository__id__gte"] = requestParameters["repositoryIdGte"];
    }

    if (requestParameters["repositoryIdIsnull"] != null) {
      queryParameters["repository__id__isnull"] = requestParameters["repositoryIdIsnull"];
    }

    if (requestParameters["repositoryIdLt"] != null) {
      queryParameters["repository__id__lt"] = requestParameters["repositoryIdLt"];
    }

    if (requestParameters["repositoryIdLte"] != null) {
      queryParameters["repository__id__lte"] = requestParameters["repositoryIdLte"];
    }

    if (requestParameters["repositoryOrganisationName"] != null) {
      queryParameters["repository__organisation__name"] =
        requestParameters["repositoryOrganisationName"];
    }

    if (requestParameters["repositoryOrganisationNameContains"] != null) {
      queryParameters["repository__organisation__name__contains"] =
        requestParameters["repositoryOrganisationNameContains"];
    }

    if (requestParameters["repositoryOrganisationNameEndswith"] != null) {
      queryParameters["repository__organisation__name__endswith"] =
        requestParameters["repositoryOrganisationNameEndswith"];
    }

    if (requestParameters["repositoryOrganisationNameIcontains"] != null) {
      queryParameters["repository__organisation__name__icontains"] =
        requestParameters["repositoryOrganisationNameIcontains"];
    }

    if (requestParameters["repositoryOrganisationNameIexact"] != null) {
      queryParameters["repository__organisation__name__iexact"] =
        requestParameters["repositoryOrganisationNameIexact"];
    }

    if (requestParameters["repositoryOrganisationNameIn"] != null) {
      queryParameters["repository__organisation__name__in"] = requestParameters[
        "repositoryOrganisationNameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["repositoryOrganisationNameIstartswith"] != null) {
      queryParameters["repository__organisation__name__istartswith"] =
        requestParameters["repositoryOrganisationNameIstartswith"];
    }

    if (requestParameters["repositoryOrganisationNameRegex"] != null) {
      queryParameters["repository__organisation__name__regex"] =
        requestParameters["repositoryOrganisationNameRegex"];
    }

    if (requestParameters["repositoryOrganisationNameStartswith"] != null) {
      queryParameters["repository__organisation__name__startswith"] =
        requestParameters["repositoryOrganisationNameStartswith"];
    }

    if (requestParameters["repositoryOrganisationUniqueId"] != null) {
      queryParameters["repository__organisation__unique_id"] =
        requestParameters["repositoryOrganisationUniqueId"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdContains"] != null) {
      queryParameters["repository__organisation__unique_id__contains"] =
        requestParameters["repositoryOrganisationUniqueIdContains"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdEndswith"] != null) {
      queryParameters["repository__organisation__unique_id__endswith"] =
        requestParameters["repositoryOrganisationUniqueIdEndswith"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdIcontains"] != null) {
      queryParameters["repository__organisation__unique_id__icontains"] =
        requestParameters["repositoryOrganisationUniqueIdIcontains"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdIexact"] != null) {
      queryParameters["repository__organisation__unique_id__iexact"] =
        requestParameters["repositoryOrganisationUniqueIdIexact"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdIn"] != null) {
      queryParameters["repository__organisation__unique_id__in"] = requestParameters[
        "repositoryOrganisationUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["repositoryOrganisationUniqueIdIstartswith"] != null) {
      queryParameters["repository__organisation__unique_id__istartswith"] =
        requestParameters["repositoryOrganisationUniqueIdIstartswith"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdRegex"] != null) {
      queryParameters["repository__organisation__unique_id__regex"] =
        requestParameters["repositoryOrganisationUniqueIdRegex"];
    }

    if (requestParameters["repositoryOrganisationUniqueIdStartswith"] != null) {
      queryParameters["repository__organisation__unique_id__startswith"] =
        requestParameters["repositoryOrganisationUniqueIdStartswith"];
    }

    if (requestParameters["repositorySlug"] != null) {
      queryParameters["repository__slug"] = requestParameters["repositorySlug"];
    }

    if (requestParameters["repositorySlugContains"] != null) {
      queryParameters["repository__slug__contains"] = requestParameters["repositorySlugContains"];
    }

    if (requestParameters["repositorySlugEndswith"] != null) {
      queryParameters["repository__slug__endswith"] = requestParameters["repositorySlugEndswith"];
    }

    if (requestParameters["repositorySlugIcontains"] != null) {
      queryParameters["repository__slug__icontains"] = requestParameters["repositorySlugIcontains"];
    }

    if (requestParameters["repositorySlugIexact"] != null) {
      queryParameters["repository__slug__iexact"] = requestParameters["repositorySlugIexact"];
    }

    if (requestParameters["repositorySlugIn"] != null) {
      queryParameters["repository__slug__in"] = requestParameters["repositorySlugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["repositorySlugIstartswith"] != null) {
      queryParameters["repository__slug__istartswith"] =
        requestParameters["repositorySlugIstartswith"];
    }

    if (requestParameters["repositorySlugRegex"] != null) {
      queryParameters["repository__slug__regex"] = requestParameters["repositorySlugRegex"];
    }

    if (requestParameters["repositorySlugStartswith"] != null) {
      queryParameters["repository__slug__startswith"] =
        requestParameters["repositorySlugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/revisions/{id}/threedimodels/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsThreedimodelsRaw(
    requestParameters: RevisionsThreedimodelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<ThreediModel>>> {
    const requestOptions = await this.revisionsThreedimodelsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ThreediModelFromJSON)
    );
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsThreedimodels(
    requestParameters: RevisionsThreedimodelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<ThreediModel>> {
    const response = await this.revisionsThreedimodelsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for revisionsUpdate without sending the request
   */
  async revisionsUpdateRequestOpts(
    requestParameters: RevisionsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling revisionsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling revisionsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsUpdateRaw(
    requestParameters: RevisionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Revision>> {
    const requestOptions = await this.revisionsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing modelmeta
   */
  async revisionsUpdate(
    requestParameters: RevisionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Revision> {
    const response = await this.revisionsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for rolesList without sending the request
   */
  async rolesListRequestOpts(requestParameters: RolesListRequest): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/roles/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for viewing roles
   */
  async rolesListRaw(
    requestParameters: RolesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRoleList>> {
    const requestOptions = await this.rolesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRoleListFromJSON(jsonValue)
    );
  }

  /**
   * Read-only API endpoint for viewing roles
   */
  async rolesList(
    requestParameters: RolesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRoleList> {
    const response = await this.rolesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for rolesRead without sending the request
   */
  async rolesReadRequestOpts(requestParameters: RolesReadRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling rolesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/roles/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Read-only API endpoint for viewing roles
   */
  async rolesReadRaw(
    requestParameters: RolesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Role>> {
    const requestOptions = await this.rolesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
  }

  /**
   * Read-only API endpoint for viewing roles
   */
  async rolesRead(
    requestParameters: RolesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Role> {
    const response = await this.rolesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsCreate without sending the request
   */
  async schematisationsCreateRequestOpts(
    requestParameters: SchematisationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SchematisationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Manage schematisations
   */
  async schematisationsCreateRaw(
    requestParameters: SchematisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Schematisation>> {
    const requestOptions = await this.schematisationsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SchematisationFromJSON(jsonValue));
  }

  /**
   * Manage schematisations
   */
  async schematisationsCreate(
    requestParameters: SchematisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Schematisation> {
    const response = await this.schematisationsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsDelete without sending the request
   */
  async schematisationsDeleteRequestOpts(
    requestParameters: SchematisationsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Archive schematisation.
   */
  async schematisationsDeleteRaw(
    requestParameters: SchematisationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.schematisationsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Archive schematisation.
   */
  async schematisationsDelete(
    requestParameters: SchematisationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.schematisationsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for schematisationsLatestRevision without sending the request
   */
  async schematisationsLatestRevisionRequestOpts(
    requestParameters: SchematisationsLatestRevisionRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsLatestRevision().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{id}/latest-revision/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Get the latest committed revision.  For retrieving all revisions use: `/schematisations/{id}/revisions`
   */
  async schematisationsLatestRevisionRaw(
    requestParameters: SchematisationsLatestRevisionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationRevision>> {
    const requestOptions = await this.schematisationsLatestRevisionRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationRevisionFromJSON(jsonValue)
    );
  }

  /**
   * Get the latest committed revision.  For retrieving all revisions use: `/schematisations/{id}/revisions`
   */
  async schematisationsLatestRevision(
    requestParameters: SchematisationsLatestRevisionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationRevision> {
    const response = await this.schematisationsLatestRevisionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsList without sending the request
   */
  async schematisationsListRequestOpts(
    requestParameters: SchematisationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["archived"] != null) {
      queryParameters["archived"] = requestParameters["archived"];
    }

    if (requestParameters["createdDate"] != null) {
      queryParameters["created__date"] = runtime.serializeDate(
        requestParameters["createdDate"] as any
      );
    }

    if (requestParameters["createdDateGt"] != null) {
      queryParameters["created__date__gt"] = runtime.serializeDate(
        requestParameters["createdDateGt"] as any
      );
    }

    if (requestParameters["createdDateGte"] != null) {
      queryParameters["created__date__gte"] = runtime.serializeDate(
        requestParameters["createdDateGte"] as any
      );
    }

    if (requestParameters["createdDateLt"] != null) {
      queryParameters["created__date__lt"] = runtime.serializeDate(
        requestParameters["createdDateLt"] as any
      );
    }

    if (requestParameters["createdDateLte"] != null) {
      queryParameters["created__date__lte"] = runtime.serializeDate(
        requestParameters["createdDateLte"] as any
      );
    }

    if (requestParameters["createdDay"] != null) {
      queryParameters["created__day"] = requestParameters["createdDay"];
    }

    if (requestParameters["createdDayLt"] != null) {
      queryParameters["created__day__lt"] = requestParameters["createdDayLt"];
    }

    if (requestParameters["createdHour"] != null) {
      queryParameters["created__hour"] = requestParameters["createdHour"];
    }

    if (requestParameters["createdIsnull"] != null) {
      queryParameters["created__isnull"] = requestParameters["createdIsnull"];
    }

    if (requestParameters["createdMinute"] != null) {
      queryParameters["created__minute"] = requestParameters["createdMinute"];
    }

    if (requestParameters["createdMonth"] != null) {
      queryParameters["created__month"] = requestParameters["createdMonth"];
    }

    if (requestParameters["createdMonthLte"] != null) {
      queryParameters["created__month__lte"] = requestParameters["createdMonthLte"];
    }

    if (requestParameters["createdQuarter"] != null) {
      queryParameters["created__quarter"] = requestParameters["createdQuarter"];
    }

    if (requestParameters["createdRange"] != null) {
      queryParameters["created__range"] = requestParameters["createdRange"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["createdSecond"] != null) {
      queryParameters["created__second"] = requestParameters["createdSecond"];
    }

    if (requestParameters["createdTime"] != null) {
      queryParameters["created__time"] = requestParameters["createdTime"];
    }

    if (requestParameters["createdWeek"] != null) {
      queryParameters["created__week"] = requestParameters["createdWeek"];
    }

    if (requestParameters["createdWeekDay"] != null) {
      queryParameters["created__week_day"] = requestParameters["createdWeekDay"];
    }

    if (requestParameters["createdYear"] != null) {
      queryParameters["created__year"] = requestParameters["createdYear"];
    }

    if (requestParameters["createdYearGt"] != null) {
      queryParameters["created__year__gt"] = requestParameters["createdYearGt"];
    }

    if (requestParameters["createdYearGte"] != null) {
      queryParameters["created__year__gte"] = requestParameters["createdYearGte"];
    }

    if (requestParameters["createdYearLt"] != null) {
      queryParameters["created__year__lt"] = requestParameters["createdYearLt"];
    }

    if (requestParameters["createdYearLte"] != null) {
      queryParameters["created__year__lte"] = requestParameters["createdYearLte"];
    }

    if (requestParameters["createdByUsername"] != null) {
      queryParameters["created_by__username"] = requestParameters["createdByUsername"];
    }

    if (requestParameters["createdByUsernameContains"] != null) {
      queryParameters["created_by__username__contains"] =
        requestParameters["createdByUsernameContains"];
    }

    if (requestParameters["createdByUsernameEndswith"] != null) {
      queryParameters["created_by__username__endswith"] =
        requestParameters["createdByUsernameEndswith"];
    }

    if (requestParameters["createdByUsernameIcontains"] != null) {
      queryParameters["created_by__username__icontains"] =
        requestParameters["createdByUsernameIcontains"];
    }

    if (requestParameters["createdByUsernameIexact"] != null) {
      queryParameters["created_by__username__iexact"] =
        requestParameters["createdByUsernameIexact"];
    }

    if (requestParameters["createdByUsernameIn"] != null) {
      queryParameters["created_by__username__in"] = requestParameters["createdByUsernameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["createdByUsernameIstartswith"] != null) {
      queryParameters["created_by__username__istartswith"] =
        requestParameters["createdByUsernameIstartswith"];
    }

    if (requestParameters["createdByUsernameRegex"] != null) {
      queryParameters["created_by__username__regex"] = requestParameters["createdByUsernameRegex"];
    }

    if (requestParameters["createdByUsernameStartswith"] != null) {
      queryParameters["created_by__username__startswith"] =
        requestParameters["createdByUsernameStartswith"];
    }

    if (requestParameters["lastUpdatedDate"] != null) {
      queryParameters["last_updated__date"] = runtime.serializeDate(
        requestParameters["lastUpdatedDate"] as any
      );
    }

    if (requestParameters["lastUpdatedDateGt"] != null) {
      queryParameters["last_updated__date__gt"] = runtime.serializeDate(
        requestParameters["lastUpdatedDateGt"] as any
      );
    }

    if (requestParameters["lastUpdatedDateGte"] != null) {
      queryParameters["last_updated__date__gte"] = runtime.serializeDate(
        requestParameters["lastUpdatedDateGte"] as any
      );
    }

    if (requestParameters["lastUpdatedDateLt"] != null) {
      queryParameters["last_updated__date__lt"] = runtime.serializeDate(
        requestParameters["lastUpdatedDateLt"] as any
      );
    }

    if (requestParameters["lastUpdatedDateLte"] != null) {
      queryParameters["last_updated__date__lte"] = runtime.serializeDate(
        requestParameters["lastUpdatedDateLte"] as any
      );
    }

    if (requestParameters["lastUpdatedDay"] != null) {
      queryParameters["last_updated__day"] = requestParameters["lastUpdatedDay"];
    }

    if (requestParameters["lastUpdatedDayLt"] != null) {
      queryParameters["last_updated__day__lt"] = requestParameters["lastUpdatedDayLt"];
    }

    if (requestParameters["lastUpdatedHour"] != null) {
      queryParameters["last_updated__hour"] = requestParameters["lastUpdatedHour"];
    }

    if (requestParameters["lastUpdatedIsnull"] != null) {
      queryParameters["last_updated__isnull"] = requestParameters["lastUpdatedIsnull"];
    }

    if (requestParameters["lastUpdatedMinute"] != null) {
      queryParameters["last_updated__minute"] = requestParameters["lastUpdatedMinute"];
    }

    if (requestParameters["lastUpdatedMonth"] != null) {
      queryParameters["last_updated__month"] = requestParameters["lastUpdatedMonth"];
    }

    if (requestParameters["lastUpdatedMonthLte"] != null) {
      queryParameters["last_updated__month__lte"] = requestParameters["lastUpdatedMonthLte"];
    }

    if (requestParameters["lastUpdatedQuarter"] != null) {
      queryParameters["last_updated__quarter"] = requestParameters["lastUpdatedQuarter"];
    }

    if (requestParameters["lastUpdatedRange"] != null) {
      queryParameters["last_updated__range"] = requestParameters["lastUpdatedRange"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["lastUpdatedSecond"] != null) {
      queryParameters["last_updated__second"] = requestParameters["lastUpdatedSecond"];
    }

    if (requestParameters["lastUpdatedTime"] != null) {
      queryParameters["last_updated__time"] = requestParameters["lastUpdatedTime"];
    }

    if (requestParameters["lastUpdatedWeek"] != null) {
      queryParameters["last_updated__week"] = requestParameters["lastUpdatedWeek"];
    }

    if (requestParameters["lastUpdatedWeekDay"] != null) {
      queryParameters["last_updated__week_day"] = requestParameters["lastUpdatedWeekDay"];
    }

    if (requestParameters["lastUpdatedYear"] != null) {
      queryParameters["last_updated__year"] = requestParameters["lastUpdatedYear"];
    }

    if (requestParameters["lastUpdatedYearGt"] != null) {
      queryParameters["last_updated__year__gt"] = requestParameters["lastUpdatedYearGt"];
    }

    if (requestParameters["lastUpdatedYearGte"] != null) {
      queryParameters["last_updated__year__gte"] = requestParameters["lastUpdatedYearGte"];
    }

    if (requestParameters["lastUpdatedYearLt"] != null) {
      queryParameters["last_updated__year__lt"] = requestParameters["lastUpdatedYearLt"];
    }

    if (requestParameters["lastUpdatedYearLte"] != null) {
      queryParameters["last_updated__year__lte"] = requestParameters["lastUpdatedYearLte"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["ownerName"] != null) {
      queryParameters["owner__name"] = requestParameters["ownerName"];
    }

    if (requestParameters["ownerNameContains"] != null) {
      queryParameters["owner__name__contains"] = requestParameters["ownerNameContains"];
    }

    if (requestParameters["ownerNameEndswith"] != null) {
      queryParameters["owner__name__endswith"] = requestParameters["ownerNameEndswith"];
    }

    if (requestParameters["ownerNameIcontains"] != null) {
      queryParameters["owner__name__icontains"] = requestParameters["ownerNameIcontains"];
    }

    if (requestParameters["ownerNameIexact"] != null) {
      queryParameters["owner__name__iexact"] = requestParameters["ownerNameIexact"];
    }

    if (requestParameters["ownerNameIn"] != null) {
      queryParameters["owner__name__in"] = requestParameters["ownerNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["ownerNameIstartswith"] != null) {
      queryParameters["owner__name__istartswith"] = requestParameters["ownerNameIstartswith"];
    }

    if (requestParameters["ownerNameRegex"] != null) {
      queryParameters["owner__name__regex"] = requestParameters["ownerNameRegex"];
    }

    if (requestParameters["ownerNameStartswith"] != null) {
      queryParameters["owner__name__startswith"] = requestParameters["ownerNameStartswith"];
    }

    if (requestParameters["ownerUniqueId"] != null) {
      queryParameters["owner__unique_id"] = requestParameters["ownerUniqueId"];
    }

    if (requestParameters["ownerUniqueIdContains"] != null) {
      queryParameters["owner__unique_id__contains"] = requestParameters["ownerUniqueIdContains"];
    }

    if (requestParameters["ownerUniqueIdEndswith"] != null) {
      queryParameters["owner__unique_id__endswith"] = requestParameters["ownerUniqueIdEndswith"];
    }

    if (requestParameters["ownerUniqueIdIcontains"] != null) {
      queryParameters["owner__unique_id__icontains"] = requestParameters["ownerUniqueIdIcontains"];
    }

    if (requestParameters["ownerUniqueIdIexact"] != null) {
      queryParameters["owner__unique_id__iexact"] = requestParameters["ownerUniqueIdIexact"];
    }

    if (requestParameters["ownerUniqueIdIn"] != null) {
      queryParameters["owner__unique_id__in"] = requestParameters["ownerUniqueIdIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["ownerUniqueIdIstartswith"] != null) {
      queryParameters["owner__unique_id__istartswith"] =
        requestParameters["ownerUniqueIdIstartswith"];
    }

    if (requestParameters["ownerUniqueIdRegex"] != null) {
      queryParameters["owner__unique_id__regex"] = requestParameters["ownerUniqueIdRegex"];
    }

    if (requestParameters["ownerUniqueIdStartswith"] != null) {
      queryParameters["owner__unique_id__startswith"] =
        requestParameters["ownerUniqueIdStartswith"];
    }

    if (requestParameters["ranaProjectId"] != null) {
      queryParameters["rana_project_id"] = requestParameters["ranaProjectId"];
    }

    if (requestParameters["ranaProjectIdIsnull"] != null) {
      queryParameters["rana_project_id__isnull"] = requestParameters["ranaProjectIdIsnull"];
    }

    if (requestParameters["ranaTenantId"] != null) {
      queryParameters["rana_tenant_id"] = requestParameters["ranaTenantId"];
    }

    if (requestParameters["ranaTenantIdIsnull"] != null) {
      queryParameters["rana_tenant_id__isnull"] = requestParameters["ranaTenantIdIsnull"];
    }

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    if (requestParameters["slugContains"] != null) {
      queryParameters["slug__contains"] = requestParameters["slugContains"];
    }

    if (requestParameters["slugEndswith"] != null) {
      queryParameters["slug__endswith"] = requestParameters["slugEndswith"];
    }

    if (requestParameters["slugIcontains"] != null) {
      queryParameters["slug__icontains"] = requestParameters["slugIcontains"];
    }

    if (requestParameters["slugIexact"] != null) {
      queryParameters["slug__iexact"] = requestParameters["slugIexact"];
    }

    if (requestParameters["slugIn"] != null) {
      queryParameters["slug__in"] = requestParameters["slugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["slugIstartswith"] != null) {
      queryParameters["slug__istartswith"] = requestParameters["slugIstartswith"];
    }

    if (requestParameters["slugRegex"] != null) {
      queryParameters["slug__regex"] = requestParameters["slugRegex"];
    }

    if (requestParameters["slugStartswith"] != null) {
      queryParameters["slug__startswith"] = requestParameters["slugStartswith"];
    }

    if (requestParameters["tagsIn"] != null) {
      queryParameters["tags__in"] = requestParameters["tagsIn"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Manage schematisations
   */
  async schematisationsListRaw(
    requestParameters: SchematisationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedSchematisationList>> {
    const requestOptions = await this.schematisationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedSchematisationListFromJSON(jsonValue)
    );
  }

  /**
   * Manage schematisations
   */
  async schematisationsList(
    requestParameters: SchematisationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedSchematisationList> {
    const response = await this.schematisationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsPartialUpdate without sending the request
   */
  async schematisationsPartialUpdateRequestOpts(
    requestParameters: SchematisationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedSchematisationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Manage schematisations
   */
  async schematisationsPartialUpdateRaw(
    requestParameters: SchematisationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Schematisation>> {
    const requestOptions = await this.schematisationsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SchematisationFromJSON(jsonValue));
  }

  /**
   * Manage schematisations
   */
  async schematisationsPartialUpdate(
    requestParameters: SchematisationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Schematisation> {
    const response = await this.schematisationsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRead without sending the request
   */
  async schematisationsReadRequestOpts(
    requestParameters: SchematisationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Manage schematisations
   */
  async schematisationsReadRaw(
    requestParameters: SchematisationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Schematisation>> {
    const requestOptions = await this.schematisationsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SchematisationFromJSON(jsonValue));
  }

  /**
   * Manage schematisations
   */
  async schematisationsRead(
    requestParameters: SchematisationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Schematisation> {
    const response = await this.schematisationsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsCheck without sending the request
   */
  async schematisationsRevisionsCheckRequestOpts(
    requestParameters: SchematisationsRevisionsCheckRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsCheck().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsCheck().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/check/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsCheckRaw(
    requestParameters: SchematisationsRevisionsCheckRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionTask>> {
    const requestOptions = await this.schematisationsRevisionsCheckRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionTaskFromJSON(jsonValue));
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsCheck(
    requestParameters: SchematisationsRevisionsCheckRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionTask> {
    const response = await this.schematisationsRevisionsCheckRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsCloneToSchematisation without sending the request
   */
  async schematisationsRevisionsCloneToSchematisationRequestOpts(
    requestParameters: SchematisationsRevisionsCloneToSchematisationRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsCloneToSchematisation().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsCloneToSchematisation().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsCloneToSchematisation().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/clone_to_schematisation/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CloneRevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Clone the revision to a different schematisation  Returns: the newly created revision in the new schematisation
   */
  async schematisationsRevisionsCloneToSchematisationRaw(
    requestParameters: SchematisationsRevisionsCloneToSchematisationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationRevision>> {
    const requestOptions = await this.schematisationsRevisionsCloneToSchematisationRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationRevisionFromJSON(jsonValue)
    );
  }

  /**
   * Clone the revision to a different schematisation  Returns: the newly created revision in the new schematisation
   */
  async schematisationsRevisionsCloneToSchematisation(
    requestParameters: SchematisationsRevisionsCloneToSchematisationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationRevision> {
    const response = await this.schematisationsRevisionsCloneToSchematisationRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsCommit without sending the request
   */
  async schematisationsRevisionsCommitRequestOpts(
    requestParameters: SchematisationsRevisionsCommitRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsCommit().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsCommit().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsCommit().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/commit/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CommitToJSON(requestParameters["data"]),
    };
  }

  /**
   * Commit the revision  The `commit_message` can be used to describe the changes.  The `force_as` parameter allows to override the default behaviour of committing the revision with the already assigned revision number.  In case another user has already committed a revision with the same number, an HTTP 409 status code is returned.  In this case you can either: 1) Save the revision with a higher revision number using    `force_as` = `new_revision`, effectively overwriting changes    from the other user. 2) Save the revision under a new schematisation using    `force_as` = `new_schematisation` and specifying    a `schematisation_name`.  If you want to merge your changes with the changes from the other user, you need to download his/hers revision locally and merge it yourselves.
   */
  async schematisationsRevisionsCommitRaw(
    requestParameters: SchematisationsRevisionsCommitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationRevision>> {
    const requestOptions = await this.schematisationsRevisionsCommitRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationRevisionFromJSON(jsonValue)
    );
  }

  /**
   * Commit the revision  The `commit_message` can be used to describe the changes.  The `force_as` parameter allows to override the default behaviour of committing the revision with the already assigned revision number.  In case another user has already committed a revision with the same number, an HTTP 409 status code is returned.  In this case you can either: 1) Save the revision with a higher revision number using    `force_as` = `new_revision`, effectively overwriting changes    from the other user. 2) Save the revision under a new schematisation using    `force_as` = `new_schematisation` and specifying    a `schematisation_name`.  If you want to merge your changes with the changes from the other user, you need to download his/hers revision locally and merge it yourselves.
   */
  async schematisationsRevisionsCommit(
    requestParameters: SchematisationsRevisionsCommitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationRevision> {
    const response = await this.schematisationsRevisionsCommitRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsCreate without sending the request
   */
  async schematisationsRevisionsCreateRequestOpts(
    requestParameters: SchematisationsRevisionsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/`;
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateRevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a new revision  Creates a clone of the last committed revision (if present) by default except when empty=true is passed in the data.
   */
  async schematisationsRevisionsCreateRaw(
    requestParameters: SchematisationsRevisionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationRevision>> {
    const requestOptions = await this.schematisationsRevisionsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationRevisionFromJSON(jsonValue)
    );
  }

  /**
   * Create a new revision  Creates a clone of the last committed revision (if present) by default except when empty=true is passed in the data.
   */
  async schematisationsRevisionsCreate(
    requestParameters: SchematisationsRevisionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationRevision> {
    const response = await this.schematisationsRevisionsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsCreateThreedimodel without sending the request
   */
  async schematisationsRevisionsCreateThreedimodelRequestOpts(
    requestParameters: SchematisationsRevisionsCreateThreedimodelRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsCreateThreedimodel().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsCreateThreedimodel().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsCreateThreedimodel().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/create-threedimodel/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateThreedimodelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsCreateThreedimodelRaw(
    requestParameters: SchematisationsRevisionsCreateThreedimodelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModel>> {
    const requestOptions = await this.schematisationsRevisionsCreateThreedimodelRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ThreediModelFromJSON(jsonValue));
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsCreateThreedimodel(
    requestParameters: SchematisationsRevisionsCreateThreedimodelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModel> {
    const response = await this.schematisationsRevisionsCreateThreedimodelRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsDelete without sending the request
   */
  async schematisationsRevisionsDeleteRequestOpts(
    requestParameters: SchematisationsRevisionsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsDelete().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsDelete().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
      body: DestroyRevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Provide the revision id to delete the revision
   */
  async schematisationsRevisionsDeleteRaw(
    requestParameters: SchematisationsRevisionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.schematisationsRevisionsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Provide the revision id to delete the revision
   */
  async schematisationsRevisionsDelete(
    requestParameters: SchematisationsRevisionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.schematisationsRevisionsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for schematisationsRevisionsList without sending the request
   */
  async schematisationsRevisionsListRequestOpts(
    requestParameters: SchematisationsRevisionsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["archived"] != null) {
      queryParameters["archived"] = requestParameters["archived"];
    }

    if (requestParameters["commitDate"] != null) {
      queryParameters["commit_date"] = runtime.serializeDateTime(
        requestParameters["commitDate"] as any
      );
    }

    if (requestParameters["commitDateDate"] != null) {
      queryParameters["commit_date__date"] = runtime.serializeDate(
        requestParameters["commitDateDate"] as any
      );
    }

    if (requestParameters["commitDateDateGt"] != null) {
      queryParameters["commit_date__date__gt"] = runtime.serializeDate(
        requestParameters["commitDateDateGt"] as any
      );
    }

    if (requestParameters["commitDateDateGte"] != null) {
      queryParameters["commit_date__date__gte"] = runtime.serializeDate(
        requestParameters["commitDateDateGte"] as any
      );
    }

    if (requestParameters["commitDateDateLt"] != null) {
      queryParameters["commit_date__date__lt"] = runtime.serializeDate(
        requestParameters["commitDateDateLt"] as any
      );
    }

    if (requestParameters["commitDateDateLte"] != null) {
      queryParameters["commit_date__date__lte"] = runtime.serializeDate(
        requestParameters["commitDateDateLte"] as any
      );
    }

    if (requestParameters["commitDateDay"] != null) {
      queryParameters["commit_date__day"] = requestParameters["commitDateDay"];
    }

    if (requestParameters["commitDateDayLt"] != null) {
      queryParameters["commit_date__day__lt"] = requestParameters["commitDateDayLt"];
    }

    if (requestParameters["commitDateGt"] != null) {
      queryParameters["commit_date__gt"] = runtime.serializeDateTime(
        requestParameters["commitDateGt"] as any
      );
    }

    if (requestParameters["commitDateGte"] != null) {
      queryParameters["commit_date__gte"] = runtime.serializeDateTime(
        requestParameters["commitDateGte"] as any
      );
    }

    if (requestParameters["commitDateLt"] != null) {
      queryParameters["commit_date__lt"] = runtime.serializeDateTime(
        requestParameters["commitDateLt"] as any
      );
    }

    if (requestParameters["commitDateLte"] != null) {
      queryParameters["commit_date__lte"] = runtime.serializeDateTime(
        requestParameters["commitDateLte"] as any
      );
    }

    if (requestParameters["commitDateMonth"] != null) {
      queryParameters["commit_date__month"] = requestParameters["commitDateMonth"];
    }

    if (requestParameters["commitDateMonthLte"] != null) {
      queryParameters["commit_date__month__lte"] = requestParameters["commitDateMonthLte"];
    }

    if (requestParameters["commitDateWeek"] != null) {
      queryParameters["commit_date__week"] = requestParameters["commitDateWeek"];
    }

    if (requestParameters["commitDateWeekDay"] != null) {
      queryParameters["commit_date__week_day"] = requestParameters["commitDateWeekDay"];
    }

    if (requestParameters["commitDateYear"] != null) {
      queryParameters["commit_date__year"] = requestParameters["commitDateYear"];
    }

    if (requestParameters["commitDateYearGt"] != null) {
      queryParameters["commit_date__year__gt"] = requestParameters["commitDateYearGt"];
    }

    if (requestParameters["commitDateYearGte"] != null) {
      queryParameters["commit_date__year__gte"] = requestParameters["commitDateYearGte"];
    }

    if (requestParameters["commitDateYearLt"] != null) {
      queryParameters["commit_date__year__lt"] = requestParameters["commitDateYearLt"];
    }

    if (requestParameters["commitDateYearLte"] != null) {
      queryParameters["commit_date__year__lte"] = requestParameters["commitDateYearLte"];
    }

    if (requestParameters["commitMessage"] != null) {
      queryParameters["commit_message"] = requestParameters["commitMessage"];
    }

    if (requestParameters["commitMessageContains"] != null) {
      queryParameters["commit_message__contains"] = requestParameters["commitMessageContains"];
    }

    if (requestParameters["commitMessageEndswith"] != null) {
      queryParameters["commit_message__endswith"] = requestParameters["commitMessageEndswith"];
    }

    if (requestParameters["commitMessageIcontains"] != null) {
      queryParameters["commit_message__icontains"] = requestParameters["commitMessageIcontains"];
    }

    if (requestParameters["commitMessageIexact"] != null) {
      queryParameters["commit_message__iexact"] = requestParameters["commitMessageIexact"];
    }

    if (requestParameters["commitMessageIn"] != null) {
      queryParameters["commit_message__in"] = requestParameters["commitMessageIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["commitMessageIstartswith"] != null) {
      queryParameters["commit_message__istartswith"] =
        requestParameters["commitMessageIstartswith"];
    }

    if (requestParameters["commitMessageRegex"] != null) {
      queryParameters["commit_message__regex"] = requestParameters["commitMessageRegex"];
    }

    if (requestParameters["commitMessageStartswith"] != null) {
      queryParameters["commit_message__startswith"] = requestParameters["commitMessageStartswith"];
    }

    if (requestParameters["commitUserUsername"] != null) {
      queryParameters["commit_user__username"] = requestParameters["commitUserUsername"];
    }

    if (requestParameters["commitUserUsernameContains"] != null) {
      queryParameters["commit_user__username__contains"] =
        requestParameters["commitUserUsernameContains"];
    }

    if (requestParameters["commitUserUsernameEndswith"] != null) {
      queryParameters["commit_user__username__endswith"] =
        requestParameters["commitUserUsernameEndswith"];
    }

    if (requestParameters["commitUserUsernameIcontains"] != null) {
      queryParameters["commit_user__username__icontains"] =
        requestParameters["commitUserUsernameIcontains"];
    }

    if (requestParameters["commitUserUsernameIexact"] != null) {
      queryParameters["commit_user__username__iexact"] =
        requestParameters["commitUserUsernameIexact"];
    }

    if (requestParameters["commitUserUsernameIn"] != null) {
      queryParameters["commit_user__username__in"] = requestParameters[
        "commitUserUsernameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["commitUserUsernameIstartswith"] != null) {
      queryParameters["commit_user__username__istartswith"] =
        requestParameters["commitUserUsernameIstartswith"];
    }

    if (requestParameters["commitUserUsernameRegex"] != null) {
      queryParameters["commit_user__username__regex"] =
        requestParameters["commitUserUsernameRegex"];
    }

    if (requestParameters["commitUserUsernameStartswith"] != null) {
      queryParameters["commit_user__username__startswith"] =
        requestParameters["commitUserUsernameStartswith"];
    }

    if (requestParameters["committed"] != null) {
      queryParameters["committed"] = requestParameters["committed"];
    }

    if (requestParameters["hasThreedimodel"] != null) {
      queryParameters["has_threedimodel"] = requestParameters["hasThreedimodel"];
    }

    if (requestParameters["isValid"] != null) {
      queryParameters["is_valid"] = requestParameters["isValid"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["number"] != null) {
      queryParameters["number"] = requestParameters["number"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["schematisationId"] != null) {
      queryParameters["schematisation__id"] = requestParameters["schematisationId"];
    }

    if (requestParameters["schematisationOwnerName"] != null) {
      queryParameters["schematisation__owner__name"] = requestParameters["schematisationOwnerName"];
    }

    if (requestParameters["schematisationOwnerNameContains"] != null) {
      queryParameters["schematisation__owner__name__contains"] =
        requestParameters["schematisationOwnerNameContains"];
    }

    if (requestParameters["schematisationOwnerNameEndswith"] != null) {
      queryParameters["schematisation__owner__name__endswith"] =
        requestParameters["schematisationOwnerNameEndswith"];
    }

    if (requestParameters["schematisationOwnerNameIcontains"] != null) {
      queryParameters["schematisation__owner__name__icontains"] =
        requestParameters["schematisationOwnerNameIcontains"];
    }

    if (requestParameters["schematisationOwnerNameIexact"] != null) {
      queryParameters["schematisation__owner__name__iexact"] =
        requestParameters["schematisationOwnerNameIexact"];
    }

    if (requestParameters["schematisationOwnerNameIn"] != null) {
      queryParameters["schematisation__owner__name__in"] = requestParameters[
        "schematisationOwnerNameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["schematisationOwnerNameIstartswith"] != null) {
      queryParameters["schematisation__owner__name__istartswith"] =
        requestParameters["schematisationOwnerNameIstartswith"];
    }

    if (requestParameters["schematisationOwnerNameRegex"] != null) {
      queryParameters["schematisation__owner__name__regex"] =
        requestParameters["schematisationOwnerNameRegex"];
    }

    if (requestParameters["schematisationOwnerNameStartswith"] != null) {
      queryParameters["schematisation__owner__name__startswith"] =
        requestParameters["schematisationOwnerNameStartswith"];
    }

    if (requestParameters["schematisationOwnerUniqueId"] != null) {
      queryParameters["schematisation__owner__unique_id"] =
        requestParameters["schematisationOwnerUniqueId"];
    }

    if (requestParameters["schematisationOwnerUniqueIdContains"] != null) {
      queryParameters["schematisation__owner__unique_id__contains"] =
        requestParameters["schematisationOwnerUniqueIdContains"];
    }

    if (requestParameters["schematisationOwnerUniqueIdEndswith"] != null) {
      queryParameters["schematisation__owner__unique_id__endswith"] =
        requestParameters["schematisationOwnerUniqueIdEndswith"];
    }

    if (requestParameters["schematisationOwnerUniqueIdIcontains"] != null) {
      queryParameters["schematisation__owner__unique_id__icontains"] =
        requestParameters["schematisationOwnerUniqueIdIcontains"];
    }

    if (requestParameters["schematisationOwnerUniqueIdIexact"] != null) {
      queryParameters["schematisation__owner__unique_id__iexact"] =
        requestParameters["schematisationOwnerUniqueIdIexact"];
    }

    if (requestParameters["schematisationOwnerUniqueIdIn"] != null) {
      queryParameters["schematisation__owner__unique_id__in"] = requestParameters[
        "schematisationOwnerUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["schematisationOwnerUniqueIdIstartswith"] != null) {
      queryParameters["schematisation__owner__unique_id__istartswith"] =
        requestParameters["schematisationOwnerUniqueIdIstartswith"];
    }

    if (requestParameters["schematisationOwnerUniqueIdRegex"] != null) {
      queryParameters["schematisation__owner__unique_id__regex"] =
        requestParameters["schematisationOwnerUniqueIdRegex"];
    }

    if (requestParameters["schematisationOwnerUniqueIdStartswith"] != null) {
      queryParameters["schematisation__owner__unique_id__startswith"] =
        requestParameters["schematisationOwnerUniqueIdStartswith"];
    }

    if (requestParameters["schematisationSlug"] != null) {
      queryParameters["schematisation__slug"] = requestParameters["schematisationSlug"];
    }

    if (requestParameters["schematisationSlugContains"] != null) {
      queryParameters["schematisation__slug__contains"] =
        requestParameters["schematisationSlugContains"];
    }

    if (requestParameters["schematisationSlugEndswith"] != null) {
      queryParameters["schematisation__slug__endswith"] =
        requestParameters["schematisationSlugEndswith"];
    }

    if (requestParameters["schematisationSlugIcontains"] != null) {
      queryParameters["schematisation__slug__icontains"] =
        requestParameters["schematisationSlugIcontains"];
    }

    if (requestParameters["schematisationSlugIexact"] != null) {
      queryParameters["schematisation__slug__iexact"] =
        requestParameters["schematisationSlugIexact"];
    }

    if (requestParameters["schematisationSlugIn"] != null) {
      queryParameters["schematisation__slug__in"] = requestParameters["schematisationSlugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["schematisationSlugIstartswith"] != null) {
      queryParameters["schematisation__slug__istartswith"] =
        requestParameters["schematisationSlugIstartswith"];
    }

    if (requestParameters["schematisationSlugRegex"] != null) {
      queryParameters["schematisation__slug__regex"] = requestParameters["schematisationSlugRegex"];
    }

    if (requestParameters["schematisationSlugStartswith"] != null) {
      queryParameters["schematisation__slug__startswith"] =
        requestParameters["schematisationSlugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/`;
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsListRaw(
    requestParameters: SchematisationsRevisionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedSchematisationRevisionList>> {
    const requestOptions = await this.schematisationsRevisionsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedSchematisationRevisionListFromJSON(jsonValue)
    );
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsList(
    requestParameters: SchematisationsRevisionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedSchematisationRevisionList> {
    const response = await this.schematisationsRevisionsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsPartialUpdate without sending the request
   */
  async schematisationsRevisionsPartialUpdateRequestOpts(
    requestParameters: SchematisationsRevisionsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsPartialUpdate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedUpdateRevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsPartialUpdateRaw(
    requestParameters: SchematisationsRevisionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateRevision>> {
    const requestOptions = await this.schematisationsRevisionsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UpdateRevisionFromJSON(jsonValue));
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsPartialUpdate(
    requestParameters: SchematisationsRevisionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateRevision> {
    const response = await this.schematisationsRevisionsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRastersCreate without sending the request
   */
  async schematisationsRevisionsRastersCreateRequestOpts(
    requestParameters: SchematisationsRevisionsRastersCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersCreate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsRastersCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/`;
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RasterCreateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for creating a raster linked to a revision.  Every raster type can be created/uploaded only once.  Optional md5sum can be added to detect if the file already has been uploaded and automatically perform de-duplication.
   */
  async schematisationsRevisionsRastersCreateRaw(
    requestParameters: SchematisationsRevisionsRastersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionRaster>> {
    const requestOptions = await this.schematisationsRevisionsRastersCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionRasterFromJSON(jsonValue));
  }

  /**
   * Endpoint for creating a raster linked to a revision.  Every raster type can be created/uploaded only once.  Optional md5sum can be added to detect if the file already has been uploaded and automatically perform de-duplication.
   */
  async schematisationsRevisionsRastersCreate(
    requestParameters: SchematisationsRevisionsRastersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionRaster> {
    const response = await this.schematisationsRevisionsRastersCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRastersDelete without sending the request
   */
  async schematisationsRevisionsRastersDeleteRequestOpts(
    requestParameters: SchematisationsRevisionsRastersDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsRastersDelete().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersDelete().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersDeleteRaw(
    requestParameters: SchematisationsRevisionsRastersDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.schematisationsRevisionsRastersDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersDelete(
    requestParameters: SchematisationsRevisionsRastersDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.schematisationsRevisionsRastersDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for schematisationsRevisionsRastersDownload without sending the request
   */
  async schematisationsRevisionsRastersDownloadRequestOpts(
    requestParameters: SchematisationsRevisionsRastersDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsRastersDownload().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersDownload().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async schematisationsRevisionsRastersDownloadRaw(
    requestParameters: SchematisationsRevisionsRastersDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.schematisationsRevisionsRastersDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async schematisationsRevisionsRastersDownload(
    requestParameters: SchematisationsRevisionsRastersDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.schematisationsRevisionsRastersDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRastersList without sending the request
   */
  async schematisationsRevisionsRastersListRequestOpts(
    requestParameters: SchematisationsRevisionsRastersListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersList().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/`;
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersListRaw(
    requestParameters: SchematisationsRevisionsRastersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRevisionRasterList>> {
    const requestOptions = await this.schematisationsRevisionsRastersListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRevisionRasterListFromJSON(jsonValue)
    );
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersList(
    requestParameters: SchematisationsRevisionsRastersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRevisionRasterList> {
    const response = await this.schematisationsRevisionsRastersListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRastersPartialUpdate without sending the request
   */
  async schematisationsRevisionsRastersPartialUpdateRequestOpts(
    requestParameters: SchematisationsRevisionsRastersPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsRastersPartialUpdate().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersPartialUpdate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsRastersPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedRevisionRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersPartialUpdateRaw(
    requestParameters: SchematisationsRevisionsRastersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionRaster>> {
    const requestOptions = await this.schematisationsRevisionsRastersPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionRasterFromJSON(jsonValue));
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersPartialUpdate(
    requestParameters: SchematisationsRevisionsRastersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionRaster> {
    const response = await this.schematisationsRevisionsRastersPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRastersRead without sending the request
   */
  async schematisationsRevisionsRastersReadRequestOpts(
    requestParameters: SchematisationsRevisionsRastersReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsRastersRead().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersRead().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersReadRaw(
    requestParameters: SchematisationsRevisionsRastersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionRaster>> {
    const requestOptions = await this.schematisationsRevisionsRastersReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionRasterFromJSON(jsonValue));
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersRead(
    requestParameters: SchematisationsRevisionsRastersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionRaster> {
    const response = await this.schematisationsRevisionsRastersReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRastersUpdate without sending the request
   */
  async schematisationsRevisionsRastersUpdateRequestOpts(
    requestParameters: SchematisationsRevisionsRastersUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsRastersUpdate().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersUpdate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsRastersUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RevisionRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersUpdateRaw(
    requestParameters: SchematisationsRevisionsRastersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionRaster>> {
    const requestOptions = await this.schematisationsRevisionsRastersUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionRasterFromJSON(jsonValue));
  }

  /**
   * Mixin for default \'download\' action for downloading files  Note: need to implement self.get_file()
   */
  async schematisationsRevisionsRastersUpdate(
    requestParameters: SchematisationsRevisionsRastersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionRaster> {
    const response = await this.schematisationsRevisionsRastersUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRastersUpload without sending the request
   */
  async schematisationsRevisionsRastersUploadRequestOpts(
    requestParameters: SchematisationsRevisionsRastersUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsRastersUpload().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsRastersUpload().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRastersUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsRastersUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/rasters/{id}/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading a raster.
   */
  async schematisationsRevisionsRastersUploadRaw(
    requestParameters: SchematisationsRevisionsRastersUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.schematisationsRevisionsRastersUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading a raster.
   */
  async schematisationsRevisionsRastersUpload(
    requestParameters: SchematisationsRevisionsRastersUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.schematisationsRevisionsRastersUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsRead without sending the request
   */
  async schematisationsRevisionsReadRequestOpts(
    requestParameters: SchematisationsRevisionsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsRead().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsReadRaw(
    requestParameters: SchematisationsRevisionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationRevision>> {
    const requestOptions = await this.schematisationsRevisionsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationRevisionFromJSON(jsonValue)
    );
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsRead(
    requestParameters: SchematisationsRevisionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationRevision> {
    const response = await this.schematisationsRevisionsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsSqliteDelete without sending the request
   */
  async schematisationsRevisionsSqliteDeleteRequestOpts(
    requestParameters: SchematisationsRevisionsSqliteDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsSqliteDelete().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsSqliteDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/sqlite/delete/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsSqliteDeleteRaw(
    requestParameters: SchematisationsRevisionsSqliteDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.schematisationsRevisionsSqliteDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsSqliteDelete(
    requestParameters: SchematisationsRevisionsSqliteDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.schematisationsRevisionsSqliteDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for schematisationsRevisionsSqliteDownload without sending the request
   */
  async schematisationsRevisionsSqliteDownloadRequestOpts(
    requestParameters: SchematisationsRevisionsSqliteDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsSqliteDownload().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsSqliteDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/sqlite/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async schematisationsRevisionsSqliteDownloadRaw(
    requestParameters: SchematisationsRevisionsSqliteDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.schematisationsRevisionsSqliteDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async schematisationsRevisionsSqliteDownload(
    requestParameters: SchematisationsRevisionsSqliteDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.schematisationsRevisionsSqliteDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsSqliteUpload without sending the request
   */
  async schematisationsRevisionsSqliteUploadRequestOpts(
    requestParameters: SchematisationsRevisionsSqliteUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsSqliteUpload().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsSqliteUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsSqliteUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/sqlite/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SqliteFileUploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading the sqlite file.  The file should preferably be zipped (deflate).  Replaces the present sqlite file if there already exists one.  Optional md5sum can be added to detect if the file already has been uploaded and perform de-duplication. (md5sum of the compressed sqlite file)  Note: Uploading the sqlite file without compression is also supported, but not advised, see above. Use the md5sum of the (uncompressed) sqlite file in this case.
   */
  async schematisationsRevisionsSqliteUploadRaw(
    requestParameters: SchematisationsRevisionsSqliteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.schematisationsRevisionsSqliteUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading the sqlite file.  The file should preferably be zipped (deflate).  Replaces the present sqlite file if there already exists one.  Optional md5sum can be added to detect if the file already has been uploaded and perform de-duplication. (md5sum of the compressed sqlite file)  Note: Uploading the sqlite file without compression is also supported, but not advised, see above. Use the md5sum of the (uncompressed) sqlite file in this case.
   */
  async schematisationsRevisionsSqliteUpload(
    requestParameters: SchematisationsRevisionsSqliteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.schematisationsRevisionsSqliteUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsTasksCreate without sending the request
   */
  async schematisationsRevisionsTasksCreateRequestOpts(
    requestParameters: SchematisationsRevisionsTasksCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsTasksCreate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsTasksCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsTasksCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/tasks/`;
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RevisionTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksCreateRaw(
    requestParameters: SchematisationsRevisionsTasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionTask>> {
    const requestOptions = await this.schematisationsRevisionsTasksCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionTaskFromJSON(jsonValue));
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksCreate(
    requestParameters: SchematisationsRevisionsTasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionTask> {
    const response = await this.schematisationsRevisionsTasksCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsTasksDelete without sending the request
   */
  async schematisationsRevisionsTasksDeleteRequestOpts(
    requestParameters: SchematisationsRevisionsTasksDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsTasksDelete().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsTasksDelete().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsTasksDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksDeleteRaw(
    requestParameters: SchematisationsRevisionsTasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.schematisationsRevisionsTasksDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksDelete(
    requestParameters: SchematisationsRevisionsTasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.schematisationsRevisionsTasksDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for schematisationsRevisionsTasksList without sending the request
   */
  async schematisationsRevisionsTasksListRequestOpts(
    requestParameters: SchematisationsRevisionsTasksListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsTasksList().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsTasksList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/tasks/`;
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksListRaw(
    requestParameters: SchematisationsRevisionsTasksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRevisionTaskList>> {
    const requestOptions = await this.schematisationsRevisionsTasksListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRevisionTaskListFromJSON(jsonValue)
    );
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksList(
    requestParameters: SchematisationsRevisionsTasksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRevisionTaskList> {
    const response = await this.schematisationsRevisionsTasksListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsTasksPartialUpdate without sending the request
   */
  async schematisationsRevisionsTasksPartialUpdateRequestOpts(
    requestParameters: SchematisationsRevisionsTasksPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsTasksPartialUpdate().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsTasksPartialUpdate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsTasksPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsTasksPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedRevisionTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksPartialUpdateRaw(
    requestParameters: SchematisationsRevisionsTasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionTask>> {
    const requestOptions = await this.schematisationsRevisionsTasksPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionTaskFromJSON(jsonValue));
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksPartialUpdate(
    requestParameters: SchematisationsRevisionsTasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionTask> {
    const response = await this.schematisationsRevisionsTasksPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsTasksRead without sending the request
   */
  async schematisationsRevisionsTasksReadRequestOpts(
    requestParameters: SchematisationsRevisionsTasksReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsTasksRead().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsTasksRead().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsTasksRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksReadRaw(
    requestParameters: SchematisationsRevisionsTasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionTask>> {
    const requestOptions = await this.schematisationsRevisionsTasksReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionTaskFromJSON(jsonValue));
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksRead(
    requestParameters: SchematisationsRevisionsTasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionTask> {
    const response = await this.schematisationsRevisionsTasksReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsTasksUpdate without sending the request
   */
  async schematisationsRevisionsTasksUpdateRequestOpts(
    requestParameters: SchematisationsRevisionsTasksUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsTasksUpdate().'
      );
    }

    if (requestParameters["revisionPk"] == null) {
      throw new runtime.RequiredError(
        "revisionPk",
        'Required parameter "revisionPk" was null or undefined when calling schematisationsRevisionsTasksUpdate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsTasksUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsTasksUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{revision_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{revision_pk}",
      encodeURIComponent(String(requestParameters["revisionPk"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RevisionTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksUpdateRaw(
    requestParameters: SchematisationsRevisionsTasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RevisionTask>> {
    const requestOptions = await this.schematisationsRevisionsTasksUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RevisionTaskFromJSON(jsonValue));
  }

  /**
   * View revision tasks
   */
  async schematisationsRevisionsTasksUpdate(
    requestParameters: SchematisationsRevisionsTasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RevisionTask> {
    const response = await this.schematisationsRevisionsTasksUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsThreedimodels without sending the request
   */
  async schematisationsRevisionsThreedimodelsRequestOpts(
    requestParameters: SchematisationsRevisionsThreedimodelsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsThreedimodels().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsThreedimodels().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["archived"] != null) {
      queryParameters["archived"] = requestParameters["archived"];
    }

    if (requestParameters["commitDate"] != null) {
      queryParameters["commit_date"] = runtime.serializeDateTime(
        requestParameters["commitDate"] as any
      );
    }

    if (requestParameters["commitDateDate"] != null) {
      queryParameters["commit_date__date"] = runtime.serializeDate(
        requestParameters["commitDateDate"] as any
      );
    }

    if (requestParameters["commitDateDateGt"] != null) {
      queryParameters["commit_date__date__gt"] = runtime.serializeDate(
        requestParameters["commitDateDateGt"] as any
      );
    }

    if (requestParameters["commitDateDateGte"] != null) {
      queryParameters["commit_date__date__gte"] = runtime.serializeDate(
        requestParameters["commitDateDateGte"] as any
      );
    }

    if (requestParameters["commitDateDateLt"] != null) {
      queryParameters["commit_date__date__lt"] = runtime.serializeDate(
        requestParameters["commitDateDateLt"] as any
      );
    }

    if (requestParameters["commitDateDateLte"] != null) {
      queryParameters["commit_date__date__lte"] = runtime.serializeDate(
        requestParameters["commitDateDateLte"] as any
      );
    }

    if (requestParameters["commitDateDay"] != null) {
      queryParameters["commit_date__day"] = requestParameters["commitDateDay"];
    }

    if (requestParameters["commitDateDayLt"] != null) {
      queryParameters["commit_date__day__lt"] = requestParameters["commitDateDayLt"];
    }

    if (requestParameters["commitDateGt"] != null) {
      queryParameters["commit_date__gt"] = runtime.serializeDateTime(
        requestParameters["commitDateGt"] as any
      );
    }

    if (requestParameters["commitDateGte"] != null) {
      queryParameters["commit_date__gte"] = runtime.serializeDateTime(
        requestParameters["commitDateGte"] as any
      );
    }

    if (requestParameters["commitDateLt"] != null) {
      queryParameters["commit_date__lt"] = runtime.serializeDateTime(
        requestParameters["commitDateLt"] as any
      );
    }

    if (requestParameters["commitDateLte"] != null) {
      queryParameters["commit_date__lte"] = runtime.serializeDateTime(
        requestParameters["commitDateLte"] as any
      );
    }

    if (requestParameters["commitDateMonth"] != null) {
      queryParameters["commit_date__month"] = requestParameters["commitDateMonth"];
    }

    if (requestParameters["commitDateMonthLte"] != null) {
      queryParameters["commit_date__month__lte"] = requestParameters["commitDateMonthLte"];
    }

    if (requestParameters["commitDateWeek"] != null) {
      queryParameters["commit_date__week"] = requestParameters["commitDateWeek"];
    }

    if (requestParameters["commitDateWeekDay"] != null) {
      queryParameters["commit_date__week_day"] = requestParameters["commitDateWeekDay"];
    }

    if (requestParameters["commitDateYear"] != null) {
      queryParameters["commit_date__year"] = requestParameters["commitDateYear"];
    }

    if (requestParameters["commitDateYearGt"] != null) {
      queryParameters["commit_date__year__gt"] = requestParameters["commitDateYearGt"];
    }

    if (requestParameters["commitDateYearGte"] != null) {
      queryParameters["commit_date__year__gte"] = requestParameters["commitDateYearGte"];
    }

    if (requestParameters["commitDateYearLt"] != null) {
      queryParameters["commit_date__year__lt"] = requestParameters["commitDateYearLt"];
    }

    if (requestParameters["commitDateYearLte"] != null) {
      queryParameters["commit_date__year__lte"] = requestParameters["commitDateYearLte"];
    }

    if (requestParameters["commitMessage"] != null) {
      queryParameters["commit_message"] = requestParameters["commitMessage"];
    }

    if (requestParameters["commitMessageContains"] != null) {
      queryParameters["commit_message__contains"] = requestParameters["commitMessageContains"];
    }

    if (requestParameters["commitMessageEndswith"] != null) {
      queryParameters["commit_message__endswith"] = requestParameters["commitMessageEndswith"];
    }

    if (requestParameters["commitMessageIcontains"] != null) {
      queryParameters["commit_message__icontains"] = requestParameters["commitMessageIcontains"];
    }

    if (requestParameters["commitMessageIexact"] != null) {
      queryParameters["commit_message__iexact"] = requestParameters["commitMessageIexact"];
    }

    if (requestParameters["commitMessageIn"] != null) {
      queryParameters["commit_message__in"] = requestParameters["commitMessageIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["commitMessageIstartswith"] != null) {
      queryParameters["commit_message__istartswith"] =
        requestParameters["commitMessageIstartswith"];
    }

    if (requestParameters["commitMessageRegex"] != null) {
      queryParameters["commit_message__regex"] = requestParameters["commitMessageRegex"];
    }

    if (requestParameters["commitMessageStartswith"] != null) {
      queryParameters["commit_message__startswith"] = requestParameters["commitMessageStartswith"];
    }

    if (requestParameters["commitUserUsername"] != null) {
      queryParameters["commit_user__username"] = requestParameters["commitUserUsername"];
    }

    if (requestParameters["commitUserUsernameContains"] != null) {
      queryParameters["commit_user__username__contains"] =
        requestParameters["commitUserUsernameContains"];
    }

    if (requestParameters["commitUserUsernameEndswith"] != null) {
      queryParameters["commit_user__username__endswith"] =
        requestParameters["commitUserUsernameEndswith"];
    }

    if (requestParameters["commitUserUsernameIcontains"] != null) {
      queryParameters["commit_user__username__icontains"] =
        requestParameters["commitUserUsernameIcontains"];
    }

    if (requestParameters["commitUserUsernameIexact"] != null) {
      queryParameters["commit_user__username__iexact"] =
        requestParameters["commitUserUsernameIexact"];
    }

    if (requestParameters["commitUserUsernameIn"] != null) {
      queryParameters["commit_user__username__in"] = requestParameters[
        "commitUserUsernameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["commitUserUsernameIstartswith"] != null) {
      queryParameters["commit_user__username__istartswith"] =
        requestParameters["commitUserUsernameIstartswith"];
    }

    if (requestParameters["commitUserUsernameRegex"] != null) {
      queryParameters["commit_user__username__regex"] =
        requestParameters["commitUserUsernameRegex"];
    }

    if (requestParameters["commitUserUsernameStartswith"] != null) {
      queryParameters["commit_user__username__startswith"] =
        requestParameters["commitUserUsernameStartswith"];
    }

    if (requestParameters["committed"] != null) {
      queryParameters["committed"] = requestParameters["committed"];
    }

    if (requestParameters["hasThreedimodel"] != null) {
      queryParameters["has_threedimodel"] = requestParameters["hasThreedimodel"];
    }

    if (requestParameters["isValid"] != null) {
      queryParameters["is_valid"] = requestParameters["isValid"];
    }

    if (requestParameters["number"] != null) {
      queryParameters["number"] = requestParameters["number"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["schematisationId"] != null) {
      queryParameters["schematisation__id"] = requestParameters["schematisationId"];
    }

    if (requestParameters["schematisationOwnerName"] != null) {
      queryParameters["schematisation__owner__name"] = requestParameters["schematisationOwnerName"];
    }

    if (requestParameters["schematisationOwnerNameContains"] != null) {
      queryParameters["schematisation__owner__name__contains"] =
        requestParameters["schematisationOwnerNameContains"];
    }

    if (requestParameters["schematisationOwnerNameEndswith"] != null) {
      queryParameters["schematisation__owner__name__endswith"] =
        requestParameters["schematisationOwnerNameEndswith"];
    }

    if (requestParameters["schematisationOwnerNameIcontains"] != null) {
      queryParameters["schematisation__owner__name__icontains"] =
        requestParameters["schematisationOwnerNameIcontains"];
    }

    if (requestParameters["schematisationOwnerNameIexact"] != null) {
      queryParameters["schematisation__owner__name__iexact"] =
        requestParameters["schematisationOwnerNameIexact"];
    }

    if (requestParameters["schematisationOwnerNameIn"] != null) {
      queryParameters["schematisation__owner__name__in"] = requestParameters[
        "schematisationOwnerNameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["schematisationOwnerNameIstartswith"] != null) {
      queryParameters["schematisation__owner__name__istartswith"] =
        requestParameters["schematisationOwnerNameIstartswith"];
    }

    if (requestParameters["schematisationOwnerNameRegex"] != null) {
      queryParameters["schematisation__owner__name__regex"] =
        requestParameters["schematisationOwnerNameRegex"];
    }

    if (requestParameters["schematisationOwnerNameStartswith"] != null) {
      queryParameters["schematisation__owner__name__startswith"] =
        requestParameters["schematisationOwnerNameStartswith"];
    }

    if (requestParameters["schematisationOwnerUniqueId"] != null) {
      queryParameters["schematisation__owner__unique_id"] =
        requestParameters["schematisationOwnerUniqueId"];
    }

    if (requestParameters["schematisationOwnerUniqueIdContains"] != null) {
      queryParameters["schematisation__owner__unique_id__contains"] =
        requestParameters["schematisationOwnerUniqueIdContains"];
    }

    if (requestParameters["schematisationOwnerUniqueIdEndswith"] != null) {
      queryParameters["schematisation__owner__unique_id__endswith"] =
        requestParameters["schematisationOwnerUniqueIdEndswith"];
    }

    if (requestParameters["schematisationOwnerUniqueIdIcontains"] != null) {
      queryParameters["schematisation__owner__unique_id__icontains"] =
        requestParameters["schematisationOwnerUniqueIdIcontains"];
    }

    if (requestParameters["schematisationOwnerUniqueIdIexact"] != null) {
      queryParameters["schematisation__owner__unique_id__iexact"] =
        requestParameters["schematisationOwnerUniqueIdIexact"];
    }

    if (requestParameters["schematisationOwnerUniqueIdIn"] != null) {
      queryParameters["schematisation__owner__unique_id__in"] = requestParameters[
        "schematisationOwnerUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["schematisationOwnerUniqueIdIstartswith"] != null) {
      queryParameters["schematisation__owner__unique_id__istartswith"] =
        requestParameters["schematisationOwnerUniqueIdIstartswith"];
    }

    if (requestParameters["schematisationOwnerUniqueIdRegex"] != null) {
      queryParameters["schematisation__owner__unique_id__regex"] =
        requestParameters["schematisationOwnerUniqueIdRegex"];
    }

    if (requestParameters["schematisationOwnerUniqueIdStartswith"] != null) {
      queryParameters["schematisation__owner__unique_id__startswith"] =
        requestParameters["schematisationOwnerUniqueIdStartswith"];
    }

    if (requestParameters["schematisationSlug"] != null) {
      queryParameters["schematisation__slug"] = requestParameters["schematisationSlug"];
    }

    if (requestParameters["schematisationSlugContains"] != null) {
      queryParameters["schematisation__slug__contains"] =
        requestParameters["schematisationSlugContains"];
    }

    if (requestParameters["schematisationSlugEndswith"] != null) {
      queryParameters["schematisation__slug__endswith"] =
        requestParameters["schematisationSlugEndswith"];
    }

    if (requestParameters["schematisationSlugIcontains"] != null) {
      queryParameters["schematisation__slug__icontains"] =
        requestParameters["schematisationSlugIcontains"];
    }

    if (requestParameters["schematisationSlugIexact"] != null) {
      queryParameters["schematisation__slug__iexact"] =
        requestParameters["schematisationSlugIexact"];
    }

    if (requestParameters["schematisationSlugIn"] != null) {
      queryParameters["schematisation__slug__in"] = requestParameters["schematisationSlugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["schematisationSlugIstartswith"] != null) {
      queryParameters["schematisation__slug__istartswith"] =
        requestParameters["schematisationSlugIstartswith"];
    }

    if (requestParameters["schematisationSlugRegex"] != null) {
      queryParameters["schematisation__slug__regex"] = requestParameters["schematisationSlugRegex"];
    }

    if (requestParameters["schematisationSlugStartswith"] != null) {
      queryParameters["schematisation__slug__startswith"] =
        requestParameters["schematisationSlugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/threedimodels/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsThreedimodelsRaw(
    requestParameters: SchematisationsRevisionsThreedimodelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<ThreediModel>>> {
    const requestOptions = await this.schematisationsRevisionsThreedimodelsRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ThreediModelFromJSON)
    );
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsThreedimodels(
    requestParameters: SchematisationsRevisionsThreedimodelsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<ThreediModel>> {
    const response = await this.schematisationsRevisionsThreedimodelsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for schematisationsRevisionsUpdate without sending the request
   */
  async schematisationsRevisionsUpdateRequestOpts(
    requestParameters: SchematisationsRevisionsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsRevisionsUpdate().'
      );
    }

    if (requestParameters["schematisationPk"] == null) {
      throw new runtime.RequiredError(
        "schematisationPk",
        'Required parameter "schematisationPk" was null or undefined when calling schematisationsRevisionsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsRevisionsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{schematisation_pk}/revisions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{schematisation_pk}",
      encodeURIComponent(String(requestParameters["schematisationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SchematisationRevisionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsUpdateRaw(
    requestParameters: SchematisationsRevisionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationRevision>> {
    const requestOptions = await this.schematisationsRevisionsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationRevisionFromJSON(jsonValue)
    );
  }

  /**
   * Manage revisions of schematisations.
   */
  async schematisationsRevisionsUpdate(
    requestParameters: SchematisationsRevisionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationRevision> {
    const response = await this.schematisationsRevisionsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for schematisationsUpdate without sending the request
   */
  async schematisationsUpdateRequestOpts(
    requestParameters: SchematisationsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling schematisationsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling schematisationsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/schematisations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SchematisationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Manage schematisations
   */
  async schematisationsUpdateRaw(
    requestParameters: SchematisationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Schematisation>> {
    const requestOptions = await this.schematisationsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SchematisationFromJSON(jsonValue));
  }

  /**
   * Manage schematisations
   */
  async schematisationsUpdate(
    requestParameters: SchematisationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Schematisation> {
    const response = await this.schematisationsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationTemplatesCreate without sending the request
   */
  async simulationTemplatesCreateRequestOpts(
    requestParameters: SimulationTemplatesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationTemplatesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulation-templates/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateTemplateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a (optionally cloned) simulation template from the given simulation.  A simulation template is actually nothing more than a simulation with a special status. It\'s immutable after creation and only can be used to create new simulations.  Simulations \'upgraded\' to simulations templates can\'t be directly run. The \'from_template\' endpoint allows to create a new simulation from a template in a runnable state.  A simulation template can be changed by first creating a simulation from it with \'from_template\'. Changing that simulation and use this endpoint to \'upgrade\' it to a simulation template.  Note: A clone of a simulation is created if the simulation is not in the \'created\' state. Otherwise the simulation in \'created\' state is \'upgraded\' to a simulation template.  The limit for the number of templates per Threedimodel is 50.
   */
  async simulationTemplatesCreateRaw(
    requestParameters: SimulationTemplatesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Template>> {
    const requestOptions = await this.simulationTemplatesCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TemplateFromJSON(jsonValue));
  }

  /**
   * Create a (optionally cloned) simulation template from the given simulation.  A simulation template is actually nothing more than a simulation with a special status. It\'s immutable after creation and only can be used to create new simulations.  Simulations \'upgraded\' to simulations templates can\'t be directly run. The \'from_template\' endpoint allows to create a new simulation from a template in a runnable state.  A simulation template can be changed by first creating a simulation from it with \'from_template\'. Changing that simulation and use this endpoint to \'upgrade\' it to a simulation template.  Note: A clone of a simulation is created if the simulation is not in the \'created\' state. Otherwise the simulation in \'created\' state is \'upgraded\' to a simulation template.  The limit for the number of templates per Threedimodel is 50.
   */
  async simulationTemplatesCreate(
    requestParameters: SimulationTemplatesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Template> {
    const response = await this.simulationTemplatesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationTemplatesDelete without sending the request
   */
  async simulationTemplatesDeleteRequestOpts(
    requestParameters: SimulationTemplatesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationTemplatesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulation-templates/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationTemplatesDeleteRaw(
    requestParameters: SimulationTemplatesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationTemplatesDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async simulationTemplatesDelete(
    requestParameters: SimulationTemplatesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationTemplatesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationTemplatesList without sending the request
   */
  async simulationTemplatesListRequestOpts(
    requestParameters: SimulationTemplatesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["createdDate"] != null) {
      queryParameters["created__date"] = runtime.serializeDate(
        requestParameters["createdDate"] as any
      );
    }

    if (requestParameters["createdDateGt"] != null) {
      queryParameters["created__date__gt"] = runtime.serializeDate(
        requestParameters["createdDateGt"] as any
      );
    }

    if (requestParameters["createdDateGte"] != null) {
      queryParameters["created__date__gte"] = runtime.serializeDate(
        requestParameters["createdDateGte"] as any
      );
    }

    if (requestParameters["createdDateLt"] != null) {
      queryParameters["created__date__lt"] = runtime.serializeDate(
        requestParameters["createdDateLt"] as any
      );
    }

    if (requestParameters["createdDateLte"] != null) {
      queryParameters["created__date__lte"] = runtime.serializeDate(
        requestParameters["createdDateLte"] as any
      );
    }

    if (requestParameters["createdDay"] != null) {
      queryParameters["created__day"] = requestParameters["createdDay"];
    }

    if (requestParameters["createdDayLt"] != null) {
      queryParameters["created__day__lt"] = requestParameters["createdDayLt"];
    }

    if (requestParameters["createdMonth"] != null) {
      queryParameters["created__month"] = requestParameters["createdMonth"];
    }

    if (requestParameters["createdMonthLte"] != null) {
      queryParameters["created__month__lte"] = requestParameters["createdMonthLte"];
    }

    if (requestParameters["createdYear"] != null) {
      queryParameters["created__year"] = requestParameters["createdYear"];
    }

    if (requestParameters["createdYearGt"] != null) {
      queryParameters["created__year__gt"] = requestParameters["createdYearGt"];
    }

    if (requestParameters["createdYearGte"] != null) {
      queryParameters["created__year__gte"] = requestParameters["createdYearGte"];
    }

    if (requestParameters["createdYearLt"] != null) {
      queryParameters["created__year__lt"] = requestParameters["createdYearLt"];
    }

    if (requestParameters["createdYearLte"] != null) {
      queryParameters["created__year__lte"] = requestParameters["createdYearLte"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["simulationThreedimodelId"] != null) {
      queryParameters["simulation__threedimodel__id"] =
        requestParameters["simulationThreedimodelId"];
    }

    if (requestParameters["simulationThreedimodelIdRange"] != null) {
      queryParameters["simulation__threedimodel__id__range"] = requestParameters[
        "simulationThreedimodelIdRange"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["uuidContains"] != null) {
      queryParameters["uuid__contains"] = requestParameters["uuidContains"];
    }

    if (requestParameters["uuidEndswith"] != null) {
      queryParameters["uuid__endswith"] = requestParameters["uuidEndswith"];
    }

    if (requestParameters["uuidIcontains"] != null) {
      queryParameters["uuid__icontains"] = requestParameters["uuidIcontains"];
    }

    if (requestParameters["uuidIexact"] != null) {
      queryParameters["uuid__iexact"] = requestParameters["uuidIexact"];
    }

    if (requestParameters["uuidIn"] != null) {
      queryParameters["uuid__in"] = requestParameters["uuidIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["uuidIstartswith"] != null) {
      queryParameters["uuid__istartswith"] = requestParameters["uuidIstartswith"];
    }

    if (requestParameters["uuidRegex"] != null) {
      queryParameters["uuid__regex"] = requestParameters["uuidRegex"];
    }

    if (requestParameters["uuidStartswith"] != null) {
      queryParameters["uuid__startswith"] = requestParameters["uuidStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulation-templates/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationTemplatesListRaw(
    requestParameters: SimulationTemplatesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTemplateList>> {
    const requestOptions = await this.simulationTemplatesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTemplateListFromJSON(jsonValue)
    );
  }

  /**
   */
  async simulationTemplatesList(
    requestParameters: SimulationTemplatesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTemplateList> {
    const response = await this.simulationTemplatesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationTemplatesPartialUpdate without sending the request
   */
  async simulationTemplatesPartialUpdateRequestOpts(
    requestParameters: SimulationTemplatesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationTemplatesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationTemplatesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulation-templates/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedUpdateTemplateToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async simulationTemplatesPartialUpdateRaw(
    requestParameters: SimulationTemplatesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateTemplate>> {
    const requestOptions = await this.simulationTemplatesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UpdateTemplateFromJSON(jsonValue));
  }

  /**
   */
  async simulationTemplatesPartialUpdate(
    requestParameters: SimulationTemplatesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateTemplate> {
    const response = await this.simulationTemplatesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationTemplatesRead without sending the request
   */
  async simulationTemplatesReadRequestOpts(
    requestParameters: SimulationTemplatesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationTemplatesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulation-templates/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationTemplatesReadRaw(
    requestParameters: SimulationTemplatesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Template>> {
    const requestOptions = await this.simulationTemplatesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TemplateFromJSON(jsonValue));
  }

  /**
   */
  async simulationTemplatesRead(
    requestParameters: SimulationTemplatesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Template> {
    const response = await this.simulationTemplatesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationTemplatesUpdate without sending the request
   */
  async simulationTemplatesUpdateRequestOpts(
    requestParameters: SimulationTemplatesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationTemplatesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationTemplatesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulation-templates/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TemplateToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async simulationTemplatesUpdateRaw(
    requestParameters: SimulationTemplatesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Template>> {
    const requestOptions = await this.simulationTemplatesUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TemplateFromJSON(jsonValue));
  }

  /**
   */
  async simulationTemplatesUpdate(
    requestParameters: SimulationTemplatesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Template> {
    const response = await this.simulationTemplatesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsActionsCreate without sending the request
   */
  async simulationsActionsCreateRequestOpts(
    requestParameters: SimulationsActionsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsActionsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsActionsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/actions/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ActionToJSON(requestParameters["data"]),
    };
  }

  /**
   * Post an action to the simulation to start, pause or end it.  Example usage:  To initialize a simulation (and pause) ``` {\"name\": \"initialize\"} ```  To initialize and directly run a simulation ``` {\"name\": \"start\"} ``` Also use \"start\" to resume a paused simulation.  If you want to pause the simulation automatically after a given duration use the duration parameter ``` {   \"name\": \"start\",   \"duration\": 2500 } ```  To pause a simulation ``` {\"name\": \"pause\"} ``` Please note: The simulation will automatically be shut down after the default timeout of 300 seconds has been reached. You can customize this value by specifying the timeout parameter ``` {   \"name\": \"pause\",   \"timeout\": 999 } ```  To end a simulation ``` {\"name\": \"shutdown\"} ```  To queue a simulation ``` {\"name\": \"queue\"} ``` Queued simulations will be started as soon as a session spot becomes available. If a session spot is directly is available the simulation will also be started immediately. The response body will then contain `{\"name\": \"start\"}` ```
   */
  async simulationsActionsCreateRaw(
    requestParameters: SimulationsActionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Action>> {
    const requestOptions = await this.simulationsActionsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ActionFromJSON(jsonValue));
  }

  /**
   * Post an action to the simulation to start, pause or end it.  Example usage:  To initialize a simulation (and pause) ``` {\"name\": \"initialize\"} ```  To initialize and directly run a simulation ``` {\"name\": \"start\"} ``` Also use \"start\" to resume a paused simulation.  If you want to pause the simulation automatically after a given duration use the duration parameter ``` {   \"name\": \"start\",   \"duration\": 2500 } ```  To pause a simulation ``` {\"name\": \"pause\"} ``` Please note: The simulation will automatically be shut down after the default timeout of 300 seconds has been reached. You can customize this value by specifying the timeout parameter ``` {   \"name\": \"pause\",   \"timeout\": 999 } ```  To end a simulation ``` {\"name\": \"shutdown\"} ```  To queue a simulation ``` {\"name\": \"queue\"} ``` Queued simulations will be started as soon as a session spot becomes available. If a session spot is directly is available the simulation will also be started immediately. The response body will then contain `{\"name\": \"start\"}` ```
   */
  async simulationsActionsCreate(
    requestParameters: SimulationsActionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Action> {
    const response = await this.simulationsActionsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsActionsResetPauseTimeout without sending the request
   */
  async simulationsActionsResetPauseTimeoutRequestOpts(
    requestParameters: SimulationsActionsResetPauseTimeoutRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsActionsResetPauseTimeout().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsActionsResetPauseTimeout().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/actions/reset_pause_timeout/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeoutToJSON(requestParameters["data"]),
    };
  }

  /**
   * Reset the pause timeout with the new specified timeout value  You can only reset the pause timeout when the SimulationStatus.name is \'initialized\' and SimulationStatus.paused is True.
   */
  async simulationsActionsResetPauseTimeoutRaw(
    requestParameters: SimulationsActionsResetPauseTimeoutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Action>> {
    const requestOptions = await this.simulationsActionsResetPauseTimeoutRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ActionFromJSON(jsonValue));
  }

  /**
   * Reset the pause timeout with the new specified timeout value  You can only reset the pause timeout when the SimulationStatus.name is \'initialized\' and SimulationStatus.paused is True.
   */
  async simulationsActionsResetPauseTimeout(
    requestParameters: SimulationsActionsResetPauseTimeoutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Action> {
    const response = await this.simulationsActionsResetPauseTimeoutRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsClone without sending the request
   */
  async simulationsCloneRequestOpts(
    requestParameters: SimulationsCloneRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsClone().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{id}/clone/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Clone the simulation.   Clones the simulation in a runnable state, only events & initials.
   */
  async simulationsCloneRaw(
    requestParameters: SimulationsCloneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Simulation>> {
    const requestOptions = await this.simulationsCloneRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SimulationFromJSON(jsonValue));
  }

  /**
   * Clone the simulation.   Clones the simulation in a runnable state, only events & initials.
   */
  async simulationsClone(
    requestParameters: SimulationsCloneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Simulation> {
    const response = await this.simulationsCloneRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreate without sending the request
   */
  async simulationsCreateRequestOpts(
    requestParameters: SimulationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SimulationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a simulation resource  There are two options to specify the desired duration for the simulation, either by using the ``end_datetime`` **or** the ``duration`` parameter.  ``` {   \"name\":           # give the simulation a name   \"tags\":           # add as many tags as you like: handy to find your simulation back later!   \"threedimodel\":   # The model schema to use for the simulation by                     referring to the id of the threedimodel resource   \"organisation\":   # uuid of the organisation for which the                     simulation is run   \"start_datetime\": # datetime (in ISO 8601 (UTC) format) for the                     simulation start, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"end_datetime\":   # datetime (in ISO 8601 (UTC) format) for the                     simulation end, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"duration\":       # in seconds, can be used instead of end_datetime } ```
   */
  async simulationsCreateRaw(
    requestParameters: SimulationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Simulation>> {
    const requestOptions = await this.simulationsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SimulationFromJSON(jsonValue));
  }

  /**
   * Create a simulation resource  There are two options to specify the desired duration for the simulation, either by using the ``end_datetime`` **or** the ``duration`` parameter.  ``` {   \"name\":           # give the simulation a name   \"tags\":           # add as many tags as you like: handy to find your simulation back later!   \"threedimodel\":   # The model schema to use for the simulation by                     referring to the id of the threedimodel resource   \"organisation\":   # uuid of the organisation for which the                     simulation is run   \"start_datetime\": # datetime (in ISO 8601 (UTC) format) for the                     simulation start, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"end_datetime\":   # datetime (in ISO 8601 (UTC) format) for the                     simulation end, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"duration\":       # in seconds, can be used instead of end_datetime } ```
   */
  async simulationsCreate(
    requestParameters: SimulationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Simulation> {
    const response = await this.simulationsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesStableThresholdCreate without sending the request
   */
  async simulationsCreateSavedStatesStableThresholdCreateRequestOpts(
    requestParameters: SimulationsCreateSavedStatesStableThresholdCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesStableThresholdCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesStableThresholdCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/stable-threshold/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: StableThresholdSavedStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Save the state of the simulation to file when a given (set of) variable(s) becomes stable  Example ``` {   \"expiry\": \"2020-08-15T13:02:30.317Z\",   \"thresholds\": [     {       \"variable\": \"s1\",       \"value\": 0.005     }   ] } ```
   */
  async simulationsCreateSavedStatesStableThresholdCreateRaw(
    requestParameters: SimulationsCreateSavedStatesStableThresholdCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<StableThresholdSavedState>> {
    const requestOptions = await this.simulationsCreateSavedStatesStableThresholdCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StableThresholdSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * Save the state of the simulation to file when a given (set of) variable(s) becomes stable  Example ``` {   \"expiry\": \"2020-08-15T13:02:30.317Z\",   \"thresholds\": [     {       \"variable\": \"s1\",       \"value\": 0.005     }   ] } ```
   */
  async simulationsCreateSavedStatesStableThresholdCreate(
    requestParameters: SimulationsCreateSavedStatesStableThresholdCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<StableThresholdSavedState> {
    const response = await this.simulationsCreateSavedStatesStableThresholdCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesStableThresholdDelete without sending the request
   */
  async simulationsCreateSavedStatesStableThresholdDeleteRequestOpts(
    requestParameters: SimulationsCreateSavedStatesStableThresholdDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesStableThresholdDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesStableThresholdDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/stable-threshold/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdDeleteRaw(
    requestParameters: SimulationsCreateSavedStatesStableThresholdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsCreateSavedStatesStableThresholdDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdDelete(
    requestParameters: SimulationsCreateSavedStatesStableThresholdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsCreateSavedStatesStableThresholdDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsCreateSavedStatesStableThresholdList without sending the request
   */
  async simulationsCreateSavedStatesStableThresholdListRequestOpts(
    requestParameters: SimulationsCreateSavedStatesStableThresholdListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesStableThresholdList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/stable-threshold/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdListRaw(
    requestParameters: SimulationsCreateSavedStatesStableThresholdListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedStableThresholdSavedStateList>> {
    const requestOptions = await this.simulationsCreateSavedStatesStableThresholdListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedStableThresholdSavedStateListFromJSON(jsonValue)
    );
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdList(
    requestParameters: SimulationsCreateSavedStatesStableThresholdListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedStableThresholdSavedStateList> {
    const response = await this.simulationsCreateSavedStatesStableThresholdListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesStableThresholdPartialUpdate without sending the request
   */
  async simulationsCreateSavedStatesStableThresholdPartialUpdateRequestOpts(
    requestParameters: SimulationsCreateSavedStatesStableThresholdPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesStableThresholdPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesStableThresholdPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesStableThresholdPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/stable-threshold/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedStableThresholdSavedStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * When the simulation has started this resource can not be patched.
   */
  async simulationsCreateSavedStatesStableThresholdPartialUpdateRaw(
    requestParameters: SimulationsCreateSavedStatesStableThresholdPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsCreateSavedStatesStableThresholdPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * When the simulation has started this resource can not be patched.
   */
  async simulationsCreateSavedStatesStableThresholdPartialUpdate(
    requestParameters: SimulationsCreateSavedStatesStableThresholdPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsCreateSavedStatesStableThresholdPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsCreateSavedStatesStableThresholdRead without sending the request
   */
  async simulationsCreateSavedStatesStableThresholdReadRequestOpts(
    requestParameters: SimulationsCreateSavedStatesStableThresholdReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesStableThresholdRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesStableThresholdRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/stable-threshold/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdReadRaw(
    requestParameters: SimulationsCreateSavedStatesStableThresholdReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<StableThresholdSavedState>> {
    const requestOptions = await this.simulationsCreateSavedStatesStableThresholdReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StableThresholdSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdRead(
    requestParameters: SimulationsCreateSavedStatesStableThresholdReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<StableThresholdSavedState> {
    const response = await this.simulationsCreateSavedStatesStableThresholdReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesStableThresholdUpdate without sending the request
   */
  async simulationsCreateSavedStatesStableThresholdUpdateRequestOpts(
    requestParameters: SimulationsCreateSavedStatesStableThresholdUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesStableThresholdUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesStableThresholdUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesStableThresholdUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/stable-threshold/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: StableThresholdSavedStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdUpdateRaw(
    requestParameters: SimulationsCreateSavedStatesStableThresholdUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<StableThresholdSavedState>> {
    const requestOptions = await this.simulationsCreateSavedStatesStableThresholdUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StableThresholdSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdUpdate(
    requestParameters: SimulationsCreateSavedStatesStableThresholdUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<StableThresholdSavedState> {
    const response = await this.simulationsCreateSavedStatesStableThresholdUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesStableThresholdUpload without sending the request
   */
  async simulationsCreateSavedStatesStableThresholdUploadRequestOpts(
    requestParameters: SimulationsCreateSavedStatesStableThresholdUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesStableThresholdUpload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesStableThresholdUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesStableThresholdUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/stable-threshold/{id}/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdUploadRaw(
    requestParameters: SimulationsCreateSavedStatesStableThresholdUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.simulationsCreateSavedStatesStableThresholdUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Stable threshold SavedState
   */
  async simulationsCreateSavedStatesStableThresholdUpload(
    requestParameters: SimulationsCreateSavedStatesStableThresholdUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.simulationsCreateSavedStatesStableThresholdUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesTimedCreate without sending the request
   */
  async simulationsCreateSavedStatesTimedCreateRequestOpts(
    requestParameters: SimulationsCreateSavedStatesTimedCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesTimedCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesTimedCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/timed/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimedSavedStateUpdateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Save the state at a given time of the simulation to file  ```     {       \"name\":   # custom name for the saved state (optional)       \"tags\":   # add tags to the resource. Either space or comma                 separated (optional)       \"expiry\": # datetime (in ISO 8601 (UTC) format) until the saved                 state file will be kept       \"time\":   # the state at this given time of the simulation will                  be saved to file     } ```
   */
  async simulationsCreateSavedStatesTimedCreateRaw(
    requestParameters: SimulationsCreateSavedStatesTimedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimedSavedStateUpdate>> {
    const requestOptions = await this.simulationsCreateSavedStatesTimedCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimedSavedStateUpdateFromJSON(jsonValue)
    );
  }

  /**
   * Save the state at a given time of the simulation to file  ```     {       \"name\":   # custom name for the saved state (optional)       \"tags\":   # add tags to the resource. Either space or comma                 separated (optional)       \"expiry\": # datetime (in ISO 8601 (UTC) format) until the saved                 state file will be kept       \"time\":   # the state at this given time of the simulation will                  be saved to file     } ```
   */
  async simulationsCreateSavedStatesTimedCreate(
    requestParameters: SimulationsCreateSavedStatesTimedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimedSavedStateUpdate> {
    const response = await this.simulationsCreateSavedStatesTimedCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesTimedDelete without sending the request
   */
  async simulationsCreateSavedStatesTimedDeleteRequestOpts(
    requestParameters: SimulationsCreateSavedStatesTimedDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesTimedDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesTimedDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedDeleteRaw(
    requestParameters: SimulationsCreateSavedStatesTimedDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsCreateSavedStatesTimedDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedDelete(
    requestParameters: SimulationsCreateSavedStatesTimedDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsCreateSavedStatesTimedDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsCreateSavedStatesTimedList without sending the request
   */
  async simulationsCreateSavedStatesTimedListRequestOpts(
    requestParameters: SimulationsCreateSavedStatesTimedListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesTimedList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/timed/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedListRaw(
    requestParameters: SimulationsCreateSavedStatesTimedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimedSavedStateUpdateList>> {
    const requestOptions = await this.simulationsCreateSavedStatesTimedListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimedSavedStateUpdateListFromJSON(jsonValue)
    );
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedList(
    requestParameters: SimulationsCreateSavedStatesTimedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimedSavedStateUpdateList> {
    const response = await this.simulationsCreateSavedStatesTimedListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesTimedPartialUpdate without sending the request
   */
  async simulationsCreateSavedStatesTimedPartialUpdateRequestOpts(
    requestParameters: SimulationsCreateSavedStatesTimedPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesTimedPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesTimedPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesTimedPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimedSavedStateUpdateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedPartialUpdateRaw(
    requestParameters: SimulationsCreateSavedStatesTimedPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsCreateSavedStatesTimedPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedPartialUpdate(
    requestParameters: SimulationsCreateSavedStatesTimedPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsCreateSavedStatesTimedPartialUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsCreateSavedStatesTimedRead without sending the request
   */
  async simulationsCreateSavedStatesTimedReadRequestOpts(
    requestParameters: SimulationsCreateSavedStatesTimedReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesTimedRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesTimedRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedReadRaw(
    requestParameters: SimulationsCreateSavedStatesTimedReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimedSavedStateUpdate>> {
    const requestOptions = await this.simulationsCreateSavedStatesTimedReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimedSavedStateUpdateFromJSON(jsonValue)
    );
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedRead(
    requestParameters: SimulationsCreateSavedStatesTimedReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimedSavedStateUpdate> {
    const response = await this.simulationsCreateSavedStatesTimedReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesTimedUpdate without sending the request
   */
  async simulationsCreateSavedStatesTimedUpdateRequestOpts(
    requestParameters: SimulationsCreateSavedStatesTimedUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesTimedUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesTimedUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesTimedUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimedSavedStateUpdateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedUpdateRaw(
    requestParameters: SimulationsCreateSavedStatesTimedUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimedSavedStateUpdate>> {
    const requestOptions = await this.simulationsCreateSavedStatesTimedUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimedSavedStateUpdateFromJSON(jsonValue)
    );
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedUpdate(
    requestParameters: SimulationsCreateSavedStatesTimedUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimedSavedStateUpdate> {
    const response = await this.simulationsCreateSavedStatesTimedUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsCreateSavedStatesTimedUpload without sending the request
   */
  async simulationsCreateSavedStatesTimedUploadRequestOpts(
    requestParameters: SimulationsCreateSavedStatesTimedUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsCreateSavedStatesTimedUpload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsCreateSavedStatesTimedUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsCreateSavedStatesTimedUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/create-saved-states/timed/{id}/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedUploadRaw(
    requestParameters: SimulationsCreateSavedStatesTimedUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.simulationsCreateSavedStatesTimedUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Timed SavedState
   */
  async simulationsCreateSavedStatesTimedUpload(
    requestParameters: SimulationsCreateSavedStatesTimedUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.simulationsCreateSavedStatesTimedUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsDelete without sending the request
   */
  async simulationsDeleteRequestOpts(
    requestParameters: SimulationsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsDeleteRaw(
    requestParameters: SimulationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async simulationsDelete(
    requestParameters: SimulationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEvents without sending the request
   */
  async simulationsEventsRequestOpts(
    requestParameters: SimulationsEventsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEvents().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{id}/events/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsEventsRaw(
    requestParameters: SimulationsEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Event>> {
    const requestOptions = await this.simulationsEventsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => EventFromJSON(jsonValue));
  }

  /**
   */
  async simulationsEvents(
    requestParameters: SimulationsEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Event> {
    const response = await this.simulationsEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFileCreate without sending the request
   */
  async simulationsEventsBoundaryconditionsFileCreateRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFileCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFileCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsBoundaryconditionsFileCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading a boundary-conditions file.  The format of the filename should be <filename>.<extension>, e.g.  `boundary_conditions_bergermeer.json`  Every leading and trailing spaces will be removed. Other spaces are converted to underscores and anything that is not an alphanumeric, dash, underscore, or dot will be removed as well.  The response provides a put_url which allows you to upload a file containing one or more boundary-conditions.  The uploaded file should be a JSON-file containing an array of boundary-conditions timeseries.  The file must contain a timeseries for each boundary condition in the threedimodel. This is validated after upload.  Boundary-conditions need to be added before initializing/starting the simulation and cannot be changed once the simulation is initialized.  Example -------  **Notes** The ordering of the boundaries does not matter.  ``` [     {         \"id\": 1,   # sqlite boundary_1d table id         \"type\": \"1D\",  # \"1D\" for 1d boundaries         \"interpolate\": false,         \"values\": [             [0, 0.5],             [500, 0,8],             [1000, 0]         ]     },     {         \"id\": 2,  # sqlite boundary_2d table id         \"type\": \"2D\", # \"2D\" for 2d boundaries         \"interpolate\": false,         \"values\": [             [0, 0,3],             [400, 0.1]         ]     },     {         \"id\": 3,         \"type\": \"2D\",         \"interpolate\": false,         \"values\": [             [0, -2.4],             [1300, 0,3],             [3000, 1.2],             [3600, 0]         ]     } ] ```  Example with (water quality) substances. **Note**, the substance concentrations timesteps need to exactly match the boundary values timesteps (0, 500, 1000 in example below). ``` [     {         \"id\": 1,   # sqlite boundary_1d table id         \"type\": \"1D\",  # \"1D\" for 1d boundaries         \"interpolate\": false,         \"values\": [             [0, 0.5],             [500, 0,8],             [1000, 0]         ]         \"substances\": [             {                 \"substance\": 1,                 \"interpolate\": false,                 \"concentrations\": [                     [0, 0.1],                     [500, 0.2],                     [1000, 0]                 ]             }         ]     } ] ```
   */
  async simulationsEventsBoundaryconditionsFileCreateRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.simulationsEventsBoundaryconditionsFileCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading a boundary-conditions file.  The format of the filename should be <filename>.<extension>, e.g.  `boundary_conditions_bergermeer.json`  Every leading and trailing spaces will be removed. Other spaces are converted to underscores and anything that is not an alphanumeric, dash, underscore, or dot will be removed as well.  The response provides a put_url which allows you to upload a file containing one or more boundary-conditions.  The uploaded file should be a JSON-file containing an array of boundary-conditions timeseries.  The file must contain a timeseries for each boundary condition in the threedimodel. This is validated after upload.  Boundary-conditions need to be added before initializing/starting the simulation and cannot be changed once the simulation is initialized.  Example -------  **Notes** The ordering of the boundaries does not matter.  ``` [     {         \"id\": 1,   # sqlite boundary_1d table id         \"type\": \"1D\",  # \"1D\" for 1d boundaries         \"interpolate\": false,         \"values\": [             [0, 0.5],             [500, 0,8],             [1000, 0]         ]     },     {         \"id\": 2,  # sqlite boundary_2d table id         \"type\": \"2D\", # \"2D\" for 2d boundaries         \"interpolate\": false,         \"values\": [             [0, 0,3],             [400, 0.1]         ]     },     {         \"id\": 3,         \"type\": \"2D\",         \"interpolate\": false,         \"values\": [             [0, -2.4],             [1300, 0,3],             [3000, 1.2],             [3600, 0]         ]     } ] ```  Example with (water quality) substances. **Note**, the substance concentrations timesteps need to exactly match the boundary values timesteps (0, 500, 1000 in example below). ``` [     {         \"id\": 1,   # sqlite boundary_1d table id         \"type\": \"1D\",  # \"1D\" for 1d boundaries         \"interpolate\": false,         \"values\": [             [0, 0.5],             [500, 0,8],             [1000, 0]         ]         \"substances\": [             {                 \"substance\": 1,                 \"interpolate\": false,                 \"concentrations\": [                     [0, 0.1],                     [500, 0.2],                     [1000, 0]                 ]             }         ]     } ] ```
   */
  async simulationsEventsBoundaryconditionsFileCreate(
    requestParameters: SimulationsEventsBoundaryconditionsFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.simulationsEventsBoundaryconditionsFileCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFileDelete without sending the request
   */
  async simulationsEventsBoundaryconditionsFileDeleteRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFileDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBoundaryconditionsFileDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFileDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsBoundaryconditionsFileDeleteRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsBoundaryconditionsFileDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsBoundaryconditionsFileDelete(
    requestParameters: SimulationsEventsBoundaryconditionsFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsBoundaryconditionsFileDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFileDownload without sending the request
   */
  async simulationsEventsBoundaryconditionsFileDownloadRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFileDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBoundaryconditionsFileDownload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFileDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsBoundaryconditionsFileDownloadRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.simulationsEventsBoundaryconditionsFileDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsBoundaryconditionsFileDownload(
    requestParameters: SimulationsEventsBoundaryconditionsFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.simulationsEventsBoundaryconditionsFileDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFileList without sending the request
   */
  async simulationsEventsBoundaryconditionsFileListRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFileListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFileList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileListRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedFileBoundaryConditionList>> {
    const requestOptions = await this.simulationsEventsBoundaryconditionsFileListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedFileBoundaryConditionListFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileList(
    requestParameters: SimulationsEventsBoundaryconditionsFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedFileBoundaryConditionList> {
    const response = await this.simulationsEventsBoundaryconditionsFileListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFilePartialUpdate without sending the request
   */
  async simulationsEventsBoundaryconditionsFilePartialUpdateRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFilePartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBoundaryconditionsFilePartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFilePartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsBoundaryconditionsFilePartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedFileBoundaryConditionToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFilePartialUpdateRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileBoundaryCondition>> {
    const requestOptions =
      await this.simulationsEventsBoundaryconditionsFilePartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FileBoundaryConditionFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFilePartialUpdate(
    requestParameters: SimulationsEventsBoundaryconditionsFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileBoundaryCondition> {
    const response = await this.simulationsEventsBoundaryconditionsFilePartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFileProcessed without sending the request
   */
  async simulationsEventsBoundaryconditionsFileProcessedRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFileProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBoundaryconditionsFileProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFileProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsBoundaryconditionsFileProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BaseEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileProcessedRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsBoundaryconditionsFileProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileProcessed(
    requestParameters: SimulationsEventsBoundaryconditionsFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsBoundaryconditionsFileProcessedRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFileRead without sending the request
   */
  async simulationsEventsBoundaryconditionsFileReadRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFileReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBoundaryconditionsFileRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFileRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileReadRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileBoundaryCondition>> {
    const requestOptions = await this.simulationsEventsBoundaryconditionsFileReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FileBoundaryConditionFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileRead(
    requestParameters: SimulationsEventsBoundaryconditionsFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileBoundaryCondition> {
    const response = await this.simulationsEventsBoundaryconditionsFileReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBoundaryconditionsFileUpdate without sending the request
   */
  async simulationsEventsBoundaryconditionsFileUpdateRequestOpts(
    requestParameters: SimulationsEventsBoundaryconditionsFileUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBoundaryconditionsFileUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBoundaryconditionsFileUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsBoundaryconditionsFileUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/boundaryconditions/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: FileBoundaryConditionToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileUpdateRaw(
    requestParameters: SimulationsEventsBoundaryconditionsFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileBoundaryCondition>> {
    const requestOptions = await this.simulationsEventsBoundaryconditionsFileUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FileBoundaryConditionFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsBoundaryconditionsFileUpdate(
    requestParameters: SimulationsEventsBoundaryconditionsFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileBoundaryCondition> {
    const response = await this.simulationsEventsBoundaryconditionsFileUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBreachesCreate without sending the request
   */
  async simulationsEventsBreachesCreateRequestOpts(
    requestParameters: SimulationsEventsBreachesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBreachesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsBreachesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/breaches/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BreachToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a breach during a given simulation. The `potential_breach` parameter refers to the id of a potential location associated with the threedimodel. A list of these locations can be retrieved at the uri `/threedimodels/{id}/potentialbreaches/`  The `duration_till_max_depth` parameter describes the time it takes until the deepest point of the breach is reached. [seconds]  `maximum_breach_depth` specifies the maximum depth of the breach relative to the top of the levee [meters]  `initial_width` of the breach [meters]  `discharge_coefficient_positive` and `discharge_coefficient_negative` are dimensionless parameters to deal with behaviour of energy loss around a breach.
   */
  async simulationsEventsBreachesCreateRaw(
    requestParameters: SimulationsEventsBreachesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Breach>> {
    const requestOptions = await this.simulationsEventsBreachesCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BreachFromJSON(jsonValue));
  }

  /**
   * Create a breach during a given simulation. The `potential_breach` parameter refers to the id of a potential location associated with the threedimodel. A list of these locations can be retrieved at the uri `/threedimodels/{id}/potentialbreaches/`  The `duration_till_max_depth` parameter describes the time it takes until the deepest point of the breach is reached. [seconds]  `maximum_breach_depth` specifies the maximum depth of the breach relative to the top of the levee [meters]  `initial_width` of the breach [meters]  `discharge_coefficient_positive` and `discharge_coefficient_negative` are dimensionless parameters to deal with behaviour of energy loss around a breach.
   */
  async simulationsEventsBreachesCreate(
    requestParameters: SimulationsEventsBreachesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Breach> {
    const response = await this.simulationsEventsBreachesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBreachesDelete without sending the request
   */
  async simulationsEventsBreachesDeleteRequestOpts(
    requestParameters: SimulationsEventsBreachesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBreachesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBreachesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/breaches/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsBreachesDeleteRaw(
    requestParameters: SimulationsEventsBreachesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsBreachesDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsBreachesDelete(
    requestParameters: SimulationsEventsBreachesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsBreachesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsBreachesList without sending the request
   */
  async simulationsEventsBreachesListRequestOpts(
    requestParameters: SimulationsEventsBreachesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBreachesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/breaches/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing Breaches
   */
  async simulationsEventsBreachesListRaw(
    requestParameters: SimulationsEventsBreachesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedBreachList>> {
    const requestOptions = await this.simulationsEventsBreachesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedBreachListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing Breaches
   */
  async simulationsEventsBreachesList(
    requestParameters: SimulationsEventsBreachesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedBreachList> {
    const response = await this.simulationsEventsBreachesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBreachesPartialUpdate without sending the request
   */
  async simulationsEventsBreachesPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsBreachesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBreachesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBreachesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsBreachesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/breaches/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedBreachToJSON(requestParameters["data"]),
    };
  }

  /**
   * Please note: **Breach resources are not allowed to be patched after the simulation has started**
   */
  async simulationsEventsBreachesPartialUpdateRaw(
    requestParameters: SimulationsEventsBreachesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsBreachesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Please note: **Breach resources are not allowed to be patched after the simulation has started**
   */
  async simulationsEventsBreachesPartialUpdate(
    requestParameters: SimulationsEventsBreachesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsBreachesPartialUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsBreachesRead without sending the request
   */
  async simulationsEventsBreachesReadRequestOpts(
    requestParameters: SimulationsEventsBreachesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBreachesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBreachesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/breaches/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing Breaches
   */
  async simulationsEventsBreachesReadRaw(
    requestParameters: SimulationsEventsBreachesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Breach>> {
    const requestOptions = await this.simulationsEventsBreachesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BreachFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing Breaches
   */
  async simulationsEventsBreachesRead(
    requestParameters: SimulationsEventsBreachesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Breach> {
    const response = await this.simulationsEventsBreachesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsBreachesUpdate without sending the request
   */
  async simulationsEventsBreachesUpdateRequestOpts(
    requestParameters: SimulationsEventsBreachesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsBreachesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsBreachesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsBreachesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/breaches/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BreachToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing Breaches
   */
  async simulationsEventsBreachesUpdateRaw(
    requestParameters: SimulationsEventsBreachesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Breach>> {
    const requestOptions = await this.simulationsEventsBreachesUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BreachFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing Breaches
   */
  async simulationsEventsBreachesUpdate(
    requestParameters: SimulationsEventsBreachesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Breach> {
    const response = await this.simulationsEventsBreachesUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralConstantCreate without sending the request
   */
  async simulationsEventsLateralConstantCreateRequestOpts(
    requestParameters: SimulationsEventsLateralConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantCreateRaw(
    requestParameters: SimulationsEventsLateralConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLateral>> {
    const requestOptions = await this.simulationsEventsLateralConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantLateralFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantCreate(
    requestParameters: SimulationsEventsLateralConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLateral> {
    const response = await this.simulationsEventsLateralConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralConstantDelete without sending the request
   */
  async simulationsEventsLateralConstantDeleteRequestOpts(
    requestParameters: SimulationsEventsLateralConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLateralConstantDeleteRaw(
    requestParameters: SimulationsEventsLateralConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLateralConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLateralConstantDelete(
    requestParameters: SimulationsEventsLateralConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLateralConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLateralConstantList without sending the request
   */
  async simulationsEventsLateralConstantListRequestOpts(
    requestParameters: SimulationsEventsLateralConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantListRaw(
    requestParameters: SimulationsEventsLateralConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedConstantLateralList>> {
    const requestOptions = await this.simulationsEventsLateralConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedConstantLateralListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantList(
    requestParameters: SimulationsEventsLateralConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedConstantLateralList> {
    const response = await this.simulationsEventsLateralConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralConstantPartialUpdate without sending the request
   */
  async simulationsEventsLateralConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsLateralConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedConstantLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLateralConstantPartialUpdateRaw(
    requestParameters: SimulationsEventsLateralConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsLateralConstantPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLateralConstantPartialUpdate(
    requestParameters: SimulationsEventsLateralConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsLateralConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralConstantProcessed without sending the request
   */
  async simulationsEventsLateralConstantProcessedRequestOpts(
    requestParameters: SimulationsEventsLateralConstantProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralConstantProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralConstantProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralConstantProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/constant/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: GridEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantProcessedRaw(
    requestParameters: SimulationsEventsLateralConstantProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLateralConstantProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantProcessed(
    requestParameters: SimulationsEventsLateralConstantProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLateralConstantProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLateralConstantRead without sending the request
   */
  async simulationsEventsLateralConstantReadRequestOpts(
    requestParameters: SimulationsEventsLateralConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantReadRaw(
    requestParameters: SimulationsEventsLateralConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLateral>> {
    const requestOptions = await this.simulationsEventsLateralConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantLateralFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantRead(
    requestParameters: SimulationsEventsLateralConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLateral> {
    const response = await this.simulationsEventsLateralConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralConstantUpdate without sending the request
   */
  async simulationsEventsLateralConstantUpdateRequestOpts(
    requestParameters: SimulationsEventsLateralConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantUpdateRaw(
    requestParameters: SimulationsEventsLateralConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLateral>> {
    const requestOptions = await this.simulationsEventsLateralConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantLateralFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing ConstantLateral
   */
  async simulationsEventsLateralConstantUpdate(
    requestParameters: SimulationsEventsLateralConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLateral> {
    const response = await this.simulationsEventsLateralConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralFileCreate without sending the request
   */
  async simulationsEventsLateralFileCreateRequestOpts(
    requestParameters: SimulationsEventsLateralFileCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFileCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralFileCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadLateralFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading a file with one or more laterals.  The format of the filename should be `<filename>.<extension>`, e.g.  `laterals_bergermeer.json`  Every leading and trailing spaces will be removed. Other spaces are converted to underscores and anything that is not an alphanumeric, dash, underscore, or dot will be removed as well.  The response provides a put_url which allows you to upload a file containing one or more laterals. These laterals should either be a constant- or a timeseries-lateral, or a combination of both. See their respective endpoint for the required fields of these laterals.  The uploaded file should be a JSON-file containing an array of laterals. Example of the content of such a file: ``` [   {     \"offset\": 100,     \"value\": 0.05,     \"duration\": 300,     \"units\": \"m3/s\",     \"connection_node\": 5   },   {     \"offset\": 180,     \"interpolate\": false,     \"values\": [       [0.0, 0.0002],       [900.0, 0.0],       [1200.0, 0.0001],       [1620.0, 0.0]     ],     \"units\": \"m3/s\",     \"connection_node\": 4   },   {     \"offset\": 0,     \"value\": 0.03,     \"duration\": 500,     \"units\": \"m3/s\",     \"point\": {       \"type\": \"Point\",       \"coordinates\": [4.70184629, 52.62586862]   #  longitude, latitude     }   } ] ```  The `offset` of this file-lateral-event will be applied to each individual lateral offset in the uploaded file  If the `periodic` field is set to `daily` the values given are used for every hour of every day in the simulation. Exactly 25 (0-24) timeseries per entry are required like such:       \"values\": [         [0.0, 0.0002],         [3600, 0.01],         .....         <SNIP>         .....         [82800, 0.15]  # 3600.0 * 23         [86400, 0.0]   # 3600.0 * 24       ]  Only laterals with \'values\' are allowed in this case.  The **hour** (not minutes or seconds) of the simulation `start_datetime` (UTC) is taken into consideration for the first timeseries value to use. Periodic laterals are intended for dry weather flow.  Example with (water quality) substances. **Note**: the substance concentrations timesteps need to exactly match the lateral values timesteps (0, 300 in example below). ``` [   {     \"offset\": 100,     \"values\": [[0, 0.05], [300, 0]],     \"units\": \"m3/s\",     \"connection_node\": 5,     \"substances\": [         {\"substance\": 1, \"concentrations\": [[0, 0.1], [300, 0]]}     ]   } ] ```
   */
  async simulationsEventsLateralFileCreateRaw(
    requestParameters: SimulationsEventsLateralFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadLateralFile>> {
    const requestOptions = await this.simulationsEventsLateralFileCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadLateralFileFromJSON(jsonValue)
    );
  }

  /**
   * Endpoint for uploading a file with one or more laterals.  The format of the filename should be `<filename>.<extension>`, e.g.  `laterals_bergermeer.json`  Every leading and trailing spaces will be removed. Other spaces are converted to underscores and anything that is not an alphanumeric, dash, underscore, or dot will be removed as well.  The response provides a put_url which allows you to upload a file containing one or more laterals. These laterals should either be a constant- or a timeseries-lateral, or a combination of both. See their respective endpoint for the required fields of these laterals.  The uploaded file should be a JSON-file containing an array of laterals. Example of the content of such a file: ``` [   {     \"offset\": 100,     \"value\": 0.05,     \"duration\": 300,     \"units\": \"m3/s\",     \"connection_node\": 5   },   {     \"offset\": 180,     \"interpolate\": false,     \"values\": [       [0.0, 0.0002],       [900.0, 0.0],       [1200.0, 0.0001],       [1620.0, 0.0]     ],     \"units\": \"m3/s\",     \"connection_node\": 4   },   {     \"offset\": 0,     \"value\": 0.03,     \"duration\": 500,     \"units\": \"m3/s\",     \"point\": {       \"type\": \"Point\",       \"coordinates\": [4.70184629, 52.62586862]   #  longitude, latitude     }   } ] ```  The `offset` of this file-lateral-event will be applied to each individual lateral offset in the uploaded file  If the `periodic` field is set to `daily` the values given are used for every hour of every day in the simulation. Exactly 25 (0-24) timeseries per entry are required like such:       \"values\": [         [0.0, 0.0002],         [3600, 0.01],         .....         <SNIP>         .....         [82800, 0.15]  # 3600.0 * 23         [86400, 0.0]   # 3600.0 * 24       ]  Only laterals with \'values\' are allowed in this case.  The **hour** (not minutes or seconds) of the simulation `start_datetime` (UTC) is taken into consideration for the first timeseries value to use. Periodic laterals are intended for dry weather flow.  Example with (water quality) substances. **Note**: the substance concentrations timesteps need to exactly match the lateral values timesteps (0, 300 in example below). ``` [   {     \"offset\": 100,     \"values\": [[0, 0.05], [300, 0]],     \"units\": \"m3/s\",     \"connection_node\": 5,     \"substances\": [         {\"substance\": 1, \"concentrations\": [[0, 0.1], [300, 0]]}     ]   } ] ```
   */
  async simulationsEventsLateralFileCreate(
    requestParameters: SimulationsEventsLateralFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadLateralFile> {
    const response = await this.simulationsEventsLateralFileCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralFileDelete without sending the request
   */
  async simulationsEventsLateralFileDeleteRequestOpts(
    requestParameters: SimulationsEventsLateralFileDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralFileDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFileDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLateralFileDeleteRaw(
    requestParameters: SimulationsEventsLateralFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLateralFileDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLateralFileDelete(
    requestParameters: SimulationsEventsLateralFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLateralFileDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLateralFileDownload without sending the request
   */
  async simulationsEventsLateralFileDownloadRequestOpts(
    requestParameters: SimulationsEventsLateralFileDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralFileDownload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFileDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsLateralFileDownloadRaw(
    requestParameters: SimulationsEventsLateralFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.simulationsEventsLateralFileDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsLateralFileDownload(
    requestParameters: SimulationsEventsLateralFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.simulationsEventsLateralFileDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralFileList without sending the request
   */
  async simulationsEventsLateralFileListRequestOpts(
    requestParameters: SimulationsEventsLateralFileListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFileList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileListRaw(
    requestParameters: SimulationsEventsLateralFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedFileLateralList>> {
    const requestOptions = await this.simulationsEventsLateralFileListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedFileLateralListFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileList(
    requestParameters: SimulationsEventsLateralFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedFileLateralList> {
    const response = await this.simulationsEventsLateralFileListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralFilePartialUpdate without sending the request
   */
  async simulationsEventsLateralFilePartialUpdateRequestOpts(
    requestParameters: SimulationsEventsLateralFilePartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralFilePartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFilePartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralFilePartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedFileLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLateralFilePartialUpdateRaw(
    requestParameters: SimulationsEventsLateralFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsLateralFilePartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLateralFilePartialUpdate(
    requestParameters: SimulationsEventsLateralFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsLateralFilePartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralFileProcessed without sending the request
   */
  async simulationsEventsLateralFileProcessedRequestOpts(
    requestParameters: SimulationsEventsLateralFileProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralFileProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFileProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralFileProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BaseEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileProcessedRaw(
    requestParameters: SimulationsEventsLateralFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLateralFileProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileProcessed(
    requestParameters: SimulationsEventsLateralFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLateralFileProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLateralFileRead without sending the request
   */
  async simulationsEventsLateralFileReadRequestOpts(
    requestParameters: SimulationsEventsLateralFileReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralFileRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFileRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileReadRaw(
    requestParameters: SimulationsEventsLateralFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileLateral>> {
    const requestOptions = await this.simulationsEventsLateralFileReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileLateralFromJSON(jsonValue));
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileRead(
    requestParameters: SimulationsEventsLateralFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileLateral> {
    const response = await this.simulationsEventsLateralFileReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralFileUpdate without sending the request
   */
  async simulationsEventsLateralFileUpdateRequestOpts(
    requestParameters: SimulationsEventsLateralFileUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralFileUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralFileUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralFileUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: FileLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileUpdateRaw(
    requestParameters: SimulationsEventsLateralFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileLateral>> {
    const requestOptions = await this.simulationsEventsLateralFileUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileLateralFromJSON(jsonValue));
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsLateralFileUpdate(
    requestParameters: SimulationsEventsLateralFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileLateral> {
    const response = await this.simulationsEventsLateralFileUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralTimeseriesCreate without sending the request
   */
  async simulationsEventsLateralTimeseriesCreateRequestOpts(
    requestParameters: SimulationsEventsLateralTimeseriesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralTimeseriesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralTimeseriesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesCreateRaw(
    requestParameters: SimulationsEventsLateralTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLateral>> {
    const requestOptions = await this.simulationsEventsLateralTimeseriesCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLateralFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesCreate(
    requestParameters: SimulationsEventsLateralTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLateral> {
    const response = await this.simulationsEventsLateralTimeseriesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralTimeseriesDelete without sending the request
   */
  async simulationsEventsLateralTimeseriesDeleteRequestOpts(
    requestParameters: SimulationsEventsLateralTimeseriesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralTimeseriesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralTimeseriesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLateralTimeseriesDeleteRaw(
    requestParameters: SimulationsEventsLateralTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLateralTimeseriesDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLateralTimeseriesDelete(
    requestParameters: SimulationsEventsLateralTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLateralTimeseriesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLateralTimeseriesList without sending the request
   */
  async simulationsEventsLateralTimeseriesListRequestOpts(
    requestParameters: SimulationsEventsLateralTimeseriesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralTimeseriesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesListRaw(
    requestParameters: SimulationsEventsLateralTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimeseriesLateralList>> {
    const requestOptions = await this.simulationsEventsLateralTimeseriesListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimeseriesLateralListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesList(
    requestParameters: SimulationsEventsLateralTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimeseriesLateralList> {
    const response = await this.simulationsEventsLateralTimeseriesListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralTimeseriesPartialUpdate without sending the request
   */
  async simulationsEventsLateralTimeseriesPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsLateralTimeseriesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralTimeseriesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimeseriesLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLateralTimeseriesPartialUpdateRaw(
    requestParameters: SimulationsEventsLateralTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsLateralTimeseriesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLateralTimeseriesPartialUpdate(
    requestParameters: SimulationsEventsLateralTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsLateralTimeseriesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralTimeseriesProcessed without sending the request
   */
  async simulationsEventsLateralTimeseriesProcessedRequestOpts(
    requestParameters: SimulationsEventsLateralTimeseriesProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralTimeseriesProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralTimeseriesProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralTimeseriesProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/timeseries/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: GridEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesProcessedRaw(
    requestParameters: SimulationsEventsLateralTimeseriesProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLateralTimeseriesProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesProcessed(
    requestParameters: SimulationsEventsLateralTimeseriesProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLateralTimeseriesProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLateralTimeseriesRead without sending the request
   */
  async simulationsEventsLateralTimeseriesReadRequestOpts(
    requestParameters: SimulationsEventsLateralTimeseriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralTimeseriesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralTimeseriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesReadRaw(
    requestParameters: SimulationsEventsLateralTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLateral>> {
    const requestOptions = await this.simulationsEventsLateralTimeseriesReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLateralFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesRead(
    requestParameters: SimulationsEventsLateralTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLateral> {
    const response = await this.simulationsEventsLateralTimeseriesReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLateralTimeseriesUpdate without sending the request
   */
  async simulationsEventsLateralTimeseriesUpdateRequestOpts(
    requestParameters: SimulationsEventsLateralTimeseriesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLateralTimeseriesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLateralTimeseriesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLateralTimeseriesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/lateral/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesLateralToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesUpdateRaw(
    requestParameters: SimulationsEventsLateralTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLateral>> {
    const requestOptions = await this.simulationsEventsLateralTimeseriesUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLateralFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsLateralTimeseriesUpdate(
    requestParameters: SimulationsEventsLateralTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLateral> {
    const response = await this.simulationsEventsLateralTimeseriesUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageConstantCreate without sending the request
   */
  async simulationsEventsLeakageConstantCreateRequestOpts(
    requestParameters: SimulationsEventsLeakageConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantLeakageToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantCreateRaw(
    requestParameters: SimulationsEventsLeakageConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantLeakageFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantCreate(
    requestParameters: SimulationsEventsLeakageConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLeakage> {
    const response = await this.simulationsEventsLeakageConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageConstantDelete without sending the request
   */
  async simulationsEventsLeakageConstantDeleteRequestOpts(
    requestParameters: SimulationsEventsLeakageConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageConstantDeleteRaw(
    requestParameters: SimulationsEventsLeakageConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLeakageConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageConstantDelete(
    requestParameters: SimulationsEventsLeakageConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLeakageConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLeakageConstantList without sending the request
   */
  async simulationsEventsLeakageConstantListRequestOpts(
    requestParameters: SimulationsEventsLeakageConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantListRaw(
    requestParameters: SimulationsEventsLeakageConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedConstantLeakageList>> {
    const requestOptions = await this.simulationsEventsLeakageConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedConstantLeakageListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantList(
    requestParameters: SimulationsEventsLeakageConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedConstantLeakageList> {
    const response = await this.simulationsEventsLeakageConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageConstantPartialUpdate without sending the request
   */
  async simulationsEventsLeakageConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsLeakageConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedConstantLeakageToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLeakageConstantPartialUpdateRaw(
    requestParameters: SimulationsEventsLeakageConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsLeakageConstantPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLeakageConstantPartialUpdate(
    requestParameters: SimulationsEventsLeakageConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsLeakageConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageConstantRead without sending the request
   */
  async simulationsEventsLeakageConstantReadRequestOpts(
    requestParameters: SimulationsEventsLeakageConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantReadRaw(
    requestParameters: SimulationsEventsLeakageConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantLeakageFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantRead(
    requestParameters: SimulationsEventsLeakageConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLeakage> {
    const response = await this.simulationsEventsLeakageConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageConstantUpdate without sending the request
   */
  async simulationsEventsLeakageConstantUpdateRequestOpts(
    requestParameters: SimulationsEventsLeakageConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantLeakageToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantUpdateRaw(
    requestParameters: SimulationsEventsLeakageConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantLeakageFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing ConstantLeakage
   */
  async simulationsEventsLeakageConstantUpdate(
    requestParameters: SimulationsEventsLeakageConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLeakage> {
    const response = await this.simulationsEventsLeakageConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageRastersNetcdfCreate without sending the request
   */
  async simulationsEventsLeakageRastersNetcdfCreateRequestOpts(
    requestParameters: SimulationsEventsLeakageRastersNetcdfCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageRastersNetcdfCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageRastersNetcdfCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/rasters/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadWithSubstancesToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 raster leakage
   */
  async simulationsEventsLeakageRastersNetcdfCreateRaw(
    requestParameters: SimulationsEventsLeakageRastersNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadWithSubstances>> {
    const requestOptions = await this.simulationsEventsLeakageRastersNetcdfCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadWithSubstancesFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster leakage
   */
  async simulationsEventsLeakageRastersNetcdfCreate(
    requestParameters: SimulationsEventsLeakageRastersNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadWithSubstances> {
    const response = await this.simulationsEventsLeakageRastersNetcdfCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageRastersNetcdfDelete without sending the request
   */
  async simulationsEventsLeakageRastersNetcdfDeleteRequestOpts(
    requestParameters: SimulationsEventsLeakageRastersNetcdfDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageRastersNetcdfDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageRastersNetcdfDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageRastersNetcdfDeleteRaw(
    requestParameters: SimulationsEventsLeakageRastersNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLeakageRastersNetcdfDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageRastersNetcdfDelete(
    requestParameters: SimulationsEventsLeakageRastersNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLeakageRastersNetcdfDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLeakageRastersNetcdfList without sending the request
   */
  async simulationsEventsLeakageRastersNetcdfListRequestOpts(
    requestParameters: SimulationsEventsLeakageRastersNetcdfListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageRastersNetcdfList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/rasters/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 raster leakage
   */
  async simulationsEventsLeakageRastersNetcdfListRaw(
    requestParameters: SimulationsEventsLeakageRastersNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedNetCDFRasterLeakageList>> {
    const requestOptions = await this.simulationsEventsLeakageRastersNetcdfListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedNetCDFRasterLeakageListFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster leakage
   */
  async simulationsEventsLeakageRastersNetcdfList(
    requestParameters: SimulationsEventsLeakageRastersNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedNetCDFRasterLeakageList> {
    const response = await this.simulationsEventsLeakageRastersNetcdfListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageRastersNetcdfRead without sending the request
   */
  async simulationsEventsLeakageRastersNetcdfReadRequestOpts(
    requestParameters: SimulationsEventsLeakageRastersNetcdfReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageRastersNetcdfRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageRastersNetcdfRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 raster leakage
   */
  async simulationsEventsLeakageRastersNetcdfReadRaw(
    requestParameters: SimulationsEventsLeakageRastersNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFRasterLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageRastersNetcdfReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFRasterLeakageFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster leakage
   */
  async simulationsEventsLeakageRastersNetcdfRead(
    requestParameters: SimulationsEventsLeakageRastersNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFRasterLeakage> {
    const response = await this.simulationsEventsLeakageRastersNetcdfReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesCreate without sending the request
   */
  async simulationsEventsLeakageTimeseriesCreateRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageTimeseriesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesLeakageToJSON(requestParameters["data"]),
    };
  }

  /**
   * Note: make sure the threedimodel has groundwater, if not a default value of 0 is used.  Example payload: ```     {       \"offset\": 0,       \"values\": [         [           0,           0.0005         ],         [           300,           0.0002         ]       ],       \"units\": \"m/s\"     } ```
   */
  async simulationsEventsLeakageTimeseriesCreateRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLeakageFromJSON(jsonValue)
    );
  }

  /**
   * Note: make sure the threedimodel has groundwater, if not a default value of 0 is used.  Example payload: ```     {       \"offset\": 0,       \"values\": [         [           0,           0.0005         ],         [           300,           0.0002         ]       ],       \"units\": \"m/s\"     } ```
   */
  async simulationsEventsLeakageTimeseriesCreate(
    requestParameters: SimulationsEventsLeakageTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLeakage> {
    const response = await this.simulationsEventsLeakageTimeseriesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesDelete without sending the request
   */
  async simulationsEventsLeakageTimeseriesDeleteRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageTimeseriesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageTimeseriesDeleteRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageTimeseriesDelete(
    requestParameters: SimulationsEventsLeakageTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLeakageTimeseriesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesList without sending the request
   */
  async simulationsEventsLeakageTimeseriesListRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLeakage
   */
  async simulationsEventsLeakageTimeseriesListRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimeseriesLeakageList>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimeseriesLeakageListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLeakage
   */
  async simulationsEventsLeakageTimeseriesList(
    requestParameters: SimulationsEventsLeakageTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimeseriesLeakageList> {
    const response = await this.simulationsEventsLeakageTimeseriesListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesNetcdfCreate without sending the request
   */
  async simulationsEventsLeakageTimeseriesNetcdfCreateRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesNetcdfCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageTimeseriesNetcdfCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadWithSubstancesToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 timeseries leakage
   */
  async simulationsEventsLeakageTimeseriesNetcdfCreateRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadWithSubstances>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesNetcdfCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadWithSubstancesFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries leakage
   */
  async simulationsEventsLeakageTimeseriesNetcdfCreate(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadWithSubstances> {
    const response = await this.simulationsEventsLeakageTimeseriesNetcdfCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesNetcdfDelete without sending the request
   */
  async simulationsEventsLeakageTimeseriesNetcdfDeleteRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageTimeseriesNetcdfDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesNetcdfDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageTimeseriesNetcdfDeleteRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesNetcdfDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsLeakageTimeseriesNetcdfDelete(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsLeakageTimeseriesNetcdfDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesNetcdfList without sending the request
   */
  async simulationsEventsLeakageTimeseriesNetcdfListRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesNetcdfList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 timeseries leakage
   */
  async simulationsEventsLeakageTimeseriesNetcdfListRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedNetCDFTimeseriesLeakageList>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesNetcdfListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedNetCDFTimeseriesLeakageListFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries leakage
   */
  async simulationsEventsLeakageTimeseriesNetcdfList(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedNetCDFTimeseriesLeakageList> {
    const response = await this.simulationsEventsLeakageTimeseriesNetcdfListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesNetcdfRead without sending the request
   */
  async simulationsEventsLeakageTimeseriesNetcdfReadRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageTimeseriesNetcdfRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesNetcdfRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 timeseries leakage
   */
  async simulationsEventsLeakageTimeseriesNetcdfReadRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFTimeseriesLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesNetcdfReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFTimeseriesLeakageFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries leakage
   */
  async simulationsEventsLeakageTimeseriesNetcdfRead(
    requestParameters: SimulationsEventsLeakageTimeseriesNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFTimeseriesLeakage> {
    const response = await this.simulationsEventsLeakageTimeseriesNetcdfReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesPartialUpdate without sending the request
   */
  async simulationsEventsLeakageTimeseriesPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageTimeseriesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimeseriesLeakageToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLeakageTimeseriesPartialUpdateRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsLeakageTimeseriesPartialUpdate(
    requestParameters: SimulationsEventsLeakageTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsLeakageTimeseriesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesRead without sending the request
   */
  async simulationsEventsLeakageTimeseriesReadRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageTimeseriesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLeakage
   */
  async simulationsEventsLeakageTimeseriesReadRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLeakageFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLeakage
   */
  async simulationsEventsLeakageTimeseriesRead(
    requestParameters: SimulationsEventsLeakageTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLeakage> {
    const response = await this.simulationsEventsLeakageTimeseriesReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsLeakageTimeseriesUpdate without sending the request
   */
  async simulationsEventsLeakageTimeseriesUpdateRequestOpts(
    requestParameters: SimulationsEventsLeakageTimeseriesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsLeakageTimeseriesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsLeakageTimeseriesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsLeakageTimeseriesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/leakage/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesLeakageToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLeakage
   */
  async simulationsEventsLeakageTimeseriesUpdateRaw(
    requestParameters: SimulationsEventsLeakageTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLeakage>> {
    const requestOptions = await this.simulationsEventsLeakageTimeseriesUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLeakageFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLeakage
   */
  async simulationsEventsLeakageTimeseriesUpdate(
    requestParameters: SimulationsEventsLeakageTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLeakage> {
    const response = await this.simulationsEventsLeakageTimeseriesUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainConstantCreate without sending the request
   */
  async simulationsEventsRainConstantCreateRequestOpts(
    requestParameters: SimulationsEventsRainConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantCreateRaw(
    requestParameters: SimulationsEventsRainConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantRain>> {
    const requestOptions = await this.simulationsEventsRainConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantRainFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantCreate(
    requestParameters: SimulationsEventsRainConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantRain> {
    const response = await this.simulationsEventsRainConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainConstantDelete without sending the request
   */
  async simulationsEventsRainConstantDeleteRequestOpts(
    requestParameters: SimulationsEventsRainConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainConstantDeleteRaw(
    requestParameters: SimulationsEventsRainConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainConstantDelete(
    requestParameters: SimulationsEventsRainConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainConstantList without sending the request
   */
  async simulationsEventsRainConstantListRequestOpts(
    requestParameters: SimulationsEventsRainConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantListRaw(
    requestParameters: SimulationsEventsRainConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedConstantRainList>> {
    const requestOptions = await this.simulationsEventsRainConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedConstantRainListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantList(
    requestParameters: SimulationsEventsRainConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedConstantRainList> {
    const response = await this.simulationsEventsRainConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainConstantPartialUpdate without sending the request
   */
  async simulationsEventsRainConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedConstantRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainConstantPartialUpdateRaw(
    requestParameters: SimulationsEventsRainConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainConstantPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainConstantPartialUpdate(
    requestParameters: SimulationsEventsRainConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainConstantRead without sending the request
   */
  async simulationsEventsRainConstantReadRequestOpts(
    requestParameters: SimulationsEventsRainConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantReadRaw(
    requestParameters: SimulationsEventsRainConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantRain>> {
    const requestOptions = await this.simulationsEventsRainConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantRainFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantRead(
    requestParameters: SimulationsEventsRainConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantRain> {
    const response = await this.simulationsEventsRainConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainConstantUpdate without sending the request
   */
  async simulationsEventsRainConstantUpdateRequestOpts(
    requestParameters: SimulationsEventsRainConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantUpdateRaw(
    requestParameters: SimulationsEventsRainConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantRain>> {
    const requestOptions = await this.simulationsEventsRainConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantRainFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainConstantUpdate(
    requestParameters: SimulationsEventsRainConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantRain> {
    const response = await this.simulationsEventsRainConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalConstantCreate without sending the request
   */
  async simulationsEventsRainLocalConstantCreateRequestOpts(
    requestParameters: SimulationsEventsRainLocalConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainLocalConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantLocalRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantCreateRaw(
    requestParameters: SimulationsEventsRainLocalConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLocalRain>> {
    const requestOptions = await this.simulationsEventsRainLocalConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConstantLocalRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantCreate(
    requestParameters: SimulationsEventsRainLocalConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLocalRain> {
    const response = await this.simulationsEventsRainLocalConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalConstantDelete without sending the request
   */
  async simulationsEventsRainLocalConstantDeleteRequestOpts(
    requestParameters: SimulationsEventsRainLocalConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainLocalConstantDeleteRaw(
    requestParameters: SimulationsEventsRainLocalConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainLocalConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainLocalConstantDelete(
    requestParameters: SimulationsEventsRainLocalConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainLocalConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainLocalConstantList without sending the request
   */
  async simulationsEventsRainLocalConstantListRequestOpts(
    requestParameters: SimulationsEventsRainLocalConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantListRaw(
    requestParameters: SimulationsEventsRainLocalConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedConstantLocalRainList>> {
    const requestOptions = await this.simulationsEventsRainLocalConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedConstantLocalRainListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantList(
    requestParameters: SimulationsEventsRainLocalConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedConstantLocalRainList> {
    const response = await this.simulationsEventsRainLocalConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalConstantPartialUpdate without sending the request
   */
  async simulationsEventsRainLocalConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainLocalConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainLocalConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedConstantLocalRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainLocalConstantPartialUpdateRaw(
    requestParameters: SimulationsEventsRainLocalConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainLocalConstantPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainLocalConstantPartialUpdate(
    requestParameters: SimulationsEventsRainLocalConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainLocalConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalConstantRead without sending the request
   */
  async simulationsEventsRainLocalConstantReadRequestOpts(
    requestParameters: SimulationsEventsRainLocalConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantReadRaw(
    requestParameters: SimulationsEventsRainLocalConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLocalRain>> {
    const requestOptions = await this.simulationsEventsRainLocalConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConstantLocalRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantRead(
    requestParameters: SimulationsEventsRainLocalConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLocalRain> {
    const response = await this.simulationsEventsRainLocalConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalConstantUpdate without sending the request
   */
  async simulationsEventsRainLocalConstantUpdateRequestOpts(
    requestParameters: SimulationsEventsRainLocalConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainLocalConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantLocalRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantUpdateRaw(
    requestParameters: SimulationsEventsRainLocalConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantLocalRain>> {
    const requestOptions = await this.simulationsEventsRainLocalConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConstantLocalRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainLocalConstantUpdate(
    requestParameters: SimulationsEventsRainLocalConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantLocalRain> {
    const response = await this.simulationsEventsRainLocalConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalTimeseriesCreate without sending the request
   */
  async simulationsEventsRainLocalTimeseriesCreateRequestOpts(
    requestParameters: SimulationsEventsRainLocalTimeseriesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalTimeseriesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainLocalTimeseriesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesLocalRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesCreateRaw(
    requestParameters: SimulationsEventsRainLocalTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLocalRain>> {
    const requestOptions = await this.simulationsEventsRainLocalTimeseriesCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLocalRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesCreate(
    requestParameters: SimulationsEventsRainLocalTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLocalRain> {
    const response = await this.simulationsEventsRainLocalTimeseriesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalTimeseriesDelete without sending the request
   */
  async simulationsEventsRainLocalTimeseriesDeleteRequestOpts(
    requestParameters: SimulationsEventsRainLocalTimeseriesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalTimeseriesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalTimeseriesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainLocalTimeseriesDeleteRaw(
    requestParameters: SimulationsEventsRainLocalTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainLocalTimeseriesDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainLocalTimeseriesDelete(
    requestParameters: SimulationsEventsRainLocalTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainLocalTimeseriesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainLocalTimeseriesList without sending the request
   */
  async simulationsEventsRainLocalTimeseriesListRequestOpts(
    requestParameters: SimulationsEventsRainLocalTimeseriesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalTimeseriesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesListRaw(
    requestParameters: SimulationsEventsRainLocalTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimeseriesLocalRainList>> {
    const requestOptions = await this.simulationsEventsRainLocalTimeseriesListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimeseriesLocalRainListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesList(
    requestParameters: SimulationsEventsRainLocalTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimeseriesLocalRainList> {
    const response = await this.simulationsEventsRainLocalTimeseriesListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalTimeseriesPartialUpdate without sending the request
   */
  async simulationsEventsRainLocalTimeseriesPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainLocalTimeseriesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainLocalTimeseriesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimeseriesLocalRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainLocalTimeseriesPartialUpdateRaw(
    requestParameters: SimulationsEventsRainLocalTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainLocalTimeseriesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainLocalTimeseriesPartialUpdate(
    requestParameters: SimulationsEventsRainLocalTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainLocalTimeseriesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalTimeseriesRead without sending the request
   */
  async simulationsEventsRainLocalTimeseriesReadRequestOpts(
    requestParameters: SimulationsEventsRainLocalTimeseriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalTimeseriesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalTimeseriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesReadRaw(
    requestParameters: SimulationsEventsRainLocalTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLocalRain>> {
    const requestOptions = await this.simulationsEventsRainLocalTimeseriesReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLocalRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesRead(
    requestParameters: SimulationsEventsRainLocalTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLocalRain> {
    const response = await this.simulationsEventsRainLocalTimeseriesReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainLocalTimeseriesUpdate without sending the request
   */
  async simulationsEventsRainLocalTimeseriesUpdateRequestOpts(
    requestParameters: SimulationsEventsRainLocalTimeseriesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainLocalTimeseriesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainLocalTimeseriesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainLocalTimeseriesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/local/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesLocalRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesUpdateRaw(
    requestParameters: SimulationsEventsRainLocalTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesLocalRain>> {
    const requestOptions = await this.simulationsEventsRainLocalTimeseriesUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesLocalRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesLateral
   */
  async simulationsEventsRainLocalTimeseriesUpdate(
    requestParameters: SimulationsEventsRainLocalTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesLocalRain> {
    const response = await this.simulationsEventsRainLocalTimeseriesUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersLizardCreate without sending the request
   */
  async simulationsEventsRainRastersLizardCreateRequestOpts(
    requestParameters: SimulationsEventsRainRastersLizardCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersLizardCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainRastersLizardCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: LizardRasterRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardCreateRaw(
    requestParameters: SimulationsEventsRainRastersLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardRasterRain>> {
    const requestOptions = await this.simulationsEventsRainRastersLizardCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardRasterRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardCreate(
    requestParameters: SimulationsEventsRainRastersLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardRasterRain> {
    const response = await this.simulationsEventsRainRastersLizardCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersLizardDelete without sending the request
   */
  async simulationsEventsRainRastersLizardDeleteRequestOpts(
    requestParameters: SimulationsEventsRainRastersLizardDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersLizardDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersLizardDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainRastersLizardDeleteRaw(
    requestParameters: SimulationsEventsRainRastersLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainRastersLizardDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainRastersLizardDelete(
    requestParameters: SimulationsEventsRainRastersLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainRastersLizardDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainRastersLizardList without sending the request
   */
  async simulationsEventsRainRastersLizardListRequestOpts(
    requestParameters: SimulationsEventsRainRastersLizardListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersLizardList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardListRaw(
    requestParameters: SimulationsEventsRainRastersLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedLizardRasterRainList>> {
    const requestOptions = await this.simulationsEventsRainRastersLizardListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedLizardRasterRainListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardList(
    requestParameters: SimulationsEventsRainRastersLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedLizardRasterRainList> {
    const response = await this.simulationsEventsRainRastersLizardListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersLizardPartialUpdate without sending the request
   */
  async simulationsEventsRainRastersLizardPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainRastersLizardPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersLizardPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersLizardPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainRastersLizardPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedLizardRasterRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainRastersLizardPartialUpdateRaw(
    requestParameters: SimulationsEventsRainRastersLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainRastersLizardPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainRastersLizardPartialUpdate(
    requestParameters: SimulationsEventsRainRastersLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainRastersLizardPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersLizardRead without sending the request
   */
  async simulationsEventsRainRastersLizardReadRequestOpts(
    requestParameters: SimulationsEventsRainRastersLizardReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersLizardRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersLizardRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardReadRaw(
    requestParameters: SimulationsEventsRainRastersLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardRasterRain>> {
    const requestOptions = await this.simulationsEventsRainRastersLizardReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardRasterRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardRead(
    requestParameters: SimulationsEventsRainRastersLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardRasterRain> {
    const response = await this.simulationsEventsRainRastersLizardReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersLizardUpdate without sending the request
   */
  async simulationsEventsRainRastersLizardUpdateRequestOpts(
    requestParameters: SimulationsEventsRainRastersLizardUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersLizardUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersLizardUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainRastersLizardUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: LizardRasterRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardUpdateRaw(
    requestParameters: SimulationsEventsRainRastersLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardRasterRain>> {
    const requestOptions = await this.simulationsEventsRainRastersLizardUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardRasterRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsRainRastersLizardUpdate(
    requestParameters: SimulationsEventsRainRastersLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardRasterRain> {
    const response = await this.simulationsEventsRainRastersLizardUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersNetcdfCreate without sending the request
   */
  async simulationsEventsRainRastersNetcdfCreateRequestOpts(
    requestParameters: SimulationsEventsRainRastersNetcdfCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersNetcdfCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainRastersNetcdfCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadWithSubstancesToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfCreateRaw(
    requestParameters: SimulationsEventsRainRastersNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadWithSubstances>> {
    const requestOptions = await this.simulationsEventsRainRastersNetcdfCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadWithSubstancesFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfCreate(
    requestParameters: SimulationsEventsRainRastersNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadWithSubstances> {
    const response = await this.simulationsEventsRainRastersNetcdfCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersNetcdfDelete without sending the request
   */
  async simulationsEventsRainRastersNetcdfDeleteRequestOpts(
    requestParameters: SimulationsEventsRainRastersNetcdfDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersNetcdfDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersNetcdfDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainRastersNetcdfDeleteRaw(
    requestParameters: SimulationsEventsRainRastersNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainRastersNetcdfDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainRastersNetcdfDelete(
    requestParameters: SimulationsEventsRainRastersNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainRastersNetcdfDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainRastersNetcdfList without sending the request
   */
  async simulationsEventsRainRastersNetcdfListRequestOpts(
    requestParameters: SimulationsEventsRainRastersNetcdfListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersNetcdfList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfListRaw(
    requestParameters: SimulationsEventsRainRastersNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedNetCDFRasterRainList>> {
    const requestOptions = await this.simulationsEventsRainRastersNetcdfListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedNetCDFRasterRainListFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfList(
    requestParameters: SimulationsEventsRainRastersNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedNetCDFRasterRainList> {
    const response = await this.simulationsEventsRainRastersNetcdfListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersNetcdfPartialUpdate without sending the request
   */
  async simulationsEventsRainRastersNetcdfPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainRastersNetcdfPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersNetcdfPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersNetcdfPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainRastersNetcdfPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedNetCDFRasterRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainRastersNetcdfPartialUpdateRaw(
    requestParameters: SimulationsEventsRainRastersNetcdfPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainRastersNetcdfPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainRastersNetcdfPartialUpdate(
    requestParameters: SimulationsEventsRainRastersNetcdfPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainRastersNetcdfPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersNetcdfRead without sending the request
   */
  async simulationsEventsRainRastersNetcdfReadRequestOpts(
    requestParameters: SimulationsEventsRainRastersNetcdfReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersNetcdfRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersNetcdfRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfReadRaw(
    requestParameters: SimulationsEventsRainRastersNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFRasterRain>> {
    const requestOptions = await this.simulationsEventsRainRastersNetcdfReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFRasterRainFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfRead(
    requestParameters: SimulationsEventsRainRastersNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFRasterRain> {
    const response = await this.simulationsEventsRainRastersNetcdfReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainRastersNetcdfUpdate without sending the request
   */
  async simulationsEventsRainRastersNetcdfUpdateRequestOpts(
    requestParameters: SimulationsEventsRainRastersNetcdfUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainRastersNetcdfUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainRastersNetcdfUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainRastersNetcdfUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: NetCDFRasterRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfUpdateRaw(
    requestParameters: SimulationsEventsRainRastersNetcdfUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFRasterRain>> {
    const requestOptions = await this.simulationsEventsRainRastersNetcdfUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFRasterRainFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster rain
   */
  async simulationsEventsRainRastersNetcdfUpdate(
    requestParameters: SimulationsEventsRainRastersNetcdfUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFRasterRain> {
    const response = await this.simulationsEventsRainRastersNetcdfUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesCreate without sending the request
   */
  async simulationsEventsRainTimeseriesCreateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesCreateRaw(
    requestParameters: SimulationsEventsRainTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TimeseriesRainFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesCreate(
    requestParameters: SimulationsEventsRainTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesDelete without sending the request
   */
  async simulationsEventsRainTimeseriesDeleteRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesDeleteRaw(
    requestParameters: SimulationsEventsRainTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesDelete(
    requestParameters: SimulationsEventsRainTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainTimeseriesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesList without sending the request
   */
  async simulationsEventsRainTimeseriesListRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesListRaw(
    requestParameters: SimulationsEventsRainTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimeseriesRainList>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimeseriesRainListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesList(
    requestParameters: SimulationsEventsRainTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimeseriesRainList> {
    const response = await this.simulationsEventsRainTimeseriesListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesLizardCreate without sending the request
   */
  async simulationsEventsRainTimeseriesLizardCreateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesLizardCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesLizardCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesLizardCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: LizardTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardCreateRaw(
    requestParameters: SimulationsEventsRainTimeseriesLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardTimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesLizardCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardTimeseriesRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardCreate(
    requestParameters: SimulationsEventsRainTimeseriesLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardTimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesLizardCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesLizardDelete without sending the request
   */
  async simulationsEventsRainTimeseriesLizardDeleteRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesLizardDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesLizardDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesLizardDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesLizardDeleteRaw(
    requestParameters: SimulationsEventsRainTimeseriesLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesLizardDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesLizardDelete(
    requestParameters: SimulationsEventsRainTimeseriesLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainTimeseriesLizardDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesLizardList without sending the request
   */
  async simulationsEventsRainTimeseriesLizardListRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesLizardListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesLizardList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardListRaw(
    requestParameters: SimulationsEventsRainTimeseriesLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedLizardTimeseriesRainList>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesLizardListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedLizardTimeseriesRainListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardList(
    requestParameters: SimulationsEventsRainTimeseriesLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedLizardTimeseriesRainList> {
    const response = await this.simulationsEventsRainTimeseriesLizardListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesLizardPartialUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesLizardPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesLizardPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesLizardPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesLizardPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesLizardPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedLizardTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesLizardPartialUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesLizardPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesLizardPartialUpdate(
    requestParameters: SimulationsEventsRainTimeseriesLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainTimeseriesLizardPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesLizardRead without sending the request
   */
  async simulationsEventsRainTimeseriesLizardReadRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesLizardReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesLizardRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesLizardRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardReadRaw(
    requestParameters: SimulationsEventsRainTimeseriesLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardTimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesLizardReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardTimeseriesRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardRead(
    requestParameters: SimulationsEventsRainTimeseriesLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardTimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesLizardReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesLizardUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesLizardUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesLizardUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesLizardUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesLizardUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesLizardUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: LizardTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardTimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesLizardUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardTimeseriesRainFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsRainTimeseriesLizardUpdate(
    requestParameters: SimulationsEventsRainTimeseriesLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardTimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesLizardUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesNetcdfCreate without sending the request
   */
  async simulationsEventsRainTimeseriesNetcdfCreateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadWithSubstancesToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfCreateRaw(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadWithSubstances>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesNetcdfCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadWithSubstancesFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfCreate(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadWithSubstances> {
    const response = await this.simulationsEventsRainTimeseriesNetcdfCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesNetcdfDelete without sending the request
   */
  async simulationsEventsRainTimeseriesNetcdfDeleteRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesNetcdfDeleteRaw(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesNetcdfDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesNetcdfDelete(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainTimeseriesNetcdfDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesNetcdfList without sending the request
   */
  async simulationsEventsRainTimeseriesNetcdfListRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfListRaw(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedNetCDFTimeseriesRainList>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesNetcdfListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedNetCDFTimeseriesRainListFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfList(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedNetCDFTimeseriesRainList> {
    const response = await this.simulationsEventsRainTimeseriesNetcdfListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesNetcdfPartialUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesNetcdfPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedNetCDFTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesNetcdfPartialUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesNetcdfPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesNetcdfPartialUpdate(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainTimeseriesNetcdfPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesNetcdfRead without sending the request
   */
  async simulationsEventsRainTimeseriesNetcdfReadRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfReadRaw(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFTimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesNetcdfReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFTimeseriesRainFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfRead(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFTimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesNetcdfReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesNetcdfUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesNetcdfUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesNetcdfUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: NetCDFTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFTimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesNetcdfUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFTimeseriesRainFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries rain
   */
  async simulationsEventsRainTimeseriesNetcdfUpdate(
    requestParameters: SimulationsEventsRainTimeseriesNetcdfUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFTimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesNetcdfUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesPartialUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesPartialUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesPartialUpdate(
    requestParameters: SimulationsEventsRainTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainTimeseriesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesRead without sending the request
   */
  async simulationsEventsRainTimeseriesReadRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesReadRaw(
    requestParameters: SimulationsEventsRainTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TimeseriesRainFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesRead(
    requestParameters: SimulationsEventsRainTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/rain/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TimeseriesRainFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing TimeseriesRain
   */
  async simulationsEventsRainTimeseriesUpdate(
    requestParameters: SimulationsEventsRainTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRasterEditsCreate without sending the request
   */
  async simulationsEventsRasterEditsCreateRequestOpts(
    requestParameters: SimulationsEventsRasterEditsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRasterEditsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRasterEditsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/raster-edits/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RasterEditToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsCreateRaw(
    requestParameters: SimulationsEventsRasterEditsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RasterEdit>> {
    const requestOptions = await this.simulationsEventsRasterEditsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterEditFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsCreate(
    requestParameters: SimulationsEventsRasterEditsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RasterEdit> {
    const response = await this.simulationsEventsRasterEditsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRasterEditsDelete without sending the request
   */
  async simulationsEventsRasterEditsDeleteRequestOpts(
    requestParameters: SimulationsEventsRasterEditsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRasterEditsDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRasterEditsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/raster-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRasterEditsDeleteRaw(
    requestParameters: SimulationsEventsRasterEditsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRasterEditsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRasterEditsDelete(
    requestParameters: SimulationsEventsRasterEditsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRasterEditsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRasterEditsList without sending the request
   */
  async simulationsEventsRasterEditsListRequestOpts(
    requestParameters: SimulationsEventsRasterEditsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRasterEditsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/raster-edits/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsListRaw(
    requestParameters: SimulationsEventsRasterEditsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRasterEditList>> {
    const requestOptions = await this.simulationsEventsRasterEditsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRasterEditListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsList(
    requestParameters: SimulationsEventsRasterEditsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRasterEditList> {
    const response = await this.simulationsEventsRasterEditsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRasterEditsPartialUpdate without sending the request
   */
  async simulationsEventsRasterEditsPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRasterEditsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRasterEditsPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRasterEditsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRasterEditsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/raster-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedRasterEditToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRasterEditsPartialUpdateRaw(
    requestParameters: SimulationsEventsRasterEditsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRasterEditsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRasterEditsPartialUpdate(
    requestParameters: SimulationsEventsRasterEditsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRasterEditsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRasterEditsRead without sending the request
   */
  async simulationsEventsRasterEditsReadRequestOpts(
    requestParameters: SimulationsEventsRasterEditsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRasterEditsRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRasterEditsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/raster-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsReadRaw(
    requestParameters: SimulationsEventsRasterEditsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RasterEdit>> {
    const requestOptions = await this.simulationsEventsRasterEditsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterEditFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsRead(
    requestParameters: SimulationsEventsRasterEditsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RasterEdit> {
    const response = await this.simulationsEventsRasterEditsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRasterEditsRegisterRelatedRasters without sending the request
   */
  async simulationsEventsRasterEditsRegisterRelatedRastersRequestOpts(
    requestParameters: SimulationsEventsRasterEditsRegisterRelatedRastersRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRasterEditsRegisterRelatedRasters().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRasterEditsRegisterRelatedRasters().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/raster-edits/{id}/register_related_rasters/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Register all related rasters in the results-api and return read_bbox urls of the registered rasters  Skips registering of related rasters when the simulation is not in the state \'starting\' or \'initialized\'. In this case the urls will be empty
   */
  async simulationsEventsRasterEditsRegisterRelatedRastersRaw(
    requestParameters: SimulationsEventsRasterEditsRegisterRelatedRastersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<RasterEditUrls>>> {
    const requestOptions = await this.simulationsEventsRasterEditsRegisterRelatedRastersRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RasterEditUrlsFromJSON)
    );
  }

  /**
   * Register all related rasters in the results-api and return read_bbox urls of the registered rasters  Skips registering of related rasters when the simulation is not in the state \'starting\' or \'initialized\'. In this case the urls will be empty
   */
  async simulationsEventsRasterEditsRegisterRelatedRasters(
    requestParameters: SimulationsEventsRasterEditsRegisterRelatedRastersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<RasterEditUrls>> {
    const response = await this.simulationsEventsRasterEditsRegisterRelatedRastersRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRasterEditsUpdate without sending the request
   */
  async simulationsEventsRasterEditsUpdateRequestOpts(
    requestParameters: SimulationsEventsRasterEditsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRasterEditsUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRasterEditsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRasterEditsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/raster-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RasterEditToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsUpdateRaw(
    requestParameters: SimulationsEventsRasterEditsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RasterEdit>> {
    const requestOptions = await this.simulationsEventsRasterEditsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterEditFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing raster edits
   */
  async simulationsEventsRasterEditsUpdate(
    requestParameters: SimulationsEventsRasterEditsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RasterEdit> {
    const response = await this.simulationsEventsRasterEditsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksConstantCreate without sending the request
   */
  async simulationsEventsSourcesSinksConstantCreateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantCreateRaw(
    requestParameters: SimulationsEventsSourcesSinksConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConstantSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantCreate(
    requestParameters: SimulationsEventsSourcesSinksConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksConstantDelete without sending the request
   */
  async simulationsEventsSourcesSinksConstantDeleteRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksConstantDeleteRaw(
    requestParameters: SimulationsEventsSourcesSinksConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsSourcesSinksConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksConstantDelete(
    requestParameters: SimulationsEventsSourcesSinksConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsSourcesSinksConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksConstantList without sending the request
   */
  async simulationsEventsSourcesSinksConstantListRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantListRaw(
    requestParameters: SimulationsEventsSourcesSinksConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedConstantSourcesSinksList>> {
    const requestOptions = await this.simulationsEventsSourcesSinksConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedConstantSourcesSinksListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantList(
    requestParameters: SimulationsEventsSourcesSinksConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedConstantSourcesSinksList> {
    const response = await this.simulationsEventsSourcesSinksConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksConstantPartialUpdate without sending the request
   */
  async simulationsEventsSourcesSinksConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedConstantSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksConstantPartialUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsSourcesSinksConstantPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksConstantPartialUpdate(
    requestParameters: SimulationsEventsSourcesSinksConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsSourcesSinksConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksConstantRead without sending the request
   */
  async simulationsEventsSourcesSinksConstantReadRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantReadRaw(
    requestParameters: SimulationsEventsSourcesSinksConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConstantSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantRead(
    requestParameters: SimulationsEventsSourcesSinksConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksConstantUpdate without sending the request
   */
  async simulationsEventsSourcesSinksConstantUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConstantSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing ConstantSourcesSinks
   */
  async simulationsEventsSourcesSinksConstantUpdate(
    requestParameters: SimulationsEventsSourcesSinksConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersLizardCreate without sending the request
   */
  async simulationsEventsSourcesSinksRastersLizardCreateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: LizardRasterSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardCreateRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardRasterSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersLizardCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardRasterSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardCreate(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardRasterSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksRastersLizardCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersLizardDelete without sending the request
   */
  async simulationsEventsSourcesSinksRastersLizardDeleteRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksRastersLizardDeleteRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersLizardDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksRastersLizardDelete(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsSourcesSinksRastersLizardDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersLizardList without sending the request
   */
  async simulationsEventsSourcesSinksRastersLizardListRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardListRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedLizardRasterSourcesSinksList>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersLizardListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedLizardRasterSourcesSinksListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardList(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedLizardRasterSourcesSinksList> {
    const response = await this.simulationsEventsSourcesSinksRastersLizardListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersLizardPartialUpdate without sending the request
   */
  async simulationsEventsSourcesSinksRastersLizardPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedLizardRasterSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksRastersLizardPartialUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksRastersLizardPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksRastersLizardPartialUpdate(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsSourcesSinksRastersLizardPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersLizardRead without sending the request
   */
  async simulationsEventsSourcesSinksRastersLizardReadRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardReadRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardRasterSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersLizardReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardRasterSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardRead(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardRasterSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksRastersLizardReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersLizardUpdate without sending the request
   */
  async simulationsEventsSourcesSinksRastersLizardUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksRastersLizardUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: LizardRasterSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardRasterSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersLizardUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardRasterSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing lizardRasterRain
   */
  async simulationsEventsSourcesSinksRastersLizardUpdate(
    requestParameters: SimulationsEventsSourcesSinksRastersLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardRasterSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksRastersLizardUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersNetcdfCreate without sending the request
   */
  async simulationsEventsSourcesSinksRastersNetcdfCreateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadWithSubstancesToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfCreateRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadWithSubstances>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersNetcdfCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadWithSubstancesFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfCreate(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadWithSubstances> {
    const response = await this.simulationsEventsSourcesSinksRastersNetcdfCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersNetcdfDelete without sending the request
   */
  async simulationsEventsSourcesSinksRastersNetcdfDeleteRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksRastersNetcdfDeleteRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersNetcdfDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksRastersNetcdfDelete(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsSourcesSinksRastersNetcdfDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersNetcdfList without sending the request
   */
  async simulationsEventsSourcesSinksRastersNetcdfListRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfListRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedNetCDFRasterSourcesSinksList>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersNetcdfListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedNetCDFRasterSourcesSinksListFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfList(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedNetCDFRasterSourcesSinksList> {
    const response = await this.simulationsEventsSourcesSinksRastersNetcdfListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersNetcdfPartialUpdate without sending the request
   */
  async simulationsEventsSourcesSinksRastersNetcdfPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedNetCDFRasterSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksRastersNetcdfPartialUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksRastersNetcdfPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksRastersNetcdfPartialUpdate(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsSourcesSinksRastersNetcdfPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersNetcdfRead without sending the request
   */
  async simulationsEventsSourcesSinksRastersNetcdfReadRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfReadRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFRasterSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersNetcdfReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFRasterSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfRead(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFRasterSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksRastersNetcdfReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksRastersNetcdfUpdate without sending the request
   */
  async simulationsEventsSourcesSinksRastersNetcdfUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksRastersNetcdfUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/rasters/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: NetCDFRasterSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFRasterSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksRastersNetcdfUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFRasterSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 raster sources & sinks
   */
  async simulationsEventsSourcesSinksRastersNetcdfUpdate(
    requestParameters: SimulationsEventsSourcesSinksRastersNetcdfUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFRasterSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksRastersNetcdfUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesCreate without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesCreateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * Example payload: ```     {       \"offset\": 0,       \"values\": [         [           0,           0.0005         ],         [           300,           0.0002         ]       ],       \"units\": \"m/s\"     } ```
   */
  async simulationsEventsSourcesSinksTimeseriesCreateRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * Example payload: ```     {       \"offset\": 0,       \"values\": [         [           0,           0.0005         ],         [           300,           0.0002         ]       ],       \"units\": \"m/s\"     } ```
   */
  async simulationsEventsSourcesSinksTimeseriesCreate(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesDelete without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesDeleteRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksTimeseriesDeleteRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksTimeseriesDelete(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsSourcesSinksTimeseriesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesList without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesListRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesSourcesSinks
   */
  async simulationsEventsSourcesSinksTimeseriesListRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimeseriesSourcesSinksList>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimeseriesSourcesSinksListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesSourcesSinks
   */
  async simulationsEventsSourcesSinksTimeseriesList(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimeseriesSourcesSinksList> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesLizardCreate without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesLizardCreateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: LizardTimeseriesSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardCreateRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardTimeseriesSourcesSinks>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksTimeseriesLizardCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardTimeseriesSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardCreate(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardTimeseriesSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesLizardCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesLizardDelete without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesLizardDeleteRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksTimeseriesLizardDeleteRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksTimeseriesLizardDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksTimeseriesLizardDelete(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsSourcesSinksTimeseriesLizardDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesLizardList without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesLizardListRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/lizard/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardListRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedLizardTimeseriesSourcesSinksList>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesLizardListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedLizardTimeseriesSourcesSinksListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardList(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedLizardTimeseriesSourcesSinksList> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesLizardListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesLizardPartialUpdate without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedLizardTimeseriesSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksTimeseriesLizardPartialUpdate(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesLizardPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesLizardRead without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesLizardReadRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardReadRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardTimeseriesSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesLizardReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardTimeseriesSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardRead(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardTimeseriesSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesLizardReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesLizardUpdate without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesLizardUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesLizardUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/lizard/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: LizardTimeseriesSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LizardTimeseriesSourcesSinks>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksTimeseriesLizardUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LizardTimeseriesSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing LizardTimeseriesRain
   */
  async simulationsEventsSourcesSinksTimeseriesLizardUpdate(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesLizardUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LizardTimeseriesSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesLizardUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesNetcdfCreate without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfCreateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesNetcdfCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesNetcdfCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadWithSubstancesToJSON(requestParameters["data"]),
    };
  }

  /**
   * NetCDF 4 timeseries sources & sinks
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfCreateRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadWithSubstances>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksTimeseriesNetcdfCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadWithSubstancesFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries sources & sinks
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfCreate(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadWithSubstances> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesNetcdfCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesNetcdfDelete without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfDeleteRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesNetcdfDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesNetcdfDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfDeleteRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksTimeseriesNetcdfDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfDelete(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsSourcesSinksTimeseriesNetcdfDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesNetcdfList without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfListRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesNetcdfList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/netcdf/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 timeseries sources & sinks
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfListRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedNetCDFTimeseriesSourcesSinksList>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesNetcdfListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedNetCDFTimeseriesSourcesSinksListFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries sources & sinks
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfList(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedNetCDFTimeseriesSourcesSinksList> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesNetcdfListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesNetcdfRead without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfReadRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesNetcdfRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesNetcdfRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/netcdf/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * NetCDF 4 timeseries sources & sinks
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfReadRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<NetCDFTimeseriesSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesNetcdfReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      NetCDFTimeseriesSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * NetCDF 4 timeseries sources & sinks
   */
  async simulationsEventsSourcesSinksTimeseriesNetcdfRead(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesNetcdfReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<NetCDFTimeseriesSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesNetcdfReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesPartialUpdate without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimeseriesSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksTimeseriesPartialUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions =
      await this.simulationsEventsSourcesSinksTimeseriesPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsSourcesSinksTimeseriesPartialUpdate(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesRead without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesReadRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesSourcesSinks
   */
  async simulationsEventsSourcesSinksTimeseriesReadRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesSourcesSinks
   */
  async simulationsEventsSourcesSinksTimeseriesRead(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsSourcesSinksTimeseriesUpdate without sending the request
   */
  async simulationsEventsSourcesSinksTimeseriesUpdateRequestOpts(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsSourcesSinksTimeseriesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/sources-sinks/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesSourcesSinksToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimeseriesSourcesSinks
   */
  async simulationsEventsSourcesSinksTimeseriesUpdateRaw(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesSourcesSinks>> {
    const requestOptions = await this.simulationsEventsSourcesSinksTimeseriesUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimeseriesSourcesSinksFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimeseriesSourcesSinks
   */
  async simulationsEventsSourcesSinksTimeseriesUpdate(
    requestParameters: SimulationsEventsSourcesSinksTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesSourcesSinks> {
    const response = await this.simulationsEventsSourcesSinksTimeseriesUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlFileCreate without sending the request
   */
  async simulationsEventsStructureControlFileCreateRequestOpts(
    requestParameters: SimulationsEventsStructureControlFileCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFileCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlFileCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadEventFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading a file with one or more structure controls.  The supplied filename should be include the extension, for example \"bergermeer_controls.json\".  `bergermeer_controls.json`  The response provides a put_url which may be used to upload a file containing one or more controls. These controls are divided in memory, table and timed structure controls. See the respective endpoints for the required fields of these controls.  The uploaded file should be a JSON-file containing an array of controls per control type. Example of the content of such a file: ``` {     \"timed\": [         {             \"offset\": 0,             \"duration\": 100,             \"value\": [                 0.4, 0.8             ],             \"type\": \"set_discharge_coefficients\",             \"structure_id\": 21,             \"structure_type\": \"v2_weir\"         }     ],     \"memory\": [         {             \"offset\": 0,             \"duration\": 3600,             \"measure_specification\": {                 \"name\": \"Measurement location\",                 \"locations\": [                     {                         \"weight\": \"1.00\",                         \"content_type\": \"v2_connection_node\",                         \"content_pk\": 356,                     }                 ],                 \"variable\": \"s1\",                 \"operator\": \"<\"             },             \"structure_id\": 10250,             \"structure_type\": \"v2_weir\",             \"type\": \"set_crest_level\",             \"value\": [                 9.05             ],             \"upper_threshold\": 0.3,             \"lower_threshold\": 0.1,             \"is_active\": false,             \"is_inverse\": false         }     ],     \"table\": [         {             \"offset\": 0,             \"duration\": 3600,             \"measure_specification\": {                 \"name\": \"Measurement location\",                 \"locations\": [                     {                         \"weight\": \"1.00\",                         \"content_type\": \"v2_connection_node\",                         \"content_pk\": 356,                     }                 ],                 \"variable\": \"s1\",                 \"operator\": \"<\"             },             \"structure_id\": 10249,             \"structure_type\": \"v2_weir\",             \"type\": \"set_crest_level\",             \"values\": [                 [                     9.05,                     -1.45                 ],             ]         }     ] } ```  If there are only controls of one category, the other arrays can be omitted, like for example: ``` {     \"timed\": [         {             \"offset\": 0,             \"duration\": 100,             \"value\": [                 0.4, 0.8             ],             \"type\": \"set_discharge_coefficients\",             \"structure_id\": 21,             \"structure_type\": \"v2_weir\"         }     ] } ```  The `offset` supplied in the request body will be applied on top of each individual structure control offset in the uploaded file.
   */
  async simulationsEventsStructureControlFileCreateRaw(
    requestParameters: SimulationsEventsStructureControlFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadEventFile>> {
    const requestOptions = await this.simulationsEventsStructureControlFileCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadEventFileFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading a file with one or more structure controls.  The supplied filename should be include the extension, for example \"bergermeer_controls.json\".  `bergermeer_controls.json`  The response provides a put_url which may be used to upload a file containing one or more controls. These controls are divided in memory, table and timed structure controls. See the respective endpoints for the required fields of these controls.  The uploaded file should be a JSON-file containing an array of controls per control type. Example of the content of such a file: ``` {     \"timed\": [         {             \"offset\": 0,             \"duration\": 100,             \"value\": [                 0.4, 0.8             ],             \"type\": \"set_discharge_coefficients\",             \"structure_id\": 21,             \"structure_type\": \"v2_weir\"         }     ],     \"memory\": [         {             \"offset\": 0,             \"duration\": 3600,             \"measure_specification\": {                 \"name\": \"Measurement location\",                 \"locations\": [                     {                         \"weight\": \"1.00\",                         \"content_type\": \"v2_connection_node\",                         \"content_pk\": 356,                     }                 ],                 \"variable\": \"s1\",                 \"operator\": \"<\"             },             \"structure_id\": 10250,             \"structure_type\": \"v2_weir\",             \"type\": \"set_crest_level\",             \"value\": [                 9.05             ],             \"upper_threshold\": 0.3,             \"lower_threshold\": 0.1,             \"is_active\": false,             \"is_inverse\": false         }     ],     \"table\": [         {             \"offset\": 0,             \"duration\": 3600,             \"measure_specification\": {                 \"name\": \"Measurement location\",                 \"locations\": [                     {                         \"weight\": \"1.00\",                         \"content_type\": \"v2_connection_node\",                         \"content_pk\": 356,                     }                 ],                 \"variable\": \"s1\",                 \"operator\": \"<\"             },             \"structure_id\": 10249,             \"structure_type\": \"v2_weir\",             \"type\": \"set_crest_level\",             \"values\": [                 [                     9.05,                     -1.45                 ],             ]         }     ] } ```  If there are only controls of one category, the other arrays can be omitted, like for example: ``` {     \"timed\": [         {             \"offset\": 0,             \"duration\": 100,             \"value\": [                 0.4, 0.8             ],             \"type\": \"set_discharge_coefficients\",             \"structure_id\": 21,             \"structure_type\": \"v2_weir\"         }     ] } ```  The `offset` supplied in the request body will be applied on top of each individual structure control offset in the uploaded file.
   */
  async simulationsEventsStructureControlFileCreate(
    requestParameters: SimulationsEventsStructureControlFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadEventFile> {
    const response = await this.simulationsEventsStructureControlFileCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlFileDelete without sending the request
   */
  async simulationsEventsStructureControlFileDeleteRequestOpts(
    requestParameters: SimulationsEventsStructureControlFileDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlFileDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFileDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlFileDeleteRaw(
    requestParameters: SimulationsEventsStructureControlFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlFileDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlFileDelete(
    requestParameters: SimulationsEventsStructureControlFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlFileDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsStructureControlFileDownload without sending the request
   */
  async simulationsEventsStructureControlFileDownloadRequestOpts(
    requestParameters: SimulationsEventsStructureControlFileDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlFileDownload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFileDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsStructureControlFileDownloadRaw(
    requestParameters: SimulationsEventsStructureControlFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.simulationsEventsStructureControlFileDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsStructureControlFileDownload(
    requestParameters: SimulationsEventsStructureControlFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.simulationsEventsStructureControlFileDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlFileList without sending the request
   */
  async simulationsEventsStructureControlFileListRequestOpts(
    requestParameters: SimulationsEventsStructureControlFileListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFileList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileListRaw(
    requestParameters: SimulationsEventsStructureControlFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedFileStructureControlList>> {
    const requestOptions = await this.simulationsEventsStructureControlFileListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedFileStructureControlListFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileList(
    requestParameters: SimulationsEventsStructureControlFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedFileStructureControlList> {
    const response = await this.simulationsEventsStructureControlFileListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlFilePartialUpdate without sending the request
   */
  async simulationsEventsStructureControlFilePartialUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlFilePartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlFilePartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFilePartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlFilePartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedFileStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlFilePartialUpdateRaw(
    requestParameters: SimulationsEventsStructureControlFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsStructureControlFilePartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlFilePartialUpdate(
    requestParameters: SimulationsEventsStructureControlFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsStructureControlFilePartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlFileProcessed without sending the request
   */
  async simulationsEventsStructureControlFileProcessedRequestOpts(
    requestParameters: SimulationsEventsStructureControlFileProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlFileProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFileProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlFileProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BaseEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileProcessedRaw(
    requestParameters: SimulationsEventsStructureControlFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlFileProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileProcessed(
    requestParameters: SimulationsEventsStructureControlFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlFileProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsStructureControlFileRead without sending the request
   */
  async simulationsEventsStructureControlFileReadRequestOpts(
    requestParameters: SimulationsEventsStructureControlFileReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlFileRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFileRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileReadRaw(
    requestParameters: SimulationsEventsStructureControlFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlFileReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FileStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileRead(
    requestParameters: SimulationsEventsStructureControlFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileStructureControl> {
    const response = await this.simulationsEventsStructureControlFileReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlFileUpdate without sending the request
   */
  async simulationsEventsStructureControlFileUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlFileUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlFileUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlFileUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlFileUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: FileStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileUpdateRaw(
    requestParameters: SimulationsEventsStructureControlFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlFileUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FileStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsStructureControlFileUpdate(
    requestParameters: SimulationsEventsStructureControlFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileStructureControl> {
    const response = await this.simulationsEventsStructureControlFileUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlMemoryCreate without sending the request
   */
  async simulationsEventsStructureControlMemoryCreateRequestOpts(
    requestParameters: SimulationsEventsStructureControlMemoryCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlMemoryCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlMemoryCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/memory/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: MemoryStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * See tables structure endpoint for more information.
   */
  async simulationsEventsStructureControlMemoryCreateRaw(
    requestParameters: SimulationsEventsStructureControlMemoryCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MemoryStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlMemoryCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MemoryStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * See tables structure endpoint for more information.
   */
  async simulationsEventsStructureControlMemoryCreate(
    requestParameters: SimulationsEventsStructureControlMemoryCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MemoryStructureControl> {
    const response = await this.simulationsEventsStructureControlMemoryCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlMemoryDelete without sending the request
   */
  async simulationsEventsStructureControlMemoryDeleteRequestOpts(
    requestParameters: SimulationsEventsStructureControlMemoryDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlMemoryDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlMemoryDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/memory/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlMemoryDeleteRaw(
    requestParameters: SimulationsEventsStructureControlMemoryDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlMemoryDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlMemoryDelete(
    requestParameters: SimulationsEventsStructureControlMemoryDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlMemoryDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsStructureControlMemoryList without sending the request
   */
  async simulationsEventsStructureControlMemoryListRequestOpts(
    requestParameters: SimulationsEventsStructureControlMemoryListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlMemoryList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/memory/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryListRaw(
    requestParameters: SimulationsEventsStructureControlMemoryListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedMemoryStructureControlList>> {
    const requestOptions = await this.simulationsEventsStructureControlMemoryListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedMemoryStructureControlListFromJSON(jsonValue)
    );
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryList(
    requestParameters: SimulationsEventsStructureControlMemoryListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedMemoryStructureControlList> {
    const response = await this.simulationsEventsStructureControlMemoryListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlMemoryPartialUpdate without sending the request
   */
  async simulationsEventsStructureControlMemoryPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlMemoryPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlMemoryPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlMemoryPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlMemoryPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/memory/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedMemoryStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlMemoryPartialUpdateRaw(
    requestParameters: SimulationsEventsStructureControlMemoryPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions =
      await this.simulationsEventsStructureControlMemoryPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlMemoryPartialUpdate(
    requestParameters: SimulationsEventsStructureControlMemoryPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsStructureControlMemoryPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlMemoryProcessed without sending the request
   */
  async simulationsEventsStructureControlMemoryProcessedRequestOpts(
    requestParameters: SimulationsEventsStructureControlMemoryProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlMemoryProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlMemoryProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlMemoryProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/memory/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: MeasureLocationGridEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryProcessedRaw(
    requestParameters: SimulationsEventsStructureControlMemoryProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlMemoryProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryProcessed(
    requestParameters: SimulationsEventsStructureControlMemoryProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlMemoryProcessedRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsEventsStructureControlMemoryRead without sending the request
   */
  async simulationsEventsStructureControlMemoryReadRequestOpts(
    requestParameters: SimulationsEventsStructureControlMemoryReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlMemoryRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlMemoryRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/memory/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryReadRaw(
    requestParameters: SimulationsEventsStructureControlMemoryReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MemoryStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlMemoryReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MemoryStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryRead(
    requestParameters: SimulationsEventsStructureControlMemoryReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MemoryStructureControl> {
    const response = await this.simulationsEventsStructureControlMemoryReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlMemoryUpdate without sending the request
   */
  async simulationsEventsStructureControlMemoryUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlMemoryUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlMemoryUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlMemoryUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlMemoryUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/memory/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: MemoryStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryUpdateRaw(
    requestParameters: SimulationsEventsStructureControlMemoryUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MemoryStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlMemoryUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MemoryStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * ViewSet for viewing MemoryStructureControls
   */
  async simulationsEventsStructureControlMemoryUpdate(
    requestParameters: SimulationsEventsStructureControlMemoryUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MemoryStructureControl> {
    const response = await this.simulationsEventsStructureControlMemoryUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTableCreate without sending the request
   */
  async simulationsEventsStructureControlTableCreateRequestOpts(
    requestParameters: SimulationsEventsStructureControlTableCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTableCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTableCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/table/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TableStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * A table structure control can used to apply a certain action, e.g increase the pump capacity of a pump station, based on the measured values of one or more locations.  **type**  *for weirs and orifices*  - set_crest_level - set_discharge_coefficients  *for culverts, channels and pipes*  - set_discharge_coefficients  *for pumps*  - set_pump_capacity (m3/s)  **values**  The action table consists of one or more value pairs (threshold, action_value)  To close/open or partially close/open a structure using the `set_discharge_coefficients` type the values must contain **three** values. For example `[[1.2, 0.5, 0.7]]`,  where     1.2 is the threshold value     0.5 the action value for the left flow direction     0.7 action value for the right flow direction  Please note: action values for `set_discharge_coefficients` type must be > 0.  For ALL operators threshold values must be ascending,  In most cases the measure location will be of type `v2_connection_node`. For this location type only the variables `s1` and `vol1` apply. If your measure location, however, is of any other type the variable must either be `q` or `u1`.  Note that the `v2_` prefixes are no longer used in the schematisations, but are required in the API.  For both the target structure as well as for the measure location it is allowed to use a grid id as input directly. In this case we will check if the structure type associated with the given id matches with the grid administration data.  Nonetheless, we encourage you to use the structure id (that is the id of the structure in the model sqlite database) as input data. We will look up the corresponding grid id for you. If the validation holds, the state of the resource will be updated from `processing` to `valid`. Using the structure id will enable you to re-use the structure control resource after a model revision as a grid id will most likely change with every new grid generation.
   */
  async simulationsEventsStructureControlTableCreateRaw(
    requestParameters: SimulationsEventsStructureControlTableCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TableStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlTableCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TableStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * A table structure control can used to apply a certain action, e.g increase the pump capacity of a pump station, based on the measured values of one or more locations.  **type**  *for weirs and orifices*  - set_crest_level - set_discharge_coefficients  *for culverts, channels and pipes*  - set_discharge_coefficients  *for pumps*  - set_pump_capacity (m3/s)  **values**  The action table consists of one or more value pairs (threshold, action_value)  To close/open or partially close/open a structure using the `set_discharge_coefficients` type the values must contain **three** values. For example `[[1.2, 0.5, 0.7]]`,  where     1.2 is the threshold value     0.5 the action value for the left flow direction     0.7 action value for the right flow direction  Please note: action values for `set_discharge_coefficients` type must be > 0.  For ALL operators threshold values must be ascending,  In most cases the measure location will be of type `v2_connection_node`. For this location type only the variables `s1` and `vol1` apply. If your measure location, however, is of any other type the variable must either be `q` or `u1`.  Note that the `v2_` prefixes are no longer used in the schematisations, but are required in the API.  For both the target structure as well as for the measure location it is allowed to use a grid id as input directly. In this case we will check if the structure type associated with the given id matches with the grid administration data.  Nonetheless, we encourage you to use the structure id (that is the id of the structure in the model sqlite database) as input data. We will look up the corresponding grid id for you. If the validation holds, the state of the resource will be updated from `processing` to `valid`. Using the structure id will enable you to re-use the structure control resource after a model revision as a grid id will most likely change with every new grid generation.
   */
  async simulationsEventsStructureControlTableCreate(
    requestParameters: SimulationsEventsStructureControlTableCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TableStructureControl> {
    const response = await this.simulationsEventsStructureControlTableCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTableDelete without sending the request
   */
  async simulationsEventsStructureControlTableDeleteRequestOpts(
    requestParameters: SimulationsEventsStructureControlTableDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTableDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTableDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/table/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlTableDeleteRaw(
    requestParameters: SimulationsEventsStructureControlTableDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlTableDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlTableDelete(
    requestParameters: SimulationsEventsStructureControlTableDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlTableDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsStructureControlTableList without sending the request
   */
  async simulationsEventsStructureControlTableListRequestOpts(
    requestParameters: SimulationsEventsStructureControlTableListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTableList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/table/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableListRaw(
    requestParameters: SimulationsEventsStructureControlTableListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTableStructureControlList>> {
    const requestOptions = await this.simulationsEventsStructureControlTableListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTableStructureControlListFromJSON(jsonValue)
    );
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableList(
    requestParameters: SimulationsEventsStructureControlTableListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTableStructureControlList> {
    const response = await this.simulationsEventsStructureControlTableListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTablePartialUpdate without sending the request
   */
  async simulationsEventsStructureControlTablePartialUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlTablePartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTablePartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTablePartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTablePartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/table/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTableStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlTablePartialUpdateRaw(
    requestParameters: SimulationsEventsStructureControlTablePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions =
      await this.simulationsEventsStructureControlTablePartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlTablePartialUpdate(
    requestParameters: SimulationsEventsStructureControlTablePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsStructureControlTablePartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTableProcessed without sending the request
   */
  async simulationsEventsStructureControlTableProcessedRequestOpts(
    requestParameters: SimulationsEventsStructureControlTableProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTableProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTableProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTableProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/table/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: MeasureLocationGridEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableProcessedRaw(
    requestParameters: SimulationsEventsStructureControlTableProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlTableProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableProcessed(
    requestParameters: SimulationsEventsStructureControlTableProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlTableProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsStructureControlTableRead without sending the request
   */
  async simulationsEventsStructureControlTableReadRequestOpts(
    requestParameters: SimulationsEventsStructureControlTableReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTableRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTableRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/table/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableReadRaw(
    requestParameters: SimulationsEventsStructureControlTableReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TableStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlTableReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TableStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableRead(
    requestParameters: SimulationsEventsStructureControlTableReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TableStructureControl> {
    const response = await this.simulationsEventsStructureControlTableReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTableUpdate without sending the request
   */
  async simulationsEventsStructureControlTableUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlTableUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTableUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTableUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTableUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/table/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TableStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableUpdateRaw(
    requestParameters: SimulationsEventsStructureControlTableUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TableStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlTableUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TableStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * ViewSet for viewing TableStructureControls
   */
  async simulationsEventsStructureControlTableUpdate(
    requestParameters: SimulationsEventsStructureControlTableUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TableStructureControl> {
    const response = await this.simulationsEventsStructureControlTableUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTimedCreate without sending the request
   */
  async simulationsEventsStructureControlTimedCreateRequestOpts(
    requestParameters: SimulationsEventsStructureControlTimedCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTimedCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTimedCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/timed/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimedStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * A timed structure control allows for actively altering parameters of structures at a given point in time of the simulation for a given period of time. The ``type`` parameter specifies which action should be applied to the structure. Not all valid action types can be applied to every structure. An overview of valid combinations:     set_discharge_coefficients: v2_orifice, v2_weir, v2_pipe,                                v2_channel, v2_culvert    set_crest_level: v2_orifice, v2_weir    set_pump_capacity: v2_pumpstation  The value parameter must contain 1 value, except for the ``set_discharge_coefficients``action that expects a value for both flow directions.  Example payload:  ```     {       \"offset\": 0,       \"duration\": 100,       \"value\": [         0.4, 0.8       ],       \"type\": \"set_discharge_coefficients\",       \"structure_id\": 21,       \"structure_type\": \"v2_weir\"     } ```  **v2_channel and v2_pipe are for internal use only. They expect a grid_id instead of a structure_id!**
   */
  async simulationsEventsStructureControlTimedCreateRaw(
    requestParameters: SimulationsEventsStructureControlTimedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimedStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlTimedCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimedStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * A timed structure control allows for actively altering parameters of structures at a given point in time of the simulation for a given period of time. The ``type`` parameter specifies which action should be applied to the structure. Not all valid action types can be applied to every structure. An overview of valid combinations:     set_discharge_coefficients: v2_orifice, v2_weir, v2_pipe,                                v2_channel, v2_culvert    set_crest_level: v2_orifice, v2_weir    set_pump_capacity: v2_pumpstation  The value parameter must contain 1 value, except for the ``set_discharge_coefficients``action that expects a value for both flow directions.  Example payload:  ```     {       \"offset\": 0,       \"duration\": 100,       \"value\": [         0.4, 0.8       ],       \"type\": \"set_discharge_coefficients\",       \"structure_id\": 21,       \"structure_type\": \"v2_weir\"     } ```  **v2_channel and v2_pipe are for internal use only. They expect a grid_id instead of a structure_id!**
   */
  async simulationsEventsStructureControlTimedCreate(
    requestParameters: SimulationsEventsStructureControlTimedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimedStructureControl> {
    const response = await this.simulationsEventsStructureControlTimedCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTimedDelete without sending the request
   */
  async simulationsEventsStructureControlTimedDeleteRequestOpts(
    requestParameters: SimulationsEventsStructureControlTimedDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTimedDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTimedDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlTimedDeleteRaw(
    requestParameters: SimulationsEventsStructureControlTimedDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlTimedDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsStructureControlTimedDelete(
    requestParameters: SimulationsEventsStructureControlTimedDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlTimedDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsStructureControlTimedList without sending the request
   */
  async simulationsEventsStructureControlTimedListRequestOpts(
    requestParameters: SimulationsEventsStructureControlTimedListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTimedList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/timed/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedListRaw(
    requestParameters: SimulationsEventsStructureControlTimedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimedStructureControlList>> {
    const requestOptions = await this.simulationsEventsStructureControlTimedListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimedStructureControlListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedList(
    requestParameters: SimulationsEventsStructureControlTimedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimedStructureControlList> {
    const response = await this.simulationsEventsStructureControlTimedListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTimedPartialUpdate without sending the request
   */
  async simulationsEventsStructureControlTimedPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlTimedPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTimedPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTimedPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTimedPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimedStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlTimedPartialUpdateRaw(
    requestParameters: SimulationsEventsStructureControlTimedPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions =
      await this.simulationsEventsStructureControlTimedPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsStructureControlTimedPartialUpdate(
    requestParameters: SimulationsEventsStructureControlTimedPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsStructureControlTimedPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTimedProcessed without sending the request
   */
  async simulationsEventsStructureControlTimedProcessedRequestOpts(
    requestParameters: SimulationsEventsStructureControlTimedProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTimedProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTimedProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTimedProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/timed/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: GridEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedProcessedRaw(
    requestParameters: SimulationsEventsStructureControlTimedProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsStructureControlTimedProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedProcessed(
    requestParameters: SimulationsEventsStructureControlTimedProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsStructureControlTimedProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsStructureControlTimedRead without sending the request
   */
  async simulationsEventsStructureControlTimedReadRequestOpts(
    requestParameters: SimulationsEventsStructureControlTimedReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTimedRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTimedRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedReadRaw(
    requestParameters: SimulationsEventsStructureControlTimedReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimedStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlTimedReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimedStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedRead(
    requestParameters: SimulationsEventsStructureControlTimedReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimedStructureControl> {
    const response = await this.simulationsEventsStructureControlTimedReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsStructureControlTimedUpdate without sending the request
   */
  async simulationsEventsStructureControlTimedUpdateRequestOpts(
    requestParameters: SimulationsEventsStructureControlTimedUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsStructureControlTimedUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsStructureControlTimedUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsStructureControlTimedUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/structure-control/timed/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimedStructureControlToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedUpdateRaw(
    requestParameters: SimulationsEventsStructureControlTimedUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimedStructureControl>> {
    const requestOptions = await this.simulationsEventsStructureControlTimedUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TimedStructureControlFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing TimedStructureControls
   */
  async simulationsEventsStructureControlTimedUpdate(
    requestParameters: SimulationsEventsStructureControlTimedUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimedStructureControl> {
    const response = await this.simulationsEventsStructureControlTimedUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindConstantCreate without sending the request
   */
  async simulationsEventsWindConstantCreateRequestOpts(
    requestParameters: SimulationsEventsWindConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsWindConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantWindToJSON(requestParameters["data"]),
    };
  }

  /**
   * A constant wind event allows for wind forcing at a given point in time of the simulation for a given period of time. No distinction is made (yet) between the 1D and 2D model domain.  The ``units`` parameter is the wind speed unit (\'m/s\' or \'km/h\').  The ``direction_value`` parameter is the wind direction in degrees (0-360) from the north - meteorological standard. Thus, a direction_value of 180 represents a south wind (which comes from the south and blows your hat towards the north.  The ``speed_value`` parameter as well as the ``direction_value`` must contain 1 value. Behind the the scenes these are converted into nested array [time, speed_value, direction_value]. This means that this payload (example):  ``` {     \"offset\": 100,     \"duration\": 400,     \"units\": \"m/s\",     \"speed_value\": 80,     \"direction_value\": 220 } ```  becomes an Timeseries object with values:  ``` {     \"values\": [         [ 0, 80, 220],    # time, speed, direction         [ 400, 0, 0]      # time, speed, direction     ], } ```  Note that the (dimensionless) ``drag-coefficient`` is not part of a simulation event, but part of simulation initial condition.
   */
  async simulationsEventsWindConstantCreateRaw(
    requestParameters: SimulationsEventsWindConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantWind>> {
    const requestOptions = await this.simulationsEventsWindConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantWindFromJSON(jsonValue));
  }

  /**
   * A constant wind event allows for wind forcing at a given point in time of the simulation for a given period of time. No distinction is made (yet) between the 1D and 2D model domain.  The ``units`` parameter is the wind speed unit (\'m/s\' or \'km/h\').  The ``direction_value`` parameter is the wind direction in degrees (0-360) from the north - meteorological standard. Thus, a direction_value of 180 represents a south wind (which comes from the south and blows your hat towards the north.  The ``speed_value`` parameter as well as the ``direction_value`` must contain 1 value. Behind the the scenes these are converted into nested array [time, speed_value, direction_value]. This means that this payload (example):  ``` {     \"offset\": 100,     \"duration\": 400,     \"units\": \"m/s\",     \"speed_value\": 80,     \"direction_value\": 220 } ```  becomes an Timeseries object with values:  ``` {     \"values\": [         [ 0, 80, 220],    # time, speed, direction         [ 400, 0, 0]      # time, speed, direction     ], } ```  Note that the (dimensionless) ``drag-coefficient`` is not part of a simulation event, but part of simulation initial condition.
   */
  async simulationsEventsWindConstantCreate(
    requestParameters: SimulationsEventsWindConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantWind> {
    const response = await this.simulationsEventsWindConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindConstantDelete without sending the request
   */
  async simulationsEventsWindConstantDeleteRequestOpts(
    requestParameters: SimulationsEventsWindConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantDeleteRaw(
    requestParameters: SimulationsEventsWindConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsWindConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantDelete(
    requestParameters: SimulationsEventsWindConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsWindConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsWindConstantList without sending the request
   */
  async simulationsEventsWindConstantListRequestOpts(
    requestParameters: SimulationsEventsWindConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantListRaw(
    requestParameters: SimulationsEventsWindConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedConstantWindList>> {
    const requestOptions = await this.simulationsEventsWindConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedConstantWindListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantList(
    requestParameters: SimulationsEventsWindConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedConstantWindList> {
    const response = await this.simulationsEventsWindConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindConstantPartialUpdate without sending the request
   */
  async simulationsEventsWindConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsWindConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsWindConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedConstantWindToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantPartialUpdateRaw(
    requestParameters: SimulationsEventsWindConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantWind>> {
    const requestOptions = await this.simulationsEventsWindConstantPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantWindFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantPartialUpdate(
    requestParameters: SimulationsEventsWindConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantWind> {
    const response = await this.simulationsEventsWindConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindConstantRead without sending the request
   */
  async simulationsEventsWindConstantReadRequestOpts(
    requestParameters: SimulationsEventsWindConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantReadRaw(
    requestParameters: SimulationsEventsWindConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantWind>> {
    const requestOptions = await this.simulationsEventsWindConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantWindFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantRead(
    requestParameters: SimulationsEventsWindConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantWind> {
    const response = await this.simulationsEventsWindConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindConstantUpdate without sending the request
   */
  async simulationsEventsWindConstantUpdateRequestOpts(
    requestParameters: SimulationsEventsWindConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsWindConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ConstantWindToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantUpdateRaw(
    requestParameters: SimulationsEventsWindConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ConstantWind>> {
    const requestOptions = await this.simulationsEventsWindConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ConstantWindFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing Wind.
   */
  async simulationsEventsWindConstantUpdate(
    requestParameters: SimulationsEventsWindConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ConstantWind> {
    const response = await this.simulationsEventsWindConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindTimeseriesCreate without sending the request
   */
  async simulationsEventsWindTimeseriesCreateRequestOpts(
    requestParameters: SimulationsEventsWindTimeseriesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindTimeseriesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsWindTimeseriesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesWindToJSON(requestParameters["data"]),
    };
  }

  /**
   * Same as constant wind event but now without separate fields for ``speed_value`` and ``direction_value``. Instead - to avoid time-mapping issues - the field ``values`` holds the speed and direction values: ``` [     [time, speed1, direction1],     [time, speed2, direction2], ] ```  example payload: ``` {     \"offset\": 2,     \"values\": [         [0, 40, 180],         [60, 35, 181]     ],     \"units\": \"m/s\", } ```  becomes an Timeseries object with values: ``` {     \"values\": [         [ 0, 40, 180 ],         [60, 35, 181 ]     ] } ```
   */
  async simulationsEventsWindTimeseriesCreateRaw(
    requestParameters: SimulationsEventsWindTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesWind>> {
    const requestOptions = await this.simulationsEventsWindTimeseriesCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TimeseriesWindFromJSON(jsonValue));
  }

  /**
   * Same as constant wind event but now without separate fields for ``speed_value`` and ``direction_value``. Instead - to avoid time-mapping issues - the field ``values`` holds the speed and direction values: ``` [     [time, speed1, direction1],     [time, speed2, direction2], ] ```  example payload: ``` {     \"offset\": 2,     \"values\": [         [0, 40, 180],         [60, 35, 181]     ],     \"units\": \"m/s\", } ```  becomes an Timeseries object with values: ``` {     \"values\": [         [ 0, 40, 180 ],         [60, 35, 181 ]     ] } ```
   */
  async simulationsEventsWindTimeseriesCreate(
    requestParameters: SimulationsEventsWindTimeseriesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesWind> {
    const response = await this.simulationsEventsWindTimeseriesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindTimeseriesDelete without sending the request
   */
  async simulationsEventsWindTimeseriesDeleteRequestOpts(
    requestParameters: SimulationsEventsWindTimeseriesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindTimeseriesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindTimeseriesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesDeleteRaw(
    requestParameters: SimulationsEventsWindTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsWindTimeseriesDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesDelete(
    requestParameters: SimulationsEventsWindTimeseriesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsWindTimeseriesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsWindTimeseriesList without sending the request
   */
  async simulationsEventsWindTimeseriesListRequestOpts(
    requestParameters: SimulationsEventsWindTimeseriesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindTimeseriesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/timeseries/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesListRaw(
    requestParameters: SimulationsEventsWindTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTimeseriesWindList>> {
    const requestOptions = await this.simulationsEventsWindTimeseriesListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTimeseriesWindListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesList(
    requestParameters: SimulationsEventsWindTimeseriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTimeseriesWindList> {
    const response = await this.simulationsEventsWindTimeseriesListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindTimeseriesPartialUpdate without sending the request
   */
  async simulationsEventsWindTimeseriesPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsWindTimeseriesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindTimeseriesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsWindTimeseriesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimeseriesWindToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesPartialUpdateRaw(
    requestParameters: SimulationsEventsWindTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesWind>> {
    const requestOptions = await this.simulationsEventsWindTimeseriesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TimeseriesWindFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesPartialUpdate(
    requestParameters: SimulationsEventsWindTimeseriesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesWind> {
    const response = await this.simulationsEventsWindTimeseriesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindTimeseriesRead without sending the request
   */
  async simulationsEventsWindTimeseriesReadRequestOpts(
    requestParameters: SimulationsEventsWindTimeseriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindTimeseriesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindTimeseriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesReadRaw(
    requestParameters: SimulationsEventsWindTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesWind>> {
    const requestOptions = await this.simulationsEventsWindTimeseriesReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TimeseriesWindFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesRead(
    requestParameters: SimulationsEventsWindTimeseriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesWind> {
    const response = await this.simulationsEventsWindTimeseriesReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsWindTimeseriesUpdate without sending the request
   */
  async simulationsEventsWindTimeseriesUpdateRequestOpts(
    requestParameters: SimulationsEventsWindTimeseriesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsWindTimeseriesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsWindTimeseriesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsWindTimeseriesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/events/wind/timeseries/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimeseriesWindToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesUpdateRaw(
    requestParameters: SimulationsEventsWindTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TimeseriesWind>> {
    const requestOptions = await this.simulationsEventsWindTimeseriesUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TimeseriesWindFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewig Wind.
   */
  async simulationsEventsWindTimeseriesUpdate(
    requestParameters: SimulationsEventsWindTimeseriesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TimeseriesWind> {
    const response = await this.simulationsEventsWindTimeseriesUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsFromTemplate without sending the request
   */
  async simulationsFromTemplateRequestOpts(
    requestParameters: SimulationsFromTemplateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsFromTemplate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/from-template/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: FromTemplateToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a (new/cloned) simulation from a simulation template.  There are two options to specify the desired duration for the new simulation, either by using the ``end_datetime`` **or** the ``duration`` parameter.  {   \"template\":                  # source simulation template resource id   \"name\":                      # name for the new simulation.   \"tags\":                      # extra tags, added to existing simulation template tags.   \"organisation\":              # uuid of the organisation for which the                                  simulation is run   \"start_datetime\":            # datetime (in ISO 8601 (UTC) format) for the                                  simulation start, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"end_datetime\":              # datetime (in ISO 8601 (UTC) format) for the                                  simulation end, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"duration\":                  # in seconds, can be used instead of end_datetime   \"clone_events\":              # if true, clone events like rain/sources & sinks etc.   \"clone_initials\":            # if true, clone initial waterlevels   \"clone_settings\":            # if true, clone simulation settings, like physical settings etc.   \"threedimodel_id\":           # copy simulation template to threedimodel   \"started_from\":              # platform from which the simulation was started }
   */
  async simulationsFromTemplateRaw(
    requestParameters: SimulationsFromTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Simulation>> {
    const requestOptions = await this.simulationsFromTemplateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SimulationFromJSON(jsonValue));
  }

  /**
   * Create a (new/cloned) simulation from a simulation template.  There are two options to specify the desired duration for the new simulation, either by using the ``end_datetime`` **or** the ``duration`` parameter.  {   \"template\":                  # source simulation template resource id   \"name\":                      # name for the new simulation.   \"tags\":                      # extra tags, added to existing simulation template tags.   \"organisation\":              # uuid of the organisation for which the                                  simulation is run   \"start_datetime\":            # datetime (in ISO 8601 (UTC) format) for the                                  simulation start, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"end_datetime\":              # datetime (in ISO 8601 (UTC) format) for the                                  simulation end, e.g. \"YYYY-MM-DDThh:mm:ss\"   \"duration\":                  # in seconds, can be used instead of end_datetime   \"clone_events\":              # if true, clone events like rain/sources & sinks etc.   \"clone_initials\":            # if true, clone initial waterlevels   \"clone_settings\":            # if true, clone simulation settings, like physical settings etc.   \"threedimodel_id\":           # copy simulation template to threedimodel   \"started_from\":              # platform from which the simulation was started }
   */
  async simulationsFromTemplate(
    requestParameters: SimulationsFromTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Simulation> {
    const response = await this.simulationsFromTemplateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelConstantCreate without sending the request
   */
  async simulationsInitial1dWaterLevelConstantCreateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: OneDWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with a global 1D water level
   */
  async simulationsInitial1dWaterLevelConstantCreateRaw(
    requestParameters: SimulationsInitial1dWaterLevelConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevel>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OneDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Start the simulation with a global 1D water level
   */
  async simulationsInitial1dWaterLevelConstantCreate(
    requestParameters: SimulationsInitial1dWaterLevelConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevel> {
    const response = await this.simulationsInitial1dWaterLevelConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelConstantDelete without sending the request
   */
  async simulationsInitial1dWaterLevelConstantDeleteRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantDeleteRaw(
    requestParameters: SimulationsInitial1dWaterLevelConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantDelete(
    requestParameters: SimulationsInitial1dWaterLevelConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitial1dWaterLevelConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelConstantList without sending the request
   */
  async simulationsInitial1dWaterLevelConstantListRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantListRaw(
    requestParameters: SimulationsInitial1dWaterLevelConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedOneDWaterLevelList>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedOneDWaterLevelListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantList(
    requestParameters: SimulationsInitial1dWaterLevelConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedOneDWaterLevelList> {
    const response = await this.simulationsInitial1dWaterLevelConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelConstantPartialUpdate without sending the request
   */
  async simulationsInitial1dWaterLevelConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedOneDWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantPartialUpdateRaw(
    requestParameters: SimulationsInitial1dWaterLevelConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevel>> {
    const requestOptions =
      await this.simulationsInitial1dWaterLevelConstantPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OneDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantPartialUpdate(
    requestParameters: SimulationsInitial1dWaterLevelConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevel> {
    const response = await this.simulationsInitial1dWaterLevelConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelConstantRead without sending the request
   */
  async simulationsInitial1dWaterLevelConstantReadRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantReadRaw(
    requestParameters: SimulationsInitial1dWaterLevelConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevel>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OneDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantRead(
    requestParameters: SimulationsInitial1dWaterLevelConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevel> {
    const response = await this.simulationsInitial1dWaterLevelConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelConstantUpdate without sending the request
   */
  async simulationsInitial1dWaterLevelConstantUpdateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: OneDWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantUpdateRaw(
    requestParameters: SimulationsInitial1dWaterLevelConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevel>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OneDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelConstantUpdate(
    requestParameters: SimulationsInitial1dWaterLevelConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevel> {
    const response = await this.simulationsInitial1dWaterLevelConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelFileCreate without sending the request
   */
  async simulationsInitial1dWaterLevelFileCreateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelFileCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelFileCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelFileCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: OneDWaterLevelFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with a 1D water levels from a file. Applies the given values to the predefined nodes subset \"1D\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial1dWaterLevelFileCreateRaw(
    requestParameters: SimulationsInitial1dWaterLevelFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelFile>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelFileCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelFileFromJSON(jsonValue)
    );
  }

  /**
   * Start the simulation with a 1D water levels from a file. Applies the given values to the predefined nodes subset \"1D\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial1dWaterLevelFileCreate(
    requestParameters: SimulationsInitial1dWaterLevelFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelFile> {
    const response = await this.simulationsInitial1dWaterLevelFileCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelFileDelete without sending the request
   */
  async simulationsInitial1dWaterLevelFileDeleteRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelFileDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelFileDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelFileDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileDeleteRaw(
    requestParameters: SimulationsInitial1dWaterLevelFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelFileDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileDelete(
    requestParameters: SimulationsInitial1dWaterLevelFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitial1dWaterLevelFileDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelFileList without sending the request
   */
  async simulationsInitial1dWaterLevelFileListRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelFileListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelFileList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileListRaw(
    requestParameters: SimulationsInitial1dWaterLevelFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedOneDWaterLevelFileList>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelFileListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedOneDWaterLevelFileListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileList(
    requestParameters: SimulationsInitial1dWaterLevelFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedOneDWaterLevelFileList> {
    const response = await this.simulationsInitial1dWaterLevelFileListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelFilePartialUpdate without sending the request
   */
  async simulationsInitial1dWaterLevelFilePartialUpdateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelFilePartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelFilePartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelFilePartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelFilePartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedOneDWaterLevelFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFilePartialUpdateRaw(
    requestParameters: SimulationsInitial1dWaterLevelFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelFile>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelFilePartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelFileFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFilePartialUpdate(
    requestParameters: SimulationsInitial1dWaterLevelFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelFile> {
    const response = await this.simulationsInitial1dWaterLevelFilePartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelFileRead without sending the request
   */
  async simulationsInitial1dWaterLevelFileReadRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelFileReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelFileRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelFileRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileReadRaw(
    requestParameters: SimulationsInitial1dWaterLevelFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelFile>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelFileReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelFileFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileRead(
    requestParameters: SimulationsInitial1dWaterLevelFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelFile> {
    const response = await this.simulationsInitial1dWaterLevelFileReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelFileUpdate without sending the request
   */
  async simulationsInitial1dWaterLevelFileUpdateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelFileUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelFileUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelFileUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelFileUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: OneDWaterLevelFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileUpdateRaw(
    requestParameters: SimulationsInitial1dWaterLevelFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelFile>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelFileUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelFileFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D water levels
   */
  async simulationsInitial1dWaterLevelFileUpdate(
    requestParameters: SimulationsInitial1dWaterLevelFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelFile> {
    const response = await this.simulationsInitial1dWaterLevelFileUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelPredefinedCreate without sending the request
   */
  async simulationsInitial1dWaterLevelPredefinedCreateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/predefined/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: OneDWaterLevelPredefinedToJSON(requestParameters["data"]),
    };
  }

  /**
   * This endpoint is pending deprecation.  For threedimodels that came from a repository on models.lizard.net: Start the simulation with predefined 1D water levels. That is, use the initial water levels that have been specified in the ``connection_nodes`` schema.  For threedimodels that came from a schematisation in this API, there might be a threedimodels/{}/initial_waterlevels 1D resource. If such a resource exists, there will also be a /file initial condition created. The /predefined resource will still be created but is ignored by the simulation.
   */
  async simulationsInitial1dWaterLevelPredefinedCreateRaw(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelPredefined>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelPredefinedCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelPredefinedFromJSON(jsonValue)
    );
  }

  /**
   * This endpoint is pending deprecation.  For threedimodels that came from a repository on models.lizard.net: Start the simulation with predefined 1D water levels. That is, use the initial water levels that have been specified in the ``connection_nodes`` schema.  For threedimodels that came from a schematisation in this API, there might be a threedimodels/{}/initial_waterlevels 1D resource. If such a resource exists, there will also be a /file initial condition created. The /predefined resource will still be created but is ignored by the simulation.
   */
  async simulationsInitial1dWaterLevelPredefinedCreate(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelPredefined> {
    const response = await this.simulationsInitial1dWaterLevelPredefinedCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelPredefinedDelete without sending the request
   */
  async simulationsInitial1dWaterLevelPredefinedDeleteRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/predefined/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedDeleteRaw(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelPredefinedDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedDelete(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitial1dWaterLevelPredefinedDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelPredefinedList without sending the request
   */
  async simulationsInitial1dWaterLevelPredefinedListRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/predefined/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedListRaw(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedOneDWaterLevelPredefinedList>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelPredefinedListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedOneDWaterLevelPredefinedListFromJSON(jsonValue)
    );
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedList(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedOneDWaterLevelPredefinedList> {
    const response = await this.simulationsInitial1dWaterLevelPredefinedListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelPredefinedPartialUpdate without sending the request
   */
  async simulationsInitial1dWaterLevelPredefinedPartialUpdateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/predefined/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedOneDWaterLevelPredefinedToJSON(requestParameters["data"]),
    };
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedPartialUpdateRaw(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelPredefined>> {
    const requestOptions =
      await this.simulationsInitial1dWaterLevelPredefinedPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelPredefinedFromJSON(jsonValue)
    );
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedPartialUpdate(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelPredefined> {
    const response = await this.simulationsInitial1dWaterLevelPredefinedPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelPredefinedRead without sending the request
   */
  async simulationsInitial1dWaterLevelPredefinedReadRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/predefined/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedReadRaw(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelPredefined>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelPredefinedReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelPredefinedFromJSON(jsonValue)
    );
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedRead(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelPredefined> {
    const response = await this.simulationsInitial1dWaterLevelPredefinedReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dWaterLevelPredefinedUpdate without sending the request
   */
  async simulationsInitial1dWaterLevelPredefinedUpdateRequestOpts(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dWaterLevelPredefinedUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/1d_water_level/predefined/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: OneDWaterLevelPredefinedToJSON(requestParameters["data"]),
    };
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedUpdateRaw(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDWaterLevelPredefined>> {
    const requestOptions = await this.simulationsInitial1dWaterLevelPredefinedUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDWaterLevelPredefinedFromJSON(jsonValue)
    );
  }

  /**
   * initial predefined 1D water levels
   */
  async simulationsInitial1dWaterLevelPredefinedUpdate(
    requestParameters: SimulationsInitial1dWaterLevelPredefinedUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDWaterLevelPredefined> {
    const response = await this.simulationsInitial1dWaterLevelPredefinedUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelConstantCreate without sending the request
   */
  async simulationsInitial2dWaterLevelConstantCreateRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dWaterLevelConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TwoDWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with a global 2D water level. Applies the given value to the predefined nodes subset \"2D_OPEN_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial2dWaterLevelConstantCreateRaw(
    requestParameters: SimulationsInitial2dWaterLevelConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterLevel>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Start the simulation with a global 2D water level. Applies the given value to the predefined nodes subset \"2D_OPEN_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial2dWaterLevelConstantCreate(
    requestParameters: SimulationsInitial2dWaterLevelConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterLevel> {
    const response = await this.simulationsInitial2dWaterLevelConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelConstantDelete without sending the request
   */
  async simulationsInitial2dWaterLevelConstantDeleteRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantDeleteRaw(
    requestParameters: SimulationsInitial2dWaterLevelConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantDelete(
    requestParameters: SimulationsInitial2dWaterLevelConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitial2dWaterLevelConstantDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelConstantList without sending the request
   */
  async simulationsInitial2dWaterLevelConstantListRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantListRaw(
    requestParameters: SimulationsInitial2dWaterLevelConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTwoDWaterLevelList>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTwoDWaterLevelListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantList(
    requestParameters: SimulationsInitial2dWaterLevelConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTwoDWaterLevelList> {
    const response = await this.simulationsInitial2dWaterLevelConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelConstantPartialUpdate without sending the request
   */
  async simulationsInitial2dWaterLevelConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dWaterLevelConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTwoDWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantPartialUpdateRaw(
    requestParameters: SimulationsInitial2dWaterLevelConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterLevel>> {
    const requestOptions =
      await this.simulationsInitial2dWaterLevelConstantPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantPartialUpdate(
    requestParameters: SimulationsInitial2dWaterLevelConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterLevel> {
    const response = await this.simulationsInitial2dWaterLevelConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelConstantRead without sending the request
   */
  async simulationsInitial2dWaterLevelConstantReadRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantReadRaw(
    requestParameters: SimulationsInitial2dWaterLevelConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterLevel>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantRead(
    requestParameters: SimulationsInitial2dWaterLevelConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterLevel> {
    const response = await this.simulationsInitial2dWaterLevelConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelConstantUpdate without sending the request
   */
  async simulationsInitial2dWaterLevelConstantUpdateRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dWaterLevelConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TwoDWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantUpdateRaw(
    requestParameters: SimulationsInitial2dWaterLevelConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterLevel>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterLevelFromJSON(jsonValue));
  }

  /**
   * Initial 2D water levels
   */
  async simulationsInitial2dWaterLevelConstantUpdate(
    requestParameters: SimulationsInitial2dWaterLevelConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterLevel> {
    const response = await this.simulationsInitial2dWaterLevelConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelRasterCreate without sending the request
   */
  async simulationsInitial2dWaterLevelRasterCreateRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelRasterCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelRasterCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dWaterLevelRasterCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/raster/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TwoDWaterRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with 2D water levels derived from the raster by using the aggregation method. Applies the resulting levels to the predefined nodes subset \"2D_OPEN_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial2dWaterLevelRasterCreateRaw(
    requestParameters: SimulationsInitial2dWaterLevelRasterCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterRaster>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelRasterCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterRasterFromJSON(jsonValue));
  }

  /**
   * Start the simulation with 2D water levels derived from the raster by using the aggregation method. Applies the resulting levels to the predefined nodes subset \"2D_OPEN_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial2dWaterLevelRasterCreate(
    requestParameters: SimulationsInitial2dWaterLevelRasterCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterRaster> {
    const response = await this.simulationsInitial2dWaterLevelRasterCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelRasterDelete without sending the request
   */
  async simulationsInitial2dWaterLevelRasterDeleteRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelRasterDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelRasterDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelRasterDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterDeleteRaw(
    requestParameters: SimulationsInitial2dWaterLevelRasterDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelRasterDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterDelete(
    requestParameters: SimulationsInitial2dWaterLevelRasterDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitial2dWaterLevelRasterDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelRasterList without sending the request
   */
  async simulationsInitial2dWaterLevelRasterListRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelRasterListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelRasterList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/raster/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterListRaw(
    requestParameters: SimulationsInitial2dWaterLevelRasterListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTwoDWaterRasterList>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelRasterListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTwoDWaterRasterListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterList(
    requestParameters: SimulationsInitial2dWaterLevelRasterListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTwoDWaterRasterList> {
    const response = await this.simulationsInitial2dWaterLevelRasterListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelRasterPartialUpdate without sending the request
   */
  async simulationsInitial2dWaterLevelRasterPartialUpdateRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelRasterPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelRasterPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelRasterPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dWaterLevelRasterPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTwoDWaterRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterPartialUpdateRaw(
    requestParameters: SimulationsInitial2dWaterLevelRasterPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterRaster>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelRasterPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterRasterFromJSON(jsonValue));
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterPartialUpdate(
    requestParameters: SimulationsInitial2dWaterLevelRasterPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterRaster> {
    const response = await this.simulationsInitial2dWaterLevelRasterPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelRasterRead without sending the request
   */
  async simulationsInitial2dWaterLevelRasterReadRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelRasterReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelRasterRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelRasterRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterReadRaw(
    requestParameters: SimulationsInitial2dWaterLevelRasterReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterRaster>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelRasterReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterRasterFromJSON(jsonValue));
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterRead(
    requestParameters: SimulationsInitial2dWaterLevelRasterReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterRaster> {
    const response = await this.simulationsInitial2dWaterLevelRasterReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dWaterLevelRasterUpdate without sending the request
   */
  async simulationsInitial2dWaterLevelRasterUpdateRequestOpts(
    requestParameters: SimulationsInitial2dWaterLevelRasterUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dWaterLevelRasterUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dWaterLevelRasterUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dWaterLevelRasterUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/2d_water_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TwoDWaterRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterUpdateRaw(
    requestParameters: SimulationsInitial2dWaterLevelRasterUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDWaterRaster>> {
    const requestOptions = await this.simulationsInitial2dWaterLevelRasterUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TwoDWaterRasterFromJSON(jsonValue));
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitial2dWaterLevelRasterUpdate(
    requestParameters: SimulationsInitial2dWaterLevelRasterUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDWaterRaster> {
    const response = await this.simulationsInitial2dWaterLevelRasterUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelConstantCreate without sending the request
   */
  async simulationsInitialGroundwaterLevelConstantCreateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelConstantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelConstantCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterLevelConstantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GroundWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with a global 2D groundwater level. Applies the given value to the predefined nodes subset \"2D_GROUNDWATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitialGroundwaterLevelConstantCreateRaw(
    requestParameters: SimulationsInitialGroundwaterLevelConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterLevel>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelConstantCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterLevelFromJSON(jsonValue)
    );
  }

  /**
   * Start the simulation with a global 2D groundwater level. Applies the given value to the predefined nodes subset \"2D_GROUNDWATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitialGroundwaterLevelConstantCreate(
    requestParameters: SimulationsInitialGroundwaterLevelConstantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterLevel> {
    const response = await this.simulationsInitialGroundwaterLevelConstantCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelConstantDelete without sending the request
   */
  async simulationsInitialGroundwaterLevelConstantDeleteRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelConstantDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelConstantDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelConstantDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantDeleteRaw(
    requestParameters: SimulationsInitialGroundwaterLevelConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelConstantDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantDelete(
    requestParameters: SimulationsInitialGroundwaterLevelConstantDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitialGroundwaterLevelConstantDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelConstantList without sending the request
   */
  async simulationsInitialGroundwaterLevelConstantListRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelConstantListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelConstantList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/constant/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantListRaw(
    requestParameters: SimulationsInitialGroundwaterLevelConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedGroundWaterLevelList>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelConstantListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedGroundWaterLevelListFromJSON(jsonValue)
    );
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantList(
    requestParameters: SimulationsInitialGroundwaterLevelConstantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedGroundWaterLevelList> {
    const response = await this.simulationsInitialGroundwaterLevelConstantListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelConstantPartialUpdate without sending the request
   */
  async simulationsInitialGroundwaterLevelConstantPartialUpdateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelConstantPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelConstantPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelConstantPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterLevelConstantPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedGroundWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantPartialUpdateRaw(
    requestParameters: SimulationsInitialGroundwaterLevelConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterLevel>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterLevelConstantPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterLevelFromJSON(jsonValue)
    );
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantPartialUpdate(
    requestParameters: SimulationsInitialGroundwaterLevelConstantPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterLevel> {
    const response = await this.simulationsInitialGroundwaterLevelConstantPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelConstantRead without sending the request
   */
  async simulationsInitialGroundwaterLevelConstantReadRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelConstantReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelConstantRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelConstantRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantReadRaw(
    requestParameters: SimulationsInitialGroundwaterLevelConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterLevel>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelConstantReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterLevelFromJSON(jsonValue)
    );
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantRead(
    requestParameters: SimulationsInitialGroundwaterLevelConstantReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterLevel> {
    const response = await this.simulationsInitialGroundwaterLevelConstantReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelConstantUpdate without sending the request
   */
  async simulationsInitialGroundwaterLevelConstantUpdateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelConstantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelConstantUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelConstantUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterLevelConstantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/constant/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: GroundWaterLevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantUpdateRaw(
    requestParameters: SimulationsInitialGroundwaterLevelConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterLevel>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelConstantUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterLevelFromJSON(jsonValue)
    );
  }

  /**
   * Initial groundwater levels.
   */
  async simulationsInitialGroundwaterLevelConstantUpdate(
    requestParameters: SimulationsInitialGroundwaterLevelConstantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterLevel> {
    const response = await this.simulationsInitialGroundwaterLevelConstantUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelRasterCreate without sending the request
   */
  async simulationsInitialGroundwaterLevelRasterCreateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelRasterCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelRasterCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterLevelRasterCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/raster/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GroundWaterRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with groundwaterlevels derived from the raster by using the aggregation method. Applies the given value to the predefined nodes subset \"2D_GROUNDWATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitialGroundwaterLevelRasterCreateRaw(
    requestParameters: SimulationsInitialGroundwaterLevelRasterCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterRaster>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelRasterCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterRasterFromJSON(jsonValue)
    );
  }

  /**
   * Start the simulation with groundwaterlevels derived from the raster by using the aggregation method. Applies the given value to the predefined nodes subset \"2D_GROUNDWATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitialGroundwaterLevelRasterCreate(
    requestParameters: SimulationsInitialGroundwaterLevelRasterCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterRaster> {
    const response = await this.simulationsInitialGroundwaterLevelRasterCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelRasterDelete without sending the request
   */
  async simulationsInitialGroundwaterLevelRasterDeleteRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelRasterDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelRasterDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelRasterDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterDeleteRaw(
    requestParameters: SimulationsInitialGroundwaterLevelRasterDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelRasterDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterDelete(
    requestParameters: SimulationsInitialGroundwaterLevelRasterDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitialGroundwaterLevelRasterDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelRasterList without sending the request
   */
  async simulationsInitialGroundwaterLevelRasterListRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelRasterListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelRasterList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/raster/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterListRaw(
    requestParameters: SimulationsInitialGroundwaterLevelRasterListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedGroundWaterRasterList>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelRasterListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedGroundWaterRasterListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterList(
    requestParameters: SimulationsInitialGroundwaterLevelRasterListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedGroundWaterRasterList> {
    const response = await this.simulationsInitialGroundwaterLevelRasterListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelRasterPartialUpdate without sending the request
   */
  async simulationsInitialGroundwaterLevelRasterPartialUpdateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelRasterPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelRasterPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelRasterPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterLevelRasterPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedGroundWaterRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterPartialUpdateRaw(
    requestParameters: SimulationsInitialGroundwaterLevelRasterPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterRaster>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterLevelRasterPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterRasterFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterPartialUpdate(
    requestParameters: SimulationsInitialGroundwaterLevelRasterPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterRaster> {
    const response = await this.simulationsInitialGroundwaterLevelRasterPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelRasterRead without sending the request
   */
  async simulationsInitialGroundwaterLevelRasterReadRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelRasterReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelRasterRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelRasterRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterReadRaw(
    requestParameters: SimulationsInitialGroundwaterLevelRasterReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterRaster>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelRasterReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterRasterFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterRead(
    requestParameters: SimulationsInitialGroundwaterLevelRasterReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterRaster> {
    const response = await this.simulationsInitialGroundwaterLevelRasterReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterLevelRasterUpdate without sending the request
   */
  async simulationsInitialGroundwaterLevelRasterUpdateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterLevelRasterUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterLevelRasterUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterLevelRasterUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterLevelRasterUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/groundwater_level/raster/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: GroundWaterRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterUpdateRaw(
    requestParameters: SimulationsInitialGroundwaterLevelRasterUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterRaster>> {
    const requestOptions = await this.simulationsInitialGroundwaterLevelRasterUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterRasterFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D water raster
   */
  async simulationsInitialGroundwaterLevelRasterUpdate(
    requestParameters: SimulationsInitialGroundwaterLevelRasterUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterRaster> {
    const response = await this.simulationsInitialGroundwaterLevelRasterUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialSavedStateCreate without sending the request
   */
  async simulationsInitialSavedStateCreateRequestOpts(
    requestParameters: SimulationsInitialSavedStateCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialSavedStateCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialSavedStateCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/saved_state/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: InitialSavedStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateCreateRaw(
    requestParameters: SimulationsInitialSavedStateCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialSavedState>> {
    const requestOptions = await this.simulationsInitialSavedStateCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateCreate(
    requestParameters: SimulationsInitialSavedStateCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialSavedState> {
    const response = await this.simulationsInitialSavedStateCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialSavedStateDelete without sending the request
   */
  async simulationsInitialSavedStateDeleteRequestOpts(
    requestParameters: SimulationsInitialSavedStateDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialSavedStateDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialSavedStateDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/saved_state/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateDeleteRaw(
    requestParameters: SimulationsInitialSavedStateDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitialSavedStateDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateDelete(
    requestParameters: SimulationsInitialSavedStateDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitialSavedStateDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitialSavedStateList without sending the request
   */
  async simulationsInitialSavedStateListRequestOpts(
    requestParameters: SimulationsInitialSavedStateListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialSavedStateList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/saved_state/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateListRaw(
    requestParameters: SimulationsInitialSavedStateListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedInitialSavedStateList>> {
    const requestOptions = await this.simulationsInitialSavedStateListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedInitialSavedStateListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateList(
    requestParameters: SimulationsInitialSavedStateListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedInitialSavedStateList> {
    const response = await this.simulationsInitialSavedStateListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialSavedStatePartialUpdate without sending the request
   */
  async simulationsInitialSavedStatePartialUpdateRequestOpts(
    requestParameters: SimulationsInitialSavedStatePartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialSavedStatePartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialSavedStatePartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialSavedStatePartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/saved_state/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedInitialSavedStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStatePartialUpdateRaw(
    requestParameters: SimulationsInitialSavedStatePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialSavedState>> {
    const requestOptions = await this.simulationsInitialSavedStatePartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStatePartialUpdate(
    requestParameters: SimulationsInitialSavedStatePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialSavedState> {
    const response = await this.simulationsInitialSavedStatePartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialSavedStateRead without sending the request
   */
  async simulationsInitialSavedStateReadRequestOpts(
    requestParameters: SimulationsInitialSavedStateReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialSavedStateRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialSavedStateRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/saved_state/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateReadRaw(
    requestParameters: SimulationsInitialSavedStateReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialSavedState>> {
    const requestOptions = await this.simulationsInitialSavedStateReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateRead(
    requestParameters: SimulationsInitialSavedStateReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialSavedState> {
    const response = await this.simulationsInitialSavedStateReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialSavedStateUpdate without sending the request
   */
  async simulationsInitialSavedStateUpdateRequestOpts(
    requestParameters: SimulationsInitialSavedStateUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialSavedStateUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialSavedStateUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialSavedStateUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/saved_state/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: InitialSavedStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateUpdateRaw(
    requestParameters: SimulationsInitialSavedStateUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialSavedState>> {
    const requestOptions = await this.simulationsInitialSavedStateUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial SavedState\'s
   */
  async simulationsInitialSavedStateUpdate(
    requestParameters: SimulationsInitialSavedStateUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialSavedState> {
    const response = await this.simulationsInitialSavedStateUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialWindDragCoefficientCreate without sending the request
   */
  async simulationsInitialWindDragCoefficientCreateRequestOpts(
    requestParameters: SimulationsInitialWindDragCoefficientCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialWindDragCoefficientCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialWindDragCoefficientCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/wind_drag-coefficient/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WindDragCoefficientToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with a global wind drag-coefficient. This (dimensionless) ``drag-coefficient`` translates the wind speed on a 10 m elevation to the speed on the ground (default=0.005). Currently the drag-coefficient works as a global factor for the entire model: 1D lines and 2D lines if exists
   */
  async simulationsInitialWindDragCoefficientCreateRaw(
    requestParameters: SimulationsInitialWindDragCoefficientCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WindDragCoefficient>> {
    const requestOptions = await this.simulationsInitialWindDragCoefficientCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WindDragCoefficientFromJSON(jsonValue)
    );
  }

  /**
   * Start the simulation with a global wind drag-coefficient. This (dimensionless) ``drag-coefficient`` translates the wind speed on a 10 m elevation to the speed on the ground (default=0.005). Currently the drag-coefficient works as a global factor for the entire model: 1D lines and 2D lines if exists
   */
  async simulationsInitialWindDragCoefficientCreate(
    requestParameters: SimulationsInitialWindDragCoefficientCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WindDragCoefficient> {
    const response = await this.simulationsInitialWindDragCoefficientCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialWindDragCoefficientDelete without sending the request
   */
  async simulationsInitialWindDragCoefficientDeleteRequestOpts(
    requestParameters: SimulationsInitialWindDragCoefficientDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialWindDragCoefficientDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialWindDragCoefficientDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/wind_drag-coefficient/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientDeleteRaw(
    requestParameters: SimulationsInitialWindDragCoefficientDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitialWindDragCoefficientDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientDelete(
    requestParameters: SimulationsInitialWindDragCoefficientDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitialWindDragCoefficientDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsInitialWindDragCoefficientList without sending the request
   */
  async simulationsInitialWindDragCoefficientListRequestOpts(
    requestParameters: SimulationsInitialWindDragCoefficientListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialWindDragCoefficientList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/wind_drag-coefficient/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientListRaw(
    requestParameters: SimulationsInitialWindDragCoefficientListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedWindDragCoefficientList>> {
    const requestOptions = await this.simulationsInitialWindDragCoefficientListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedWindDragCoefficientListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientList(
    requestParameters: SimulationsInitialWindDragCoefficientListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedWindDragCoefficientList> {
    const response = await this.simulationsInitialWindDragCoefficientListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialWindDragCoefficientPartialUpdate without sending the request
   */
  async simulationsInitialWindDragCoefficientPartialUpdateRequestOpts(
    requestParameters: SimulationsInitialWindDragCoefficientPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialWindDragCoefficientPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialWindDragCoefficientPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialWindDragCoefficientPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/wind_drag-coefficient/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedWindDragCoefficientToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientPartialUpdateRaw(
    requestParameters: SimulationsInitialWindDragCoefficientPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WindDragCoefficient>> {
    const requestOptions = await this.simulationsInitialWindDragCoefficientPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WindDragCoefficientFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientPartialUpdate(
    requestParameters: SimulationsInitialWindDragCoefficientPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WindDragCoefficient> {
    const response = await this.simulationsInitialWindDragCoefficientPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialWindDragCoefficientRead without sending the request
   */
  async simulationsInitialWindDragCoefficientReadRequestOpts(
    requestParameters: SimulationsInitialWindDragCoefficientReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialWindDragCoefficientRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialWindDragCoefficientRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/wind_drag-coefficient/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientReadRaw(
    requestParameters: SimulationsInitialWindDragCoefficientReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WindDragCoefficient>> {
    const requestOptions = await this.simulationsInitialWindDragCoefficientReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WindDragCoefficientFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientRead(
    requestParameters: SimulationsInitialWindDragCoefficientReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WindDragCoefficient> {
    const response = await this.simulationsInitialWindDragCoefficientReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialWindDragCoefficientUpdate without sending the request
   */
  async simulationsInitialWindDragCoefficientUpdateRequestOpts(
    requestParameters: SimulationsInitialWindDragCoefficientUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialWindDragCoefficientUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialWindDragCoefficientUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialWindDragCoefficientUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/initial/wind_drag-coefficient/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: WindDragCoefficientToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientUpdateRaw(
    requestParameters: SimulationsInitialWindDragCoefficientUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WindDragCoefficient>> {
    const requestOptions = await this.simulationsInitialWindDragCoefficientUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WindDragCoefficientFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for initial Wind drag coefficient
   */
  async simulationsInitialWindDragCoefficientUpdate(
    requestParameters: SimulationsInitialWindDragCoefficientUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WindDragCoefficient> {
    const response = await this.simulationsInitialWindDragCoefficientUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsList without sending the request
   */
  async simulationsListRequestOpts(
    requestParameters: SimulationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["createdDate"] != null) {
      queryParameters["created__date"] = runtime.serializeDate(
        requestParameters["createdDate"] as any
      );
    }

    if (requestParameters["createdDateGt"] != null) {
      queryParameters["created__date__gt"] = runtime.serializeDate(
        requestParameters["createdDateGt"] as any
      );
    }

    if (requestParameters["createdDateGte"] != null) {
      queryParameters["created__date__gte"] = runtime.serializeDate(
        requestParameters["createdDateGte"] as any
      );
    }

    if (requestParameters["createdDateLt"] != null) {
      queryParameters["created__date__lt"] = runtime.serializeDate(
        requestParameters["createdDateLt"] as any
      );
    }

    if (requestParameters["createdDateLte"] != null) {
      queryParameters["created__date__lte"] = runtime.serializeDate(
        requestParameters["createdDateLte"] as any
      );
    }

    if (requestParameters["createdDay"] != null) {
      queryParameters["created__day"] = requestParameters["createdDay"];
    }

    if (requestParameters["createdDayLt"] != null) {
      queryParameters["created__day__lt"] = requestParameters["createdDayLt"];
    }

    if (requestParameters["createdMonth"] != null) {
      queryParameters["created__month"] = requestParameters["createdMonth"];
    }

    if (requestParameters["createdMonthLte"] != null) {
      queryParameters["created__month__lte"] = requestParameters["createdMonthLte"];
    }

    if (requestParameters["createdYear"] != null) {
      queryParameters["created__year"] = requestParameters["createdYear"];
    }

    if (requestParameters["createdYearGt"] != null) {
      queryParameters["created__year__gt"] = requestParameters["createdYearGt"];
    }

    if (requestParameters["createdYearGte"] != null) {
      queryParameters["created__year__gte"] = requestParameters["createdYearGte"];
    }

    if (requestParameters["createdYearLt"] != null) {
      queryParameters["created__year__lt"] = requestParameters["createdYearLt"];
    }

    if (requestParameters["createdYearLte"] != null) {
      queryParameters["created__year__lte"] = requestParameters["createdYearLte"];
    }

    if (requestParameters["idContains"] != null) {
      queryParameters["id__contains"] = requestParameters["idContains"];
    }

    if (requestParameters["isTemplate"] != null) {
      queryParameters["is_template"] = requestParameters["isTemplate"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["organisationUniqueId"] != null) {
      queryParameters["organisation__unique_id"] = requestParameters["organisationUniqueId"];
    }

    if (requestParameters["ranaProjectId"] != null) {
      queryParameters["rana_project_id"] = requestParameters["ranaProjectId"];
    }

    if (requestParameters["ranaProjectIdIsnull"] != null) {
      queryParameters["rana_project_id__isnull"] = requestParameters["ranaProjectIdIsnull"];
    }

    if (requestParameters["ranaTenantId"] != null) {
      queryParameters["rana_tenant_id"] = requestParameters["ranaTenantId"];
    }

    if (requestParameters["ranaTenantIdIsnull"] != null) {
      queryParameters["rana_tenant_id__isnull"] = requestParameters["ranaTenantIdIsnull"];
    }

    if (requestParameters["startedFrom"] != null) {
      queryParameters["started_from"] = requestParameters["startedFrom"];
    }

    if (requestParameters["tagsIn"] != null) {
      queryParameters["tags__in"] = requestParameters["tagsIn"];
    }

    if (requestParameters["threedimodelId"] != null) {
      queryParameters["threedimodel__id"] = requestParameters["threedimodelId"];
    }

    if (requestParameters["threedimodelRevisionId"] != null) {
      queryParameters["threedimodel__revision__id"] = requestParameters["threedimodelRevisionId"];
    }

    if (requestParameters["userUsername"] != null) {
      queryParameters["user__username"] = requestParameters["userUsername"];
    }

    if (requestParameters["userUsernameIstartswith"] != null) {
      queryParameters["user__username__istartswith"] = requestParameters["userUsernameIstartswith"];
    }

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["uuidContains"] != null) {
      queryParameters["uuid__contains"] = requestParameters["uuidContains"];
    }

    if (requestParameters["uuidEndswith"] != null) {
      queryParameters["uuid__endswith"] = requestParameters["uuidEndswith"];
    }

    if (requestParameters["uuidIcontains"] != null) {
      queryParameters["uuid__icontains"] = requestParameters["uuidIcontains"];
    }

    if (requestParameters["uuidIexact"] != null) {
      queryParameters["uuid__iexact"] = requestParameters["uuidIexact"];
    }

    if (requestParameters["uuidIn"] != null) {
      queryParameters["uuid__in"] = requestParameters["uuidIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["uuidIstartswith"] != null) {
      queryParameters["uuid__istartswith"] = requestParameters["uuidIstartswith"];
    }

    if (requestParameters["uuidRegex"] != null) {
      queryParameters["uuid__regex"] = requestParameters["uuidRegex"];
    }

    if (requestParameters["uuidStartswith"] != null) {
      queryParameters["uuid__startswith"] = requestParameters["uuidStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * List all simulations resources. By default the results are sorted from newest to oldest.  The reverse this order  ```     ?created ``` In general it is possible to specify reverse orderings by prefixing the field name with \'-\', like so:  ```     ?-id ``` Other fields that can be used to order the results are `name` and `id`.  Several filter are available, for instance the creation date of the resource. Some usage examples:  To get all simulation resources that have been created on Guido van Rossum\'s birthday  ```     ?created__date=1956-01-31 ```  To get all simulation resources that have been created during the 1988 UEFA European Football Championship ```    ?created__date__gte=1988-06-10&created__date__lte=1988-06-25 ```  To get all simulation resources that have been created in the month of the Carnation Revolution ```     ?created__year=1974&created__month=04 ```
   */
  async simulationsListRaw(
    requestParameters: SimulationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedSimulationList>> {
    const requestOptions = await this.simulationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedSimulationListFromJSON(jsonValue)
    );
  }

  /**
   * List all simulations resources. By default the results are sorted from newest to oldest.  The reverse this order  ```     ?created ``` In general it is possible to specify reverse orderings by prefixing the field name with \'-\', like so:  ```     ?-id ``` Other fields that can be used to order the results are `name` and `id`.  Several filter are available, for instance the creation date of the resource. Some usage examples:  To get all simulation resources that have been created on Guido van Rossum\'s birthday  ```     ?created__date=1956-01-31 ```  To get all simulation resources that have been created during the 1988 UEFA European Football Championship ```    ?created__date__gte=1988-06-10&created__date__lte=1988-06-25 ```  To get all simulation resources that have been created in the month of the Carnation Revolution ```     ?created__year=1974&created__month=04 ```
   */
  async simulationsList(
    requestParameters: SimulationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedSimulationList> {
    const response = await this.simulationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsPartialUpdate without sending the request
   */
  async simulationsPartialUpdateRequestOpts(
    requestParameters: SimulationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedSimulationUpdateToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async simulationsPartialUpdateRaw(
    requestParameters: SimulationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationUpdate>> {
    const requestOptions = await this.simulationsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationUpdateFromJSON(jsonValue)
    );
  }

  /**
   */
  async simulationsPartialUpdate(
    requestParameters: SimulationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationUpdate> {
    const response = await this.simulationsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsPostProcessingLizardQueueList without sending the request
   */
  async simulationsPostProcessingLizardQueueListRequestOpts(
    requestParameters: SimulationsPostProcessingLizardQueueListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/post_processing/lizard/queue/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsPostProcessingLizardQueueListRaw(
    requestParameters: SimulationsPostProcessingLizardQueueListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedPostProcessingQueueList>> {
    const requestOptions = await this.simulationsPostProcessingLizardQueueListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedPostProcessingQueueListFromJSON(jsonValue)
    );
  }

  /**
   */
  async simulationsPostProcessingLizardQueueList(
    requestParameters: SimulationsPostProcessingLizardQueueListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedPostProcessingQueueList> {
    const response = await this.simulationsPostProcessingLizardQueueListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsProgressList without sending the request
   */
  async simulationsProgressListRequestOpts(
    requestParameters: SimulationsProgressListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsProgressList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/progress/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsProgressListRaw(
    requestParameters: SimulationsProgressListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Progress>> {
    const requestOptions = await this.simulationsProgressListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProgressFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsProgressList(
    requestParameters: SimulationsProgressListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Progress> {
    const response = await this.simulationsProgressListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsRead without sending the request
   */
  async simulationsReadRequestOpts(
    requestParameters: SimulationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsReadRaw(
    requestParameters: SimulationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Simulation>> {
    const requestOptions = await this.simulationsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SimulationFromJSON(jsonValue));
  }

  /**
   */
  async simulationsRead(
    requestParameters: SimulationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Simulation> {
    const response = await this.simulationsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsFilesCreate without sending the request
   */
  async simulationsResultsFilesCreateRequestOpts(
    requestParameters: SimulationsResultsFilesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsFilesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ResultFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesCreateRaw(
    requestParameters: SimulationsResultsFilesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResultFile>> {
    const requestOptions = await this.simulationsResultsFilesCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ResultFileFromJSON(jsonValue));
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesCreate(
    requestParameters: SimulationsResultsFilesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResultFile> {
    const response = await this.simulationsResultsFilesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsFilesDelete without sending the request
   */
  async simulationsResultsFilesDeleteRequestOpts(
    requestParameters: SimulationsResultsFilesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsResultsFilesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesDeleteRaw(
    requestParameters: SimulationsResultsFilesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsResultsFilesDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesDelete(
    requestParameters: SimulationsResultsFilesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsResultsFilesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsResultsFilesDownload without sending the request
   */
  async simulationsResultsFilesDownloadRequestOpts(
    requestParameters: SimulationsResultsFilesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsResultsFilesDownload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsResultsFilesDownloadRaw(
    requestParameters: SimulationsResultsFilesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.simulationsResultsFilesDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsResultsFilesDownload(
    requestParameters: SimulationsResultsFilesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.simulationsResultsFilesDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsFilesList without sending the request
   */
  async simulationsResultsFilesListRequestOpts(
    requestParameters: SimulationsResultsFilesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesListRaw(
    requestParameters: SimulationsResultsFilesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedResultFileList>> {
    const requestOptions = await this.simulationsResultsFilesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedResultFileListFromJSON(jsonValue)
    );
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesList(
    requestParameters: SimulationsResultsFilesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedResultFileList> {
    const response = await this.simulationsResultsFilesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsFilesPartialUpdate without sending the request
   */
  async simulationsResultsFilesPartialUpdateRequestOpts(
    requestParameters: SimulationsResultsFilesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsResultsFilesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsFilesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedResultFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesPartialUpdateRaw(
    requestParameters: SimulationsResultsFilesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResultFile>> {
    const requestOptions = await this.simulationsResultsFilesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ResultFileFromJSON(jsonValue));
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesPartialUpdate(
    requestParameters: SimulationsResultsFilesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResultFile> {
    const response = await this.simulationsResultsFilesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsFilesRead without sending the request
   */
  async simulationsResultsFilesReadRequestOpts(
    requestParameters: SimulationsResultsFilesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsResultsFilesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesReadRaw(
    requestParameters: SimulationsResultsFilesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResultFile>> {
    const requestOptions = await this.simulationsResultsFilesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ResultFileFromJSON(jsonValue));
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesRead(
    requestParameters: SimulationsResultsFilesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResultFile> {
    const response = await this.simulationsResultsFilesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsFilesUpdate without sending the request
   */
  async simulationsResultsFilesUpdateRequestOpts(
    requestParameters: SimulationsResultsFilesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsResultsFilesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsFilesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ResultFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesUpdateRaw(
    requestParameters: SimulationsResultsFilesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ResultFile>> {
    const requestOptions = await this.simulationsResultsFilesUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ResultFileFromJSON(jsonValue));
  }

  /**
   * Retrieve simulation results
   */
  async simulationsResultsFilesUpdate(
    requestParameters: SimulationsResultsFilesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ResultFile> {
    const response = await this.simulationsResultsFilesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsFilesUpload without sending the request
   */
  async simulationsResultsFilesUploadRequestOpts(
    requestParameters: SimulationsResultsFilesUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsResultsFilesUpload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsFilesUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsFilesUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/files/{id}/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading a result file
   */
  async simulationsResultsFilesUploadRaw(
    requestParameters: SimulationsResultsFilesUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.simulationsResultsFilesUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading a result file
   */
  async simulationsResultsFilesUpload(
    requestParameters: SimulationsResultsFilesUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.simulationsResultsFilesUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardArrivalCreate without sending the request
   */
  async simulationsResultsPostProcessingLizardArrivalCreateRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardArrivalCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsPostProcessingLizardArrivalCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/arrival/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ArrivalTimePostProcessingToJSON(requestParameters["data"]),
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting an ArrivalTimePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one ArrivalTimePostProcessing object. An ArrivalTimePostProcessing resource is created with an empty POST.  Three conditions are validated when creating an resource: - The simulation may not already have an ArrivalTimePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.
   */
  async simulationsResultsPostProcessingLizardArrivalCreateRaw(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ArrivalTimePostProcessing>> {
    const requestOptions =
      await this.simulationsResultsPostProcessingLizardArrivalCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ArrivalTimePostProcessingFromJSON(jsonValue)
    );
  }

  /**
   * A Custom ViewSet for creating, listing or deleting an ArrivalTimePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one ArrivalTimePostProcessing object. An ArrivalTimePostProcessing resource is created with an empty POST.  Three conditions are validated when creating an resource: - The simulation may not already have an ArrivalTimePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.
   */
  async simulationsResultsPostProcessingLizardArrivalCreate(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ArrivalTimePostProcessing> {
    const response = await this.simulationsResultsPostProcessingLizardArrivalCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardArrivalDelete without sending the request
   */
  async simulationsResultsPostProcessingLizardArrivalDeleteRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardArrivalDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/arrival/delete/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting an ArrivalTimePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one ArrivalTimePostProcessing object. An ArrivalTimePostProcessing resource is created with an empty POST.  Three conditions are validated when creating an resource: - The simulation may not already have an ArrivalTimePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.
   */
  async simulationsResultsPostProcessingLizardArrivalDeleteRaw(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsResultsPostProcessingLizardArrivalDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A Custom ViewSet for creating, listing or deleting an ArrivalTimePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one ArrivalTimePostProcessing object. An ArrivalTimePostProcessing resource is created with an empty POST.  Three conditions are validated when creating an resource: - The simulation may not already have an ArrivalTimePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.
   */
  async simulationsResultsPostProcessingLizardArrivalDelete(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsResultsPostProcessingLizardArrivalDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardArrivalList without sending the request
   */
  async simulationsResultsPostProcessingLizardArrivalListRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardArrivalList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/arrival/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting an ArrivalTimePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one ArrivalTimePostProcessing object. An ArrivalTimePostProcessing resource is created with an empty POST.  Three conditions are validated when creating an resource: - The simulation may not already have an ArrivalTimePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.
   */
  async simulationsResultsPostProcessingLizardArrivalListRaw(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ArrivalTimePostProcessing>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardArrivalListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ArrivalTimePostProcessingFromJSON(jsonValue)
    );
  }

  /**
   * A Custom ViewSet for creating, listing or deleting an ArrivalTimePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one ArrivalTimePostProcessing object. An ArrivalTimePostProcessing resource is created with an empty POST.  Three conditions are validated when creating an resource: - The simulation may not already have an ArrivalTimePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.
   */
  async simulationsResultsPostProcessingLizardArrivalList(
    requestParameters: SimulationsResultsPostProcessingLizardArrivalListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ArrivalTimePostProcessing> {
    const response = await this.simulationsResultsPostProcessingLizardArrivalListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardBasicCreate without sending the request
   */
  async simulationsResultsPostProcessingLizardBasicCreateRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardBasicCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardBasicCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsPostProcessingLizardBasicCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/basic/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BasicPostProcessingToJSON(requestParameters["data"]),
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a BasicPostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a BasicPostProcessing resource. - Lizard may not already have been triggered to processing this simulation. - The Simulation must hold a \'dem_raw_file\' in case parameter \'process_basic_results\' is True.  The ``scenario_name`` parameter is optional (max 50 chars). If not provided it becomes an empty string.  THe ``result_uuid`` can be defined for e.g. operational models. Defaults to an uuid4 if not provided.  If ``process_basic_results`` (boolean) is False then: - It is not possible to have ArrivalTimePostProcessing and DamagePostProcessing. - Only raw_results (.nc, .log, etc) are uploaded to Lizard.  If ``process_basic_results`` (boolean) is True then: - It is possible to have ArrivalTimePostProcessing and DamagePostProcessing. - raw_results are uploaded to Lizard and additional WMS layers are available on Lizard.  Payload example ``` {     \"scenario_name\": \"my_scenario_name\",     \"process_basic_results\": True, } ```
   */
  async simulationsResultsPostProcessingLizardBasicCreateRaw(
    requestParameters: SimulationsResultsPostProcessingLizardBasicCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BasicPostProcessing>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardBasicCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BasicPostProcessingFromJSON(jsonValue)
    );
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a BasicPostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a BasicPostProcessing resource. - Lizard may not already have been triggered to processing this simulation. - The Simulation must hold a \'dem_raw_file\' in case parameter \'process_basic_results\' is True.  The ``scenario_name`` parameter is optional (max 50 chars). If not provided it becomes an empty string.  THe ``result_uuid`` can be defined for e.g. operational models. Defaults to an uuid4 if not provided.  If ``process_basic_results`` (boolean) is False then: - It is not possible to have ArrivalTimePostProcessing and DamagePostProcessing. - Only raw_results (.nc, .log, etc) are uploaded to Lizard.  If ``process_basic_results`` (boolean) is True then: - It is possible to have ArrivalTimePostProcessing and DamagePostProcessing. - raw_results are uploaded to Lizard and additional WMS layers are available on Lizard.  Payload example ``` {     \"scenario_name\": \"my_scenario_name\",     \"process_basic_results\": True, } ```
   */
  async simulationsResultsPostProcessingLizardBasicCreate(
    requestParameters: SimulationsResultsPostProcessingLizardBasicCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BasicPostProcessing> {
    const response = await this.simulationsResultsPostProcessingLizardBasicCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardBasicDelete without sending the request
   */
  async simulationsResultsPostProcessingLizardBasicDeleteRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardBasicDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardBasicDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/basic/delete/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a BasicPostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a BasicPostProcessing resource. - Lizard may not already have been triggered to processing this simulation. - The Simulation must hold a \'dem_raw_file\' in case parameter \'process_basic_results\' is True.  The ``scenario_name`` parameter is optional (max 50 chars). If not provided it becomes an empty string.  THe ``result_uuid`` can be defined for e.g. operational models. Defaults to an uuid4 if not provided.  If ``process_basic_results`` (boolean) is False then: - It is not possible to have ArrivalTimePostProcessing and DamagePostProcessing. - Only raw_results (.nc, .log, etc) are uploaded to Lizard.  If ``process_basic_results`` (boolean) is True then: - It is possible to have ArrivalTimePostProcessing and DamagePostProcessing. - raw_results are uploaded to Lizard and additional WMS layers are available on Lizard.  Payload example ``` {     \"scenario_name\": \"my_scenario_name\",     \"process_basic_results\": True, } ```
   */
  async simulationsResultsPostProcessingLizardBasicDeleteRaw(
    requestParameters: SimulationsResultsPostProcessingLizardBasicDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardBasicDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a BasicPostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a BasicPostProcessing resource. - Lizard may not already have been triggered to processing this simulation. - The Simulation must hold a \'dem_raw_file\' in case parameter \'process_basic_results\' is True.  The ``scenario_name`` parameter is optional (max 50 chars). If not provided it becomes an empty string.  THe ``result_uuid`` can be defined for e.g. operational models. Defaults to an uuid4 if not provided.  If ``process_basic_results`` (boolean) is False then: - It is not possible to have ArrivalTimePostProcessing and DamagePostProcessing. - Only raw_results (.nc, .log, etc) are uploaded to Lizard.  If ``process_basic_results`` (boolean) is True then: - It is possible to have ArrivalTimePostProcessing and DamagePostProcessing. - raw_results are uploaded to Lizard and additional WMS layers are available on Lizard.  Payload example ``` {     \"scenario_name\": \"my_scenario_name\",     \"process_basic_results\": True, } ```
   */
  async simulationsResultsPostProcessingLizardBasicDelete(
    requestParameters: SimulationsResultsPostProcessingLizardBasicDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsResultsPostProcessingLizardBasicDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardBasicList without sending the request
   */
  async simulationsResultsPostProcessingLizardBasicListRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardBasicListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardBasicList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/basic/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a BasicPostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a BasicPostProcessing resource. - Lizard may not already have been triggered to processing this simulation. - The Simulation must hold a \'dem_raw_file\' in case parameter \'process_basic_results\' is True.  The ``scenario_name`` parameter is optional (max 50 chars). If not provided it becomes an empty string.  THe ``result_uuid`` can be defined for e.g. operational models. Defaults to an uuid4 if not provided.  If ``process_basic_results`` (boolean) is False then: - It is not possible to have ArrivalTimePostProcessing and DamagePostProcessing. - Only raw_results (.nc, .log, etc) are uploaded to Lizard.  If ``process_basic_results`` (boolean) is True then: - It is possible to have ArrivalTimePostProcessing and DamagePostProcessing. - raw_results are uploaded to Lizard and additional WMS layers are available on Lizard.  Payload example ``` {     \"scenario_name\": \"my_scenario_name\",     \"process_basic_results\": True, } ```
   */
  async simulationsResultsPostProcessingLizardBasicListRaw(
    requestParameters: SimulationsResultsPostProcessingLizardBasicListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BasicPostProcessing>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardBasicListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BasicPostProcessingFromJSON(jsonValue)
    );
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a BasicPostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a BasicPostProcessing resource. - Lizard may not already have been triggered to processing this simulation. - The Simulation must hold a \'dem_raw_file\' in case parameter \'process_basic_results\' is True.  The ``scenario_name`` parameter is optional (max 50 chars). If not provided it becomes an empty string.  THe ``result_uuid`` can be defined for e.g. operational models. Defaults to an uuid4 if not provided.  If ``process_basic_results`` (boolean) is False then: - It is not possible to have ArrivalTimePostProcessing and DamagePostProcessing. - Only raw_results (.nc, .log, etc) are uploaded to Lizard.  If ``process_basic_results`` (boolean) is True then: - It is possible to have ArrivalTimePostProcessing and DamagePostProcessing. - raw_results are uploaded to Lizard and additional WMS layers are available on Lizard.  Payload example ``` {     \"scenario_name\": \"my_scenario_name\",     \"process_basic_results\": True, } ```
   */
  async simulationsResultsPostProcessingLizardBasicList(
    requestParameters: SimulationsResultsPostProcessingLizardBasicListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BasicPostProcessing> {
    const response = await this.simulationsResultsPostProcessingLizardBasicListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardDamageCreate without sending the request
   */
  async simulationsResultsPostProcessingLizardDamageCreateRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardDamageCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardDamageCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsPostProcessingLizardDamageCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/damage/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: DamagePostProcessingToJSON(requestParameters["data"]),
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a DamagePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a DamagePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.  The ``cost_type`` parameter choices are: \'min\', \'avg\', \'max\'.  The ``flood_month`` parameter choices are: \'jan\', \'feb\', etc  The ``inundation_period`` parameter is ime in hours (float), min_value=1.0  The ``repair_time_infrastructure`` parameter is time in hours (integer), min_value=1, max_value=240  The ``repair_time_buildings`` parameter is time in hours (integer), min_value=1, max_value=240  Payload example ``` {     \"cost_type\": \"min\",     \"flood_month\": \"jan\",     \"inundation_period\": 12.0,     \"repair_time_infrastructure\": 120,     \"repair_time_buildings\": 240 } ```
   */
  async simulationsResultsPostProcessingLizardDamageCreateRaw(
    requestParameters: SimulationsResultsPostProcessingLizardDamageCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DamagePostProcessing>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardDamageCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DamagePostProcessingFromJSON(jsonValue)
    );
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a DamagePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a DamagePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.  The ``cost_type`` parameter choices are: \'min\', \'avg\', \'max\'.  The ``flood_month`` parameter choices are: \'jan\', \'feb\', etc  The ``inundation_period`` parameter is ime in hours (float), min_value=1.0  The ``repair_time_infrastructure`` parameter is time in hours (integer), min_value=1, max_value=240  The ``repair_time_buildings`` parameter is time in hours (integer), min_value=1, max_value=240  Payload example ``` {     \"cost_type\": \"min\",     \"flood_month\": \"jan\",     \"inundation_period\": 12.0,     \"repair_time_infrastructure\": 120,     \"repair_time_buildings\": 240 } ```
   */
  async simulationsResultsPostProcessingLizardDamageCreate(
    requestParameters: SimulationsResultsPostProcessingLizardDamageCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DamagePostProcessing> {
    const response = await this.simulationsResultsPostProcessingLizardDamageCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardDamageDelete without sending the request
   */
  async simulationsResultsPostProcessingLizardDamageDeleteRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardDamageDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardDamageDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/damage/delete/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a DamagePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a DamagePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.  The ``cost_type`` parameter choices are: \'min\', \'avg\', \'max\'.  The ``flood_month`` parameter choices are: \'jan\', \'feb\', etc  The ``inundation_period`` parameter is ime in hours (float), min_value=1.0  The ``repair_time_infrastructure`` parameter is time in hours (integer), min_value=1, max_value=240  The ``repair_time_buildings`` parameter is time in hours (integer), min_value=1, max_value=240  Payload example ``` {     \"cost_type\": \"min\",     \"flood_month\": \"jan\",     \"inundation_period\": 12.0,     \"repair_time_infrastructure\": 120,     \"repair_time_buildings\": 240 } ```
   */
  async simulationsResultsPostProcessingLizardDamageDeleteRaw(
    requestParameters: SimulationsResultsPostProcessingLizardDamageDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardDamageDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a DamagePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a DamagePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.  The ``cost_type`` parameter choices are: \'min\', \'avg\', \'max\'.  The ``flood_month`` parameter choices are: \'jan\', \'feb\', etc  The ``inundation_period`` parameter is ime in hours (float), min_value=1.0  The ``repair_time_infrastructure`` parameter is time in hours (integer), min_value=1, max_value=240  The ``repair_time_buildings`` parameter is time in hours (integer), min_value=1, max_value=240  Payload example ``` {     \"cost_type\": \"min\",     \"flood_month\": \"jan\",     \"inundation_period\": 12.0,     \"repair_time_infrastructure\": 120,     \"repair_time_buildings\": 240 } ```
   */
  async simulationsResultsPostProcessingLizardDamageDelete(
    requestParameters: SimulationsResultsPostProcessingLizardDamageDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsResultsPostProcessingLizardDamageDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardDamageList without sending the request
   */
  async simulationsResultsPostProcessingLizardDamageListRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardDamageListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardDamageList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/damage/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a DamagePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a DamagePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.  The ``cost_type`` parameter choices are: \'min\', \'avg\', \'max\'.  The ``flood_month`` parameter choices are: \'jan\', \'feb\', etc  The ``inundation_period`` parameter is ime in hours (float), min_value=1.0  The ``repair_time_infrastructure`` parameter is time in hours (integer), min_value=1, max_value=240  The ``repair_time_buildings`` parameter is time in hours (integer), min_value=1, max_value=240  Payload example ``` {     \"cost_type\": \"min\",     \"flood_month\": \"jan\",     \"inundation_period\": 12.0,     \"repair_time_infrastructure\": 120,     \"repair_time_buildings\": 240 } ```
   */
  async simulationsResultsPostProcessingLizardDamageListRaw(
    requestParameters: SimulationsResultsPostProcessingLizardDamageListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DamagePostProcessing>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardDamageListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DamagePostProcessingFromJSON(jsonValue)
    );
  }

  /**
   * A Custom ViewSet for creating, listing or deleting a DamagePostProcessing resource. It includes a custom destroy action (with detail=False) as a BasicPostProcessing object can have only one DamagePostProcessing object.  Three conditions are validated when creating an resource: - The simulation may not already have a DamagePostProcessing resource. - The simulation must have a BasicPostProcessing resource with \'process_basic_results\'=True. - Lizard may not already have been triggered to processing this simulation.  The ``cost_type`` parameter choices are: \'min\', \'avg\', \'max\'.  The ``flood_month`` parameter choices are: \'jan\', \'feb\', etc  The ``inundation_period`` parameter is ime in hours (float), min_value=1.0  The ``repair_time_infrastructure`` parameter is time in hours (integer), min_value=1, max_value=240  The ``repair_time_buildings`` parameter is time in hours (integer), min_value=1, max_value=240  Payload example ``` {     \"cost_type\": \"min\",     \"flood_month\": \"jan\",     \"inundation_period\": 12.0,     \"repair_time_infrastructure\": 120,     \"repair_time_buildings\": 240 } ```
   */
  async simulationsResultsPostProcessingLizardDamageList(
    requestParameters: SimulationsResultsPostProcessingLizardDamageListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DamagePostProcessing> {
    const response = await this.simulationsResultsPostProcessingLizardDamageListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardOverviewList without sending the request
   */
  async simulationsResultsPostProcessingLizardOverviewListRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardOverviewListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardOverviewList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/overview/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Custom list that provides overview of post-processing configuration. Below a format specification is provided. All keys always exists, regardless post-processing config:  ``` {   \"username\": str,   \"external_user_id\": Optional[str],   \"metadata_version\": float,   \"start_time_sim\": datetime (UTC),   \"end_time_sim\": datetime (UTC),   \"results\": {     \"basic\": bool,     \"damage_estimation\": bool,     \"arrival_time\": bool   },   \"settings\": {     \"damage_estimation\": {         \"damage_table\": str,         \"elevation_raster_uuid\": str,         \"landcover_raster_uuid\": str,         \"road_rail_raster_uuid\": str,         \"cost_type\": int,         \"flood_month\": int,         \"inundation_period\": int,         \"repair_time_infrastructure\": int,         \"repair_time_buildings\": int         },   },   \"model_name\": str, (=threedimodel_slug)   \"simulation_name\": str, (=simulation_slug)   \"scenario_name\": str,   \"model_id\": int,   \"model_revision_id\": str,   \"email\": str,   \"result_uuid\": str,   \"organisation_uuid\": str,   \"simulation\": int } ```
   */
  async simulationsResultsPostProcessingLizardOverviewListRaw(
    requestParameters: SimulationsResultsPostProcessingLizardOverviewListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PostProcessingOverview>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardOverviewListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PostProcessingOverviewFromJSON(jsonValue)
    );
  }

  /**
   * Custom list that provides overview of post-processing configuration. Below a format specification is provided. All keys always exists, regardless post-processing config:  ``` {   \"username\": str,   \"external_user_id\": Optional[str],   \"metadata_version\": float,   \"start_time_sim\": datetime (UTC),   \"end_time_sim\": datetime (UTC),   \"results\": {     \"basic\": bool,     \"damage_estimation\": bool,     \"arrival_time\": bool   },   \"settings\": {     \"damage_estimation\": {         \"damage_table\": str,         \"elevation_raster_uuid\": str,         \"landcover_raster_uuid\": str,         \"road_rail_raster_uuid\": str,         \"cost_type\": int,         \"flood_month\": int,         \"inundation_period\": int,         \"repair_time_infrastructure\": int,         \"repair_time_buildings\": int         },   },   \"model_name\": str, (=threedimodel_slug)   \"simulation_name\": str, (=simulation_slug)   \"scenario_name\": str,   \"model_id\": int,   \"model_revision_id\": str,   \"email\": str,   \"result_uuid\": str,   \"organisation_uuid\": str,   \"simulation\": int } ```
   */
  async simulationsResultsPostProcessingLizardOverviewList(
    requestParameters: SimulationsResultsPostProcessingLizardOverviewListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PostProcessingOverview> {
    const response = await this.simulationsResultsPostProcessingLizardOverviewListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardStartCreate without sending the request
   */
  async simulationsResultsPostProcessingLizardStartCreateRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardStartCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardStartCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsPostProcessingLizardStartCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/start/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters["data"],
    };
  }

  /**
   * Empty post to start Lizard post-processing for one Simulation result.
   */
  async simulationsResultsPostProcessingLizardStartCreateRaw(
    requestParameters: SimulationsResultsPostProcessingLizardStartCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any }>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardStartCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Empty post to start Lizard post-processing for one Simulation result.
   */
  async simulationsResultsPostProcessingLizardStartCreate(
    requestParameters: SimulationsResultsPostProcessingLizardStartCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any }> {
    const response = await this.simulationsResultsPostProcessingLizardStartCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardStartRetry without sending the request
   */
  async simulationsResultsPostProcessingLizardStartRetryRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardStartRetryRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardStartRetry().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsPostProcessingLizardStartRetry().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/start/retry/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters["data"],
    };
  }

  /**
   * Retry the Lizard post-processing  Will only re-trigger the post-processing if the post-processing status is in `archiving_failed`.
   */
  async simulationsResultsPostProcessingLizardStartRetryRaw(
    requestParameters: SimulationsResultsPostProcessingLizardStartRetryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any }>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardStartRetryRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Retry the Lizard post-processing  Will only re-trigger the post-processing if the post-processing status is in `archiving_failed`.
   */
  async simulationsResultsPostProcessingLizardStartRetry(
    requestParameters: SimulationsResultsPostProcessingLizardStartRetryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any }> {
    const response = await this.simulationsResultsPostProcessingLizardStartRetryRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardStatusCreate without sending the request
   */
  async simulationsResultsPostProcessingLizardStatusCreateRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardStatusCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardStatusCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsResultsPostProcessingLizardStatusCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/status/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PostProcessingStatusToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint to keep track of post-processing status (done by Lizard) per Simulation result. Status is updated internal by 3Di, and once processing starts it is updated by Lizard backend.
   */
  async simulationsResultsPostProcessingLizardStatusCreateRaw(
    requestParameters: SimulationsResultsPostProcessingLizardStatusCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PostProcessingStatus>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardStatusCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PostProcessingStatusFromJSON(jsonValue)
    );
  }

  /**
   * Endpoint to keep track of post-processing status (done by Lizard) per Simulation result. Status is updated internal by 3Di, and once processing starts it is updated by Lizard backend.
   */
  async simulationsResultsPostProcessingLizardStatusCreate(
    requestParameters: SimulationsResultsPostProcessingLizardStatusCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PostProcessingStatus> {
    const response = await this.simulationsResultsPostProcessingLizardStatusCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardStatusDelete without sending the request
   */
  async simulationsResultsPostProcessingLizardStatusDeleteRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardStatusDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardStatusDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/status/delete/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint to keep track of post-processing status (done by Lizard) per Simulation result. Status is updated internal by 3Di, and once processing starts it is updated by Lizard backend.
   */
  async simulationsResultsPostProcessingLizardStatusDeleteRaw(
    requestParameters: SimulationsResultsPostProcessingLizardStatusDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardStatusDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Endpoint to keep track of post-processing status (done by Lizard) per Simulation result. Status is updated internal by 3Di, and once processing starts it is updated by Lizard backend.
   */
  async simulationsResultsPostProcessingLizardStatusDelete(
    requestParameters: SimulationsResultsPostProcessingLizardStatusDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsResultsPostProcessingLizardStatusDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardStatusHistoryList without sending the request
   */
  async simulationsResultsPostProcessingLizardStatusHistoryListRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardStatusHistoryListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardStatusHistoryList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/status/history/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsResultsPostProcessingLizardStatusHistoryListRaw(
    requestParameters: SimulationsResultsPostProcessingLizardStatusHistoryListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedPostProcessingStatusHistoryList>> {
    const requestOptions =
      await this.simulationsResultsPostProcessingLizardStatusHistoryListRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedPostProcessingStatusHistoryListFromJSON(jsonValue)
    );
  }

  /**
   */
  async simulationsResultsPostProcessingLizardStatusHistoryList(
    requestParameters: SimulationsResultsPostProcessingLizardStatusHistoryListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedPostProcessingStatusHistoryList> {
    const response = await this.simulationsResultsPostProcessingLizardStatusHistoryListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsResultsPostProcessingLizardStatusList without sending the request
   */
  async simulationsResultsPostProcessingLizardStatusListRequestOpts(
    requestParameters: SimulationsResultsPostProcessingLizardStatusListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsResultsPostProcessingLizardStatusList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/results/post_processing/lizard/status/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Show the latest post-processing status of one simulation.
   */
  async simulationsResultsPostProcessingLizardStatusListRaw(
    requestParameters: SimulationsResultsPostProcessingLizardStatusListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PostProcessingStatus>> {
    const requestOptions = await this.simulationsResultsPostProcessingLizardStatusListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PostProcessingStatusFromJSON(jsonValue)
    );
  }

  /**
   * Show the latest post-processing status of one simulation.
   */
  async simulationsResultsPostProcessingLizardStatusList(
    requestParameters: SimulationsResultsPostProcessingLizardStatusListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PostProcessingStatus> {
    const response = await this.simulationsResultsPostProcessingLizardStatusListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsAggregationCreate without sending the request
   */
  async simulationsSettingsAggregationCreateRequestOpts(
    requestParameters: SimulationsSettingsAggregationCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsAggregationCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsAggregationCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/aggregation/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AggregationSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationCreateRaw(
    requestParameters: SimulationsSettingsAggregationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AggregationSettings>> {
    const requestOptions = await this.simulationsSettingsAggregationCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AggregationSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationCreate(
    requestParameters: SimulationsSettingsAggregationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AggregationSettings> {
    const response = await this.simulationsSettingsAggregationCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsAggregationDelete without sending the request
   */
  async simulationsSettingsAggregationDeleteRequestOpts(
    requestParameters: SimulationsSettingsAggregationDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsAggregationDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsAggregationDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/aggregation/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationDeleteRaw(
    requestParameters: SimulationsSettingsAggregationDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsAggregationDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationDelete(
    requestParameters: SimulationsSettingsAggregationDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsAggregationDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsAggregationList without sending the request
   */
  async simulationsSettingsAggregationListRequestOpts(
    requestParameters: SimulationsSettingsAggregationListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsAggregationList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/aggregation/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationListRaw(
    requestParameters: SimulationsSettingsAggregationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedAggregationSettingsList>> {
    const requestOptions = await this.simulationsSettingsAggregationListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedAggregationSettingsListFromJSON(jsonValue)
    );
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationList(
    requestParameters: SimulationsSettingsAggregationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedAggregationSettingsList> {
    const response = await this.simulationsSettingsAggregationListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsAggregationPartialUpdate without sending the request
   */
  async simulationsSettingsAggregationPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsAggregationPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsAggregationPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsAggregationPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsAggregationPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/aggregation/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedAggregationSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationPartialUpdateRaw(
    requestParameters: SimulationsSettingsAggregationPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AggregationSettings>> {
    const requestOptions = await this.simulationsSettingsAggregationPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AggregationSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationPartialUpdate(
    requestParameters: SimulationsSettingsAggregationPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AggregationSettings> {
    const response = await this.simulationsSettingsAggregationPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsAggregationRead without sending the request
   */
  async simulationsSettingsAggregationReadRequestOpts(
    requestParameters: SimulationsSettingsAggregationReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsAggregationRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsAggregationRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/aggregation/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationReadRaw(
    requestParameters: SimulationsSettingsAggregationReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AggregationSettings>> {
    const requestOptions = await this.simulationsSettingsAggregationReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AggregationSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationRead(
    requestParameters: SimulationsSettingsAggregationReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AggregationSettings> {
    const response = await this.simulationsSettingsAggregationReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsAggregationUpdate without sending the request
   */
  async simulationsSettingsAggregationUpdateRequestOpts(
    requestParameters: SimulationsSettingsAggregationUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsAggregationUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsAggregationUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsAggregationUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/aggregation/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: AggregationSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationUpdateRaw(
    requestParameters: SimulationsSettingsAggregationUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AggregationSettings>> {
    const requestOptions = await this.simulationsSettingsAggregationUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AggregationSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Simulation aggregation settings.  For a consistent water balance often the results of various snap shots - as provided by the results_3di.nc file - are not enough. Especially in case of an time step setting that is larger than the computational time step. For this purpose, an aggregated results file is available called aggregate_results_3di.nc. The structure of the file is very similar to the other result file. Each Mesh variable (s1, u1, etc.) described in the results section can be aggregated.
   */
  async simulationsSettingsAggregationUpdate(
    requestParameters: SimulationsSettingsAggregationUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AggregationSettings> {
    const response = await this.simulationsSettingsAggregationUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsCustomizedResultAreasCreate without sending the request
   */
  async simulationsSettingsCustomizedResultAreasCreateRequestOpts(
    requestParameters: SimulationsSettingsCustomizedResultAreasCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsCustomizedResultAreasCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsCustomizedResultAreasCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/customized_result_areas/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CustomizedResultAreaToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasCreateRaw(
    requestParameters: SimulationsSettingsCustomizedResultAreasCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CustomizedResultArea>> {
    const requestOptions = await this.simulationsSettingsCustomizedResultAreasCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasCreate(
    requestParameters: SimulationsSettingsCustomizedResultAreasCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CustomizedResultArea> {
    const response = await this.simulationsSettingsCustomizedResultAreasCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsCustomizedResultAreasDelete without sending the request
   */
  async simulationsSettingsCustomizedResultAreasDeleteRequestOpts(
    requestParameters: SimulationsSettingsCustomizedResultAreasDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsCustomizedResultAreasDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsCustomizedResultAreasDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasDeleteRaw(
    requestParameters: SimulationsSettingsCustomizedResultAreasDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsCustomizedResultAreasDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasDelete(
    requestParameters: SimulationsSettingsCustomizedResultAreasDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsCustomizedResultAreasDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsCustomizedResultAreasList without sending the request
   */
  async simulationsSettingsCustomizedResultAreasListRequestOpts(
    requestParameters: SimulationsSettingsCustomizedResultAreasListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsCustomizedResultAreasList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/customized_result_areas/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasListRaw(
    requestParameters: SimulationsSettingsCustomizedResultAreasListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedCustomizedResultAreaList>> {
    const requestOptions = await this.simulationsSettingsCustomizedResultAreasListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedCustomizedResultAreaListFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasList(
    requestParameters: SimulationsSettingsCustomizedResultAreasListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedCustomizedResultAreaList> {
    const response = await this.simulationsSettingsCustomizedResultAreasListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsCustomizedResultAreasPartialUpdate without sending the request
   */
  async simulationsSettingsCustomizedResultAreasPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsCustomizedResultAreasPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsCustomizedResultAreasPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsCustomizedResultAreasPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsCustomizedResultAreasPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedCustomizedResultAreaToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasPartialUpdateRaw(
    requestParameters: SimulationsSettingsCustomizedResultAreasPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CustomizedResultArea>> {
    const requestOptions =
      await this.simulationsSettingsCustomizedResultAreasPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasPartialUpdate(
    requestParameters: SimulationsSettingsCustomizedResultAreasPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CustomizedResultArea> {
    const response = await this.simulationsSettingsCustomizedResultAreasPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsCustomizedResultAreasRead without sending the request
   */
  async simulationsSettingsCustomizedResultAreasReadRequestOpts(
    requestParameters: SimulationsSettingsCustomizedResultAreasReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsCustomizedResultAreasRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsCustomizedResultAreasRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasReadRaw(
    requestParameters: SimulationsSettingsCustomizedResultAreasReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CustomizedResultArea>> {
    const requestOptions = await this.simulationsSettingsCustomizedResultAreasReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasRead(
    requestParameters: SimulationsSettingsCustomizedResultAreasReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CustomizedResultArea> {
    const response = await this.simulationsSettingsCustomizedResultAreasReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsCustomizedResultAreasUpdate without sending the request
   */
  async simulationsSettingsCustomizedResultAreasUpdateRequestOpts(
    requestParameters: SimulationsSettingsCustomizedResultAreasUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsCustomizedResultAreasUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsCustomizedResultAreasUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsCustomizedResultAreasUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: CustomizedResultAreaToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasUpdateRaw(
    requestParameters: SimulationsSettingsCustomizedResultAreasUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CustomizedResultArea>> {
    const requestOptions = await this.simulationsSettingsCustomizedResultAreasUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsCustomizedResultAreasUpdate(
    requestParameters: SimulationsSettingsCustomizedResultAreasUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CustomizedResultArea> {
    const response = await this.simulationsSettingsCustomizedResultAreasUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsNumericalCreate without sending the request
   */
  async simulationsSettingsNumericalCreateRequestOpts(
    requestParameters: SimulationsSettingsNumericalCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsNumericalCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsNumericalCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/numerical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NumericalSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * create a numerical settings resource
   */
  async simulationsSettingsNumericalCreateRaw(
    requestParameters: SimulationsSettingsNumericalCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsNumericalCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * create a numerical settings resource
   */
  async simulationsSettingsNumericalCreate(
    requestParameters: SimulationsSettingsNumericalCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsNumericalCreateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsNumericalDelete without sending the request
   */
  async simulationsSettingsNumericalDeleteRequestOpts(
    requestParameters: SimulationsSettingsNumericalDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsNumericalDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/numerical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * delete the numerical settings resource
   */
  async simulationsSettingsNumericalDeleteRaw(
    requestParameters: SimulationsSettingsNumericalDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsNumericalDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * delete the numerical settings resource
   */
  async simulationsSettingsNumericalDelete(
    requestParameters: SimulationsSettingsNumericalDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsNumericalDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsNumericalPartialUpdate without sending the request
   */
  async simulationsSettingsNumericalPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsNumericalPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsNumericalPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsNumericalPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/numerical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedNumericalSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * update the numerical settings resource
   */
  async simulationsSettingsNumericalPartialUpdateRaw(
    requestParameters: SimulationsSettingsNumericalPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsNumericalPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * update the numerical settings resource
   */
  async simulationsSettingsNumericalPartialUpdate(
    requestParameters: SimulationsSettingsNumericalPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsNumericalPartialUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsNumericalUpdate without sending the request
   */
  async simulationsSettingsNumericalUpdateRequestOpts(
    requestParameters: SimulationsSettingsNumericalUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsNumericalUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsNumericalUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/numerical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: NumericalSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * update the numerical settings resource
   */
  async simulationsSettingsNumericalUpdateRaw(
    requestParameters: SimulationsSettingsNumericalUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsNumericalUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * update the numerical settings resource
   */
  async simulationsSettingsNumericalUpdate(
    requestParameters: SimulationsSettingsNumericalUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsNumericalUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsOutputSettingsCreate without sending the request
   */
  async simulationsSettingsOutputSettingsCreateRequestOpts(
    requestParameters: SimulationsSettingsOutputSettingsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsOutputSettingsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsOutputSettingsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: OutputSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * create a output settings resource
   */
  async simulationsSettingsOutputSettingsCreateRaw(
    requestParameters: SimulationsSettingsOutputSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsOutputSettingsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * create a output settings resource
   */
  async simulationsSettingsOutputSettingsCreate(
    requestParameters: SimulationsSettingsOutputSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsOutputSettingsCreateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsOutputSettingsDelete without sending the request
   */
  async simulationsSettingsOutputSettingsDeleteRequestOpts(
    requestParameters: SimulationsSettingsOutputSettingsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsOutputSettingsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * delete the output settings resource
   */
  async simulationsSettingsOutputSettingsDeleteRaw(
    requestParameters: SimulationsSettingsOutputSettingsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsOutputSettingsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * delete the output settings resource
   */
  async simulationsSettingsOutputSettingsDelete(
    requestParameters: SimulationsSettingsOutputSettingsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsOutputSettingsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsOutputSettingsPartialUpdate without sending the request
   */
  async simulationsSettingsOutputSettingsPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsOutputSettingsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsOutputSettingsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsOutputSettingsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedOutputSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * update the output settings resource
   */
  async simulationsSettingsOutputSettingsPartialUpdateRaw(
    requestParameters: SimulationsSettingsOutputSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsOutputSettingsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * update the output settings resource
   */
  async simulationsSettingsOutputSettingsPartialUpdate(
    requestParameters: SimulationsSettingsOutputSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsOutputSettingsPartialUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsOutputSettingsUpdate without sending the request
   */
  async simulationsSettingsOutputSettingsUpdateRequestOpts(
    requestParameters: SimulationsSettingsOutputSettingsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsOutputSettingsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsOutputSettingsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: OutputSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * update the output settings resource
   */
  async simulationsSettingsOutputSettingsUpdateRaw(
    requestParameters: SimulationsSettingsOutputSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsOutputSettingsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * update the output settings resource
   */
  async simulationsSettingsOutputSettingsUpdate(
    requestParameters: SimulationsSettingsOutputSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsOutputSettingsUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsOverview without sending the request
   */
  async simulationsSettingsOverviewRequestOpts(
    requestParameters: SimulationsSettingsOverviewRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsOverview().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/overview/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Overview of the the simulation settings.
   */
  async simulationsSettingsOverviewRaw(
    requestParameters: SimulationsSettingsOverviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationSettingsOverview>> {
    const requestOptions = await this.simulationsSettingsOverviewRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationSettingsOverviewFromJSON(jsonValue)
    );
  }

  /**
   * Overview of the the simulation settings.
   */
  async simulationsSettingsOverview(
    requestParameters: SimulationsSettingsOverviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationSettingsOverview> {
    const response = await this.simulationsSettingsOverviewRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsPhysicalCreate without sending the request
   */
  async simulationsSettingsPhysicalCreateRequestOpts(
    requestParameters: SimulationsSettingsPhysicalCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsPhysicalCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsPhysicalCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/physical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PhysicalSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a general settings resource.
   */
  async simulationsSettingsPhysicalCreateRaw(
    requestParameters: SimulationsSettingsPhysicalCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsPhysicalCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Create a general settings resource.
   */
  async simulationsSettingsPhysicalCreate(
    requestParameters: SimulationsSettingsPhysicalCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsPhysicalCreateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsPhysicalDelete without sending the request
   */
  async simulationsSettingsPhysicalDeleteRequestOpts(
    requestParameters: SimulationsSettingsPhysicalDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsPhysicalDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/physical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete the general settings resource.
   */
  async simulationsSettingsPhysicalDeleteRaw(
    requestParameters: SimulationsSettingsPhysicalDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsPhysicalDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete the general settings resource.
   */
  async simulationsSettingsPhysicalDelete(
    requestParameters: SimulationsSettingsPhysicalDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsPhysicalDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsPhysicalPartialUpdate without sending the request
   */
  async simulationsSettingsPhysicalPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsPhysicalPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsPhysicalPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsPhysicalPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/physical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedPhysicalSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Update the general settings resource.
   */
  async simulationsSettingsPhysicalPartialUpdateRaw(
    requestParameters: SimulationsSettingsPhysicalPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsPhysicalPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update the general settings resource.
   */
  async simulationsSettingsPhysicalPartialUpdate(
    requestParameters: SimulationsSettingsPhysicalPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsPhysicalPartialUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsPhysicalUpdate without sending the request
   */
  async simulationsSettingsPhysicalUpdateRequestOpts(
    requestParameters: SimulationsSettingsPhysicalUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsPhysicalUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsPhysicalUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/physical/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: PhysicalSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Update the general settings resource.
   */
  async simulationsSettingsPhysicalUpdateRaw(
    requestParameters: SimulationsSettingsPhysicalUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsPhysicalUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update the general settings resource.
   */
  async simulationsSettingsPhysicalUpdate(
    requestParameters: SimulationsSettingsPhysicalUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsPhysicalUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsTimeStepCreate without sending the request
   */
  async simulationsSettingsTimeStepCreateRequestOpts(
    requestParameters: SimulationsSettingsTimeStepCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsTimeStepCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsTimeStepCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/time_step/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TimeStepSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * create a time step settings resource
   */
  async simulationsSettingsTimeStepCreateRaw(
    requestParameters: SimulationsSettingsTimeStepCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsTimeStepCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * create a time step settings resource
   */
  async simulationsSettingsTimeStepCreate(
    requestParameters: SimulationsSettingsTimeStepCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsTimeStepCreateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsTimeStepDelete without sending the request
   */
  async simulationsSettingsTimeStepDeleteRequestOpts(
    requestParameters: SimulationsSettingsTimeStepDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsTimeStepDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/time_step/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * delete the time step settings resource
   */
  async simulationsSettingsTimeStepDeleteRaw(
    requestParameters: SimulationsSettingsTimeStepDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsTimeStepDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * delete the time step settings resource
   */
  async simulationsSettingsTimeStepDelete(
    requestParameters: SimulationsSettingsTimeStepDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsTimeStepDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsTimeStepPartialUpdate without sending the request
   */
  async simulationsSettingsTimeStepPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsTimeStepPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsTimeStepPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsTimeStepPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/time_step/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTimeStepSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * update the time step settings resource
   */
  async simulationsSettingsTimeStepPartialUpdateRaw(
    requestParameters: SimulationsSettingsTimeStepPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsTimeStepPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * update the time step settings resource
   */
  async simulationsSettingsTimeStepPartialUpdate(
    requestParameters: SimulationsSettingsTimeStepPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsTimeStepPartialUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsTimeStepUpdate without sending the request
   */
  async simulationsSettingsTimeStepUpdateRequestOpts(
    requestParameters: SimulationsSettingsTimeStepUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsTimeStepUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsTimeStepUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/time_step/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TimeStepSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * update the time step settings resource
   */
  async simulationsSettingsTimeStepUpdateRaw(
    requestParameters: SimulationsSettingsTimeStepUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsTimeStepUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * update the time step settings resource
   */
  async simulationsSettingsTimeStepUpdate(
    requestParameters: SimulationsSettingsTimeStepUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsTimeStepUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityCreate without sending the request
   */
  async simulationsSettingsWaterQualityCreateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WaterQualitySettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a water quality settings resource.
   */
  async simulationsSettingsWaterQualityCreateRaw(
    requestParameters: SimulationsSettingsWaterQualityCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsWaterQualityCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Create a water quality settings resource.
   */
  async simulationsSettingsWaterQualityCreate(
    requestParameters: SimulationsSettingsWaterQualityCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityCreateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityCustomizedResultAreasCreate without sending the request
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasCreateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_customized_result_areas/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WaterQualityCustomizedResultAreaToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasCreateRaw(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WaterQualityCustomizedResultArea>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityCustomizedResultAreasCreateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WaterQualityCustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasCreate(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WaterQualityCustomizedResultArea> {
    const response = await this.simulationsSettingsWaterQualityCustomizedResultAreasCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityCustomizedResultAreasDelete without sending the request
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasDeleteRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasDeleteRaw(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityCustomizedResultAreasDeleteRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasDelete(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityCustomizedResultAreasDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityCustomizedResultAreasList without sending the request
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasListRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_customized_result_areas/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasListRaw(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedWaterQualityCustomizedResultAreaList>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityCustomizedResultAreasListRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedWaterQualityCustomizedResultAreaListFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasList(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedWaterQualityCustomizedResultAreaList> {
    const response = await this.simulationsSettingsWaterQualityCustomizedResultAreasListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdate without sending the request
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedWaterQualityCustomizedResultAreaToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRaw(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WaterQualityCustomizedResultArea>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WaterQualityCustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdate(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WaterQualityCustomizedResultArea> {
    const response =
      await this.simulationsSettingsWaterQualityCustomizedResultAreasPartialUpdateRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityCustomizedResultAreasRead without sending the request
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasReadRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasReadRaw(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WaterQualityCustomizedResultArea>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityCustomizedResultAreasReadRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WaterQualityCustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasRead(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WaterQualityCustomizedResultArea> {
    const response = await this.simulationsSettingsWaterQualityCustomizedResultAreasReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityCustomizedResultAreasUpdate without sending the request
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasUpdateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityCustomizedResultAreasUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_customized_result_areas/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: WaterQualityCustomizedResultAreaToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasUpdateRaw(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WaterQualityCustomizedResultArea>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityCustomizedResultAreasUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WaterQualityCustomizedResultAreaFromJSON(jsonValue)
    );
  }

  /**
   * Water quality customized result area
   */
  async simulationsSettingsWaterQualityCustomizedResultAreasUpdate(
    requestParameters: SimulationsSettingsWaterQualityCustomizedResultAreasUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WaterQualityCustomizedResultArea> {
    const response = await this.simulationsSettingsWaterQualityCustomizedResultAreasUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityDelete without sending the request
   */
  async simulationsSettingsWaterQualityDeleteRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete the water quality settings resource.
   */
  async simulationsSettingsWaterQualityDeleteRaw(
    requestParameters: SimulationsSettingsWaterQualityDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsWaterQualityDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete the water quality settings resource.
   */
  async simulationsSettingsWaterQualityDelete(
    requestParameters: SimulationsSettingsWaterQualityDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityOutputSettingsCreate without sending the request
   */
  async simulationsSettingsWaterQualityOutputSettingsCreateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityOutputSettingsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityOutputSettingsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WaterQualityOutputSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create a water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsCreateRaw(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityOutputSettingsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Create a water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsCreate(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityOutputSettingsCreateRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityOutputSettingsDelete without sending the request
   */
  async simulationsSettingsWaterQualityOutputSettingsDeleteRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityOutputSettingsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete the water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsDeleteRaw(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityOutputSettingsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete the water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsDelete(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityOutputSettingsDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityOutputSettingsPartialUpdate without sending the request
   */
  async simulationsSettingsWaterQualityOutputSettingsPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityOutputSettingsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityOutputSettingsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedWaterQualityOutputSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Update the water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsPartialUpdateRaw(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityOutputSettingsPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update the water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsPartialUpdate(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityOutputSettingsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityOutputSettingsUpdate without sending the request
   */
  async simulationsSettingsWaterQualityOutputSettingsUpdateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityOutputSettingsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityOutputSettingsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality_output_settings/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: WaterQualityOutputSettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Update the water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsUpdateRaw(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsSettingsWaterQualityOutputSettingsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update the water quality output settings resource.
   */
  async simulationsSettingsWaterQualityOutputSettingsUpdate(
    requestParameters: SimulationsSettingsWaterQualityOutputSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityOutputSettingsUpdateRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityPartialUpdate without sending the request
   */
  async simulationsSettingsWaterQualityPartialUpdateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedWaterQualitySettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Update the water quality settings resource.
   */
  async simulationsSettingsWaterQualityPartialUpdateRaw(
    requestParameters: SimulationsSettingsWaterQualityPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsWaterQualityPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update the water quality settings resource.
   */
  async simulationsSettingsWaterQualityPartialUpdate(
    requestParameters: SimulationsSettingsWaterQualityPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityPartialUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSettingsWaterQualityUpdate without sending the request
   */
  async simulationsSettingsWaterQualityUpdateRequestOpts(
    requestParameters: SimulationsSettingsWaterQualityUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSettingsWaterQualityUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSettingsWaterQualityUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/settings/water_quality/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: WaterQualitySettingsToJSON(requestParameters["data"]),
    };
  }

  /**
   * Update the water quality settings resource.
   */
  async simulationsSettingsWaterQualityUpdateRaw(
    requestParameters: SimulationsSettingsWaterQualityUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSettingsWaterQualityUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update the water quality settings resource.
   */
  async simulationsSettingsWaterQualityUpdate(
    requestParameters: SimulationsSettingsWaterQualityUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSettingsWaterQualityUpdateRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsStatusCreate without sending the request
   */
  async simulationsStatusCreateRequestOpts(
    requestParameters: SimulationsStatusCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsStatusCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SimulationStatusToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusCreateRaw(
    requestParameters: SimulationsStatusCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationStatus>> {
    const requestOptions = await this.simulationsStatusCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationStatusFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusCreate(
    requestParameters: SimulationsStatusCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationStatus> {
    const response = await this.simulationsStatusCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsStatusDelete without sending the request
   */
  async simulationsStatusDeleteRequestOpts(
    requestParameters: SimulationsStatusDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsStatusDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusDeleteRaw(
    requestParameters: SimulationsStatusDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsStatusDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusDelete(
    requestParameters: SimulationsStatusDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsStatusDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsStatusHistoryList without sending the request
   */
  async simulationsStatusHistoryListRequestOpts(
    requestParameters: SimulationsStatusHistoryListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusHistoryList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/history/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsStatusHistoryListRaw(
    requestParameters: SimulationsStatusHistoryListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedSimulationStatusList>> {
    const requestOptions = await this.simulationsStatusHistoryListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedSimulationStatusListFromJSON(jsonValue)
    );
  }

  /**
   */
  async simulationsStatusHistoryList(
    requestParameters: SimulationsStatusHistoryListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedSimulationStatusList> {
    const response = await this.simulationsStatusHistoryListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsStatusHistoryRead without sending the request
   */
  async simulationsStatusHistoryReadRequestOpts(
    requestParameters: SimulationsStatusHistoryReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsStatusHistoryRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusHistoryRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/history/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsStatusHistoryReadRaw(
    requestParameters: SimulationsStatusHistoryReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationStatus>> {
    const requestOptions = await this.simulationsStatusHistoryReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationStatusFromJSON(jsonValue)
    );
  }

  /**
   */
  async simulationsStatusHistoryRead(
    requestParameters: SimulationsStatusHistoryReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationStatus> {
    const response = await this.simulationsStatusHistoryReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsStatusList without sending the request
   */
  async simulationsStatusListRequestOpts(
    requestParameters: SimulationsStatusListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusListRaw(
    requestParameters: SimulationsStatusListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CurrentStatus>> {
    const requestOptions = await this.simulationsStatusListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CurrentStatusFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusList(
    requestParameters: SimulationsStatusListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CurrentStatus> {
    const response = await this.simulationsStatusListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsStatusPartialUpdate without sending the request
   */
  async simulationsStatusPartialUpdateRequestOpts(
    requestParameters: SimulationsStatusPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsStatusPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsStatusPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedSimulationStatusToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusPartialUpdateRaw(
    requestParameters: SimulationsStatusPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationStatus>> {
    const requestOptions = await this.simulationsStatusPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationStatusFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusPartialUpdate(
    requestParameters: SimulationsStatusPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationStatus> {
    const response = await this.simulationsStatusPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsStatusPatch without sending the request
   */
  async simulationsStatusPatchRequestOpts(
    requestParameters: SimulationsStatusPatchRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusPatch().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsStatusPatch().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/patch/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedSimulationStatusToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusPatchRaw(
    requestParameters: SimulationsStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationStatus>> {
    const requestOptions = await this.simulationsStatusPatchRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationStatusFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusPatch(
    requestParameters: SimulationsStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationStatus> {
    const response = await this.simulationsStatusPatchRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsStatusUpdate without sending the request
   */
  async simulationsStatusUpdateRequestOpts(
    requestParameters: SimulationsStatusUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsStatusUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsStatusUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsStatusUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/status/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SimulationStatusToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusUpdateRaw(
    requestParameters: SimulationsStatusUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationStatus>> {
    const requestOptions = await this.simulationsStatusUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationStatusFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing simulations
   */
  async simulationsStatusUpdate(
    requestParameters: SimulationsStatusUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationStatus> {
    const response = await this.simulationsStatusUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsUpdate without sending the request
   */
  async simulationsUpdateRequestOpts(
    requestParameters: SimulationsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SimulationUpdateToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async simulationsUpdateRaw(
    requestParameters: SimulationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationUpdate>> {
    const requestOptions = await this.simulationsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationUpdateFromJSON(jsonValue)
    );
  }

  /**
   */
  async simulationsUpdate(
    requestParameters: SimulationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationUpdate> {
    const response = await this.simulationsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsBreachGraphCreate without sending the request
   */
  async simulationsVisualisationsBreachGraphCreateRequestOpts(
    requestParameters: SimulationsVisualisationsBreachGraphCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsBreachGraphCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsVisualisationsBreachGraphCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/breach_graph/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BreachGraphRequestToJSON(requestParameters["data"]),
    };
  }

  /**
   * Get a websocket URL returning breaches (graph) data  The websocket-url in the response returns binary data messages consisting of timestamp, breach_width, breach_depth, q (discharge), au (wet cross-sectional area) as float32 data.  The values are alternated like: [timestamp, breach_width, breach_depth, q, au ...  timestamp_N, breach_width_N, breach_depth_N, q_N, au_N]
   */
  async simulationsVisualisationsBreachGraphCreateRaw(
    requestParameters: SimulationsVisualisationsBreachGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BreachGraph>> {
    const requestOptions = await this.simulationsVisualisationsBreachGraphCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BreachGraphFromJSON(jsonValue));
  }

  /**
   * Get a websocket URL returning breaches (graph) data  The websocket-url in the response returns binary data messages consisting of timestamp, breach_width, breach_depth, q (discharge), au (wet cross-sectional area) as float32 data.  The values are alternated like: [timestamp, breach_width, breach_depth, q, au ...  timestamp_N, breach_width_N, breach_depth_N, q_N, au_N]
   */
  async simulationsVisualisationsBreachGraphCreate(
    requestParameters: SimulationsVisualisationsBreachGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BreachGraph> {
    const response = await this.simulationsVisualisationsBreachGraphCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsProfileList without sending the request
   */
  async simulationsVisualisationsProfileListRequestOpts(
    requestParameters: SimulationsVisualisationsProfileListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["layer"] == null) {
      throw new runtime.RequiredError(
        "layer",
        'Required parameter "layer" was null or undefined when calling simulationsVisualisationsProfileList().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsProfileList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/{layer}/profile/`;
    urlPath = urlPath.replace("{layer}", encodeURIComponent(String(requestParameters["layer"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsVisualisationsProfileListRaw(
    requestParameters: SimulationsVisualisationsProfileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Profile>> {
    const requestOptions = await this.simulationsVisualisationsProfileListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
  }

  /**
   */
  async simulationsVisualisationsProfileList(
    requestParameters: SimulationsVisualisationsProfileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Profile> {
    const response = await this.simulationsVisualisationsProfileListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsPumpDischargeGraphCreate without sending the request
   */
  async simulationsVisualisationsPumpDischargeGraphCreateRequestOpts(
    requestParameters: SimulationsVisualisationsPumpDischargeGraphCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsPumpDischargeGraphCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsVisualisationsPumpDischargeGraphCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/pump_discharge_graph/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PumpDischargeGraphRequestToJSON(requestParameters["data"]),
    };
  }

  /**
   * Get a websocket URL returning pump discharge (graph) data  The websocket-url in the response returns binary data messages consisting of timestamp, q_pump (discharge) float32 data. The values are alternated like: [timestamp, q_pump, timestamp_2, q_pump_2... timestamp_N, q_pump_N]
   */
  async simulationsVisualisationsPumpDischargeGraphCreateRaw(
    requestParameters: SimulationsVisualisationsPumpDischargeGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PumpDischargeGraph>> {
    const requestOptions = await this.simulationsVisualisationsPumpDischargeGraphCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PumpDischargeGraphFromJSON(jsonValue)
    );
  }

  /**
   * Get a websocket URL returning pump discharge (graph) data  The websocket-url in the response returns binary data messages consisting of timestamp, q_pump (discharge) float32 data. The values are alternated like: [timestamp, q_pump, timestamp_2, q_pump_2... timestamp_N, q_pump_N]
   */
  async simulationsVisualisationsPumpDischargeGraphCreate(
    requestParameters: SimulationsVisualisationsPumpDischargeGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PumpDischargeGraph> {
    const response = await this.simulationsVisualisationsPumpDischargeGraphCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsRainGraphCreate without sending the request
   */
  async simulationsVisualisationsRainGraphCreateRequestOpts(
    requestParameters: SimulationsVisualisationsRainGraphCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsRainGraphCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsVisualisationsRainGraphCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/rain_graph/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RainGraphRequestToJSON(requestParameters["data"]),
    };
  }

  /**
   * Get a websocket URL returning node rain (graph) data.  The websocket-url in the response returns binary data messages consisting of timestamp and rain float32 data. The values are alternated like: [timestamp, rain, timestamp_2, rain_2... timestamp_N, rain_N]
   */
  async simulationsVisualisationsRainGraphCreateRaw(
    requestParameters: SimulationsVisualisationsRainGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RainGraph>> {
    const requestOptions = await this.simulationsVisualisationsRainGraphCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RainGraphFromJSON(jsonValue));
  }

  /**
   * Get a websocket URL returning node rain (graph) data.  The websocket-url in the response returns binary data messages consisting of timestamp and rain float32 data. The values are alternated like: [timestamp, rain, timestamp_2, rain_2... timestamp_N, rain_N]
   */
  async simulationsVisualisationsRainGraphCreate(
    requestParameters: SimulationsVisualisationsRainGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RainGraph> {
    const response = await this.simulationsVisualisationsRainGraphCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsTmsList without sending the request
   */
  async simulationsVisualisationsTmsListRequestOpts(
    requestParameters: SimulationsVisualisationsTmsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["layer"] == null) {
      throw new runtime.RequiredError(
        "layer",
        'Required parameter "layer" was null or undefined when calling simulationsVisualisationsTmsList().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsTmsList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/{layer}/tms/`;
    urlPath = urlPath.replace("{layer}", encodeURIComponent(String(requestParameters["layer"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsVisualisationsTmsListRaw(
    requestParameters: SimulationsVisualisationsTmsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TMS>> {
    const requestOptions = await this.simulationsVisualisationsTmsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TMSFromJSON(jsonValue));
  }

  /**
   */
  async simulationsVisualisationsTmsList(
    requestParameters: SimulationsVisualisationsTmsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TMS> {
    const response = await this.simulationsVisualisationsTmsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsWaterFlowGraphCreate without sending the request
   */
  async simulationsVisualisationsWaterFlowGraphCreateRequestOpts(
    requestParameters: SimulationsVisualisationsWaterFlowGraphCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsWaterFlowGraphCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsVisualisationsWaterFlowGraphCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/water_flow_graph/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WaterFlowGraphRequestToJSON(requestParameters["data"]),
    };
  }

  /**
   * Get a websocket URL returning line flow (graph) data.  The websocket-url in the response returns binary data messages consisting of timestamp, u1 (velocity), q (discharge) float32 data. The values are alternated like: [timestamp, u1, q, timestamp_2, u1_2, q_2... timestamp_N, u1_N, q_N]
   */
  async simulationsVisualisationsWaterFlowGraphCreateRaw(
    requestParameters: SimulationsVisualisationsWaterFlowGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WaterGraph>> {
    const requestOptions = await this.simulationsVisualisationsWaterFlowGraphCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => WaterGraphFromJSON(jsonValue));
  }

  /**
   * Get a websocket URL returning line flow (graph) data.  The websocket-url in the response returns binary data messages consisting of timestamp, u1 (velocity), q (discharge) float32 data. The values are alternated like: [timestamp, u1, q, timestamp_2, u1_2, q_2... timestamp_N, u1_N, q_N]
   */
  async simulationsVisualisationsWaterFlowGraphCreate(
    requestParameters: SimulationsVisualisationsWaterFlowGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WaterGraph> {
    const response = await this.simulationsVisualisationsWaterFlowGraphCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsWaterLevelGraphCreate without sending the request
   */
  async simulationsVisualisationsWaterLevelGraphCreateRequestOpts(
    requestParameters: SimulationsVisualisationsWaterLevelGraphCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsWaterLevelGraphCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsVisualisationsWaterLevelGraphCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/water_level_graph/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WaterLevelGraphRequestToJSON(requestParameters["data"]),
    };
  }

  /**
   * Get a websocket URL returning node waterlevel (graph) data.  The websocket-url in the response returns binary data messages consisting of timestamp and waterlevel float32 data. The values are alternated like: [timestamp, s1, timestamp_2, s1_2... timestamp_N, s1_N]
   */
  async simulationsVisualisationsWaterLevelGraphCreateRaw(
    requestParameters: SimulationsVisualisationsWaterLevelGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WaterGraph>> {
    const requestOptions = await this.simulationsVisualisationsWaterLevelGraphCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => WaterGraphFromJSON(jsonValue));
  }

  /**
   * Get a websocket URL returning node waterlevel (graph) data.  The websocket-url in the response returns binary data messages consisting of timestamp and waterlevel float32 data. The values are alternated like: [timestamp, s1, timestamp_2, s1_2... timestamp_N, s1_N]
   */
  async simulationsVisualisationsWaterLevelGraphCreate(
    requestParameters: SimulationsVisualisationsWaterLevelGraphCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WaterGraph> {
    const response = await this.simulationsVisualisationsWaterLevelGraphCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsWaterLevelProfileCreate without sending the request
   */
  async simulationsVisualisationsWaterLevelProfileCreateRequestOpts(
    requestParameters: SimulationsVisualisationsWaterLevelProfileCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsWaterLevelProfileCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsVisualisationsWaterLevelProfileCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/water_level_profile/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: WaterLevelProfileRequestToJSON(requestParameters["data"]),
    };
  }

  /**
   * Get a websocket URL returning waterlevel profile data.  The websocket returns binary data messages consisting of timestep and waterlevel float32 values in one message like: timestep, waterlevel, waterlevel, waterlevel, waterlevel  Groundwater waterlevel values are automatically added (after open water) if groundwater is present. The returned waterlevel values have length \'points_limit\' * 2 in this case.
   */
  async simulationsVisualisationsWaterLevelProfileCreateRaw(
    requestParameters: SimulationsVisualisationsWaterLevelProfileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WaterLevelProfile>> {
    const requestOptions = await this.simulationsVisualisationsWaterLevelProfileCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WaterLevelProfileFromJSON(jsonValue)
    );
  }

  /**
   * Get a websocket URL returning waterlevel profile data.  The websocket returns binary data messages consisting of timestep and waterlevel float32 values in one message like: timestep, waterlevel, waterlevel, waterlevel, waterlevel  Groundwater waterlevel values are automatically added (after open water) if groundwater is present. The returned waterlevel values have length \'points_limit\' * 2 in this case.
   */
  async simulationsVisualisationsWaterLevelProfileCreate(
    requestParameters: SimulationsVisualisationsWaterLevelProfileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WaterLevelProfile> {
    const response = await this.simulationsVisualisationsWaterLevelProfileCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsVisualisationsWaterdepthList without sending the request
   */
  async simulationsVisualisationsWaterdepthListRequestOpts(
    requestParameters: SimulationsVisualisationsWaterdepthListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsVisualisationsWaterdepthList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/visualisations/waterdepth/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async simulationsVisualisationsWaterdepthListRaw(
    requestParameters: SimulationsVisualisationsWaterdepthListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Waterdepth>> {
    const requestOptions = await this.simulationsVisualisationsWaterdepthListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => WaterdepthFromJSON(jsonValue));
  }

  /**
   */
  async simulationsVisualisationsWaterdepthList(
    requestParameters: SimulationsVisualisationsWaterdepthListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Waterdepth> {
    const response = await this.simulationsVisualisationsWaterdepthListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsWebsocketsList without sending the request
   */
  async simulationsWebsocketsListRequestOpts(
    requestParameters: SimulationsWebsocketsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsWebsocketsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/simulations/{simulation_pk}/websockets/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * List active websocket connections for a given simulation
   */
  async simulationsWebsocketsListRaw(
    requestParameters: SimulationsWebsocketsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedSimulationChannelList>> {
    const requestOptions = await this.simulationsWebsocketsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedSimulationChannelListFromJSON(jsonValue)
    );
  }

  /**
   * List active websocket connections for a given simulation
   */
  async simulationsWebsocketsList(
    requestParameters: SimulationsWebsocketsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedSimulationChannelList> {
    const response = await this.simulationsWebsocketsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for statusesList without sending the request
   */
  async statusesListRequestOpts(
    requestParameters: StatusesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["created"] != null) {
      queryParameters["created"] = runtime.serializeDateTime(requestParameters["created"] as any);
    }

    if (requestParameters["createdDate"] != null) {
      queryParameters["created__date"] = runtime.serializeDate(
        requestParameters["createdDate"] as any
      );
    }

    if (requestParameters["createdDateGt"] != null) {
      queryParameters["created__date__gt"] = runtime.serializeDate(
        requestParameters["createdDateGt"] as any
      );
    }

    if (requestParameters["createdDateGte"] != null) {
      queryParameters["created__date__gte"] = runtime.serializeDate(
        requestParameters["createdDateGte"] as any
      );
    }

    if (requestParameters["createdDateLt"] != null) {
      queryParameters["created__date__lt"] = runtime.serializeDate(
        requestParameters["createdDateLt"] as any
      );
    }

    if (requestParameters["createdDateLte"] != null) {
      queryParameters["created__date__lte"] = runtime.serializeDate(
        requestParameters["createdDateLte"] as any
      );
    }

    if (requestParameters["createdDay"] != null) {
      queryParameters["created__day"] = requestParameters["createdDay"];
    }

    if (requestParameters["createdDayLt"] != null) {
      queryParameters["created__day__lt"] = requestParameters["createdDayLt"];
    }

    if (requestParameters["createdGt"] != null) {
      queryParameters["created__gt"] = runtime.serializeDateTime(
        requestParameters["createdGt"] as any
      );
    }

    if (requestParameters["createdGte"] != null) {
      queryParameters["created__gte"] = runtime.serializeDateTime(
        requestParameters["createdGte"] as any
      );
    }

    if (requestParameters["createdLt"] != null) {
      queryParameters["created__lt"] = runtime.serializeDateTime(
        requestParameters["createdLt"] as any
      );
    }

    if (requestParameters["createdLte"] != null) {
      queryParameters["created__lte"] = runtime.serializeDateTime(
        requestParameters["createdLte"] as any
      );
    }

    if (requestParameters["createdMonth"] != null) {
      queryParameters["created__month"] = requestParameters["createdMonth"];
    }

    if (requestParameters["createdMonthLte"] != null) {
      queryParameters["created__month__lte"] = requestParameters["createdMonthLte"];
    }

    if (requestParameters["createdWeek"] != null) {
      queryParameters["created__week"] = requestParameters["createdWeek"];
    }

    if (requestParameters["createdWeekDay"] != null) {
      queryParameters["created__week_day"] = requestParameters["createdWeekDay"];
    }

    if (requestParameters["createdYear"] != null) {
      queryParameters["created__year"] = requestParameters["createdYear"];
    }

    if (requestParameters["createdYearGt"] != null) {
      queryParameters["created__year__gt"] = requestParameters["createdYearGt"];
    }

    if (requestParameters["createdYearGte"] != null) {
      queryParameters["created__year__gte"] = requestParameters["createdYearGte"];
    }

    if (requestParameters["createdYearLt"] != null) {
      queryParameters["created__year__lt"] = requestParameters["createdYearLt"];
    }

    if (requestParameters["createdYearLte"] != null) {
      queryParameters["created__year__lte"] = requestParameters["createdYearLte"];
    }

    if (requestParameters["exitCode"] != null) {
      queryParameters["exit_code"] = requestParameters["exitCode"];
    }

    if (requestParameters["exitCodeGt"] != null) {
      queryParameters["exit_code__gt"] = requestParameters["exitCodeGt"];
    }

    if (requestParameters["exitCodeGte"] != null) {
      queryParameters["exit_code__gte"] = requestParameters["exitCodeGte"];
    }

    if (requestParameters["exitCodeIsnull"] != null) {
      queryParameters["exit_code__isnull"] = requestParameters["exitCodeIsnull"];
    }

    if (requestParameters["exitCodeLt"] != null) {
      queryParameters["exit_code__lt"] = requestParameters["exitCodeLt"];
    }

    if (requestParameters["exitCodeLte"] != null) {
      queryParameters["exit_code__lte"] = requestParameters["exitCodeLte"];
    }

    if (requestParameters["id"] != null) {
      queryParameters["id"] = requestParameters["id"];
    }

    if (requestParameters["idGt"] != null) {
      queryParameters["id__gt"] = requestParameters["idGt"];
    }

    if (requestParameters["idGte"] != null) {
      queryParameters["id__gte"] = requestParameters["idGte"];
    }

    if (requestParameters["idIsnull"] != null) {
      queryParameters["id__isnull"] = requestParameters["idIsnull"];
    }

    if (requestParameters["idLt"] != null) {
      queryParameters["id__lt"] = requestParameters["idLt"];
    }

    if (requestParameters["idLte"] != null) {
      queryParameters["id__lte"] = requestParameters["idLte"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["simulationComputeClusterName"] != null) {
      queryParameters["simulation__compute_cluster__name"] =
        requestParameters["simulationComputeClusterName"];
    }

    if (requestParameters["simulationName"] != null) {
      queryParameters["simulation__name"] = requestParameters["simulationName"];
    }

    if (requestParameters["simulationNameContains"] != null) {
      queryParameters["simulation__name__contains"] = requestParameters["simulationNameContains"];
    }

    if (requestParameters["simulationNameEndswith"] != null) {
      queryParameters["simulation__name__endswith"] = requestParameters["simulationNameEndswith"];
    }

    if (requestParameters["simulationNameIcontains"] != null) {
      queryParameters["simulation__name__icontains"] = requestParameters["simulationNameIcontains"];
    }

    if (requestParameters["simulationNameIexact"] != null) {
      queryParameters["simulation__name__iexact"] = requestParameters["simulationNameIexact"];
    }

    if (requestParameters["simulationNameIn"] != null) {
      queryParameters["simulation__name__in"] = requestParameters["simulationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["simulationNameIstartswith"] != null) {
      queryParameters["simulation__name__istartswith"] =
        requestParameters["simulationNameIstartswith"];
    }

    if (requestParameters["simulationNameRegex"] != null) {
      queryParameters["simulation__name__regex"] = requestParameters["simulationNameRegex"];
    }

    if (requestParameters["simulationNameStartswith"] != null) {
      queryParameters["simulation__name__startswith"] =
        requestParameters["simulationNameStartswith"];
    }

    if (requestParameters["simulationOrganisationNameIstartswith"] != null) {
      queryParameters["simulation__organisation__name__istartswith"] =
        requestParameters["simulationOrganisationNameIstartswith"];
    }

    if (requestParameters["simulationOrganisationUniqueId"] != null) {
      queryParameters["simulation__organisation__unique_id"] =
        requestParameters["simulationOrganisationUniqueId"];
    }

    if (requestParameters["simulationTagsContains"] != null) {
      queryParameters["simulation__tags__contains"] = requestParameters["simulationTagsContains"];
    }

    if (requestParameters["simulationThreedimodelSlug"] != null) {
      queryParameters["simulation__threedimodel__slug"] =
        requestParameters["simulationThreedimodelSlug"];
    }

    if (requestParameters["simulationThreedimodelSlugContains"] != null) {
      queryParameters["simulation__threedimodel__slug__contains"] =
        requestParameters["simulationThreedimodelSlugContains"];
    }

    if (requestParameters["simulationThreedimodelSlugEndswith"] != null) {
      queryParameters["simulation__threedimodel__slug__endswith"] =
        requestParameters["simulationThreedimodelSlugEndswith"];
    }

    if (requestParameters["simulationThreedimodelSlugIcontains"] != null) {
      queryParameters["simulation__threedimodel__slug__icontains"] =
        requestParameters["simulationThreedimodelSlugIcontains"];
    }

    if (requestParameters["simulationThreedimodelSlugIexact"] != null) {
      queryParameters["simulation__threedimodel__slug__iexact"] =
        requestParameters["simulationThreedimodelSlugIexact"];
    }

    if (requestParameters["simulationThreedimodelSlugIn"] != null) {
      queryParameters["simulation__threedimodel__slug__in"] = requestParameters[
        "simulationThreedimodelSlugIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["simulationThreedimodelSlugIstartswith"] != null) {
      queryParameters["simulation__threedimodel__slug__istartswith"] =
        requestParameters["simulationThreedimodelSlugIstartswith"];
    }

    if (requestParameters["simulationThreedimodelSlugRegex"] != null) {
      queryParameters["simulation__threedimodel__slug__regex"] =
        requestParameters["simulationThreedimodelSlugRegex"];
    }

    if (requestParameters["simulationThreedimodelSlugStartswith"] != null) {
      queryParameters["simulation__threedimodel__slug__startswith"] =
        requestParameters["simulationThreedimodelSlugStartswith"];
    }

    if (requestParameters["simulationTypeLive"] != null) {
      queryParameters["simulation__type__live"] = requestParameters["simulationTypeLive"];
    }

    if (requestParameters["simulationUserUsername"] != null) {
      queryParameters["simulation__user__username"] = requestParameters["simulationUserUsername"];
    }

    if (requestParameters["simulationIdIn"] != null) {
      queryParameters["simulation_id__in"] = requestParameters["simulationIdIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/statuses/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Show the latest status off all simulations.  List all simulations that ever have finished successfully  ``` ?name=finished ```  List all simulations that have finished successfully during the week of the 1988 UEFA European Football Championship ``` ?name=finished&created__date__gte=1988-06-10&created__date__lte=1988-06-25 ```  The `created` field is of type date-time in ISO 8601 (UTC) format. To get all crashed simulations since St Nicolas 2018  ``` ?name=crashed&created__gte=2018-12-05T00:00:00Z ```   Note: `Expiry` and `has_results` is only valid for `finished` and `crashed` statuses.
   */
  async statusesListRaw(
    requestParameters: StatusesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedSimulationStatusList>> {
    const requestOptions = await this.statusesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedSimulationStatusListFromJSON(jsonValue)
    );
  }

  /**
   * Show the latest status off all simulations.  List all simulations that ever have finished successfully  ``` ?name=finished ```  List all simulations that have finished successfully during the week of the 1988 UEFA European Football Championship ``` ?name=finished&created__date__gte=1988-06-10&created__date__lte=1988-06-25 ```  The `created` field is of type date-time in ISO 8601 (UTC) format. To get all crashed simulations since St Nicolas 2018  ``` ?name=crashed&created__gte=2018-12-05T00:00:00Z ```   Note: `Expiry` and `has_results` is only valid for `finished` and `crashed` statuses.
   */
  async statusesList(
    requestParameters: StatusesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedSimulationStatusList> {
    const response = await this.statusesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for statusesRead without sending the request
   */
  async statusesReadRequestOpts(
    requestParameters: StatusesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling statusesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/statuses/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async statusesReadRaw(
    requestParameters: StatusesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SimulationStatus>> {
    const requestOptions = await this.statusesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SimulationStatusFromJSON(jsonValue)
    );
  }

  /**
   */
  async statusesRead(
    requestParameters: StatusesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SimulationStatus> {
    const response = await this.statusesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for statusesStatistics without sending the request
   */
  async statusesStatisticsRequestOpts(
    requestParameters: StatusesStatisticsRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["created"] != null) {
      queryParameters["created"] = runtime.serializeDateTime(requestParameters["created"] as any);
    }

    if (requestParameters["createdDate"] != null) {
      queryParameters["created__date"] = runtime.serializeDate(
        requestParameters["createdDate"] as any
      );
    }

    if (requestParameters["createdDateGt"] != null) {
      queryParameters["created__date__gt"] = runtime.serializeDate(
        requestParameters["createdDateGt"] as any
      );
    }

    if (requestParameters["createdDateGte"] != null) {
      queryParameters["created__date__gte"] = runtime.serializeDate(
        requestParameters["createdDateGte"] as any
      );
    }

    if (requestParameters["createdDateLt"] != null) {
      queryParameters["created__date__lt"] = runtime.serializeDate(
        requestParameters["createdDateLt"] as any
      );
    }

    if (requestParameters["createdDateLte"] != null) {
      queryParameters["created__date__lte"] = runtime.serializeDate(
        requestParameters["createdDateLte"] as any
      );
    }

    if (requestParameters["createdDay"] != null) {
      queryParameters["created__day"] = requestParameters["createdDay"];
    }

    if (requestParameters["createdDayLt"] != null) {
      queryParameters["created__day__lt"] = requestParameters["createdDayLt"];
    }

    if (requestParameters["createdGt"] != null) {
      queryParameters["created__gt"] = runtime.serializeDateTime(
        requestParameters["createdGt"] as any
      );
    }

    if (requestParameters["createdGte"] != null) {
      queryParameters["created__gte"] = runtime.serializeDateTime(
        requestParameters["createdGte"] as any
      );
    }

    if (requestParameters["createdLt"] != null) {
      queryParameters["created__lt"] = runtime.serializeDateTime(
        requestParameters["createdLt"] as any
      );
    }

    if (requestParameters["createdLte"] != null) {
      queryParameters["created__lte"] = runtime.serializeDateTime(
        requestParameters["createdLte"] as any
      );
    }

    if (requestParameters["createdMonth"] != null) {
      queryParameters["created__month"] = requestParameters["createdMonth"];
    }

    if (requestParameters["createdMonthLte"] != null) {
      queryParameters["created__month__lte"] = requestParameters["createdMonthLte"];
    }

    if (requestParameters["createdWeek"] != null) {
      queryParameters["created__week"] = requestParameters["createdWeek"];
    }

    if (requestParameters["createdWeekDay"] != null) {
      queryParameters["created__week_day"] = requestParameters["createdWeekDay"];
    }

    if (requestParameters["createdYear"] != null) {
      queryParameters["created__year"] = requestParameters["createdYear"];
    }

    if (requestParameters["createdYearGt"] != null) {
      queryParameters["created__year__gt"] = requestParameters["createdYearGt"];
    }

    if (requestParameters["createdYearGte"] != null) {
      queryParameters["created__year__gte"] = requestParameters["createdYearGte"];
    }

    if (requestParameters["createdYearLt"] != null) {
      queryParameters["created__year__lt"] = requestParameters["createdYearLt"];
    }

    if (requestParameters["createdYearLte"] != null) {
      queryParameters["created__year__lte"] = requestParameters["createdYearLte"];
    }

    if (requestParameters["exitCode"] != null) {
      queryParameters["exit_code"] = requestParameters["exitCode"];
    }

    if (requestParameters["exitCodeGt"] != null) {
      queryParameters["exit_code__gt"] = requestParameters["exitCodeGt"];
    }

    if (requestParameters["exitCodeGte"] != null) {
      queryParameters["exit_code__gte"] = requestParameters["exitCodeGte"];
    }

    if (requestParameters["exitCodeIsnull"] != null) {
      queryParameters["exit_code__isnull"] = requestParameters["exitCodeIsnull"];
    }

    if (requestParameters["exitCodeLt"] != null) {
      queryParameters["exit_code__lt"] = requestParameters["exitCodeLt"];
    }

    if (requestParameters["exitCodeLte"] != null) {
      queryParameters["exit_code__lte"] = requestParameters["exitCodeLte"];
    }

    if (requestParameters["id"] != null) {
      queryParameters["id"] = requestParameters["id"];
    }

    if (requestParameters["idGt"] != null) {
      queryParameters["id__gt"] = requestParameters["idGt"];
    }

    if (requestParameters["idGte"] != null) {
      queryParameters["id__gte"] = requestParameters["idGte"];
    }

    if (requestParameters["idIsnull"] != null) {
      queryParameters["id__isnull"] = requestParameters["idIsnull"];
    }

    if (requestParameters["idLt"] != null) {
      queryParameters["id__lt"] = requestParameters["idLt"];
    }

    if (requestParameters["idLte"] != null) {
      queryParameters["id__lte"] = requestParameters["idLte"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["simulationComputeClusterName"] != null) {
      queryParameters["simulation__compute_cluster__name"] =
        requestParameters["simulationComputeClusterName"];
    }

    if (requestParameters["simulationName"] != null) {
      queryParameters["simulation__name"] = requestParameters["simulationName"];
    }

    if (requestParameters["simulationNameContains"] != null) {
      queryParameters["simulation__name__contains"] = requestParameters["simulationNameContains"];
    }

    if (requestParameters["simulationNameEndswith"] != null) {
      queryParameters["simulation__name__endswith"] = requestParameters["simulationNameEndswith"];
    }

    if (requestParameters["simulationNameIcontains"] != null) {
      queryParameters["simulation__name__icontains"] = requestParameters["simulationNameIcontains"];
    }

    if (requestParameters["simulationNameIexact"] != null) {
      queryParameters["simulation__name__iexact"] = requestParameters["simulationNameIexact"];
    }

    if (requestParameters["simulationNameIn"] != null) {
      queryParameters["simulation__name__in"] = requestParameters["simulationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["simulationNameIstartswith"] != null) {
      queryParameters["simulation__name__istartswith"] =
        requestParameters["simulationNameIstartswith"];
    }

    if (requestParameters["simulationNameRegex"] != null) {
      queryParameters["simulation__name__regex"] = requestParameters["simulationNameRegex"];
    }

    if (requestParameters["simulationNameStartswith"] != null) {
      queryParameters["simulation__name__startswith"] =
        requestParameters["simulationNameStartswith"];
    }

    if (requestParameters["simulationOrganisationNameIstartswith"] != null) {
      queryParameters["simulation__organisation__name__istartswith"] =
        requestParameters["simulationOrganisationNameIstartswith"];
    }

    if (requestParameters["simulationOrganisationUniqueId"] != null) {
      queryParameters["simulation__organisation__unique_id"] =
        requestParameters["simulationOrganisationUniqueId"];
    }

    if (requestParameters["simulationTagsContains"] != null) {
      queryParameters["simulation__tags__contains"] = requestParameters["simulationTagsContains"];
    }

    if (requestParameters["simulationThreedimodelSlug"] != null) {
      queryParameters["simulation__threedimodel__slug"] =
        requestParameters["simulationThreedimodelSlug"];
    }

    if (requestParameters["simulationThreedimodelSlugContains"] != null) {
      queryParameters["simulation__threedimodel__slug__contains"] =
        requestParameters["simulationThreedimodelSlugContains"];
    }

    if (requestParameters["simulationThreedimodelSlugEndswith"] != null) {
      queryParameters["simulation__threedimodel__slug__endswith"] =
        requestParameters["simulationThreedimodelSlugEndswith"];
    }

    if (requestParameters["simulationThreedimodelSlugIcontains"] != null) {
      queryParameters["simulation__threedimodel__slug__icontains"] =
        requestParameters["simulationThreedimodelSlugIcontains"];
    }

    if (requestParameters["simulationThreedimodelSlugIexact"] != null) {
      queryParameters["simulation__threedimodel__slug__iexact"] =
        requestParameters["simulationThreedimodelSlugIexact"];
    }

    if (requestParameters["simulationThreedimodelSlugIn"] != null) {
      queryParameters["simulation__threedimodel__slug__in"] = requestParameters[
        "simulationThreedimodelSlugIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["simulationThreedimodelSlugIstartswith"] != null) {
      queryParameters["simulation__threedimodel__slug__istartswith"] =
        requestParameters["simulationThreedimodelSlugIstartswith"];
    }

    if (requestParameters["simulationThreedimodelSlugRegex"] != null) {
      queryParameters["simulation__threedimodel__slug__regex"] =
        requestParameters["simulationThreedimodelSlugRegex"];
    }

    if (requestParameters["simulationThreedimodelSlugStartswith"] != null) {
      queryParameters["simulation__threedimodel__slug__startswith"] =
        requestParameters["simulationThreedimodelSlugStartswith"];
    }

    if (requestParameters["simulationTypeLive"] != null) {
      queryParameters["simulation__type__live"] = requestParameters["simulationTypeLive"];
    }

    if (requestParameters["simulationUserUsername"] != null) {
      queryParameters["simulation__user__username"] = requestParameters["simulationUserUsername"];
    }

    if (requestParameters["simulationIdIn"] != null) {
      queryParameters["simulation_id__in"] = requestParameters["simulationIdIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/statuses/statistics/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Count of (latest/final) simulation statuses. Combine with filters to get your weekly/monthly etc statistics  For example, to get a count of finished simulations in 2020  ``` ?name=finished&created__year=2020
   */
  async statusesStatisticsRaw(
    requestParameters: StatusesStatisticsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<SimulationStatusStatistics>>> {
    const requestOptions = await this.statusesStatisticsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SimulationStatusStatisticsFromJSON)
    );
  }

  /**
   * Count of (latest/final) simulation statuses. Combine with filters to get your weekly/monthly etc statistics  For example, to get a count of finished simulations in 2020  ``` ?name=finished&created__year=2020
   */
  async statusesStatistics(
    requestParameters: StatusesStatisticsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<SimulationStatusStatistics>> {
    const response = await this.statusesStatisticsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsBoundaryconditionsCreate without sending the request
   */
  async threedimodelsBoundaryconditionsCreateRequestOpts(
    requestParameters: ThreedimodelsBoundaryconditionsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsBoundaryconditionsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsBoundaryconditionsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/boundaryconditions/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BoundaryConditionToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsCreateRaw(
    requestParameters: ThreedimodelsBoundaryconditionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BoundaryCondition>> {
    const requestOptions = await this.threedimodelsBoundaryconditionsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BoundaryConditionFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsCreate(
    requestParameters: ThreedimodelsBoundaryconditionsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BoundaryCondition> {
    const response = await this.threedimodelsBoundaryconditionsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsBoundaryconditionsDelete without sending the request
   */
  async threedimodelsBoundaryconditionsDeleteRequestOpts(
    requestParameters: ThreedimodelsBoundaryconditionsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsBoundaryconditionsDelete().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsBoundaryconditionsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/boundaryconditions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsDeleteRaw(
    requestParameters: ThreedimodelsBoundaryconditionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsBoundaryconditionsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsDelete(
    requestParameters: ThreedimodelsBoundaryconditionsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsBoundaryconditionsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsBoundaryconditionsList without sending the request
   */
  async threedimodelsBoundaryconditionsListRequestOpts(
    requestParameters: ThreedimodelsBoundaryconditionsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsBoundaryconditionsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/boundaryconditions/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsListRaw(
    requestParameters: ThreedimodelsBoundaryconditionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedBoundaryConditionList>> {
    const requestOptions = await this.threedimodelsBoundaryconditionsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedBoundaryConditionListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsList(
    requestParameters: ThreedimodelsBoundaryconditionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedBoundaryConditionList> {
    const response = await this.threedimodelsBoundaryconditionsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsBoundaryconditionsPartialUpdate without sending the request
   */
  async threedimodelsBoundaryconditionsPartialUpdateRequestOpts(
    requestParameters: ThreedimodelsBoundaryconditionsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsBoundaryconditionsPartialUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsBoundaryconditionsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsBoundaryconditionsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/boundaryconditions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedBoundaryConditionToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsPartialUpdateRaw(
    requestParameters: ThreedimodelsBoundaryconditionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BoundaryCondition>> {
    const requestOptions = await this.threedimodelsBoundaryconditionsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BoundaryConditionFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsPartialUpdate(
    requestParameters: ThreedimodelsBoundaryconditionsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BoundaryCondition> {
    const response = await this.threedimodelsBoundaryconditionsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsBoundaryconditionsRead without sending the request
   */
  async threedimodelsBoundaryconditionsReadRequestOpts(
    requestParameters: ThreedimodelsBoundaryconditionsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsBoundaryconditionsRead().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsBoundaryconditionsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/boundaryconditions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsReadRaw(
    requestParameters: ThreedimodelsBoundaryconditionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BoundaryCondition>> {
    const requestOptions = await this.threedimodelsBoundaryconditionsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BoundaryConditionFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsRead(
    requestParameters: ThreedimodelsBoundaryconditionsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BoundaryCondition> {
    const response = await this.threedimodelsBoundaryconditionsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsBoundaryconditionsUpdate without sending the request
   */
  async threedimodelsBoundaryconditionsUpdateRequestOpts(
    requestParameters: ThreedimodelsBoundaryconditionsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsBoundaryconditionsUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsBoundaryconditionsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsBoundaryconditionsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/boundaryconditions/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BoundaryConditionToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsUpdateRaw(
    requestParameters: ThreedimodelsBoundaryconditionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BoundaryCondition>> {
    const requestOptions = await this.threedimodelsBoundaryconditionsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BoundaryConditionFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing boundary conditions
   */
  async threedimodelsBoundaryconditionsUpdate(
    requestParameters: ThreedimodelsBoundaryconditionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BoundaryCondition> {
    const response = await this.threedimodelsBoundaryconditionsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsBreachesGeojsonUpload without sending the request
   */
  async threedimodelsBreachesGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsBreachesGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsBreachesGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsBreachesGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/breaches/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsBreachesGeojsonUploadRaw(
    requestParameters: ThreedimodelsBreachesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsBreachesGeojsonUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsBreachesGeojsonUpload(
    requestParameters: ThreedimodelsBreachesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsBreachesGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsBulkRastersCreate without sending the request
   */
  async threedimodelsBulkRastersCreateRequestOpts(
    requestParameters: ThreedimodelsBulkRastersCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsBulkRastersCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsBulkRastersCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/bulk_rasters/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters["data"]!.map(RasterToJSON),
    };
  }

  /**
   */
  async threedimodelsBulkRastersCreateRaw(
    requestParameters: ThreedimodelsBulkRastersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRasterList>> {
    const requestOptions = await this.threedimodelsBulkRastersCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRasterListFromJSON(jsonValue)
    );
  }

  /**
   */
  async threedimodelsBulkRastersCreate(
    requestParameters: ThreedimodelsBulkRastersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRasterList> {
    const response = await this.threedimodelsBulkRastersCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsCellsGeojsonUpload without sending the request
   */
  async threedimodelsCellsGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsCellsGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsCellsGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsCellsGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/cells/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsCellsGeojsonUploadRaw(
    requestParameters: ThreedimodelsCellsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsCellsGeojsonUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsCellsGeojsonUpload(
    requestParameters: ThreedimodelsCellsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsCellsGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsChannelsGeojsonUpload without sending the request
   */
  async threedimodelsChannelsGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsChannelsGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsChannelsGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsChannelsGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/channels/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsChannelsGeojsonUploadRaw(
    requestParameters: ThreedimodelsChannelsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsChannelsGeojsonUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsChannelsGeojsonUpload(
    requestParameters: ThreedimodelsChannelsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsChannelsGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsCreate without sending the request
   */
  async threedimodelsCreateRequestOpts(
    requestParameters: ThreedimodelsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ThreediModelToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsCreateRaw(
    requestParameters: ThreedimodelsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModel>> {
    const requestOptions = await this.threedimodelsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ThreediModelFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsCreate(
    requestParameters: ThreedimodelsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModel> {
    const response = await this.threedimodelsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsCulvertsGeojsonUpload without sending the request
   */
  async threedimodelsCulvertsGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsCulvertsGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsCulvertsGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsCulvertsGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/culverts/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsCulvertsGeojsonUploadRaw(
    requestParameters: ThreedimodelsCulvertsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsCulvertsGeojsonUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsCulvertsGeojsonUpload(
    requestParameters: ThreedimodelsCulvertsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsCulvertsGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsDelete without sending the request
   */
  async threedimodelsDeleteRequestOpts(
    requestParameters: ThreedimodelsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Soft-delete the threedimodel (sets disabled to True)  If the model is already disabled and the user is a superuser, delete the threedimodel.
   */
  async threedimodelsDeleteRaw(
    requestParameters: ThreedimodelsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Soft-delete the threedimodel (sets disabled to True)  If the model is already disabled and the user is a superuser, delete the threedimodel.
   */
  async threedimodelsDelete(
    requestParameters: ThreedimodelsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsFlowlinesGeojsonUpload without sending the request
   */
  async threedimodelsFlowlinesGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsFlowlinesGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsFlowlinesGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsFlowlinesGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/flowlines/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsFlowlinesGeojsonUploadRaw(
    requestParameters: ThreedimodelsFlowlinesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsFlowlinesGeojsonUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsFlowlinesGeojsonUpload(
    requestParameters: ThreedimodelsFlowlinesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsFlowlinesGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonBreachesDownload without sending the request
   */
  async threedimodelsGeojsonBreachesDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonBreachesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonBreachesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/breaches/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonBreachesDownloadRaw(
    requestParameters: ThreedimodelsGeojsonBreachesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonBreachesDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonBreachesDownload(
    requestParameters: ThreedimodelsGeojsonBreachesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonBreachesDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonCellsDownload without sending the request
   */
  async threedimodelsGeojsonCellsDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonCellsDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonCellsDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/cells/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Note that this is the subset of 2d open_water cells
   */
  async threedimodelsGeojsonCellsDownloadRaw(
    requestParameters: ThreedimodelsGeojsonCellsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonCellsDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Note that this is the subset of 2d open_water cells
   */
  async threedimodelsGeojsonCellsDownload(
    requestParameters: ThreedimodelsGeojsonCellsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonCellsDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonChannelsDownload without sending the request
   */
  async threedimodelsGeojsonChannelsDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonChannelsDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonChannelsDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/channels/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonChannelsDownloadRaw(
    requestParameters: ThreedimodelsGeojsonChannelsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonChannelsDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonChannelsDownload(
    requestParameters: ThreedimodelsGeojsonChannelsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonChannelsDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonCulvertsDownload without sending the request
   */
  async threedimodelsGeojsonCulvertsDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonCulvertsDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonCulvertsDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/culverts/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonCulvertsDownloadRaw(
    requestParameters: ThreedimodelsGeojsonCulvertsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonCulvertsDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonCulvertsDownload(
    requestParameters: ThreedimodelsGeojsonCulvertsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonCulvertsDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonDownload without sending the request
   */
  async threedimodelsGeojsonDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/all/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading geojson file.
   */
  async threedimodelsGeojsonDownloadRaw(
    requestParameters: ThreedimodelsGeojsonDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading geojson file.
   */
  async threedimodelsGeojsonDownload(
    requestParameters: ThreedimodelsGeojsonDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonDownloadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonFlowlinesDownload without sending the request
   */
  async threedimodelsGeojsonFlowlinesDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonFlowlinesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonFlowlinesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/flowlines/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Note that this is a subset of all lines
   */
  async threedimodelsGeojsonFlowlinesDownloadRaw(
    requestParameters: ThreedimodelsGeojsonFlowlinesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonFlowlinesDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Note that this is a subset of all lines
   */
  async threedimodelsGeojsonFlowlinesDownload(
    requestParameters: ThreedimodelsGeojsonFlowlinesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonFlowlinesDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonLeveesDownload without sending the request
   */
  async threedimodelsGeojsonLeveesDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonLeveesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonLeveesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/levees/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonLeveesDownloadRaw(
    requestParameters: ThreedimodelsGeojsonLeveesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonLeveesDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonLeveesDownload(
    requestParameters: ThreedimodelsGeojsonLeveesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonLeveesDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonManholesDownload without sending the request
   */
  async threedimodelsGeojsonManholesDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonManholesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonManholesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/manholes/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonManholesDownloadRaw(
    requestParameters: ThreedimodelsGeojsonManholesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonManholesDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonManholesDownload(
    requestParameters: ThreedimodelsGeojsonManholesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonManholesDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonOrificesDownload without sending the request
   */
  async threedimodelsGeojsonOrificesDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonOrificesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonOrificesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/orifices/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonOrificesDownloadRaw(
    requestParameters: ThreedimodelsGeojsonOrificesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonOrificesDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonOrificesDownload(
    requestParameters: ThreedimodelsGeojsonOrificesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonOrificesDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonPipesDownload without sending the request
   */
  async threedimodelsGeojsonPipesDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonPipesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonPipesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/pipes/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonPipesDownloadRaw(
    requestParameters: ThreedimodelsGeojsonPipesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonPipesDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonPipesDownload(
    requestParameters: ThreedimodelsGeojsonPipesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonPipesDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonPumpsDownload without sending the request
   */
  async threedimodelsGeojsonPumpsDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonPumpsDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonPumpsDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/pumps/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonPumpsDownloadRaw(
    requestParameters: ThreedimodelsGeojsonPumpsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonPumpsDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonPumpsDownload(
    requestParameters: ThreedimodelsGeojsonPumpsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonPumpsDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonUpload without sending the request
   */
  async threedimodelsGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/all/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading the geojson file Replaces the geojson file if there already exists one.
   */
  async threedimodelsGeojsonUploadRaw(
    requestParameters: ThreedimodelsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsGeojsonUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading the geojson file Replaces the geojson file if there already exists one.
   */
  async threedimodelsGeojsonUpload(
    requestParameters: ThreedimodelsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsGeojsonUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeojsonWeirsDownload without sending the request
   */
  async threedimodelsGeojsonWeirsDownloadRequestOpts(
    requestParameters: ThreedimodelsGeojsonWeirsDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeojsonWeirsDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/weirs/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonWeirsDownloadRaw(
    requestParameters: ThreedimodelsGeojsonWeirsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeojsonWeirsDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsGeojsonWeirsDownload(
    requestParameters: ThreedimodelsGeojsonWeirsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeojsonWeirsDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeopackageDownload without sending the request
   */
  async threedimodelsGeopackageDownloadRequestOpts(
    requestParameters: ThreedimodelsGeopackageDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeopackageDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geopackage/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading geopackage file.
   */
  async threedimodelsGeopackageDownloadRaw(
    requestParameters: ThreedimodelsGeopackageDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGeopackageDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading geopackage file.
   */
  async threedimodelsGeopackageDownload(
    requestParameters: ThreedimodelsGeopackageDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGeopackageDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGeopackageUpload without sending the request
   */
  async threedimodelsGeopackageUploadRequestOpts(
    requestParameters: ThreedimodelsGeopackageUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGeopackageUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsGeopackageUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geopackage/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading the gridadmin file  Replaces the gridadmin if there already exists one.
   */
  async threedimodelsGeopackageUploadRaw(
    requestParameters: ThreedimodelsGeopackageUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsGeopackageUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading the gridadmin file  Replaces the gridadmin if there already exists one.
   */
  async threedimodelsGeopackageUpload(
    requestParameters: ThreedimodelsGeopackageUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsGeopackageUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGridadminDownload without sending the request
   */
  async threedimodelsGridadminDownloadRequestOpts(
    requestParameters: ThreedimodelsGridadminDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGridadminDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/gridadmin/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsGridadminDownloadRaw(
    requestParameters: ThreedimodelsGridadminDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsGridadminDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsGridadminDownload(
    requestParameters: ThreedimodelsGridadminDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsGridadminDownloadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsGridadminUpload without sending the request
   */
  async threedimodelsGridadminUploadRequestOpts(
    requestParameters: ThreedimodelsGridadminUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsGridadminUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsGridadminUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/gridadmin/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading the gridadmin file  Replaces the gridadmin if there already exists one.
   */
  async threedimodelsGridadminUploadRaw(
    requestParameters: ThreedimodelsGridadminUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsGridadminUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading the gridadmin file  Replaces the gridadmin if there already exists one.
   */
  async threedimodelsGridadminUpload(
    requestParameters: ThreedimodelsGridadminUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsGridadminUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsCreate without sending the request
   */
  async threedimodelsInitialWaterlevelsCreateRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialWaterlevelsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: InitialWaterlevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Add new initial waterlevels  ### Adding (extra) 1D initial waterlevels Extra 1D initial waterlevels can be added by posting:  {\"dimension\": \"one_d\"}  Using the \'id\' value from the response, a JSON file needs to be uploaded via the PUT_URL retrieved from `initial_waterlevels/{id}/upload/` in the following JSON format:  Python code:      import json     file_contents = json.dumps({         \"node_ids\": [node_id_1, node_id2, ....],         \"values\" : [value_for_node_id_1, value_for_node_id_2, ...]     })      # Notes:     # - Omitted values are considered dry.     # - `node_ids` need to be sorted and unique     # - Make sure that the positions of the node_id\'s and values match.  ### Adding (extra) 2D initial waterlevels 2D initial waterlevels can be added by uploading an \'initial_waterlevel_file\' Geotiff raster via `rasters/{id}/upload/`. This automatically triggers the creation of a 2D initial waterlevel. The source raster is linked as \'source_raster\'. The values in the `source_raster` are aggregated per node using max, min and mean operators. The resulting values are stored in a file linked under `file`.
   */
  async threedimodelsInitialWaterlevelsCreateRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialWaterlevel>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialWaterlevelFromJSON(jsonValue)
    );
  }

  /**
   * Add new initial waterlevels  ### Adding (extra) 1D initial waterlevels Extra 1D initial waterlevels can be added by posting:  {\"dimension\": \"one_d\"}  Using the \'id\' value from the response, a JSON file needs to be uploaded via the PUT_URL retrieved from `initial_waterlevels/{id}/upload/` in the following JSON format:  Python code:      import json     file_contents = json.dumps({         \"node_ids\": [node_id_1, node_id2, ....],         \"values\" : [value_for_node_id_1, value_for_node_id_2, ...]     })      # Notes:     # - Omitted values are considered dry.     # - `node_ids` need to be sorted and unique     # - Make sure that the positions of the node_id\'s and values match.  ### Adding (extra) 2D initial waterlevels 2D initial waterlevels can be added by uploading an \'initial_waterlevel_file\' Geotiff raster via `rasters/{id}/upload/`. This automatically triggers the creation of a 2D initial waterlevel. The source raster is linked as \'source_raster\'. The values in the `source_raster` are aggregated per node using max, min and mean operators. The resulting values are stored in a file linked under `file`.
   */
  async threedimodelsInitialWaterlevelsCreate(
    requestParameters: ThreedimodelsInitialWaterlevelsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialWaterlevel> {
    const response = await this.threedimodelsInitialWaterlevelsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsDelete without sending the request
   */
  async threedimodelsInitialWaterlevelsDeleteRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialWaterlevelsDelete().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete initial waterlevel  Note: Initial waterlevels can only be deleted when not in use in any simulation.
   */
  async threedimodelsInitialWaterlevelsDeleteRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete initial waterlevel  Note: Initial waterlevels can only be deleted when not in use in any simulation.
   */
  async threedimodelsInitialWaterlevelsDelete(
    requestParameters: ThreedimodelsInitialWaterlevelsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsInitialWaterlevelsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsDownload without sending the request
   */
  async threedimodelsInitialWaterlevelsDownloadRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialWaterlevelsDownload().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsInitialWaterlevelsDownloadRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsInitialWaterlevelsDownload(
    requestParameters: ThreedimodelsInitialWaterlevelsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsInitialWaterlevelsDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsList without sending the request
   */
  async threedimodelsInitialWaterlevelsListRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsListRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedInitialWaterlevelList>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedInitialWaterlevelListFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsList(
    requestParameters: ThreedimodelsInitialWaterlevelsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedInitialWaterlevelList> {
    const response = await this.threedimodelsInitialWaterlevelsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsPartialUpdate without sending the request
   */
  async threedimodelsInitialWaterlevelsPartialUpdateRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialWaterlevelsPartialUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialWaterlevelsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedInitialWaterlevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsPartialUpdateRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialWaterlevel>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialWaterlevelFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsPartialUpdate(
    requestParameters: ThreedimodelsInitialWaterlevelsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialWaterlevel> {
    const response = await this.threedimodelsInitialWaterlevelsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsProcessed without sending the request
   */
  async threedimodelsInitialWaterlevelsProcessedRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialWaterlevelsProcessed().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialWaterlevelsProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BaseEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsProcessedRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsProcessed(
    requestParameters: ThreedimodelsInitialWaterlevelsProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsInitialWaterlevelsProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsRead without sending the request
   */
  async threedimodelsInitialWaterlevelsReadRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialWaterlevelsRead().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsReadRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialWaterlevel>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialWaterlevelFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsRead(
    requestParameters: ThreedimodelsInitialWaterlevelsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialWaterlevel> {
    const response = await this.threedimodelsInitialWaterlevelsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsUpdate without sending the request
   */
  async threedimodelsInitialWaterlevelsUpdateRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialWaterlevelsUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialWaterlevelsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: InitialWaterlevelToJSON(requestParameters["data"]),
    };
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsUpdateRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialWaterlevel>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialWaterlevelFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial waterlevels on threedimodels can be used in a simulation to specify the initial waterlevels on the 1D and/or 2D domain.  ### Initial waterlevels from schematisation 1D and 2D initial waterlevels in the schematisation are automatically picked up during the creation of the threedimodel.
   */
  async threedimodelsInitialWaterlevelsUpdate(
    requestParameters: ThreedimodelsInitialWaterlevelsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialWaterlevel> {
    const response = await this.threedimodelsInitialWaterlevelsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialWaterlevelsUpload without sending the request
   */
  async threedimodelsInitialWaterlevelsUploadRequestOpts(
    requestParameters: ThreedimodelsInitialWaterlevelsUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialWaterlevelsUpload().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialWaterlevelsUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialWaterlevelsUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/initial_waterlevels/{id}/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading an initial waterlevel file, see the POST endpoint for documentation about the file format.
   */
  async threedimodelsInitialWaterlevelsUploadRaw(
    requestParameters: ThreedimodelsInitialWaterlevelsUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsInitialWaterlevelsUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading an initial waterlevel file, see the POST endpoint for documentation about the file format.
   */
  async threedimodelsInitialWaterlevelsUpload(
    requestParameters: ThreedimodelsInitialWaterlevelsUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsInitialWaterlevelsUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsLeveesGeojsonUpload without sending the request
   */
  async threedimodelsLeveesGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsLeveesGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsLeveesGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsLeveesGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/levees/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsLeveesGeojsonUploadRaw(
    requestParameters: ThreedimodelsLeveesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsLeveesGeojsonUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsLeveesGeojsonUpload(
    requestParameters: ThreedimodelsLeveesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsLeveesGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsList without sending the request
   */
  async threedimodelsListRequestOpts(
    requestParameters: ThreedimodelsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["createdDate"] != null) {
      queryParameters["created__date"] = runtime.serializeDate(
        requestParameters["createdDate"] as any
      );
    }

    if (requestParameters["createdDateGt"] != null) {
      queryParameters["created__date__gt"] = runtime.serializeDate(
        requestParameters["createdDateGt"] as any
      );
    }

    if (requestParameters["createdDateGte"] != null) {
      queryParameters["created__date__gte"] = runtime.serializeDate(
        requestParameters["createdDateGte"] as any
      );
    }

    if (requestParameters["createdDateLt"] != null) {
      queryParameters["created__date__lt"] = runtime.serializeDate(
        requestParameters["createdDateLt"] as any
      );
    }

    if (requestParameters["createdDateLte"] != null) {
      queryParameters["created__date__lte"] = runtime.serializeDate(
        requestParameters["createdDateLte"] as any
      );
    }

    if (requestParameters["createdDay"] != null) {
      queryParameters["created__day"] = requestParameters["createdDay"];
    }

    if (requestParameters["createdDayLt"] != null) {
      queryParameters["created__day__lt"] = requestParameters["createdDayLt"];
    }

    if (requestParameters["createdHour"] != null) {
      queryParameters["created__hour"] = requestParameters["createdHour"];
    }

    if (requestParameters["createdIsnull"] != null) {
      queryParameters["created__isnull"] = requestParameters["createdIsnull"];
    }

    if (requestParameters["createdMinute"] != null) {
      queryParameters["created__minute"] = requestParameters["createdMinute"];
    }

    if (requestParameters["createdMonth"] != null) {
      queryParameters["created__month"] = requestParameters["createdMonth"];
    }

    if (requestParameters["createdMonthLte"] != null) {
      queryParameters["created__month__lte"] = requestParameters["createdMonthLte"];
    }

    if (requestParameters["createdQuarter"] != null) {
      queryParameters["created__quarter"] = requestParameters["createdQuarter"];
    }

    if (requestParameters["createdRange"] != null) {
      queryParameters["created__range"] = requestParameters["createdRange"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["createdSecond"] != null) {
      queryParameters["created__second"] = requestParameters["createdSecond"];
    }

    if (requestParameters["createdTime"] != null) {
      queryParameters["created__time"] = requestParameters["createdTime"];
    }

    if (requestParameters["createdWeek"] != null) {
      queryParameters["created__week"] = requestParameters["createdWeek"];
    }

    if (requestParameters["createdWeekDay"] != null) {
      queryParameters["created__week_day"] = requestParameters["createdWeekDay"];
    }

    if (requestParameters["createdYear"] != null) {
      queryParameters["created__year"] = requestParameters["createdYear"];
    }

    if (requestParameters["createdYearGt"] != null) {
      queryParameters["created__year__gt"] = requestParameters["createdYearGt"];
    }

    if (requestParameters["createdYearGte"] != null) {
      queryParameters["created__year__gte"] = requestParameters["createdYearGte"];
    }

    if (requestParameters["createdYearLt"] != null) {
      queryParameters["created__year__lt"] = requestParameters["createdYearLt"];
    }

    if (requestParameters["createdYearLte"] != null) {
      queryParameters["created__year__lte"] = requestParameters["createdYearLte"];
    }

    if (requestParameters["disabled"] != null) {
      queryParameters["disabled"] = requestParameters["disabled"];
    }

    if (requestParameters["epsg"] != null) {
      queryParameters["epsg"] = requestParameters["epsg"];
    }

    if (requestParameters["id"] != null) {
      queryParameters["id"] = requestParameters["id"];
    }

    if (requestParameters["inpSuccess"] != null) {
      queryParameters["inp_success"] = requestParameters["inpSuccess"];
    }

    if (requestParameters["inpyVersionActive"] != null) {
      queryParameters["inpy_version__active"] = requestParameters["inpyVersionActive"];
    }

    if (requestParameters["inpyVersionSlug"] != null) {
      queryParameters["inpy_version__slug"] = requestParameters["inpyVersionSlug"];
    }

    if (requestParameters["inpyVersionSlugContains"] != null) {
      queryParameters["inpy_version__slug__contains"] =
        requestParameters["inpyVersionSlugContains"];
    }

    if (requestParameters["inpyVersionSlugEndswith"] != null) {
      queryParameters["inpy_version__slug__endswith"] =
        requestParameters["inpyVersionSlugEndswith"];
    }

    if (requestParameters["inpyVersionSlugIcontains"] != null) {
      queryParameters["inpy_version__slug__icontains"] =
        requestParameters["inpyVersionSlugIcontains"];
    }

    if (requestParameters["inpyVersionSlugIexact"] != null) {
      queryParameters["inpy_version__slug__iexact"] = requestParameters["inpyVersionSlugIexact"];
    }

    if (requestParameters["inpyVersionSlugIn"] != null) {
      queryParameters["inpy_version__slug__in"] = requestParameters["inpyVersionSlugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["inpyVersionSlugIstartswith"] != null) {
      queryParameters["inpy_version__slug__istartswith"] =
        requestParameters["inpyVersionSlugIstartswith"];
    }

    if (requestParameters["inpyVersionSlugRegex"] != null) {
      queryParameters["inpy_version__slug__regex"] = requestParameters["inpyVersionSlugRegex"];
    }

    if (requestParameters["inpyVersionSlugStartswith"] != null) {
      queryParameters["inpy_version__slug__startswith"] =
        requestParameters["inpyVersionSlugStartswith"];
    }

    if (requestParameters["inpyVersionThreediVersion"] != null) {
      queryParameters["inpy_version__threedi_version"] =
        requestParameters["inpyVersionThreediVersion"];
    }

    if (requestParameters["inpyVersionThreediVersionContains"] != null) {
      queryParameters["inpy_version__threedi_version__contains"] =
        requestParameters["inpyVersionThreediVersionContains"];
    }

    if (requestParameters["inpyVersionThreediVersionEndswith"] != null) {
      queryParameters["inpy_version__threedi_version__endswith"] =
        requestParameters["inpyVersionThreediVersionEndswith"];
    }

    if (requestParameters["inpyVersionThreediVersionIcontains"] != null) {
      queryParameters["inpy_version__threedi_version__icontains"] =
        requestParameters["inpyVersionThreediVersionIcontains"];
    }

    if (requestParameters["inpyVersionThreediVersionIexact"] != null) {
      queryParameters["inpy_version__threedi_version__iexact"] =
        requestParameters["inpyVersionThreediVersionIexact"];
    }

    if (requestParameters["inpyVersionThreediVersionIn"] != null) {
      queryParameters["inpy_version__threedi_version__in"] = requestParameters[
        "inpyVersionThreediVersionIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["inpyVersionThreediVersionIstartswith"] != null) {
      queryParameters["inpy_version__threedi_version__istartswith"] =
        requestParameters["inpyVersionThreediVersionIstartswith"];
    }

    if (requestParameters["inpyVersionThreediVersionRegex"] != null) {
      queryParameters["inpy_version__threedi_version__regex"] =
        requestParameters["inpyVersionThreediVersionRegex"];
    }

    if (requestParameters["inpyVersionThreediVersionStartswith"] != null) {
      queryParameters["inpy_version__threedi_version__startswith"] =
        requestParameters["inpyVersionThreediVersionStartswith"];
    }

    if (requestParameters["inpyVersionThreedicoreVersion"] != null) {
      queryParameters["inpy_version__threedicore_version"] =
        requestParameters["inpyVersionThreedicoreVersion"];
    }

    if (requestParameters["inpyVersionThreedicoreVersionContains"] != null) {
      queryParameters["inpy_version__threedicore_version__contains"] =
        requestParameters["inpyVersionThreedicoreVersionContains"];
    }

    if (requestParameters["inpyVersionThreedicoreVersionEndswith"] != null) {
      queryParameters["inpy_version__threedicore_version__endswith"] =
        requestParameters["inpyVersionThreedicoreVersionEndswith"];
    }

    if (requestParameters["inpyVersionThreedicoreVersionIcontains"] != null) {
      queryParameters["inpy_version__threedicore_version__icontains"] =
        requestParameters["inpyVersionThreedicoreVersionIcontains"];
    }

    if (requestParameters["inpyVersionThreedicoreVersionIexact"] != null) {
      queryParameters["inpy_version__threedicore_version__iexact"] =
        requestParameters["inpyVersionThreedicoreVersionIexact"];
    }

    if (requestParameters["inpyVersionThreedicoreVersionIn"] != null) {
      queryParameters["inpy_version__threedicore_version__in"] = requestParameters[
        "inpyVersionThreedicoreVersionIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["inpyVersionThreedicoreVersionIstartswith"] != null) {
      queryParameters["inpy_version__threedicore_version__istartswith"] =
        requestParameters["inpyVersionThreedicoreVersionIstartswith"];
    }

    if (requestParameters["inpyVersionThreedicoreVersionRegex"] != null) {
      queryParameters["inpy_version__threedicore_version__regex"] =
        requestParameters["inpyVersionThreedicoreVersionRegex"];
    }

    if (requestParameters["inpyVersionThreedicoreVersionStartswith"] != null) {
      queryParameters["inpy_version__threedicore_version__startswith"] =
        requestParameters["inpyVersionThreedicoreVersionStartswith"];
    }

    if (requestParameters["isGenerating"] != null) {
      queryParameters["is_generating"] = requestParameters["isGenerating"];
    }

    if (requestParameters["isValid"] != null) {
      queryParameters["is_valid"] = requestParameters["isValid"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["revisionCommitUserUsername"] != null) {
      queryParameters["revision__commit_user__username"] =
        requestParameters["revisionCommitUserUsername"];
    }

    if (requestParameters["revisionCommitUserUsernameIstartswith"] != null) {
      queryParameters["revision__commit_user__username__istartswith"] =
        requestParameters["revisionCommitUserUsernameIstartswith"];
    }

    if (requestParameters["revisionHash"] != null) {
      queryParameters["revision__hash"] = requestParameters["revisionHash"];
    }

    if (requestParameters["revisionHashContains"] != null) {
      queryParameters["revision__hash__contains"] = requestParameters["revisionHashContains"];
    }

    if (requestParameters["revisionHashEndswith"] != null) {
      queryParameters["revision__hash__endswith"] = requestParameters["revisionHashEndswith"];
    }

    if (requestParameters["revisionHashIcontains"] != null) {
      queryParameters["revision__hash__icontains"] = requestParameters["revisionHashIcontains"];
    }

    if (requestParameters["revisionHashIexact"] != null) {
      queryParameters["revision__hash__iexact"] = requestParameters["revisionHashIexact"];
    }

    if (requestParameters["revisionHashIn"] != null) {
      queryParameters["revision__hash__in"] = requestParameters["revisionHashIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["revisionHashIstartswith"] != null) {
      queryParameters["revision__hash__istartswith"] = requestParameters["revisionHashIstartswith"];
    }

    if (requestParameters["revisionHashRegex"] != null) {
      queryParameters["revision__hash__regex"] = requestParameters["revisionHashRegex"];
    }

    if (requestParameters["revisionHashStartswith"] != null) {
      queryParameters["revision__hash__startswith"] = requestParameters["revisionHashStartswith"];
    }

    if (requestParameters["revisionId"] != null) {
      queryParameters["revision__id"] = requestParameters["revisionId"];
    }

    if (requestParameters["revisionIsPinned"] != null) {
      queryParameters["revision__is_pinned"] = requestParameters["revisionIsPinned"];
    }

    if (requestParameters["revisionNumber"] != null) {
      queryParameters["revision__number"] = requestParameters["revisionNumber"];
    }

    if (requestParameters["revisionNumberGt"] != null) {
      queryParameters["revision__number__gt"] = requestParameters["revisionNumberGt"];
    }

    if (requestParameters["revisionNumberGte"] != null) {
      queryParameters["revision__number__gte"] = requestParameters["revisionNumberGte"];
    }

    if (requestParameters["revisionNumberIsnull"] != null) {
      queryParameters["revision__number__isnull"] = requestParameters["revisionNumberIsnull"];
    }

    if (requestParameters["revisionNumberLt"] != null) {
      queryParameters["revision__number__lt"] = requestParameters["revisionNumberLt"];
    }

    if (requestParameters["revisionNumberLte"] != null) {
      queryParameters["revision__number__lte"] = requestParameters["revisionNumberLte"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueId"] != null) {
      queryParameters["revision__repository__organisation__unique_id"] =
        requestParameters["revisionRepositoryOrganisationUniqueId"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdContains"] != null) {
      queryParameters["revision__repository__organisation__unique_id__contains"] =
        requestParameters["revisionRepositoryOrganisationUniqueIdContains"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdEndswith"] != null) {
      queryParameters["revision__repository__organisation__unique_id__endswith"] =
        requestParameters["revisionRepositoryOrganisationUniqueIdEndswith"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdIcontains"] != null) {
      queryParameters["revision__repository__organisation__unique_id__icontains"] =
        requestParameters["revisionRepositoryOrganisationUniqueIdIcontains"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdIexact"] != null) {
      queryParameters["revision__repository__organisation__unique_id__iexact"] =
        requestParameters["revisionRepositoryOrganisationUniqueIdIexact"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdIn"] != null) {
      queryParameters["revision__repository__organisation__unique_id__in"] = requestParameters[
        "revisionRepositoryOrganisationUniqueIdIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdIstartswith"] != null) {
      queryParameters["revision__repository__organisation__unique_id__istartswith"] =
        requestParameters["revisionRepositoryOrganisationUniqueIdIstartswith"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdRegex"] != null) {
      queryParameters["revision__repository__organisation__unique_id__regex"] =
        requestParameters["revisionRepositoryOrganisationUniqueIdRegex"];
    }

    if (requestParameters["revisionRepositoryOrganisationUniqueIdStartswith"] != null) {
      queryParameters["revision__repository__organisation__unique_id__startswith"] =
        requestParameters["revisionRepositoryOrganisationUniqueIdStartswith"];
    }

    if (requestParameters["revisionSchematisationId"] != null) {
      queryParameters["revision__schematisation__id"] =
        requestParameters["revisionSchematisationId"];
    }

    if (requestParameters["revisionSchematisationIsnull"] != null) {
      queryParameters["revision__schematisation__isnull"] =
        requestParameters["revisionSchematisationIsnull"];
    }

    if (requestParameters["revisionSchematisationName"] != null) {
      queryParameters["revision__schematisation__name"] =
        requestParameters["revisionSchematisationName"];
    }

    if (requestParameters["revisionSchematisationNameContains"] != null) {
      queryParameters["revision__schematisation__name__contains"] =
        requestParameters["revisionSchematisationNameContains"];
    }

    if (requestParameters["revisionSchematisationNameEndswith"] != null) {
      queryParameters["revision__schematisation__name__endswith"] =
        requestParameters["revisionSchematisationNameEndswith"];
    }

    if (requestParameters["revisionSchematisationNameIcontains"] != null) {
      queryParameters["revision__schematisation__name__icontains"] =
        requestParameters["revisionSchematisationNameIcontains"];
    }

    if (requestParameters["revisionSchematisationNameIexact"] != null) {
      queryParameters["revision__schematisation__name__iexact"] =
        requestParameters["revisionSchematisationNameIexact"];
    }

    if (requestParameters["revisionSchematisationNameIn"] != null) {
      queryParameters["revision__schematisation__name__in"] = requestParameters[
        "revisionSchematisationNameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["revisionSchematisationNameIstartswith"] != null) {
      queryParameters["revision__schematisation__name__istartswith"] =
        requestParameters["revisionSchematisationNameIstartswith"];
    }

    if (requestParameters["revisionSchematisationNameRegex"] != null) {
      queryParameters["revision__schematisation__name__regex"] =
        requestParameters["revisionSchematisationNameRegex"];
    }

    if (requestParameters["revisionSchematisationNameStartswith"] != null) {
      queryParameters["revision__schematisation__name__startswith"] =
        requestParameters["revisionSchematisationNameStartswith"];
    }

    if (requestParameters["revisionSchematisationOwnerUniqueId"] != null) {
      queryParameters["revision__schematisation__owner__unique_id"] =
        requestParameters["revisionSchematisationOwnerUniqueId"];
    }

    if (requestParameters["revisionSchematisationRanaProjectId"] != null) {
      queryParameters["revision__schematisation__rana_project_id"] =
        requestParameters["revisionSchematisationRanaProjectId"];
    }

    if (requestParameters["revisionSchematisationRanaProjectIdIsnull"] != null) {
      queryParameters["revision__schematisation__rana_project_id__isnull"] =
        requestParameters["revisionSchematisationRanaProjectIdIsnull"];
    }

    if (requestParameters["revisionSchematisationRanaTenantId"] != null) {
      queryParameters["revision__schematisation__rana_tenant_id"] =
        requestParameters["revisionSchematisationRanaTenantId"];
    }

    if (requestParameters["revisionSchematisationRanaTenantIdIsnull"] != null) {
      queryParameters["revision__schematisation__rana_tenant_id__isnull"] =
        requestParameters["revisionSchematisationRanaTenantIdIsnull"];
    }

    if (requestParameters["revisionSchematisationTagsIn"] != null) {
      queryParameters["revision__schematisation__tags__in"] =
        requestParameters["revisionSchematisationTagsIn"];
    }

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    if (requestParameters["slugContains"] != null) {
      queryParameters["slug__contains"] = requestParameters["slugContains"];
    }

    if (requestParameters["slugEndswith"] != null) {
      queryParameters["slug__endswith"] = requestParameters["slugEndswith"];
    }

    if (requestParameters["slugIcontains"] != null) {
      queryParameters["slug__icontains"] = requestParameters["slugIcontains"];
    }

    if (requestParameters["slugIexact"] != null) {
      queryParameters["slug__iexact"] = requestParameters["slugIexact"];
    }

    if (requestParameters["slugIn"] != null) {
      queryParameters["slug__in"] = requestParameters["slugIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["slugIstartswith"] != null) {
      queryParameters["slug__istartswith"] = requestParameters["slugIstartswith"];
    }

    if (requestParameters["slugRegex"] != null) {
      queryParameters["slug__regex"] = requestParameters["slugRegex"];
    }

    if (requestParameters["slugStartswith"] != null) {
      queryParameters["slug__startswith"] = requestParameters["slugStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsListRaw(
    requestParameters: ThreedimodelsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedThreediModelList>> {
    const requestOptions = await this.threedimodelsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedThreediModelListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsList(
    requestParameters: ThreedimodelsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedThreediModelList> {
    const response = await this.threedimodelsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsManholesGeojsonUpload without sending the request
   */
  async threedimodelsManholesGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsManholesGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsManholesGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsManholesGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/manholes/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsManholesGeojsonUploadRaw(
    requestParameters: ThreedimodelsManholesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsManholesGeojsonUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsManholesGeojsonUpload(
    requestParameters: ThreedimodelsManholesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsManholesGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsOrificesGeojsonUpload without sending the request
   */
  async threedimodelsOrificesGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsOrificesGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsOrificesGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsOrificesGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/orifices/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsOrificesGeojsonUploadRaw(
    requestParameters: ThreedimodelsOrificesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsOrificesGeojsonUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsOrificesGeojsonUpload(
    requestParameters: ThreedimodelsOrificesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsOrificesGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsPartialUpdate without sending the request
   */
  async threedimodelsPartialUpdateRequestOpts(
    requestParameters: ThreedimodelsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedThreediModelToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsPartialUpdateRaw(
    requestParameters: ThreedimodelsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModel>> {
    const requestOptions = await this.threedimodelsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ThreediModelFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsPartialUpdate(
    requestParameters: ThreedimodelsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModel> {
    const response = await this.threedimodelsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsPipesGeojsonUpload without sending the request
   */
  async threedimodelsPipesGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsPipesGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsPipesGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsPipesGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/pipes/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsPipesGeojsonUploadRaw(
    requestParameters: ThreedimodelsPipesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsPipesGeojsonUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsPipesGeojsonUpload(
    requestParameters: ThreedimodelsPipesGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsPipesGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsPotentialbreachesCreate without sending the request
   */
  async threedimodelsPotentialbreachesCreateRequestOpts(
    requestParameters: ThreedimodelsPotentialbreachesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsPotentialbreachesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsPotentialbreachesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/potentialbreaches/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PotentialBreachToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing breaches  To get the potential breach from the geojson use the `content_pk` parameter to filter the potential breaches endpoint: `/potential_breaches/?connected_pnt_id={content_pk}`
   */
  async threedimodelsPotentialbreachesCreateRaw(
    requestParameters: ThreedimodelsPotentialbreachesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PotentialBreach>> {
    const requestOptions = await this.threedimodelsPotentialbreachesCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PotentialBreachFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing breaches  To get the potential breach from the geojson use the `content_pk` parameter to filter the potential breaches endpoint: `/potential_breaches/?connected_pnt_id={content_pk}`
   */
  async threedimodelsPotentialbreachesCreate(
    requestParameters: ThreedimodelsPotentialbreachesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PotentialBreach> {
    const response = await this.threedimodelsPotentialbreachesCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsPotentialbreachesList without sending the request
   */
  async threedimodelsPotentialbreachesListRequestOpts(
    requestParameters: ThreedimodelsPotentialbreachesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsPotentialbreachesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["connectedPntId"] != null) {
      queryParameters["connected_pnt_id"] = requestParameters["connectedPntId"];
    }

    if (requestParameters["connectedPntIdGt"] != null) {
      queryParameters["connected_pnt_id__gt"] = requestParameters["connectedPntIdGt"];
    }

    if (requestParameters["connectedPntIdGte"] != null) {
      queryParameters["connected_pnt_id__gte"] = requestParameters["connectedPntIdGte"];
    }

    if (requestParameters["connectedPntIdIsnull"] != null) {
      queryParameters["connected_pnt_id__isnull"] = requestParameters["connectedPntIdIsnull"];
    }

    if (requestParameters["connectedPntIdLt"] != null) {
      queryParameters["connected_pnt_id__lt"] = requestParameters["connectedPntIdLt"];
    }

    if (requestParameters["connectedPntIdLte"] != null) {
      queryParameters["connected_pnt_id__lte"] = requestParameters["connectedPntIdLte"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["threedimodelId"] != null) {
      queryParameters["threedimodel__id"] = requestParameters["threedimodelId"];
    }

    if (requestParameters["threedimodelIdGt"] != null) {
      queryParameters["threedimodel__id__gt"] = requestParameters["threedimodelIdGt"];
    }

    if (requestParameters["threedimodelIdGte"] != null) {
      queryParameters["threedimodel__id__gte"] = requestParameters["threedimodelIdGte"];
    }

    if (requestParameters["threedimodelIdIsnull"] != null) {
      queryParameters["threedimodel__id__isnull"] = requestParameters["threedimodelIdIsnull"];
    }

    if (requestParameters["threedimodelIdLt"] != null) {
      queryParameters["threedimodel__id__lt"] = requestParameters["threedimodelIdLt"];
    }

    if (requestParameters["threedimodelIdLte"] != null) {
      queryParameters["threedimodel__id__lte"] = requestParameters["threedimodelIdLte"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/potentialbreaches/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing breaches  To get the potential breach from the geojson use the `content_pk` parameter to filter the potential breaches endpoint: `/potential_breaches/?connected_pnt_id={content_pk}`
   */
  async threedimodelsPotentialbreachesListRaw(
    requestParameters: ThreedimodelsPotentialbreachesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedPotentialBreachList>> {
    const requestOptions = await this.threedimodelsPotentialbreachesListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedPotentialBreachListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing breaches  To get the potential breach from the geojson use the `content_pk` parameter to filter the potential breaches endpoint: `/potential_breaches/?connected_pnt_id={content_pk}`
   */
  async threedimodelsPotentialbreachesList(
    requestParameters: ThreedimodelsPotentialbreachesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedPotentialBreachList> {
    const response = await this.threedimodelsPotentialbreachesListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsPotentialbreachesRead without sending the request
   */
  async threedimodelsPotentialbreachesReadRequestOpts(
    requestParameters: ThreedimodelsPotentialbreachesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsPotentialbreachesRead().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsPotentialbreachesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/potentialbreaches/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing breaches  To get the potential breach from the geojson use the `content_pk` parameter to filter the potential breaches endpoint: `/potential_breaches/?connected_pnt_id={content_pk}`
   */
  async threedimodelsPotentialbreachesReadRaw(
    requestParameters: ThreedimodelsPotentialbreachesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PotentialBreach>> {
    const requestOptions = await this.threedimodelsPotentialbreachesReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PotentialBreachFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing breaches  To get the potential breach from the geojson use the `content_pk` parameter to filter the potential breaches endpoint: `/potential_breaches/?connected_pnt_id={content_pk}`
   */
  async threedimodelsPotentialbreachesRead(
    requestParameters: ThreedimodelsPotentialbreachesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PotentialBreach> {
    const response = await this.threedimodelsPotentialbreachesReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsPumpsGeojsonUpload without sending the request
   */
  async threedimodelsPumpsGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsPumpsGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsPumpsGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsPumpsGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/pumps/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsPumpsGeojsonUploadRaw(
    requestParameters: ThreedimodelsPumpsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsPumpsGeojsonUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsPumpsGeojsonUpload(
    requestParameters: ThreedimodelsPumpsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsPumpsGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRasterOptions without sending the request
   */
  async threedimodelsRasterOptionsRequestOpts(
    requestParameters: ThreedimodelsRasterOptionsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRasterOptions().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/raster_options/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsRasterOptionsRaw(
    requestParameters: ThreedimodelsRasterOptionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RasterOptions>> {
    const requestOptions = await this.threedimodelsRasterOptionsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterOptionsFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsRasterOptions(
    requestParameters: ThreedimodelsRasterOptionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RasterOptions> {
    const response = await this.threedimodelsRasterOptionsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRastersCreate without sending the request
   */
  async threedimodelsRastersCreateRequestOpts(
    requestParameters: ThreedimodelsRastersCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsRastersCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersCreateRaw(
    requestParameters: ThreedimodelsRastersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Raster>> {
    const requestOptions = await this.threedimodelsRastersCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterFromJSON(jsonValue));
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersCreate(
    requestParameters: ThreedimodelsRastersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Raster> {
    const response = await this.threedimodelsRastersCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRastersDelete without sending the request
   */
  async threedimodelsRastersDeleteRequestOpts(
    requestParameters: ThreedimodelsRastersDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRastersDelete().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersDeleteRaw(
    requestParameters: ThreedimodelsRastersDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsRastersDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersDelete(
    requestParameters: ThreedimodelsRastersDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsRastersDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsRastersDownload without sending the request
   */
  async threedimodelsRastersDownloadRequestOpts(
    requestParameters: ThreedimodelsRastersDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRastersDownload().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsRastersDownloadRaw(
    requestParameters: ThreedimodelsRastersDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsRastersDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsRastersDownload(
    requestParameters: ThreedimodelsRastersDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsRastersDownloadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRastersList without sending the request
   */
  async threedimodelsRastersListRequestOpts(
    requestParameters: ThreedimodelsRastersListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["nameContains"] != null) {
      queryParameters["name__contains"] = requestParameters["nameContains"];
    }

    if (requestParameters["nameEndswith"] != null) {
      queryParameters["name__endswith"] = requestParameters["nameEndswith"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    if (requestParameters["nameIexact"] != null) {
      queryParameters["name__iexact"] = requestParameters["nameIexact"];
    }

    if (requestParameters["nameIn"] != null) {
      queryParameters["name__in"] = requestParameters["nameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["nameIstartswith"] != null) {
      queryParameters["name__istartswith"] = requestParameters["nameIstartswith"];
    }

    if (requestParameters["nameRegex"] != null) {
      queryParameters["name__regex"] = requestParameters["nameRegex"];
    }

    if (requestParameters["nameStartswith"] != null) {
      queryParameters["name__startswith"] = requestParameters["nameStartswith"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["type"] != null) {
      queryParameters["type"] = requestParameters["type"];
    }

    if (requestParameters["typeContains"] != null) {
      queryParameters["type__contains"] = requestParameters["typeContains"];
    }

    if (requestParameters["typeEndswith"] != null) {
      queryParameters["type__endswith"] = requestParameters["typeEndswith"];
    }

    if (requestParameters["typeIcontains"] != null) {
      queryParameters["type__icontains"] = requestParameters["typeIcontains"];
    }

    if (requestParameters["typeIexact"] != null) {
      queryParameters["type__iexact"] = requestParameters["typeIexact"];
    }

    if (requestParameters["typeIn"] != null) {
      queryParameters["type__in"] = requestParameters["typeIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["typeIstartswith"] != null) {
      queryParameters["type__istartswith"] = requestParameters["typeIstartswith"];
    }

    if (requestParameters["typeRegex"] != null) {
      queryParameters["type__regex"] = requestParameters["typeRegex"];
    }

    if (requestParameters["typeStartswith"] != null) {
      queryParameters["type__startswith"] = requestParameters["typeStartswith"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersListRaw(
    requestParameters: ThreedimodelsRastersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedRasterList>> {
    const requestOptions = await this.threedimodelsRastersListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedRasterListFromJSON(jsonValue)
    );
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersList(
    requestParameters: ThreedimodelsRastersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedRasterList> {
    const response = await this.threedimodelsRastersListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRastersPartialUpdate without sending the request
   */
  async threedimodelsRastersPartialUpdateRequestOpts(
    requestParameters: ThreedimodelsRastersPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRastersPartialUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsRastersPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedRasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersPartialUpdateRaw(
    requestParameters: ThreedimodelsRastersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Raster>> {
    const requestOptions = await this.threedimodelsRastersPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterFromJSON(jsonValue));
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersPartialUpdate(
    requestParameters: ThreedimodelsRastersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Raster> {
    const response = await this.threedimodelsRastersPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRastersRead without sending the request
   */
  async threedimodelsRastersReadRequestOpts(
    requestParameters: ThreedimodelsRastersReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRastersRead().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersReadRaw(
    requestParameters: ThreedimodelsRastersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Raster>> {
    const requestOptions = await this.threedimodelsRastersReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterFromJSON(jsonValue));
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersRead(
    requestParameters: ThreedimodelsRastersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Raster> {
    const response = await this.threedimodelsRastersReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRastersUpdate without sending the request
   */
  async threedimodelsRastersUpdateRequestOpts(
    requestParameters: ThreedimodelsRastersUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRastersUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsRastersUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RasterToJSON(requestParameters["data"]),
    };
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersUpdateRaw(
    requestParameters: ThreedimodelsRastersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Raster>> {
    const requestOptions = await this.threedimodelsRastersUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RasterFromJSON(jsonValue));
  }

  /**
   * View rasters for threedimodel
   */
  async threedimodelsRastersUpdate(
    requestParameters: ThreedimodelsRastersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Raster> {
    const response = await this.threedimodelsRastersUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRastersUpload without sending the request
   */
  async threedimodelsRastersUploadRequestOpts(
    requestParameters: ThreedimodelsRastersUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRastersUpload().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsRastersUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsRastersUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/rasters/{id}/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading a raster.
   */
  async threedimodelsRastersUploadRaw(
    requestParameters: ThreedimodelsRastersUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsRastersUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading a raster.
   */
  async threedimodelsRastersUpload(
    requestParameters: ThreedimodelsRastersUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsRastersUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsRead without sending the request
   */
  async threedimodelsReadRequestOpts(
    requestParameters: ThreedimodelsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsReadRaw(
    requestParameters: ThreedimodelsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModel>> {
    const requestOptions = await this.threedimodelsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ThreediModelFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsRead(
    requestParameters: ThreedimodelsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModel> {
    const response = await this.threedimodelsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsSavedStatesDelete without sending the request
   */
  async threedimodelsSavedStatesDeleteRequestOpts(
    requestParameters: ThreedimodelsSavedStatesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsSavedStatesDelete().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsSavedStatesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/saved_states/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View saved states created for this 3Di model
   */
  async threedimodelsSavedStatesDeleteRaw(
    requestParameters: ThreedimodelsSavedStatesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsSavedStatesDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * View saved states created for this 3Di model
   */
  async threedimodelsSavedStatesDelete(
    requestParameters: ThreedimodelsSavedStatesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsSavedStatesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsSavedStatesList without sending the request
   */
  async threedimodelsSavedStatesListRequestOpts(
    requestParameters: ThreedimodelsSavedStatesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsSavedStatesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/saved_states/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View saved states created for this 3Di model
   */
  async threedimodelsSavedStatesListRaw(
    requestParameters: ThreedimodelsSavedStatesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedThreediModelSavedStateList>> {
    const requestOptions = await this.threedimodelsSavedStatesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedThreediModelSavedStateListFromJSON(jsonValue)
    );
  }

  /**
   * View saved states created for this 3Di model
   */
  async threedimodelsSavedStatesList(
    requestParameters: ThreedimodelsSavedStatesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedThreediModelSavedStateList> {
    const response = await this.threedimodelsSavedStatesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsSavedStatesRead without sending the request
   */
  async threedimodelsSavedStatesReadRequestOpts(
    requestParameters: ThreedimodelsSavedStatesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsSavedStatesRead().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsSavedStatesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/saved_states/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View saved states created for this 3Di model
   */
  async threedimodelsSavedStatesReadRaw(
    requestParameters: ThreedimodelsSavedStatesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModelSavedState>> {
    const requestOptions = await this.threedimodelsSavedStatesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ThreediModelSavedStateFromJSON(jsonValue)
    );
  }

  /**
   * View saved states created for this 3Di model
   */
  async threedimodelsSavedStatesRead(
    requestParameters: ThreedimodelsSavedStatesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModelSavedState> {
    const response = await this.threedimodelsSavedStatesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsTablesDownload without sending the request
   */
  async threedimodelsTablesDownloadRequestOpts(
    requestParameters: ThreedimodelsTablesDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsTablesDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/tables/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading tables files.
   */
  async threedimodelsTablesDownloadRaw(
    requestParameters: ThreedimodelsTablesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsTablesDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading tables files.
   */
  async threedimodelsTablesDownload(
    requestParameters: ThreedimodelsTablesDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsTablesDownloadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsTablesUpload without sending the request
   */
  async threedimodelsTablesUploadRequestOpts(
    requestParameters: ThreedimodelsTablesUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsTablesUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsTablesUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/tables/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading the tables.h5 file  Replaces the tables file if there already exists one.
   */
  async threedimodelsTablesUploadRaw(
    requestParameters: ThreedimodelsTablesUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsTablesUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading the tables.h5 file  Replaces the tables file if there already exists one.
   */
  async threedimodelsTablesUpload(
    requestParameters: ThreedimodelsTablesUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsTablesUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsTasksCreate without sending the request
   */
  async threedimodelsTasksCreateRequestOpts(
    requestParameters: ThreedimodelsTasksCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsTasksCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsTasksCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/tasks/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ThreediModelTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksCreateRaw(
    requestParameters: ThreedimodelsTasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModelTask>> {
    const requestOptions = await this.threedimodelsTasksCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ThreediModelTaskFromJSON(jsonValue)
    );
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksCreate(
    requestParameters: ThreedimodelsTasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModelTask> {
    const response = await this.threedimodelsTasksCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsTasksDelete without sending the request
   */
  async threedimodelsTasksDeleteRequestOpts(
    requestParameters: ThreedimodelsTasksDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsTasksDelete().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsTasksDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksDeleteRaw(
    requestParameters: ThreedimodelsTasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsTasksDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksDelete(
    requestParameters: ThreedimodelsTasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsTasksDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsTasksList without sending the request
   */
  async threedimodelsTasksListRequestOpts(
    requestParameters: ThreedimodelsTasksListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsTasksList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/tasks/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksListRaw(
    requestParameters: ThreedimodelsTasksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedThreediModelTaskList>> {
    const requestOptions = await this.threedimodelsTasksListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedThreediModelTaskListFromJSON(jsonValue)
    );
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksList(
    requestParameters: ThreedimodelsTasksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedThreediModelTaskList> {
    const response = await this.threedimodelsTasksListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsTasksPartialUpdate without sending the request
   */
  async threedimodelsTasksPartialUpdateRequestOpts(
    requestParameters: ThreedimodelsTasksPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsTasksPartialUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsTasksPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsTasksPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedThreediModelTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksPartialUpdateRaw(
    requestParameters: ThreedimodelsTasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModelTask>> {
    const requestOptions = await this.threedimodelsTasksPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ThreediModelTaskFromJSON(jsonValue)
    );
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksPartialUpdate(
    requestParameters: ThreedimodelsTasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModelTask> {
    const response = await this.threedimodelsTasksPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsTasksRead without sending the request
   */
  async threedimodelsTasksReadRequestOpts(
    requestParameters: ThreedimodelsTasksReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsTasksRead().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsTasksRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksReadRaw(
    requestParameters: ThreedimodelsTasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModelTask>> {
    const requestOptions = await this.threedimodelsTasksReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ThreediModelTaskFromJSON(jsonValue)
    );
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksRead(
    requestParameters: ThreedimodelsTasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModelTask> {
    const response = await this.threedimodelsTasksReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsTasksUpdate without sending the request
   */
  async threedimodelsTasksUpdateRequestOpts(
    requestParameters: ThreedimodelsTasksUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsTasksUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsTasksUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsTasksUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{threedimodel_pk}/tasks/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ThreediModelTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksUpdateRaw(
    requestParameters: ThreedimodelsTasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModelTask>> {
    const requestOptions = await this.threedimodelsTasksUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ThreediModelTaskFromJSON(jsonValue)
    );
  }

  /**
   * View threedimodel tasks
   */
  async threedimodelsTasksUpdate(
    requestParameters: ThreedimodelsTasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModelTask> {
    const response = await this.threedimodelsTasksUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsUpdate without sending the request
   */
  async threedimodelsUpdateRequestOpts(
    requestParameters: ThreedimodelsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ThreediModelToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsUpdateRaw(
    requestParameters: ThreedimodelsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ThreediModel>> {
    const requestOptions = await this.threedimodelsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ThreediModelFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsUpdate(
    requestParameters: ThreedimodelsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ThreediModel> {
    const response = await this.threedimodelsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsWeirsGeojsonUpload without sending the request
   */
  async threedimodelsWeirsGeojsonUploadRequestOpts(
    requestParameters: ThreedimodelsWeirsGeojsonUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsWeirsGeojsonUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsWeirsGeojsonUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/threedimodels/{id}/geojson/weirs/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsWeirsGeojsonUploadRaw(
    requestParameters: ThreedimodelsWeirsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsWeirsGeojsonUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing threedimodels
   */
  async threedimodelsWeirsGeojsonUpload(
    requestParameters: ThreedimodelsWeirsGeojsonUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsWeirsGeojsonUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for usageList without sending the request
   */
  async usageListRequestOpts(requestParameters: UsageListRequest): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["finishedDate"] != null) {
      queryParameters["finished__date"] = runtime.serializeDate(
        requestParameters["finishedDate"] as any
      );
    }

    if (requestParameters["finishedDateGt"] != null) {
      queryParameters["finished__date__gt"] = runtime.serializeDate(
        requestParameters["finishedDateGt"] as any
      );
    }

    if (requestParameters["finishedDateGte"] != null) {
      queryParameters["finished__date__gte"] = runtime.serializeDate(
        requestParameters["finishedDateGte"] as any
      );
    }

    if (requestParameters["finishedDateLt"] != null) {
      queryParameters["finished__date__lt"] = runtime.serializeDate(
        requestParameters["finishedDateLt"] as any
      );
    }

    if (requestParameters["finishedDateLte"] != null) {
      queryParameters["finished__date__lte"] = runtime.serializeDate(
        requestParameters["finishedDateLte"] as any
      );
    }

    if (requestParameters["finishedGt"] != null) {
      queryParameters["finished__gt"] = runtime.serializeDateTime(
        requestParameters["finishedGt"] as any
      );
    }

    if (requestParameters["finishedGte"] != null) {
      queryParameters["finished__gte"] = runtime.serializeDateTime(
        requestParameters["finishedGte"] as any
      );
    }

    if (requestParameters["finishedLt"] != null) {
      queryParameters["finished__lt"] = runtime.serializeDateTime(
        requestParameters["finishedLt"] as any
      );
    }

    if (requestParameters["finishedLte"] != null) {
      queryParameters["finished__lte"] = runtime.serializeDateTime(
        requestParameters["finishedLte"] as any
      );
    }

    if (requestParameters["finishedMonth"] != null) {
      queryParameters["finished__month"] = requestParameters["finishedMonth"];
    }

    if (requestParameters["finishedMonthLte"] != null) {
      queryParameters["finished__month__lte"] = requestParameters["finishedMonthLte"];
    }

    if (requestParameters["finishedYear"] != null) {
      queryParameters["finished__year"] = requestParameters["finishedYear"];
    }

    if (requestParameters["finishedYearGt"] != null) {
      queryParameters["finished__year__gt"] = requestParameters["finishedYearGt"];
    }

    if (requestParameters["finishedYearGte"] != null) {
      queryParameters["finished__year__gte"] = requestParameters["finishedYearGte"];
    }

    if (requestParameters["finishedYearLt"] != null) {
      queryParameters["finished__year__lt"] = requestParameters["finishedYearLt"];
    }

    if (requestParameters["finishedYearLte"] != null) {
      queryParameters["finished__year__lte"] = requestParameters["finishedYearLte"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["ordering"] != null) {
      queryParameters["ordering"] = requestParameters["ordering"];
    }

    if (requestParameters["simulationActiveStatusName"] != null) {
      queryParameters["simulation__active_status__name"] =
        requestParameters["simulationActiveStatusName"];
    }

    if (requestParameters["simulationActiveStatusNameContains"] != null) {
      queryParameters["simulation__active_status__name__contains"] =
        requestParameters["simulationActiveStatusNameContains"];
    }

    if (requestParameters["simulationActiveStatusNameEndswith"] != null) {
      queryParameters["simulation__active_status__name__endswith"] =
        requestParameters["simulationActiveStatusNameEndswith"];
    }

    if (requestParameters["simulationActiveStatusNameIcontains"] != null) {
      queryParameters["simulation__active_status__name__icontains"] =
        requestParameters["simulationActiveStatusNameIcontains"];
    }

    if (requestParameters["simulationActiveStatusNameIexact"] != null) {
      queryParameters["simulation__active_status__name__iexact"] =
        requestParameters["simulationActiveStatusNameIexact"];
    }

    if (requestParameters["simulationActiveStatusNameIn"] != null) {
      queryParameters["simulation__active_status__name__in"] = requestParameters[
        "simulationActiveStatusNameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["simulationActiveStatusNameIstartswith"] != null) {
      queryParameters["simulation__active_status__name__istartswith"] =
        requestParameters["simulationActiveStatusNameIstartswith"];
    }

    if (requestParameters["simulationActiveStatusNameRegex"] != null) {
      queryParameters["simulation__active_status__name__regex"] =
        requestParameters["simulationActiveStatusNameRegex"];
    }

    if (requestParameters["simulationActiveStatusNameStartswith"] != null) {
      queryParameters["simulation__active_status__name__startswith"] =
        requestParameters["simulationActiveStatusNameStartswith"];
    }

    if (requestParameters["simulationId"] != null) {
      queryParameters["simulation__id"] = requestParameters["simulationId"];
    }

    if (requestParameters["simulationName"] != null) {
      queryParameters["simulation__name"] = requestParameters["simulationName"];
    }

    if (requestParameters["simulationNameContains"] != null) {
      queryParameters["simulation__name__contains"] = requestParameters["simulationNameContains"];
    }

    if (requestParameters["simulationNameEndswith"] != null) {
      queryParameters["simulation__name__endswith"] = requestParameters["simulationNameEndswith"];
    }

    if (requestParameters["simulationNameIcontains"] != null) {
      queryParameters["simulation__name__icontains"] = requestParameters["simulationNameIcontains"];
    }

    if (requestParameters["simulationNameIexact"] != null) {
      queryParameters["simulation__name__iexact"] = requestParameters["simulationNameIexact"];
    }

    if (requestParameters["simulationNameIn"] != null) {
      queryParameters["simulation__name__in"] = requestParameters["simulationNameIn"]!.join(
        runtime.COLLECTION_FORMATS["csv"]
      );
    }

    if (requestParameters["simulationNameIstartswith"] != null) {
      queryParameters["simulation__name__istartswith"] =
        requestParameters["simulationNameIstartswith"];
    }

    if (requestParameters["simulationNameRegex"] != null) {
      queryParameters["simulation__name__regex"] = requestParameters["simulationNameRegex"];
    }

    if (requestParameters["simulationNameStartswith"] != null) {
      queryParameters["simulation__name__startswith"] =
        requestParameters["simulationNameStartswith"];
    }

    if (requestParameters["simulationOrganisationNameIstartswith"] != null) {
      queryParameters["simulation__organisation__name__istartswith"] =
        requestParameters["simulationOrganisationNameIstartswith"];
    }

    if (requestParameters["simulationOrganisationUniqueId"] != null) {
      queryParameters["simulation__organisation__unique_id"] =
        requestParameters["simulationOrganisationUniqueId"];
    }

    if (requestParameters["simulationStatus"] != null) {
      queryParameters["simulation__status"] = requestParameters["simulationStatus"];
    }

    if (requestParameters["simulationTagsIn"] != null) {
      queryParameters["simulation__tags__in"] = requestParameters["simulationTagsIn"];
    }

    if (requestParameters["simulationThreedimodelId"] != null) {
      queryParameters["simulation__threedimodel__id"] =
        requestParameters["simulationThreedimodelId"];
    }

    if (requestParameters["simulationThreedimodelIdGt"] != null) {
      queryParameters["simulation__threedimodel__id__gt"] =
        requestParameters["simulationThreedimodelIdGt"];
    }

    if (requestParameters["simulationThreedimodelIdGte"] != null) {
      queryParameters["simulation__threedimodel__id__gte"] =
        requestParameters["simulationThreedimodelIdGte"];
    }

    if (requestParameters["simulationThreedimodelIdIsnull"] != null) {
      queryParameters["simulation__threedimodel__id__isnull"] =
        requestParameters["simulationThreedimodelIdIsnull"];
    }

    if (requestParameters["simulationThreedimodelIdLt"] != null) {
      queryParameters["simulation__threedimodel__id__lt"] =
        requestParameters["simulationThreedimodelIdLt"];
    }

    if (requestParameters["simulationThreedimodelIdLte"] != null) {
      queryParameters["simulation__threedimodel__id__lte"] =
        requestParameters["simulationThreedimodelIdLte"];
    }

    if (requestParameters["simulationThreedimodelName"] != null) {
      queryParameters["simulation__threedimodel__name"] =
        requestParameters["simulationThreedimodelName"];
    }

    if (requestParameters["simulationThreedimodelNameContains"] != null) {
      queryParameters["simulation__threedimodel__name__contains"] =
        requestParameters["simulationThreedimodelNameContains"];
    }

    if (requestParameters["simulationThreedimodelNameEndswith"] != null) {
      queryParameters["simulation__threedimodel__name__endswith"] =
        requestParameters["simulationThreedimodelNameEndswith"];
    }

    if (requestParameters["simulationThreedimodelNameIcontains"] != null) {
      queryParameters["simulation__threedimodel__name__icontains"] =
        requestParameters["simulationThreedimodelNameIcontains"];
    }

    if (requestParameters["simulationThreedimodelNameIexact"] != null) {
      queryParameters["simulation__threedimodel__name__iexact"] =
        requestParameters["simulationThreedimodelNameIexact"];
    }

    if (requestParameters["simulationThreedimodelNameIn"] != null) {
      queryParameters["simulation__threedimodel__name__in"] = requestParameters[
        "simulationThreedimodelNameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["simulationThreedimodelNameIstartswith"] != null) {
      queryParameters["simulation__threedimodel__name__istartswith"] =
        requestParameters["simulationThreedimodelNameIstartswith"];
    }

    if (requestParameters["simulationThreedimodelNameRegex"] != null) {
      queryParameters["simulation__threedimodel__name__regex"] =
        requestParameters["simulationThreedimodelNameRegex"];
    }

    if (requestParameters["simulationThreedimodelNameStartswith"] != null) {
      queryParameters["simulation__threedimodel__name__startswith"] =
        requestParameters["simulationThreedimodelNameStartswith"];
    }

    if (requestParameters["simulationTypeLive"] != null) {
      queryParameters["simulation__type__live"] = requestParameters["simulationTypeLive"];
    }

    if (requestParameters["simulationUserUsername"] != null) {
      queryParameters["simulation__user__username"] = requestParameters["simulationUserUsername"];
    }

    if (requestParameters["simulationUserUsernameContains"] != null) {
      queryParameters["simulation__user__username__contains"] =
        requestParameters["simulationUserUsernameContains"];
    }

    if (requestParameters["simulationUserUsernameEndswith"] != null) {
      queryParameters["simulation__user__username__endswith"] =
        requestParameters["simulationUserUsernameEndswith"];
    }

    if (requestParameters["simulationUserUsernameIcontains"] != null) {
      queryParameters["simulation__user__username__icontains"] =
        requestParameters["simulationUserUsernameIcontains"];
    }

    if (requestParameters["simulationUserUsernameIexact"] != null) {
      queryParameters["simulation__user__username__iexact"] =
        requestParameters["simulationUserUsernameIexact"];
    }

    if (requestParameters["simulationUserUsernameIn"] != null) {
      queryParameters["simulation__user__username__in"] = requestParameters[
        "simulationUserUsernameIn"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["simulationUserUsernameIstartswith"] != null) {
      queryParameters["simulation__user__username__istartswith"] =
        requestParameters["simulationUserUsernameIstartswith"];
    }

    if (requestParameters["simulationUserUsernameRegex"] != null) {
      queryParameters["simulation__user__username__regex"] =
        requestParameters["simulationUserUsernameRegex"];
    }

    if (requestParameters["simulationUserUsernameStartswith"] != null) {
      queryParameters["simulation__user__username__startswith"] =
        requestParameters["simulationUserUsernameStartswith"];
    }

    if (requestParameters["startedDate"] != null) {
      queryParameters["started__date"] = runtime.serializeDate(
        requestParameters["startedDate"] as any
      );
    }

    if (requestParameters["startedDateGt"] != null) {
      queryParameters["started__date__gt"] = runtime.serializeDate(
        requestParameters["startedDateGt"] as any
      );
    }

    if (requestParameters["startedDateGte"] != null) {
      queryParameters["started__date__gte"] = runtime.serializeDate(
        requestParameters["startedDateGte"] as any
      );
    }

    if (requestParameters["startedDateLt"] != null) {
      queryParameters["started__date__lt"] = runtime.serializeDate(
        requestParameters["startedDateLt"] as any
      );
    }

    if (requestParameters["startedDateLte"] != null) {
      queryParameters["started__date__lte"] = runtime.serializeDate(
        requestParameters["startedDateLte"] as any
      );
    }

    if (requestParameters["startedGt"] != null) {
      queryParameters["started__gt"] = runtime.serializeDateTime(
        requestParameters["startedGt"] as any
      );
    }

    if (requestParameters["startedGte"] != null) {
      queryParameters["started__gte"] = runtime.serializeDateTime(
        requestParameters["startedGte"] as any
      );
    }

    if (requestParameters["startedLt"] != null) {
      queryParameters["started__lt"] = runtime.serializeDateTime(
        requestParameters["startedLt"] as any
      );
    }

    if (requestParameters["startedLte"] != null) {
      queryParameters["started__lte"] = runtime.serializeDateTime(
        requestParameters["startedLte"] as any
      );
    }

    if (requestParameters["startedMonth"] != null) {
      queryParameters["started__month"] = requestParameters["startedMonth"];
    }

    if (requestParameters["startedMonthLte"] != null) {
      queryParameters["started__month__lte"] = requestParameters["startedMonthLte"];
    }

    if (requestParameters["startedYear"] != null) {
      queryParameters["started__year"] = requestParameters["startedYear"];
    }

    if (requestParameters["startedYearGt"] != null) {
      queryParameters["started__year__gt"] = requestParameters["startedYearGt"];
    }

    if (requestParameters["startedYearGte"] != null) {
      queryParameters["started__year__gte"] = requestParameters["startedYearGte"];
    }

    if (requestParameters["startedYearLt"] != null) {
      queryParameters["started__year__lt"] = requestParameters["startedYearLt"];
    }

    if (requestParameters["startedYearLte"] != null) {
      queryParameters["started__year__lte"] = requestParameters["startedYearLte"];
    }

    if (requestParameters["totalTime"] != null) {
      queryParameters["total_time"] = requestParameters["totalTime"];
    }

    if (requestParameters["totalTimeGt"] != null) {
      queryParameters["total_time__gt"] = requestParameters["totalTimeGt"];
    }

    if (requestParameters["totalTimeGte"] != null) {
      queryParameters["total_time__gte"] = requestParameters["totalTimeGte"];
    }

    if (requestParameters["totalTimeIsnull"] != null) {
      queryParameters["total_time__isnull"] = requestParameters["totalTimeIsnull"];
    }

    if (requestParameters["totalTimeLt"] != null) {
      queryParameters["total_time__lt"] = requestParameters["totalTimeLt"];
    }

    if (requestParameters["totalTimeLte"] != null) {
      queryParameters["total_time__lte"] = requestParameters["totalTimeLte"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/usage/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View to display overview of ran simulations.  Only displays finished/crashed simulations.
   */
  async usageListRaw(
    requestParameters: UsageListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedUsageList>> {
    const requestOptions = await this.usageListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedUsageListFromJSON(jsonValue)
    );
  }

  /**
   * View to display overview of ran simulations.  Only displays finished/crashed simulations.
   */
  async usageList(
    requestParameters: UsageListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedUsageList> {
    const response = await this.usageListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for usageRead without sending the request
   */
  async usageReadRequestOpts(requestParameters: UsageReadRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling usageRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/usage/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View to display overview of ran simulations.  Only displays finished/crashed simulations.
   */
  async usageReadRaw(
    requestParameters: UsageReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Usage>> {
    const requestOptions = await this.usageReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UsageFromJSON(jsonValue));
  }

  /**
   * View to display overview of ran simulations.  Only displays finished/crashed simulations.
   */
  async usageRead(
    requestParameters: UsageReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Usage> {
    const response = await this.usageReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for usageStatistics without sending the request
   */
  async usageStatisticsRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3/usage/statistics/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Usage statistics like total session count, average session duration and such.  This endpoint comes in handy if you want to aggregate usage number over a certain period of time, for a given user or organisation.  It is also possible to limit the result to a certain simulation type, e.g. to \"live\" sessions. Use the `simulation__type__live` filter with either `true` or `false` as input values.
   */
  async usageStatisticsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UsageStatistics>> {
    const requestOptions = await this.usageStatisticsRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UsageStatisticsFromJSON(jsonValue));
  }

  /**
   * Usage statistics like total session count, average session duration and such.  This endpoint comes in handy if you want to aggregate usage number over a certain period of time, for a given user or organisation.  It is also possible to limit the result to a certain simulation type, e.g. to \"live\" sessions. Use the `simulation__type__live` filter with either `true` or `false` as input values.
   */
  async usageStatistics(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UsageStatistics> {
    const response = await this.usageStatisticsRaw(initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const FilesListStateEnum = {
  Created: "created",
  Error: "error",
  Processed: "processed",
  Removed: "removed",
  Uploaded: "uploaded",
} as const;
export type FilesListStateEnum = (typeof FilesListStateEnum)[keyof typeof FilesListStateEnum];
/**
 * @export
 */
export const FilesListTypeEnum = {
  BulkBoundaryconditions: "bulk_boundaryconditions",
  Bulkcontrol: "bulkcontrol",
  Bulklateral: "bulklateral",
  Bulktimeseriesrain: "bulktimeseriesrain",
  Geojson: "geojson",
  Geopackage: "geopackage",
  Gridadmin: "gridadmin",
  InitialSubstanceConcentration: "initial_substance_concentration",
  Initialwaterlevel: "initialwaterlevel",
  Rasters: "rasters",
  Rastertimeseries: "rastertimeseries",
  Results: "results",
  Savedstate: "savedstate",
  Sqlite: "sqlite",
  Tables: "tables",
  Timeseries: "timeseries",
} as const;
export type FilesListTypeEnum = (typeof FilesListTypeEnum)[keyof typeof FilesListTypeEnum];
/**
 * @export
 */
export const SimulationsListStartedFromEnum = {
  Empty: "",
  _3DiLive: "3Di Live",
  _3DiModellerInterface: "3Di Modeller Interface",
  RanaDesktopClient: "Rana Desktop Client",
} as const;
export type SimulationsListStartedFromEnum =
  (typeof SimulationsListStartedFromEnum)[keyof typeof SimulationsListStartedFromEnum];
/**
 * @export
 */
export const StatusesListExitCodeEnum = {
  NUMBER_1110: 1110,
  NUMBER_1210: 1210,
  NUMBER_1240: 1240,
  NUMBER_2110: 2110,
  NUMBER_2120: 2120,
  NUMBER_2150: 2150,
  NUMBER_2210: 2210,
  NUMBER_2220: 2220,
  NUMBER_2230: 2230,
  NUMBER_2240: 2240,
  NUMBER_4120: 4120,
  NUMBER_4150: 4150,
  NUMBER_4161: 4161,
  NUMBER_4220: 4220,
  NUMBER_4230: 4230,
  NUMBER_4231: 4231,
  NUMBER_4232: 4232,
  NUMBER_4240: 4240,
  NUMBER_4262: 4262,
  NUMBER_4263: 4263,
  NUMBER_4264: 4264,
  NUMBER_4265: 4265,
  NUMBER_4270: 4270,
  NUMBER_4280: 4280,
} as const;
export type StatusesListExitCodeEnum =
  (typeof StatusesListExitCodeEnum)[keyof typeof StatusesListExitCodeEnum];
/**
 * @export
 */
export const StatusesListNameEnum = {
  Crashed: "crashed",
  Created: "created",
  Ended: "ended",
  Finished: "finished",
  Initialized: "initialized",
  Postprocessing: "postprocessing",
  Queued: "queued",
  Starting: "starting",
} as const;
export type StatusesListNameEnum = (typeof StatusesListNameEnum)[keyof typeof StatusesListNameEnum];
/**
 * @export
 */
export const StatusesStatisticsExitCodeEnum = {
  NUMBER_1110: 1110,
  NUMBER_1210: 1210,
  NUMBER_1240: 1240,
  NUMBER_2110: 2110,
  NUMBER_2120: 2120,
  NUMBER_2150: 2150,
  NUMBER_2210: 2210,
  NUMBER_2220: 2220,
  NUMBER_2230: 2230,
  NUMBER_2240: 2240,
  NUMBER_4120: 4120,
  NUMBER_4150: 4150,
  NUMBER_4161: 4161,
  NUMBER_4220: 4220,
  NUMBER_4230: 4230,
  NUMBER_4231: 4231,
  NUMBER_4232: 4232,
  NUMBER_4240: 4240,
  NUMBER_4262: 4262,
  NUMBER_4263: 4263,
  NUMBER_4264: 4264,
  NUMBER_4265: 4265,
  NUMBER_4270: 4270,
  NUMBER_4280: 4280,
} as const;
export type StatusesStatisticsExitCodeEnum =
  (typeof StatusesStatisticsExitCodeEnum)[keyof typeof StatusesStatisticsExitCodeEnum];
/**
 * @export
 */
export const StatusesStatisticsNameEnum = {
  Crashed: "crashed",
  Created: "created",
  Ended: "ended",
  Finished: "finished",
  Initialized: "initialized",
  Postprocessing: "postprocessing",
  Queued: "queued",
  Starting: "starting",
} as const;
export type StatusesStatisticsNameEnum =
  (typeof StatusesStatisticsNameEnum)[keyof typeof StatusesStatisticsNameEnum];
/**
 * @export
 */
export const ThreedimodelsRastersListTypeEnum = {
  DemFile: "dem_file",
  DemRawFile: "dem_raw_file",
  EquilibriumInfiltrationRateFile: "equilibrium_infiltration_rate_file",
  FrictCoefFile: "frict_coef_file",
  GroundwaterHydroConnectivityFile: "groundwater_hydro_connectivity_file",
  GroundwaterImperviousLayerLevelFile: "groundwater_impervious_layer_level_file",
  HydraulicConductivityFile: "hydraulic_conductivity_file",
  InfiltrationDecayPeriodFile: "infiltration_decay_period_file",
  InfiltrationRateFile: "infiltration_rate_file",
  InitialConcentrationFile: "initial_concentration_file",
  InitialGroundwaterConcentrationFile: "initial_groundwater_concentration_file",
  InitialGroundwaterLevelFile: "initial_groundwater_level_file",
  InitialInfiltrationRateFile: "initial_infiltration_rate_file",
  InitialWaterlevelFile: "initial_waterlevel_file",
  InterceptionFile: "interception_file",
  LeakageFile: "leakage_file",
  MaxInfiltrationCapacityFile: "max_infiltration_capacity_file",
  PhreaticStorageCapacityFile: "phreatic_storage_capacity_file",
  PorosityFile: "porosity_file",
  VegetationDragCoefficientFile: "vegetation_drag_coefficient_file",
  VegetationHeightFile: "vegetation_height_file",
  VegetationStemCountFile: "vegetation_stem_count_file",
  VegetationStemDiameterFile: "vegetation_stem_diameter_file",
} as const;
export type ThreedimodelsRastersListTypeEnum =
  (typeof ThreedimodelsRastersListTypeEnum)[keyof typeof ThreedimodelsRastersListTypeEnum];
/**
 * @export
 */
export const UsageListSimulationActiveStatusNameEnum = {
  Crashed: "crashed",
  Created: "created",
  Ended: "ended",
  Finished: "finished",
  Initialized: "initialized",
  Postprocessing: "postprocessing",
  Queued: "queued",
  Starting: "starting",
} as const;
export type UsageListSimulationActiveStatusNameEnum =
  (typeof UsageListSimulationActiveStatusNameEnum)[keyof typeof UsageListSimulationActiveStatusNameEnum];
/**
 * @export
 */
export const UsageListSimulationStatusEnum = {
  Crashed: "crashed",
  Finished: "finished",
} as const;
export type UsageListSimulationStatusEnum =
  (typeof UsageListSimulationStatusEnum)[keyof typeof UsageListSimulationStatusEnum];
